(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("451Sc", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $2f891507bcc3501a$export$6503ec6e8aabbaf; }, function (v) { return $2f891507bcc3501a$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $2f891507bcc3501a$export$f7ad0328861e2f03; }, function (v) { return $2f891507bcc3501a$export$f7ad0328861e2f03 = v; });
var $2f891507bcc3501a$export$6503ec6e8aabbaf;
var $2f891507bcc3501a$export$f7ad0328861e2f03;
"use strict";
var $2f891507bcc3501a$var$mapping = new Map();
function $2f891507bcc3501a$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$2f891507bcc3501a$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $2f891507bcc3501a$var$resolve(id) {
    var resolved = $2f891507bcc3501a$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$2f891507bcc3501a$export$6503ec6e8aabbaf = $2f891507bcc3501a$var$register;
$2f891507bcc3501a$export$f7ad0328861e2f03 = $2f891507bcc3501a$var$resolve;

});

parcelRegister("i1aqH", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $d1e0691a4ecd19e1$export$bdfd709ae4826697; }, function (v) { return $d1e0691a4ecd19e1$export$bdfd709ae4826697 = v; });
var $d1e0691a4ecd19e1$export$bdfd709ae4826697;
var $d1e0691a4ecd19e1$export$c9e73fbda7da57b6;
var $d1e0691a4ecd19e1$export$5a759dc7a1cfb72a;
"use strict";
var $d1e0691a4ecd19e1$var$bundleURL = {};
function $d1e0691a4ecd19e1$var$getBundleURLCached(id) {
    var value = $d1e0691a4ecd19e1$var$bundleURL[id];
    if (!value) {
        value = $d1e0691a4ecd19e1$var$getBundleURL();
        $d1e0691a4ecd19e1$var$bundleURL[id] = value;
    }
    return value;
}
function $d1e0691a4ecd19e1$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $d1e0691a4ecd19e1$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $d1e0691a4ecd19e1$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $d1e0691a4ecd19e1$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$d1e0691a4ecd19e1$export$bdfd709ae4826697 = $d1e0691a4ecd19e1$var$getBundleURLCached;
$d1e0691a4ecd19e1$export$c9e73fbda7da57b6 = $d1e0691a4ecd19e1$var$getBaseURL;
$d1e0691a4ecd19e1$export$5a759dc7a1cfb72a = $d1e0691a4ecd19e1$var$getOrigin;

});

parcelRegister("cc6u1", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5HeJu"));

});
parcelRegister("5HeJu", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $425c6581edea75b8$export$ffb0004e005737fa; }, function (v) { return $425c6581edea75b8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $425c6581edea75b8$export$34b9dba7ce09269b; }, function (v) { return $425c6581edea75b8$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $425c6581edea75b8$export$25062201e9e25d76; }, function (v) { return $425c6581edea75b8$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $425c6581edea75b8$export$ffb0004e005737fa;
var $425c6581edea75b8$export$34b9dba7ce09269b;
var $425c6581edea75b8$export$25062201e9e25d76;
"use strict";
var $425c6581edea75b8$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $425c6581edea75b8$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $425c6581edea75b8$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $425c6581edea75b8$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$425c6581edea75b8$export$ffb0004e005737fa = $425c6581edea75b8$var$REACT_FRAGMENT_TYPE;
$425c6581edea75b8$export$34b9dba7ce09269b = $425c6581edea75b8$var$jsxProd;
$425c6581edea75b8$export$25062201e9e25d76 = $425c6581edea75b8$var$jsxProd;

});


parcelRegister("fIwXP", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5p0Oe"));

});
parcelRegister("5p0Oe", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $3eefea38dbe2eeaf$export$dca3b0875bd9a954; }, function (v) { return $3eefea38dbe2eeaf$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $3eefea38dbe2eeaf$export$16fa2f45be04daa8; }, function (v) { return $3eefea38dbe2eeaf$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $3eefea38dbe2eeaf$export$ffb0004e005737fa; }, function (v) { return $3eefea38dbe2eeaf$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $3eefea38dbe2eeaf$export$e2c29f18771995cb; }, function (v) { return $3eefea38dbe2eeaf$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $3eefea38dbe2eeaf$export$221d75b3f55bb0bd; }, function (v) { return $3eefea38dbe2eeaf$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $3eefea38dbe2eeaf$export$5f8d39834fd61797; }, function (v) { return $3eefea38dbe2eeaf$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $3eefea38dbe2eeaf$export$74bf444e3cd11ea5; }, function (v) { return $3eefea38dbe2eeaf$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $3eefea38dbe2eeaf$export$1ced07cd6b1985ce; }, function (v) { return $3eefea38dbe2eeaf$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "act", function () { return $3eefea38dbe2eeaf$export$3ba232387fd5d6dd; }, function (v) { return $3eefea38dbe2eeaf$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cache", function () { return $3eefea38dbe2eeaf$export$69a3209f1a06c04d; }, function (v) { return $3eefea38dbe2eeaf$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $3eefea38dbe2eeaf$export$e530037191fcd5d7; }, function (v) { return $3eefea38dbe2eeaf$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $3eefea38dbe2eeaf$export$fd42f52fd3ae1109; }, function (v) { return $3eefea38dbe2eeaf$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $3eefea38dbe2eeaf$export$c8a8987d4410bf2d; }, function (v) { return $3eefea38dbe2eeaf$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $3eefea38dbe2eeaf$export$7d1e3a5e95ceca43; }, function (v) { return $3eefea38dbe2eeaf$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $3eefea38dbe2eeaf$export$257a8862b851cb5b; }, function (v) { return $3eefea38dbe2eeaf$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $3eefea38dbe2eeaf$export$a8257692ac88316c; }, function (v) { return $3eefea38dbe2eeaf$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $3eefea38dbe2eeaf$export$488013bae63b21da; }, function (v) { return $3eefea38dbe2eeaf$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $3eefea38dbe2eeaf$export$7c73462e0d25e514; }, function (v) { return $3eefea38dbe2eeaf$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $3eefea38dbe2eeaf$export$7568632d0d33d16d; }, function (v) { return $3eefea38dbe2eeaf$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $3eefea38dbe2eeaf$export$f93f40ac0ca7e3a8; }, function (v) { return $3eefea38dbe2eeaf$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $3eefea38dbe2eeaf$export$1f96ae73734a86cc; }, function (v) { return $3eefea38dbe2eeaf$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $3eefea38dbe2eeaf$export$9a47ced3238df325; }, function (v) { return $3eefea38dbe2eeaf$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $3eefea38dbe2eeaf$export$35808ee640e87ca7; }, function (v) { return $3eefea38dbe2eeaf$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $3eefea38dbe2eeaf$export$fae74005e78b1a27; }, function (v) { return $3eefea38dbe2eeaf$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $3eefea38dbe2eeaf$export$dc8fbce3eb94dc1e; }, function (v) { return $3eefea38dbe2eeaf$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $3eefea38dbe2eeaf$export$6a7bc4e911dc01cf; }, function (v) { return $3eefea38dbe2eeaf$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $3eefea38dbe2eeaf$export$6d9c69b0de29b591; }, function (v) { return $3eefea38dbe2eeaf$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $3eefea38dbe2eeaf$export$f680877a34711e37; }, function (v) { return $3eefea38dbe2eeaf$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $3eefea38dbe2eeaf$export$d5a552a76deda3c2; }, function (v) { return $3eefea38dbe2eeaf$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $3eefea38dbe2eeaf$export$aaabe4eda9ed9969; }, function (v) { return $3eefea38dbe2eeaf$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $3eefea38dbe2eeaf$export$e5c5a5f917a5871c; }, function (v) { return $3eefea38dbe2eeaf$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $3eefea38dbe2eeaf$export$1538c33de8887b59; }, function (v) { return $3eefea38dbe2eeaf$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $3eefea38dbe2eeaf$export$fca7f784ae7a249a; }, function (v) { return $3eefea38dbe2eeaf$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $3eefea38dbe2eeaf$export$13e3392192263954; }, function (v) { return $3eefea38dbe2eeaf$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $3eefea38dbe2eeaf$export$b8f5890fc79d6aca; }, function (v) { return $3eefea38dbe2eeaf$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $3eefea38dbe2eeaf$export$60241385465d0a34; }, function (v) { return $3eefea38dbe2eeaf$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $3eefea38dbe2eeaf$export$306c0aa65ff9ec16; }, function (v) { return $3eefea38dbe2eeaf$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $3eefea38dbe2eeaf$export$7b286972b8d8ccbf; }, function (v) { return $3eefea38dbe2eeaf$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $3eefea38dbe2eeaf$export$83d89fbfd8236492; }, function (v) { return $3eefea38dbe2eeaf$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $YtE9h = parcelRequire("YtE9h");
var $3eefea38dbe2eeaf$export$dca3b0875bd9a954;
var $3eefea38dbe2eeaf$export$16fa2f45be04daa8;
var $3eefea38dbe2eeaf$export$ffb0004e005737fa;
var $3eefea38dbe2eeaf$export$e2c29f18771995cb;
var $3eefea38dbe2eeaf$export$221d75b3f55bb0bd;
var $3eefea38dbe2eeaf$export$5f8d39834fd61797;
var $3eefea38dbe2eeaf$export$74bf444e3cd11ea5;
var $3eefea38dbe2eeaf$export$1ced07cd6b1985ce;
var $3eefea38dbe2eeaf$export$3ba232387fd5d6dd;
var $3eefea38dbe2eeaf$export$69a3209f1a06c04d;
var $3eefea38dbe2eeaf$export$e530037191fcd5d7;
var $3eefea38dbe2eeaf$export$fd42f52fd3ae1109;
var $3eefea38dbe2eeaf$export$c8a8987d4410bf2d;
var $3eefea38dbe2eeaf$export$7d1e3a5e95ceca43;
var $3eefea38dbe2eeaf$export$257a8862b851cb5b;
var $3eefea38dbe2eeaf$export$a8257692ac88316c;
var $3eefea38dbe2eeaf$export$488013bae63b21da;
var $3eefea38dbe2eeaf$export$7c73462e0d25e514;
var $3eefea38dbe2eeaf$export$7568632d0d33d16d;
var $3eefea38dbe2eeaf$export$f93f40ac0ca7e3a8;
var $3eefea38dbe2eeaf$export$1f96ae73734a86cc;
var $3eefea38dbe2eeaf$export$9a47ced3238df325;
var $3eefea38dbe2eeaf$export$35808ee640e87ca7;
var $3eefea38dbe2eeaf$export$fae74005e78b1a27;
var $3eefea38dbe2eeaf$export$dc8fbce3eb94dc1e;
var $3eefea38dbe2eeaf$export$6a7bc4e911dc01cf;
var $3eefea38dbe2eeaf$export$6d9c69b0de29b591;
var $3eefea38dbe2eeaf$export$f680877a34711e37;
var $3eefea38dbe2eeaf$export$d5a552a76deda3c2;
var $3eefea38dbe2eeaf$export$aaabe4eda9ed9969;
var $3eefea38dbe2eeaf$export$e5c5a5f917a5871c;
var $3eefea38dbe2eeaf$export$1538c33de8887b59;
var $3eefea38dbe2eeaf$export$fca7f784ae7a249a;
var $3eefea38dbe2eeaf$export$13e3392192263954;
var $3eefea38dbe2eeaf$export$b8f5890fc79d6aca;
var $3eefea38dbe2eeaf$export$60241385465d0a34;
var $3eefea38dbe2eeaf$export$306c0aa65ff9ec16;
var $3eefea38dbe2eeaf$export$7b286972b8d8ccbf;
var $3eefea38dbe2eeaf$export$83d89fbfd8236492;

var $ibRPI = parcelRequire("ibRPI");
"use strict";
var $3eefea38dbe2eeaf$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $3eefea38dbe2eeaf$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $3eefea38dbe2eeaf$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $3eefea38dbe2eeaf$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $3eefea38dbe2eeaf$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $3eefea38dbe2eeaf$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $3eefea38dbe2eeaf$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $3eefea38dbe2eeaf$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $3eefea38dbe2eeaf$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $3eefea38dbe2eeaf$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $3eefea38dbe2eeaf$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $3eefea38dbe2eeaf$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $3eefea38dbe2eeaf$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== (typeof maybeIterable === "undefined" ? "undefined" : (0, $YtE9h._)(maybeIterable))) return null;
    maybeIterable = $3eefea38dbe2eeaf$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$3eefea38dbe2eeaf$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $3eefea38dbe2eeaf$var$ReactNoopUpdateQueue = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $3eefea38dbe2eeaf$var$assign = Object.assign, $3eefea38dbe2eeaf$var$emptyObject = {};
function $3eefea38dbe2eeaf$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $3eefea38dbe2eeaf$var$emptyObject;
    this.updater = updater || $3eefea38dbe2eeaf$var$ReactNoopUpdateQueue;
}
$3eefea38dbe2eeaf$var$Component.prototype.isReactComponent = {};
$3eefea38dbe2eeaf$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== (typeof partialState === "undefined" ? "undefined" : (0, $YtE9h._)(partialState)) && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$3eefea38dbe2eeaf$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $3eefea38dbe2eeaf$var$ComponentDummy() {}
$3eefea38dbe2eeaf$var$ComponentDummy.prototype = $3eefea38dbe2eeaf$var$Component.prototype;
function $3eefea38dbe2eeaf$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $3eefea38dbe2eeaf$var$emptyObject;
    this.updater = updater || $3eefea38dbe2eeaf$var$ReactNoopUpdateQueue;
}
var $3eefea38dbe2eeaf$var$pureComponentPrototype = $3eefea38dbe2eeaf$var$PureComponent.prototype = new $3eefea38dbe2eeaf$var$ComponentDummy();
$3eefea38dbe2eeaf$var$pureComponentPrototype.constructor = $3eefea38dbe2eeaf$var$PureComponent;
$3eefea38dbe2eeaf$var$assign($3eefea38dbe2eeaf$var$pureComponentPrototype, $3eefea38dbe2eeaf$var$Component.prototype);
$3eefea38dbe2eeaf$var$pureComponentPrototype.isPureReactComponent = !0;
var $3eefea38dbe2eeaf$var$isArrayImpl = Array.isArray, $3eefea38dbe2eeaf$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $3eefea38dbe2eeaf$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $3eefea38dbe2eeaf$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $3eefea38dbe2eeaf$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $3eefea38dbe2eeaf$var$cloneAndReplaceKey(oldElement, newKey) {
    return $3eefea38dbe2eeaf$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $3eefea38dbe2eeaf$var$isValidElement(object) {
    return "object" === (typeof object === "undefined" ? "undefined" : (0, $YtE9h._)(object)) && null !== object && object.$$typeof === $3eefea38dbe2eeaf$var$REACT_ELEMENT_TYPE;
}
function $3eefea38dbe2eeaf$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $3eefea38dbe2eeaf$var$userProvidedKeyEscapeRegex = /\/+/g;
function $3eefea38dbe2eeaf$var$getElementKey(element, index) {
    return "object" === (typeof element === "undefined" ? "undefined" : (0, $YtE9h._)(element)) && null !== element && null != element.key ? $3eefea38dbe2eeaf$var$escape("" + element.key) : index.toString(36);
}
function $3eefea38dbe2eeaf$var$noop$1() {}
function $3eefea38dbe2eeaf$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($3eefea38dbe2eeaf$var$noop$1, $3eefea38dbe2eeaf$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $3eefea38dbe2eeaf$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children === "undefined" ? "undefined" : (0, $YtE9h._)(children);
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $3eefea38dbe2eeaf$var$REACT_ELEMENT_TYPE:
                case $3eefea38dbe2eeaf$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $3eefea38dbe2eeaf$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $3eefea38dbe2eeaf$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $3eefea38dbe2eeaf$var$getElementKey(children, 0) : nameSoFar, $3eefea38dbe2eeaf$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($3eefea38dbe2eeaf$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $3eefea38dbe2eeaf$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($3eefea38dbe2eeaf$var$isValidElement(callback) && (callback = $3eefea38dbe2eeaf$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($3eefea38dbe2eeaf$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($3eefea38dbe2eeaf$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $3eefea38dbe2eeaf$var$getElementKey(nameSoFar, i), invokeCallback += $3eefea38dbe2eeaf$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $3eefea38dbe2eeaf$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $3eefea38dbe2eeaf$var$getElementKey(nameSoFar, i++), invokeCallback += $3eefea38dbe2eeaf$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $3eefea38dbe2eeaf$var$mapIntoArray($3eefea38dbe2eeaf$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $3eefea38dbe2eeaf$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $3eefea38dbe2eeaf$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $3eefea38dbe2eeaf$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $3eefea38dbe2eeaf$var$reportGlobalError = "function" === typeof reportError ? reportError : function reportGlobalError(error) {
    if ("object" === (typeof window === "undefined" ? "undefined" : (0, $YtE9h._)(window)) && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === (typeof error === "undefined" ? "undefined" : (0, $YtE9h._)(error)) && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === (typeof $ibRPI === "undefined" ? "undefined" : (0, $YtE9h._)($ibRPI)) && "function" === typeof $ibRPI.emit) {
        $ibRPI.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $3eefea38dbe2eeaf$var$noop() {}
$3eefea38dbe2eeaf$export$dca3b0875bd9a954 = {
    map: $3eefea38dbe2eeaf$var$mapChildren,
    forEach: function forEach(children, forEachFunc, forEachContext) {
        $3eefea38dbe2eeaf$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function count(children) {
        var n = 0;
        $3eefea38dbe2eeaf$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function toArray(children) {
        return $3eefea38dbe2eeaf$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function only(children) {
        if (!$3eefea38dbe2eeaf$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$3eefea38dbe2eeaf$export$16fa2f45be04daa8 = $3eefea38dbe2eeaf$var$Component;
$3eefea38dbe2eeaf$export$ffb0004e005737fa = $3eefea38dbe2eeaf$var$REACT_FRAGMENT_TYPE;
$3eefea38dbe2eeaf$export$e2c29f18771995cb = $3eefea38dbe2eeaf$var$REACT_PROFILER_TYPE;
$3eefea38dbe2eeaf$export$221d75b3f55bb0bd = $3eefea38dbe2eeaf$var$PureComponent;
$3eefea38dbe2eeaf$export$5f8d39834fd61797 = $3eefea38dbe2eeaf$var$REACT_STRICT_MODE_TYPE;
$3eefea38dbe2eeaf$export$74bf444e3cd11ea5 = $3eefea38dbe2eeaf$var$REACT_SUSPENSE_TYPE;
$3eefea38dbe2eeaf$export$1ced07cd6b1985ce = $3eefea38dbe2eeaf$var$ReactSharedInternals;
$3eefea38dbe2eeaf$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$3eefea38dbe2eeaf$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$3eefea38dbe2eeaf$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $3eefea38dbe2eeaf$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$3eefea38dbe2eeaf$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $3eefea38dbe2eeaf$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$3eefea38dbe2eeaf$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $3eefea38dbe2eeaf$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $3eefea38dbe2eeaf$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$3eefea38dbe2eeaf$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$3eefea38dbe2eeaf$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $3eefea38dbe2eeaf$var$ReactElement(type, key, void 0, void 0, null, props);
};
$3eefea38dbe2eeaf$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$3eefea38dbe2eeaf$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $3eefea38dbe2eeaf$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$3eefea38dbe2eeaf$export$a8257692ac88316c = $3eefea38dbe2eeaf$var$isValidElement;
$3eefea38dbe2eeaf$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $3eefea38dbe2eeaf$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $3eefea38dbe2eeaf$var$lazyInitializer
    };
};
$3eefea38dbe2eeaf$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $3eefea38dbe2eeaf$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$3eefea38dbe2eeaf$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $3eefea38dbe2eeaf$var$ReactSharedInternals.T, currentTransition = {};
    $3eefea38dbe2eeaf$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $3eefea38dbe2eeaf$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $YtE9h._)(returnValue)) && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($3eefea38dbe2eeaf$var$noop, $3eefea38dbe2eeaf$var$reportGlobalError);
    } catch (error) {
        $3eefea38dbe2eeaf$var$reportGlobalError(error);
    } finally{
        $3eefea38dbe2eeaf$var$ReactSharedInternals.T = prevTransition;
    }
};
$3eefea38dbe2eeaf$export$f93f40ac0ca7e3a8 = function() {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useCacheRefresh();
};
$3eefea38dbe2eeaf$export$1f96ae73734a86cc = function(usable) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.use(usable);
};
$3eefea38dbe2eeaf$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$3eefea38dbe2eeaf$export$35808ee640e87ca7 = function(callback, deps) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$3eefea38dbe2eeaf$export$fae74005e78b1a27 = function(Context) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useContext(Context);
};
$3eefea38dbe2eeaf$export$dc8fbce3eb94dc1e = function() {};
$3eefea38dbe2eeaf$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$3eefea38dbe2eeaf$export$6d9c69b0de29b591 = function(create, deps) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useEffect(create, deps);
};
$3eefea38dbe2eeaf$export$f680877a34711e37 = function() {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useId();
};
$3eefea38dbe2eeaf$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$3eefea38dbe2eeaf$export$aaabe4eda9ed9969 = function(create, deps) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$3eefea38dbe2eeaf$export$e5c5a5f917a5871c = function(create, deps) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$3eefea38dbe2eeaf$export$1538c33de8887b59 = function(create, deps) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useMemo(create, deps);
};
$3eefea38dbe2eeaf$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$3eefea38dbe2eeaf$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$3eefea38dbe2eeaf$export$b8f5890fc79d6aca = function(initialValue) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useRef(initialValue);
};
$3eefea38dbe2eeaf$export$60241385465d0a34 = function(initialState) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useState(initialState);
};
$3eefea38dbe2eeaf$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$3eefea38dbe2eeaf$export$7b286972b8d8ccbf = function() {
    return $3eefea38dbe2eeaf$var$ReactSharedInternals.H.useTransition();
};
$3eefea38dbe2eeaf$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("YtE9h", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0b5c99e6a0876eaa$export$71511d61b312f219; });
function $0b5c99e6a0876eaa$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("ibRPI", function(module, exports) {
// shim for using process in browser
var $d3e3033a14238d9e$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3e3033a14238d9e$var$cachedSetTimeout;
var $d3e3033a14238d9e$var$cachedClearTimeout;
function $d3e3033a14238d9e$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d3e3033a14238d9e$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d3e3033a14238d9e$var$cachedSetTimeout = setTimeout;
        else $d3e3033a14238d9e$var$cachedSetTimeout = $d3e3033a14238d9e$var$defaultSetTimout;
    } catch (e) {
        $d3e3033a14238d9e$var$cachedSetTimeout = $d3e3033a14238d9e$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d3e3033a14238d9e$var$cachedClearTimeout = clearTimeout;
        else $d3e3033a14238d9e$var$cachedClearTimeout = $d3e3033a14238d9e$var$defaultClearTimeout;
    } catch (e) {
        $d3e3033a14238d9e$var$cachedClearTimeout = $d3e3033a14238d9e$var$defaultClearTimeout;
    }
})();
function $d3e3033a14238d9e$var$runTimeout(fun) {
    if ($d3e3033a14238d9e$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3e3033a14238d9e$var$cachedSetTimeout === $d3e3033a14238d9e$var$defaultSetTimout || !$d3e3033a14238d9e$var$cachedSetTimeout) && setTimeout) {
        $d3e3033a14238d9e$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3e3033a14238d9e$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3e3033a14238d9e$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3e3033a14238d9e$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3e3033a14238d9e$var$runClearTimeout(marker) {
    if ($d3e3033a14238d9e$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3e3033a14238d9e$var$cachedClearTimeout === $d3e3033a14238d9e$var$defaultClearTimeout || !$d3e3033a14238d9e$var$cachedClearTimeout) && clearTimeout) {
        $d3e3033a14238d9e$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3e3033a14238d9e$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3e3033a14238d9e$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3e3033a14238d9e$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3e3033a14238d9e$var$queue = [];
var $d3e3033a14238d9e$var$draining = false;
var $d3e3033a14238d9e$var$currentQueue;
var $d3e3033a14238d9e$var$queueIndex = -1;
function $d3e3033a14238d9e$var$cleanUpNextTick() {
    if (!$d3e3033a14238d9e$var$draining || !$d3e3033a14238d9e$var$currentQueue) return;
    $d3e3033a14238d9e$var$draining = false;
    if ($d3e3033a14238d9e$var$currentQueue.length) $d3e3033a14238d9e$var$queue = $d3e3033a14238d9e$var$currentQueue.concat($d3e3033a14238d9e$var$queue);
    else $d3e3033a14238d9e$var$queueIndex = -1;
    if ($d3e3033a14238d9e$var$queue.length) $d3e3033a14238d9e$var$drainQueue();
}
function $d3e3033a14238d9e$var$drainQueue() {
    if ($d3e3033a14238d9e$var$draining) return;
    var timeout = $d3e3033a14238d9e$var$runTimeout($d3e3033a14238d9e$var$cleanUpNextTick);
    $d3e3033a14238d9e$var$draining = true;
    var len = $d3e3033a14238d9e$var$queue.length;
    while(len){
        $d3e3033a14238d9e$var$currentQueue = $d3e3033a14238d9e$var$queue;
        $d3e3033a14238d9e$var$queue = [];
        while(++$d3e3033a14238d9e$var$queueIndex < len)if ($d3e3033a14238d9e$var$currentQueue) $d3e3033a14238d9e$var$currentQueue[$d3e3033a14238d9e$var$queueIndex].run();
        $d3e3033a14238d9e$var$queueIndex = -1;
        len = $d3e3033a14238d9e$var$queue.length;
    }
    $d3e3033a14238d9e$var$currentQueue = null;
    $d3e3033a14238d9e$var$draining = false;
    $d3e3033a14238d9e$var$runClearTimeout(timeout);
}
$d3e3033a14238d9e$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3e3033a14238d9e$var$queue.push(new $d3e3033a14238d9e$var$Item(fun, args));
    if ($d3e3033a14238d9e$var$queue.length === 1 && !$d3e3033a14238d9e$var$draining) $d3e3033a14238d9e$var$runTimeout($d3e3033a14238d9e$var$drainQueue);
};
// v8 likes predictible objects
function $d3e3033a14238d9e$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3e3033a14238d9e$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3e3033a14238d9e$var$process.title = 'browser';
$d3e3033a14238d9e$var$process.browser = true;
$d3e3033a14238d9e$var$process.env = {};
$d3e3033a14238d9e$var$process.argv = [];
$d3e3033a14238d9e$var$process.version = ''; // empty string to avoid regexp issues
$d3e3033a14238d9e$var$process.versions = {};
function $d3e3033a14238d9e$var$noop() {}
$d3e3033a14238d9e$var$process.on = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.addListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.once = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.off = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.removeListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.removeAllListeners = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.emit = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.prependListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.prependOnceListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.listeners = function(name) {
    return [];
};
$d3e3033a14238d9e$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d3e3033a14238d9e$var$process.cwd = function() {
    return '/';
};
$d3e3033a14238d9e$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d3e3033a14238d9e$var$process.umask = function() {
    return 0;
};

});



parcelRegister("gd2PY", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $bcd00faefdd4b5d7$export$882461b6382ed46c; }, function (v) { return $bcd00faefdd4b5d7$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $bcd00faefdd4b5d7$export$757ceba2d55c277e; }, function (v) { return $bcd00faefdd4b5d7$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $bcd00faefdd4b5d7$export$83d89fbfd8236492; }, function (v) { return $bcd00faefdd4b5d7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $YtE9h = parcelRequire("YtE9h");
var $bcd00faefdd4b5d7$export$882461b6382ed46c;
var $bcd00faefdd4b5d7$export$757ceba2d55c277e;
var $bcd00faefdd4b5d7$export$83d89fbfd8236492;

var $ibRPI = parcelRequire("ibRPI");
"use strict";

var $go0bk = parcelRequire("go0bk");

var $fIwXP = parcelRequire("fIwXP");

var $9F3H4 = parcelRequire("9F3H4");
function $bcd00faefdd4b5d7$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $bcd00faefdd4b5d7$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $bcd00faefdd4b5d7$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $bcd00faefdd4b5d7$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $bcd00faefdd4b5d7$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $bcd00faefdd4b5d7$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $bcd00faefdd4b5d7$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $bcd00faefdd4b5d7$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $bcd00faefdd4b5d7$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $bcd00faefdd4b5d7$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $bcd00faefdd4b5d7$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $bcd00faefdd4b5d7$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $bcd00faefdd4b5d7$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $bcd00faefdd4b5d7$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $bcd00faefdd4b5d7$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $bcd00faefdd4b5d7$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $bcd00faefdd4b5d7$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $bcd00faefdd4b5d7$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== (typeof maybeIterable === "undefined" ? "undefined" : (0, $YtE9h._)(maybeIterable))) return null;
    maybeIterable = $bcd00faefdd4b5d7$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$bcd00faefdd4b5d7$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $bcd00faefdd4b5d7$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $bcd00faefdd4b5d7$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $bcd00faefdd4b5d7$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $bcd00faefdd4b5d7$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $bcd00faefdd4b5d7$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $bcd00faefdd4b5d7$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $bcd00faefdd4b5d7$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $bcd00faefdd4b5d7$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $bcd00faefdd4b5d7$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === (typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type))) switch(type.$$typeof){
        case $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $bcd00faefdd4b5d7$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $bcd00faefdd4b5d7$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $bcd00faefdd4b5d7$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $bcd00faefdd4b5d7$var$getComponentNameFromType(type.type) || "Memo";
        case $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $bcd00faefdd4b5d7$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $bcd00faefdd4b5d7$var$ReactSharedInternals = $fIwXP.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $bcd00faefdd4b5d7$var$assign = Object.assign, $bcd00faefdd4b5d7$var$prefix, $bcd00faefdd4b5d7$var$suffix;
function $bcd00faefdd4b5d7$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $bcd00faefdd4b5d7$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $bcd00faefdd4b5d7$var$prefix = match && match[1] || "";
        $bcd00faefdd4b5d7$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $bcd00faefdd4b5d7$var$prefix + name + $bcd00faefdd4b5d7$var$suffix;
}
var $bcd00faefdd4b5d7$var$reentry = !1;
function $bcd00faefdd4b5d7$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $bcd00faefdd4b5d7$var$reentry) return "";
    $bcd00faefdd4b5d7$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function DetermineComponentFrameRoot() {
                try {
                    if (construct) {
                        var Fake = function Fake() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function set() {
                                throw Error();
                            }
                        });
                        if ("object" === (typeof Reflect === "undefined" ? "undefined" : (0, $YtE9h._)(Reflect)) && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $bcd00faefdd4b5d7$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $bcd00faefdd4b5d7$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $bcd00faefdd4b5d7$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $bcd00faefdd4b5d7$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $bcd00faefdd4b5d7$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $bcd00faefdd4b5d7$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $bcd00faefdd4b5d7$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $bcd00faefdd4b5d7$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $bcd00faefdd4b5d7$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $bcd00faefdd4b5d7$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $bcd00faefdd4b5d7$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $bcd00faefdd4b5d7$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $bcd00faefdd4b5d7$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $bcd00faefdd4b5d7$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $bcd00faefdd4b5d7$var$assertIsMounted(fiber) {
    if ($bcd00faefdd4b5d7$var$getNearestMountedFiber(fiber) !== fiber) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(188));
}
function $bcd00faefdd4b5d7$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $bcd00faefdd4b5d7$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $bcd00faefdd4b5d7$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $bcd00faefdd4b5d7$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $bcd00faefdd4b5d7$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $bcd00faefdd4b5d7$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $bcd00faefdd4b5d7$var$isArrayImpl = Array.isArray, $bcd00faefdd4b5d7$var$ReactDOMSharedInternals = $9F3H4.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $bcd00faefdd4b5d7$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $bcd00faefdd4b5d7$var$valueStack = [], $bcd00faefdd4b5d7$var$index = -1;
function $bcd00faefdd4b5d7$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $bcd00faefdd4b5d7$var$pop(cursor) {
    0 > $bcd00faefdd4b5d7$var$index || (cursor.current = $bcd00faefdd4b5d7$var$valueStack[$bcd00faefdd4b5d7$var$index], $bcd00faefdd4b5d7$var$valueStack[$bcd00faefdd4b5d7$var$index] = null, $bcd00faefdd4b5d7$var$index--);
}
function $bcd00faefdd4b5d7$var$push(cursor, value) {
    $bcd00faefdd4b5d7$var$index++;
    $bcd00faefdd4b5d7$var$valueStack[$bcd00faefdd4b5d7$var$index] = cursor.current;
    cursor.current = value;
}
var $bcd00faefdd4b5d7$var$contextStackCursor = $bcd00faefdd4b5d7$var$createCursor(null), $bcd00faefdd4b5d7$var$contextFiberStackCursor = $bcd00faefdd4b5d7$var$createCursor(null), $bcd00faefdd4b5d7$var$rootInstanceStackCursor = $bcd00faefdd4b5d7$var$createCursor(null), $bcd00faefdd4b5d7$var$hostTransitionProviderCursor = $bcd00faefdd4b5d7$var$createCursor(null);
function $bcd00faefdd4b5d7$var$pushHostContainer(fiber, nextRootInstance) {
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$rootInstanceStackCursor, nextRootInstance);
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$contextFiberStackCursor, fiber);
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $bcd00faefdd4b5d7$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $bcd00faefdd4b5d7$var$getOwnHostContext(fiber), nextRootInstance = $bcd00faefdd4b5d7$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$contextStackCursor);
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$contextStackCursor, nextRootInstance);
}
function $bcd00faefdd4b5d7$var$popHostContainer() {
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$contextStackCursor);
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$contextFiberStackCursor);
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$rootInstanceStackCursor);
}
function $bcd00faefdd4b5d7$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$hostTransitionProviderCursor, fiber);
    var context = $bcd00faefdd4b5d7$var$contextStackCursor.current;
    var JSCompiler_inline_result = $bcd00faefdd4b5d7$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$contextFiberStackCursor, fiber), $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$contextStackCursor, JSCompiler_inline_result));
}
function $bcd00faefdd4b5d7$var$popHostContext(fiber) {
    $bcd00faefdd4b5d7$var$contextFiberStackCursor.current === fiber && ($bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$contextStackCursor), $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$contextFiberStackCursor));
    $bcd00faefdd4b5d7$var$hostTransitionProviderCursor.current === fiber && ($bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$hostTransitionProviderCursor), $bcd00faefdd4b5d7$var$HostTransitionContext._currentValue = $bcd00faefdd4b5d7$var$sharedNotPendingObject);
}
var $bcd00faefdd4b5d7$var$hasOwnProperty = Object.prototype.hasOwnProperty, $bcd00faefdd4b5d7$var$scheduleCallback$3 = $go0bk.unstable_scheduleCallback, $bcd00faefdd4b5d7$var$cancelCallback$1 = $go0bk.unstable_cancelCallback, $bcd00faefdd4b5d7$var$shouldYield = $go0bk.unstable_shouldYield, $bcd00faefdd4b5d7$var$requestPaint = $go0bk.unstable_requestPaint, $bcd00faefdd4b5d7$var$now = $go0bk.unstable_now, $bcd00faefdd4b5d7$var$getCurrentPriorityLevel = $go0bk.unstable_getCurrentPriorityLevel, $bcd00faefdd4b5d7$var$ImmediatePriority = $go0bk.unstable_ImmediatePriority, $bcd00faefdd4b5d7$var$UserBlockingPriority = $go0bk.unstable_UserBlockingPriority, $bcd00faefdd4b5d7$var$NormalPriority$1 = $go0bk.unstable_NormalPriority, $bcd00faefdd4b5d7$var$LowPriority = $go0bk.unstable_LowPriority, $bcd00faefdd4b5d7$var$IdlePriority = $go0bk.unstable_IdlePriority, $bcd00faefdd4b5d7$var$log$1 = $go0bk.log, $bcd00faefdd4b5d7$var$unstable_setDisableYieldValue = $go0bk.unstable_setDisableYieldValue, $bcd00faefdd4b5d7$var$rendererID = null, $bcd00faefdd4b5d7$var$injectedHook = null;
function $bcd00faefdd4b5d7$var$onCommitRoot(root) {
    if ($bcd00faefdd4b5d7$var$injectedHook && "function" === typeof $bcd00faefdd4b5d7$var$injectedHook.onCommitFiberRoot) try {
        $bcd00faefdd4b5d7$var$injectedHook.onCommitFiberRoot($bcd00faefdd4b5d7$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $bcd00faefdd4b5d7$var$log$1 && $bcd00faefdd4b5d7$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($bcd00faefdd4b5d7$var$injectedHook && "function" === typeof $bcd00faefdd4b5d7$var$injectedHook.setStrictMode) try {
        $bcd00faefdd4b5d7$var$injectedHook.setStrictMode($bcd00faefdd4b5d7$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $bcd00faefdd4b5d7$var$clz32 = Math.clz32 ? Math.clz32 : $bcd00faefdd4b5d7$var$clz32Fallback, $bcd00faefdd4b5d7$var$log = Math.log, $bcd00faefdd4b5d7$var$LN2 = Math.LN2;
function $bcd00faefdd4b5d7$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($bcd00faefdd4b5d7$var$log(x) / $bcd00faefdd4b5d7$var$LN2 | 0) | 0;
}
var $bcd00faefdd4b5d7$var$nextTransitionLane = 128, $bcd00faefdd4b5d7$var$nextRetryLane = 4194304;
function $bcd00faefdd4b5d7$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $bcd00faefdd4b5d7$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $bcd00faefdd4b5d7$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $bcd00faefdd4b5d7$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $bcd00faefdd4b5d7$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $bcd00faefdd4b5d7$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $bcd00faefdd4b5d7$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $bcd00faefdd4b5d7$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $bcd00faefdd4b5d7$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $bcd00faefdd4b5d7$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $bcd00faefdd4b5d7$var$claimNextTransitionLane() {
    var lane = $bcd00faefdd4b5d7$var$nextTransitionLane;
    $bcd00faefdd4b5d7$var$nextTransitionLane <<= 1;
    0 === ($bcd00faefdd4b5d7$var$nextTransitionLane & 4194176) && ($bcd00faefdd4b5d7$var$nextTransitionLane = 128);
    return lane;
}
function $bcd00faefdd4b5d7$var$claimNextRetryLane() {
    var lane = $bcd00faefdd4b5d7$var$nextRetryLane;
    $bcd00faefdd4b5d7$var$nextRetryLane <<= 1;
    0 === ($bcd00faefdd4b5d7$var$nextRetryLane & 62914560) && ($bcd00faefdd4b5d7$var$nextRetryLane = 4194304);
    return lane;
}
function $bcd00faefdd4b5d7$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $bcd00faefdd4b5d7$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $bcd00faefdd4b5d7$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $bcd00faefdd4b5d7$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $bcd00faefdd4b5d7$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $bcd00faefdd4b5d7$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $bcd00faefdd4b5d7$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $bcd00faefdd4b5d7$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $bcd00faefdd4b5d7$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $bcd00faefdd4b5d7$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $bcd00faefdd4b5d7$var$resolveUpdatePriority() {
    var updatePriority = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $bcd00faefdd4b5d7$var$getEventPriority(updatePriority.type);
}
function $bcd00faefdd4b5d7$var$runWithPriority(priority, fn) {
    var previousPriority = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p;
    try {
        return $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $bcd00faefdd4b5d7$var$randomKey = Math.random().toString(36).slice(2), $bcd00faefdd4b5d7$var$internalInstanceKey = "__reactFiber$" + $bcd00faefdd4b5d7$var$randomKey, $bcd00faefdd4b5d7$var$internalPropsKey = "__reactProps$" + $bcd00faefdd4b5d7$var$randomKey, $bcd00faefdd4b5d7$var$internalContainerInstanceKey = "__reactContainer$" + $bcd00faefdd4b5d7$var$randomKey, $bcd00faefdd4b5d7$var$internalEventHandlersKey = "__reactEvents$" + $bcd00faefdd4b5d7$var$randomKey, $bcd00faefdd4b5d7$var$internalEventHandlerListenersKey = "__reactListeners$" + $bcd00faefdd4b5d7$var$randomKey, $bcd00faefdd4b5d7$var$internalEventHandlesSetKey = "__reactHandles$" + $bcd00faefdd4b5d7$var$randomKey, $bcd00faefdd4b5d7$var$internalRootNodeResourcesKey = "__reactResources$" + $bcd00faefdd4b5d7$var$randomKey, $bcd00faefdd4b5d7$var$internalHoistableMarker = "__reactMarker$" + $bcd00faefdd4b5d7$var$randomKey;
function $bcd00faefdd4b5d7$var$detachDeletedInstance(node) {
    delete node[$bcd00faefdd4b5d7$var$internalInstanceKey];
    delete node[$bcd00faefdd4b5d7$var$internalPropsKey];
    delete node[$bcd00faefdd4b5d7$var$internalEventHandlersKey];
    delete node[$bcd00faefdd4b5d7$var$internalEventHandlerListenersKey];
    delete node[$bcd00faefdd4b5d7$var$internalEventHandlesSetKey];
}
function $bcd00faefdd4b5d7$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$bcd00faefdd4b5d7$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$bcd00faefdd4b5d7$var$internalContainerInstanceKey] || parentNode[$bcd00faefdd4b5d7$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $bcd00faefdd4b5d7$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$bcd00faefdd4b5d7$var$internalInstanceKey]) return parentNode;
                targetNode = $bcd00faefdd4b5d7$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $bcd00faefdd4b5d7$var$getInstanceFromNode(node) {
    if (node = node[$bcd00faefdd4b5d7$var$internalInstanceKey] || node[$bcd00faefdd4b5d7$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $bcd00faefdd4b5d7$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(33));
}
function $bcd00faefdd4b5d7$var$getResourcesFromRoot(root) {
    var resources = root[$bcd00faefdd4b5d7$var$internalRootNodeResourcesKey];
    resources || (resources = root[$bcd00faefdd4b5d7$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $bcd00faefdd4b5d7$var$markNodeAsHoistable(node) {
    node[$bcd00faefdd4b5d7$var$internalHoistableMarker] = !0;
}
var $bcd00faefdd4b5d7$var$allNativeEvents = new Set(), $bcd00faefdd4b5d7$var$registrationNameDependencies = {};
function $bcd00faefdd4b5d7$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $bcd00faefdd4b5d7$var$registerDirectEvent(registrationName, dependencies);
    $bcd00faefdd4b5d7$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $bcd00faefdd4b5d7$var$registerDirectEvent(registrationName, dependencies) {
    $bcd00faefdd4b5d7$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$bcd00faefdd4b5d7$var$allNativeEvents.add(dependencies[registrationName]);
}
var $bcd00faefdd4b5d7$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $bcd00faefdd4b5d7$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $bcd00faefdd4b5d7$var$illegalAttributeNameCache = {}, $bcd00faefdd4b5d7$var$validatedAttributeNameCache = {};
function $bcd00faefdd4b5d7$var$isAttributeNameSafe(attributeName) {
    if ($bcd00faefdd4b5d7$var$hasOwnProperty.call($bcd00faefdd4b5d7$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($bcd00faefdd4b5d7$var$hasOwnProperty.call($bcd00faefdd4b5d7$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($bcd00faefdd4b5d7$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $bcd00faefdd4b5d7$var$validatedAttributeNameCache[attributeName] = !0;
    $bcd00faefdd4b5d7$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $bcd00faefdd4b5d7$var$setValueForAttribute(node, name, value) {
    if ($bcd00faefdd4b5d7$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $bcd00faefdd4b5d7$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $bcd00faefdd4b5d7$var$getToStringValue(value) {
    switch(typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $bcd00faefdd4b5d7$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $bcd00faefdd4b5d7$var$trackValueOnNode(node) {
    var valueField = $bcd00faefdd4b5d7$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function get1() {
                return get.call(this);
            },
            set: function set1(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function getValue() {
                return currentValue;
            },
            setValue: function setValue(value) {
                currentValue = "" + value;
            },
            stopTracking: function stopTracking() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $bcd00faefdd4b5d7$var$track(node) {
    node._valueTracker || (node._valueTracker = $bcd00faefdd4b5d7$var$trackValueOnNode(node));
}
function $bcd00faefdd4b5d7$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $bcd00faefdd4b5d7$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $bcd00faefdd4b5d7$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $bcd00faefdd4b5d7$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== (typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type)) && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $bcd00faefdd4b5d7$var$getToStringValue(value);
        } else element.value !== "" + $bcd00faefdd4b5d7$var$getToStringValue(value) && (element.value = "" + $bcd00faefdd4b5d7$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $bcd00faefdd4b5d7$var$setDefaultValue(element, type, $bcd00faefdd4b5d7$var$getToStringValue(value)) : null != defaultValue ? $bcd00faefdd4b5d7$var$setDefaultValue(element, type, $bcd00faefdd4b5d7$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== (typeof checked === "undefined" ? "undefined" : (0, $YtE9h._)(checked)));
    null != name && "function" !== typeof name && "symbol" !== (typeof name === "undefined" ? "undefined" : (0, $YtE9h._)(name)) && "boolean" !== typeof name ? element.name = "" + $bcd00faefdd4b5d7$var$getToStringValue(name) : element.removeAttribute("name");
}
function $bcd00faefdd4b5d7$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== (typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type)) && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $bcd00faefdd4b5d7$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $bcd00faefdd4b5d7$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== (typeof checked === "undefined" ? "undefined" : (0, $YtE9h._)(checked)) && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== (typeof name === "undefined" ? "undefined" : (0, $YtE9h._)(name)) && "boolean" !== typeof name && (element.name = name);
}
function $bcd00faefdd4b5d7$var$setDefaultValue(node, type, value) {
    "number" === type && $bcd00faefdd4b5d7$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $bcd00faefdd4b5d7$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $bcd00faefdd4b5d7$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $bcd00faefdd4b5d7$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $bcd00faefdd4b5d7$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $bcd00faefdd4b5d7$var$getToStringValue(defaultValue) : "";
}
function $bcd00faefdd4b5d7$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(92));
            if ($bcd00faefdd4b5d7$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $bcd00faefdd4b5d7$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $bcd00faefdd4b5d7$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $bcd00faefdd4b5d7$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $bcd00faefdd4b5d7$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $bcd00faefdd4b5d7$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $bcd00faefdd4b5d7$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== (typeof styles === "undefined" ? "undefined" : (0, $YtE9h._)(styles))) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $bcd00faefdd4b5d7$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $bcd00faefdd4b5d7$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $bcd00faefdd4b5d7$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $bcd00faefdd4b5d7$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $bcd00faefdd4b5d7$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $bcd00faefdd4b5d7$var$sanitizeURL(url) {
    return $bcd00faefdd4b5d7$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $bcd00faefdd4b5d7$var$currentReplayingEvent = null;
function $bcd00faefdd4b5d7$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $bcd00faefdd4b5d7$var$restoreTarget = null, $bcd00faefdd4b5d7$var$restoreQueue = null;
function $bcd00faefdd4b5d7$var$restoreStateOfTarget(target) {
    var internalInstance = $bcd00faefdd4b5d7$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$bcd00faefdd4b5d7$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $bcd00faefdd4b5d7$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$bcd00faefdd4b5d7$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(90));
                            $bcd00faefdd4b5d7$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $bcd00faefdd4b5d7$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $bcd00faefdd4b5d7$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $bcd00faefdd4b5d7$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $bcd00faefdd4b5d7$var$isInsideEventHandler = !1;
function $bcd00faefdd4b5d7$var$batchedUpdates$1(fn, a, b) {
    if ($bcd00faefdd4b5d7$var$isInsideEventHandler) return fn(a, b);
    $bcd00faefdd4b5d7$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($bcd00faefdd4b5d7$var$isInsideEventHandler = !1, null !== $bcd00faefdd4b5d7$var$restoreTarget || null !== $bcd00faefdd4b5d7$var$restoreQueue) {
            if ($bcd00faefdd4b5d7$var$flushSyncWork$1(), $bcd00faefdd4b5d7$var$restoreTarget && (a = $bcd00faefdd4b5d7$var$restoreTarget, fn = $bcd00faefdd4b5d7$var$restoreQueue, $bcd00faefdd4b5d7$var$restoreQueue = $bcd00faefdd4b5d7$var$restoreTarget = null, $bcd00faefdd4b5d7$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$bcd00faefdd4b5d7$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $bcd00faefdd4b5d7$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$bcd00faefdd4b5d7$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(231, registrationName, typeof stateNode === "undefined" ? "undefined" : (0, $YtE9h._)(stateNode)));
    return stateNode;
}
var $bcd00faefdd4b5d7$var$passiveBrowserEventsSupported = !1;
if ($bcd00faefdd4b5d7$var$canUseDOM) try {
    var $bcd00faefdd4b5d7$var$options = {};
    Object.defineProperty($bcd00faefdd4b5d7$var$options, "passive", {
        get: function get() {
            $bcd00faefdd4b5d7$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $bcd00faefdd4b5d7$var$options, $bcd00faefdd4b5d7$var$options);
    window.removeEventListener("test", $bcd00faefdd4b5d7$var$options, $bcd00faefdd4b5d7$var$options);
} catch (e) {
    $bcd00faefdd4b5d7$var$passiveBrowserEventsSupported = !1;
}
var $bcd00faefdd4b5d7$var$root = null, $bcd00faefdd4b5d7$var$startText = null, $bcd00faefdd4b5d7$var$fallbackText = null;
function $bcd00faefdd4b5d7$var$getData() {
    if ($bcd00faefdd4b5d7$var$fallbackText) return $bcd00faefdd4b5d7$var$fallbackText;
    var start, startValue = $bcd00faefdd4b5d7$var$startText, startLength = startValue.length, end, endValue = "value" in $bcd00faefdd4b5d7$var$root ? $bcd00faefdd4b5d7$var$root.value : $bcd00faefdd4b5d7$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $bcd00faefdd4b5d7$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $bcd00faefdd4b5d7$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $bcd00faefdd4b5d7$var$functionThatReturnsTrue() {
    return !0;
}
function $bcd00faefdd4b5d7$var$functionThatReturnsFalse() {
    return !1;
}
function $bcd00faefdd4b5d7$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $bcd00faefdd4b5d7$var$functionThatReturnsTrue : $bcd00faefdd4b5d7$var$functionThatReturnsFalse;
        this.isPropagationStopped = $bcd00faefdd4b5d7$var$functionThatReturnsFalse;
        return this;
    }
    $bcd00faefdd4b5d7$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== (0, $YtE9h._)(event.returnValue) && (event.returnValue = !1), this.isDefaultPrevented = $bcd00faefdd4b5d7$var$functionThatReturnsTrue);
        },
        stopPropagation: function stopPropagation() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== (0, $YtE9h._)(event.cancelBubble) && (event.cancelBubble = !0), this.isPropagationStopped = $bcd00faefdd4b5d7$var$functionThatReturnsTrue);
        },
        persist: function persist() {},
        isPersistent: $bcd00faefdd4b5d7$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $bcd00faefdd4b5d7$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $bcd00faefdd4b5d7$var$SyntheticEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$EventInterface), $bcd00faefdd4b5d7$var$UIEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$EventInterface, {
    view: 0,
    detail: 0
}), $bcd00faefdd4b5d7$var$SyntheticUIEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$UIEventInterface), $bcd00faefdd4b5d7$var$lastMovementX, $bcd00faefdd4b5d7$var$lastMovementY, $bcd00faefdd4b5d7$var$lastMouseEvent, $bcd00faefdd4b5d7$var$MouseEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $bcd00faefdd4b5d7$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function movementX(event) {
        if ("movementX" in event) return event.movementX;
        event !== $bcd00faefdd4b5d7$var$lastMouseEvent && ($bcd00faefdd4b5d7$var$lastMouseEvent && "mousemove" === event.type ? ($bcd00faefdd4b5d7$var$lastMovementX = event.screenX - $bcd00faefdd4b5d7$var$lastMouseEvent.screenX, $bcd00faefdd4b5d7$var$lastMovementY = event.screenY - $bcd00faefdd4b5d7$var$lastMouseEvent.screenY) : $bcd00faefdd4b5d7$var$lastMovementY = $bcd00faefdd4b5d7$var$lastMovementX = 0, $bcd00faefdd4b5d7$var$lastMouseEvent = event);
        return $bcd00faefdd4b5d7$var$lastMovementX;
    },
    movementY: function movementY(event) {
        return "movementY" in event ? event.movementY : $bcd00faefdd4b5d7$var$lastMovementY;
    }
}), $bcd00faefdd4b5d7$var$SyntheticMouseEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$MouseEventInterface), $bcd00faefdd4b5d7$var$DragEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$MouseEventInterface, {
    dataTransfer: 0
}), $bcd00faefdd4b5d7$var$SyntheticDragEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$DragEventInterface), $bcd00faefdd4b5d7$var$FocusEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$UIEventInterface, {
    relatedTarget: 0
}), $bcd00faefdd4b5d7$var$SyntheticFocusEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$FocusEventInterface), $bcd00faefdd4b5d7$var$AnimationEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bcd00faefdd4b5d7$var$SyntheticAnimationEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$AnimationEventInterface), $bcd00faefdd4b5d7$var$ClipboardEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$EventInterface, {
    clipboardData: function clipboardData(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $bcd00faefdd4b5d7$var$SyntheticClipboardEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$ClipboardEventInterface), $bcd00faefdd4b5d7$var$CompositionEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$EventInterface, {
    data: 0
}), $bcd00faefdd4b5d7$var$SyntheticCompositionEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$CompositionEventInterface), $bcd00faefdd4b5d7$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $bcd00faefdd4b5d7$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $bcd00faefdd4b5d7$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $bcd00faefdd4b5d7$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $bcd00faefdd4b5d7$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $bcd00faefdd4b5d7$var$getEventModifierState() {
    return $bcd00faefdd4b5d7$var$modifierStateGetter;
}
var $bcd00faefdd4b5d7$var$KeyboardEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$UIEventInterface, {
    key: function key(nativeEvent) {
        if (nativeEvent.key) {
            var key = $bcd00faefdd4b5d7$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $bcd00faefdd4b5d7$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $bcd00faefdd4b5d7$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $bcd00faefdd4b5d7$var$getEventModifierState,
    charCode: function charCode(event) {
        return "keypress" === event.type ? $bcd00faefdd4b5d7$var$getEventCharCode(event) : 0;
    },
    keyCode: function keyCode(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function which(event) {
        return "keypress" === event.type ? $bcd00faefdd4b5d7$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $bcd00faefdd4b5d7$var$SyntheticKeyboardEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$KeyboardEventInterface), $bcd00faefdd4b5d7$var$PointerEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $bcd00faefdd4b5d7$var$SyntheticPointerEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$PointerEventInterface), $bcd00faefdd4b5d7$var$TouchEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $bcd00faefdd4b5d7$var$getEventModifierState
}), $bcd00faefdd4b5d7$var$SyntheticTouchEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$TouchEventInterface), $bcd00faefdd4b5d7$var$TransitionEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $bcd00faefdd4b5d7$var$SyntheticTransitionEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$TransitionEventInterface), $bcd00faefdd4b5d7$var$WheelEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$MouseEventInterface, {
    deltaX: function deltaX(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function deltaY(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $bcd00faefdd4b5d7$var$SyntheticWheelEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$WheelEventInterface), $bcd00faefdd4b5d7$var$ToggleEventInterface = $bcd00faefdd4b5d7$var$assign({}, $bcd00faefdd4b5d7$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $bcd00faefdd4b5d7$var$SyntheticToggleEvent = $bcd00faefdd4b5d7$var$createSyntheticEvent($bcd00faefdd4b5d7$var$ToggleEventInterface), $bcd00faefdd4b5d7$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $bcd00faefdd4b5d7$var$canUseCompositionEvent = $bcd00faefdd4b5d7$var$canUseDOM && "CompositionEvent" in window, $bcd00faefdd4b5d7$var$documentMode = null;
$bcd00faefdd4b5d7$var$canUseDOM && "documentMode" in document && ($bcd00faefdd4b5d7$var$documentMode = document.documentMode);
var $bcd00faefdd4b5d7$var$canUseTextInputEvent = $bcd00faefdd4b5d7$var$canUseDOM && "TextEvent" in window && !$bcd00faefdd4b5d7$var$documentMode, $bcd00faefdd4b5d7$var$useFallbackCompositionData = $bcd00faefdd4b5d7$var$canUseDOM && (!$bcd00faefdd4b5d7$var$canUseCompositionEvent || $bcd00faefdd4b5d7$var$documentMode && 8 < $bcd00faefdd4b5d7$var$documentMode && 11 >= $bcd00faefdd4b5d7$var$documentMode), $bcd00faefdd4b5d7$var$SPACEBAR_CHAR = String.fromCharCode(32), $bcd00faefdd4b5d7$var$hasSpaceKeypress = !1;
function $bcd00faefdd4b5d7$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $bcd00faefdd4b5d7$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $bcd00faefdd4b5d7$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === (typeof nativeEvent === "undefined" ? "undefined" : (0, $YtE9h._)(nativeEvent)) && "data" in nativeEvent ? nativeEvent.data : null;
}
var $bcd00faefdd4b5d7$var$isComposing = !1;
function $bcd00faefdd4b5d7$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $bcd00faefdd4b5d7$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $bcd00faefdd4b5d7$var$hasSpaceKeypress = !0;
            return $bcd00faefdd4b5d7$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $bcd00faefdd4b5d7$var$SPACEBAR_CHAR && $bcd00faefdd4b5d7$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $bcd00faefdd4b5d7$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($bcd00faefdd4b5d7$var$isComposing) return "compositionend" === domEventName || !$bcd00faefdd4b5d7$var$canUseCompositionEvent && $bcd00faefdd4b5d7$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $bcd00faefdd4b5d7$var$getData(), $bcd00faefdd4b5d7$var$fallbackText = $bcd00faefdd4b5d7$var$startText = $bcd00faefdd4b5d7$var$root = null, $bcd00faefdd4b5d7$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $bcd00faefdd4b5d7$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $bcd00faefdd4b5d7$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $bcd00faefdd4b5d7$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$bcd00faefdd4b5d7$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $bcd00faefdd4b5d7$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $bcd00faefdd4b5d7$var$restoreTarget ? $bcd00faefdd4b5d7$var$restoreQueue ? $bcd00faefdd4b5d7$var$restoreQueue.push(target) : $bcd00faefdd4b5d7$var$restoreQueue = [
        target
    ] : $bcd00faefdd4b5d7$var$restoreTarget = target;
    inst = $bcd00faefdd4b5d7$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $bcd00faefdd4b5d7$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $bcd00faefdd4b5d7$var$activeElement$1 = null, $bcd00faefdd4b5d7$var$activeElementInst$1 = null;
function $bcd00faefdd4b5d7$var$runEventInBatch(dispatchQueue) {
    $bcd00faefdd4b5d7$var$processDispatchQueue(dispatchQueue, 0);
}
function $bcd00faefdd4b5d7$var$getInstIfValueChanged(targetInst) {
    var targetNode = $bcd00faefdd4b5d7$var$getNodeFromInstance(targetInst);
    if ($bcd00faefdd4b5d7$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $bcd00faefdd4b5d7$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $bcd00faefdd4b5d7$var$isInputEventSupported = !1;
if ($bcd00faefdd4b5d7$var$canUseDOM) {
    var $bcd00faefdd4b5d7$var$JSCompiler_inline_result$jscomp$283;
    if ($bcd00faefdd4b5d7$var$canUseDOM) {
        var $bcd00faefdd4b5d7$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$bcd00faefdd4b5d7$var$isSupported$jscomp$inline_418) {
            var $bcd00faefdd4b5d7$var$element$jscomp$inline_419 = document.createElement("div");
            $bcd00faefdd4b5d7$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $bcd00faefdd4b5d7$var$isSupported$jscomp$inline_418 = "function" === typeof $bcd00faefdd4b5d7$var$element$jscomp$inline_419.oninput;
        }
        $bcd00faefdd4b5d7$var$JSCompiler_inline_result$jscomp$283 = $bcd00faefdd4b5d7$var$isSupported$jscomp$inline_418;
    } else $bcd00faefdd4b5d7$var$JSCompiler_inline_result$jscomp$283 = !1;
    $bcd00faefdd4b5d7$var$isInputEventSupported = $bcd00faefdd4b5d7$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $bcd00faefdd4b5d7$var$stopWatchingForValueChange() {
    $bcd00faefdd4b5d7$var$activeElement$1 && ($bcd00faefdd4b5d7$var$activeElement$1.detachEvent("onpropertychange", $bcd00faefdd4b5d7$var$handlePropertyChange), $bcd00faefdd4b5d7$var$activeElementInst$1 = $bcd00faefdd4b5d7$var$activeElement$1 = null);
}
function $bcd00faefdd4b5d7$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $bcd00faefdd4b5d7$var$getInstIfValueChanged($bcd00faefdd4b5d7$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $bcd00faefdd4b5d7$var$createAndAccumulateChangeEvent(dispatchQueue, $bcd00faefdd4b5d7$var$activeElementInst$1, nativeEvent, $bcd00faefdd4b5d7$var$getEventTarget(nativeEvent));
        $bcd00faefdd4b5d7$var$batchedUpdates$1($bcd00faefdd4b5d7$var$runEventInBatch, dispatchQueue);
    }
}
function $bcd00faefdd4b5d7$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($bcd00faefdd4b5d7$var$stopWatchingForValueChange(), $bcd00faefdd4b5d7$var$activeElement$1 = target, $bcd00faefdd4b5d7$var$activeElementInst$1 = targetInst, $bcd00faefdd4b5d7$var$activeElement$1.attachEvent("onpropertychange", $bcd00faefdd4b5d7$var$handlePropertyChange)) : "focusout" === domEventName && $bcd00faefdd4b5d7$var$stopWatchingForValueChange();
}
function $bcd00faefdd4b5d7$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $bcd00faefdd4b5d7$var$getInstIfValueChanged($bcd00faefdd4b5d7$var$activeElementInst$1);
}
function $bcd00faefdd4b5d7$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $bcd00faefdd4b5d7$var$getInstIfValueChanged(targetInst);
}
function $bcd00faefdd4b5d7$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $bcd00faefdd4b5d7$var$getInstIfValueChanged(targetInst);
}
function $bcd00faefdd4b5d7$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $bcd00faefdd4b5d7$var$objectIs = "function" === typeof Object.is ? Object.is : $bcd00faefdd4b5d7$var$is;
function $bcd00faefdd4b5d7$var$shallowEqual(objA, objB) {
    if ($bcd00faefdd4b5d7$var$objectIs(objA, objB)) return !0;
    if ("object" !== (typeof objA === "undefined" ? "undefined" : (0, $YtE9h._)(objA)) || null === objA || "object" !== (typeof objB === "undefined" ? "undefined" : (0, $YtE9h._)(objB)) || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$bcd00faefdd4b5d7$var$hasOwnProperty.call(objB, currentKey) || !$bcd00faefdd4b5d7$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $bcd00faefdd4b5d7$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $bcd00faefdd4b5d7$var$getNodeForCharacterOffset(root, offset) {
    var node = $bcd00faefdd4b5d7$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $bcd00faefdd4b5d7$var$getLeafNode(node);
    }
}
function $bcd00faefdd4b5d7$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $bcd00faefdd4b5d7$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $bcd00faefdd4b5d7$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $bcd00faefdd4b5d7$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $bcd00faefdd4b5d7$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $bcd00faefdd4b5d7$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $bcd00faefdd4b5d7$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $bcd00faefdd4b5d7$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $bcd00faefdd4b5d7$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $bcd00faefdd4b5d7$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $bcd00faefdd4b5d7$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $bcd00faefdd4b5d7$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $bcd00faefdd4b5d7$var$skipSelectionChangeEvent = $bcd00faefdd4b5d7$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $bcd00faefdd4b5d7$var$activeElement = null, $bcd00faefdd4b5d7$var$activeElementInst = null, $bcd00faefdd4b5d7$var$lastSelection = null, $bcd00faefdd4b5d7$var$mouseDown = !1;
function $bcd00faefdd4b5d7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $bcd00faefdd4b5d7$var$mouseDown || null == $bcd00faefdd4b5d7$var$activeElement || $bcd00faefdd4b5d7$var$activeElement !== $bcd00faefdd4b5d7$var$getActiveElement(doc) || (doc = $bcd00faefdd4b5d7$var$activeElement, "selectionStart" in doc && $bcd00faefdd4b5d7$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $bcd00faefdd4b5d7$var$lastSelection && $bcd00faefdd4b5d7$var$shallowEqual($bcd00faefdd4b5d7$var$lastSelection, doc) || ($bcd00faefdd4b5d7$var$lastSelection = doc, doc = $bcd00faefdd4b5d7$var$accumulateTwoPhaseListeners($bcd00faefdd4b5d7$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $bcd00faefdd4b5d7$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $bcd00faefdd4b5d7$var$activeElement)));
}
function $bcd00faefdd4b5d7$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $bcd00faefdd4b5d7$var$vendorPrefixes = {
    animationend: $bcd00faefdd4b5d7$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $bcd00faefdd4b5d7$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $bcd00faefdd4b5d7$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $bcd00faefdd4b5d7$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $bcd00faefdd4b5d7$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $bcd00faefdd4b5d7$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $bcd00faefdd4b5d7$var$makePrefixMap("Transition", "TransitionEnd")
}, $bcd00faefdd4b5d7$var$prefixedEventNames = {}, $bcd00faefdd4b5d7$var$style = {};
$bcd00faefdd4b5d7$var$canUseDOM && ($bcd00faefdd4b5d7$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $bcd00faefdd4b5d7$var$vendorPrefixes.animationend.animation, delete $bcd00faefdd4b5d7$var$vendorPrefixes.animationiteration.animation, delete $bcd00faefdd4b5d7$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $bcd00faefdd4b5d7$var$vendorPrefixes.transitionend.transition);
function $bcd00faefdd4b5d7$var$getVendorPrefixedEventName(eventName) {
    if ($bcd00faefdd4b5d7$var$prefixedEventNames[eventName]) return $bcd00faefdd4b5d7$var$prefixedEventNames[eventName];
    if (!$bcd00faefdd4b5d7$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $bcd00faefdd4b5d7$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $bcd00faefdd4b5d7$var$style) return $bcd00faefdd4b5d7$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $bcd00faefdd4b5d7$var$ANIMATION_END = $bcd00faefdd4b5d7$var$getVendorPrefixedEventName("animationend"), $bcd00faefdd4b5d7$var$ANIMATION_ITERATION = $bcd00faefdd4b5d7$var$getVendorPrefixedEventName("animationiteration"), $bcd00faefdd4b5d7$var$ANIMATION_START = $bcd00faefdd4b5d7$var$getVendorPrefixedEventName("animationstart"), $bcd00faefdd4b5d7$var$TRANSITION_RUN = $bcd00faefdd4b5d7$var$getVendorPrefixedEventName("transitionrun"), $bcd00faefdd4b5d7$var$TRANSITION_START = $bcd00faefdd4b5d7$var$getVendorPrefixedEventName("transitionstart"), $bcd00faefdd4b5d7$var$TRANSITION_CANCEL = $bcd00faefdd4b5d7$var$getVendorPrefixedEventName("transitioncancel"), $bcd00faefdd4b5d7$var$TRANSITION_END = $bcd00faefdd4b5d7$var$getVendorPrefixedEventName("transitionend"), $bcd00faefdd4b5d7$var$topLevelEventsToReactNames = new Map(), $bcd00faefdd4b5d7$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $bcd00faefdd4b5d7$var$registerSimpleEvent(domEventName, reactName) {
    $bcd00faefdd4b5d7$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $bcd00faefdd4b5d7$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $bcd00faefdd4b5d7$var$concurrentQueues = [], $bcd00faefdd4b5d7$var$concurrentQueuesIndex = 0, $bcd00faefdd4b5d7$var$concurrentlyUpdatedLanes = 0;
function $bcd00faefdd4b5d7$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $bcd00faefdd4b5d7$var$concurrentQueuesIndex, i = $bcd00faefdd4b5d7$var$concurrentlyUpdatedLanes = $bcd00faefdd4b5d7$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $bcd00faefdd4b5d7$var$concurrentQueues[i];
        $bcd00faefdd4b5d7$var$concurrentQueues[i++] = null;
        var queue = $bcd00faefdd4b5d7$var$concurrentQueues[i];
        $bcd00faefdd4b5d7$var$concurrentQueues[i++] = null;
        var update = $bcd00faefdd4b5d7$var$concurrentQueues[i];
        $bcd00faefdd4b5d7$var$concurrentQueues[i++] = null;
        var lane = $bcd00faefdd4b5d7$var$concurrentQueues[i];
        $bcd00faefdd4b5d7$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $bcd00faefdd4b5d7$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $bcd00faefdd4b5d7$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $bcd00faefdd4b5d7$var$concurrentQueues[$bcd00faefdd4b5d7$var$concurrentQueuesIndex++] = fiber;
    $bcd00faefdd4b5d7$var$concurrentQueues[$bcd00faefdd4b5d7$var$concurrentQueuesIndex++] = queue;
    $bcd00faefdd4b5d7$var$concurrentQueues[$bcd00faefdd4b5d7$var$concurrentQueuesIndex++] = update;
    $bcd00faefdd4b5d7$var$concurrentQueues[$bcd00faefdd4b5d7$var$concurrentQueuesIndex++] = lane;
    $bcd00faefdd4b5d7$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $bcd00faefdd4b5d7$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $bcd00faefdd4b5d7$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $bcd00faefdd4b5d7$var$getRootForUpdatedFiber(fiber);
}
function $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $bcd00faefdd4b5d7$var$enqueueUpdate$1(fiber, null, null, lane);
    return $bcd00faefdd4b5d7$var$getRootForUpdatedFiber(fiber);
}
function $bcd00faefdd4b5d7$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $bcd00faefdd4b5d7$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $bcd00faefdd4b5d7$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $bcd00faefdd4b5d7$var$nestedUpdateCount) throw $bcd00faefdd4b5d7$var$nestedUpdateCount = 0, $bcd00faefdd4b5d7$var$rootWithNestedUpdates = null, Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $bcd00faefdd4b5d7$var$emptyContextObject = {}, $bcd00faefdd4b5d7$var$CapturedStacks = new WeakMap();
function $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(value, source) {
    if ("object" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) && null !== value) {
        var existing = $bcd00faefdd4b5d7$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $bcd00faefdd4b5d7$var$getStackByFiberInDevAndProd(source)
        };
        $bcd00faefdd4b5d7$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $bcd00faefdd4b5d7$var$getStackByFiberInDevAndProd(source)
    };
}
var $bcd00faefdd4b5d7$var$forkStack = [], $bcd00faefdd4b5d7$var$forkStackIndex = 0, $bcd00faefdd4b5d7$var$treeForkProvider = null, $bcd00faefdd4b5d7$var$treeForkCount = 0, $bcd00faefdd4b5d7$var$idStack = [], $bcd00faefdd4b5d7$var$idStackIndex = 0, $bcd00faefdd4b5d7$var$treeContextProvider = null, $bcd00faefdd4b5d7$var$treeContextId = 1, $bcd00faefdd4b5d7$var$treeContextOverflow = "";
function $bcd00faefdd4b5d7$var$pushTreeFork(workInProgress, totalChildren) {
    $bcd00faefdd4b5d7$var$forkStack[$bcd00faefdd4b5d7$var$forkStackIndex++] = $bcd00faefdd4b5d7$var$treeForkCount;
    $bcd00faefdd4b5d7$var$forkStack[$bcd00faefdd4b5d7$var$forkStackIndex++] = $bcd00faefdd4b5d7$var$treeForkProvider;
    $bcd00faefdd4b5d7$var$treeForkProvider = workInProgress;
    $bcd00faefdd4b5d7$var$treeForkCount = totalChildren;
}
function $bcd00faefdd4b5d7$var$pushTreeId(workInProgress, totalChildren, index) {
    $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex++] = $bcd00faefdd4b5d7$var$treeContextId;
    $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex++] = $bcd00faefdd4b5d7$var$treeContextOverflow;
    $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex++] = $bcd00faefdd4b5d7$var$treeContextProvider;
    $bcd00faefdd4b5d7$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $bcd00faefdd4b5d7$var$treeContextId;
    workInProgress = $bcd00faefdd4b5d7$var$treeContextOverflow;
    var baseLength = 32 - $bcd00faefdd4b5d7$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $bcd00faefdd4b5d7$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $bcd00faefdd4b5d7$var$treeContextId = 1 << 32 - $bcd00faefdd4b5d7$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $bcd00faefdd4b5d7$var$treeContextOverflow = length + workInProgress;
    } else $bcd00faefdd4b5d7$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $bcd00faefdd4b5d7$var$treeContextOverflow = workInProgress;
}
function $bcd00faefdd4b5d7$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($bcd00faefdd4b5d7$var$pushTreeFork(workInProgress, 1), $bcd00faefdd4b5d7$var$pushTreeId(workInProgress, 1, 0));
}
function $bcd00faefdd4b5d7$var$popTreeContext(workInProgress) {
    for(; workInProgress === $bcd00faefdd4b5d7$var$treeForkProvider;)$bcd00faefdd4b5d7$var$treeForkProvider = $bcd00faefdd4b5d7$var$forkStack[--$bcd00faefdd4b5d7$var$forkStackIndex], $bcd00faefdd4b5d7$var$forkStack[$bcd00faefdd4b5d7$var$forkStackIndex] = null, $bcd00faefdd4b5d7$var$treeForkCount = $bcd00faefdd4b5d7$var$forkStack[--$bcd00faefdd4b5d7$var$forkStackIndex], $bcd00faefdd4b5d7$var$forkStack[$bcd00faefdd4b5d7$var$forkStackIndex] = null;
    for(; workInProgress === $bcd00faefdd4b5d7$var$treeContextProvider;)$bcd00faefdd4b5d7$var$treeContextProvider = $bcd00faefdd4b5d7$var$idStack[--$bcd00faefdd4b5d7$var$idStackIndex], $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex] = null, $bcd00faefdd4b5d7$var$treeContextOverflow = $bcd00faefdd4b5d7$var$idStack[--$bcd00faefdd4b5d7$var$idStackIndex], $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex] = null, $bcd00faefdd4b5d7$var$treeContextId = $bcd00faefdd4b5d7$var$idStack[--$bcd00faefdd4b5d7$var$idStackIndex], $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex] = null;
}
var $bcd00faefdd4b5d7$var$hydrationParentFiber = null, $bcd00faefdd4b5d7$var$nextHydratableInstance = null, $bcd00faefdd4b5d7$var$isHydrating = !1, $bcd00faefdd4b5d7$var$hydrationErrors = null, $bcd00faefdd4b5d7$var$rootOrSingletonContext = !1, $bcd00faefdd4b5d7$var$HydrationMismatchException = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(519));
function $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(fiber) {
    var error = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(418, ""));
    $bcd00faefdd4b5d7$var$queueHydrationError($bcd00faefdd4b5d7$var$createCapturedValueAtFiber(error, fiber));
    throw $bcd00faefdd4b5d7$var$HydrationMismatchException;
}
function $bcd00faefdd4b5d7$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$bcd00faefdd4b5d7$var$internalInstanceKey] = fiber;
    instance[$bcd00faefdd4b5d7$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("cancel", instance);
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $bcd00faefdd4b5d7$var$mediaEventTypes.length; type++)$bcd00faefdd4b5d7$var$listenToNonDelegatedEvent($bcd00faefdd4b5d7$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("error", instance);
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("invalid", instance);
            $bcd00faefdd4b5d7$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $bcd00faefdd4b5d7$var$track(instance);
            break;
        case "select":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("invalid", instance), $bcd00faefdd4b5d7$var$initTextarea(instance, props.value, props.defaultValue, props.children), $bcd00faefdd4b5d7$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== (typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type)) || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $bcd00faefdd4b5d7$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("beforetoggle", instance), $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $bcd00faefdd4b5d7$var$noop$1), instance = !0) : instance = !1;
    instance || $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(fiber);
}
function $bcd00faefdd4b5d7$var$popToNextHostParent(fiber) {
    for($bcd00faefdd4b5d7$var$hydrationParentFiber = fiber.return; $bcd00faefdd4b5d7$var$hydrationParentFiber;)switch($bcd00faefdd4b5d7$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $bcd00faefdd4b5d7$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $bcd00faefdd4b5d7$var$rootOrSingletonContext = !1;
            return;
        default:
            $bcd00faefdd4b5d7$var$hydrationParentFiber = $bcd00faefdd4b5d7$var$hydrationParentFiber.return;
    }
}
function $bcd00faefdd4b5d7$var$popHydrationState(fiber) {
    if (fiber !== $bcd00faefdd4b5d7$var$hydrationParentFiber) return !1;
    if (!$bcd00faefdd4b5d7$var$isHydrating) return $bcd00faefdd4b5d7$var$popToNextHostParent(fiber), $bcd00faefdd4b5d7$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $bcd00faefdd4b5d7$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $bcd00faefdd4b5d7$var$nextHydratableInstance && $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(fiber);
    $bcd00faefdd4b5d7$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $bcd00faefdd4b5d7$var$nextHydratableInstance = null;
        }
    } else $bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$hydrationParentFiber ? $bcd00faefdd4b5d7$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $bcd00faefdd4b5d7$var$resetHydrationState() {
    $bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$hydrationParentFiber = null;
    $bcd00faefdd4b5d7$var$isHydrating = !1;
}
function $bcd00faefdd4b5d7$var$queueHydrationError(error) {
    null === $bcd00faefdd4b5d7$var$hydrationErrors ? $bcd00faefdd4b5d7$var$hydrationErrors = [
        error
    ] : $bcd00faefdd4b5d7$var$hydrationErrors.push(error);
}
var $bcd00faefdd4b5d7$var$SuspenseException = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(460)), $bcd00faefdd4b5d7$var$SuspenseyCommitException = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(474)), $bcd00faefdd4b5d7$var$noopSuspenseyCommitThenable = {
    then: function then() {}
};
function $bcd00faefdd4b5d7$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $bcd00faefdd4b5d7$var$noop$3() {}
function $bcd00faefdd4b5d7$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($bcd00faefdd4b5d7$var$noop$3, $bcd00faefdd4b5d7$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $bcd00faefdd4b5d7$var$SuspenseException) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($bcd00faefdd4b5d7$var$noop$3, $bcd00faefdd4b5d7$var$noop$3);
            else {
                thenableState = $bcd00faefdd4b5d7$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $bcd00faefdd4b5d7$var$SuspenseException) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $bcd00faefdd4b5d7$var$suspendedThenable = thenable;
            throw $bcd00faefdd4b5d7$var$SuspenseException;
    }
}
var $bcd00faefdd4b5d7$var$suspendedThenable = null;
function $bcd00faefdd4b5d7$var$getSuspendedThenable() {
    if (null === $bcd00faefdd4b5d7$var$suspendedThenable) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(459));
    var thenable = $bcd00faefdd4b5d7$var$suspendedThenable;
    $bcd00faefdd4b5d7$var$suspendedThenable = null;
    return thenable;
}
var $bcd00faefdd4b5d7$var$thenableState$1 = null, $bcd00faefdd4b5d7$var$thenableIndexCounter$1 = 0;
function $bcd00faefdd4b5d7$var$unwrapThenable(thenable) {
    var index = $bcd00faefdd4b5d7$var$thenableIndexCounter$1;
    $bcd00faefdd4b5d7$var$thenableIndexCounter$1 += 1;
    null === $bcd00faefdd4b5d7$var$thenableState$1 && ($bcd00faefdd4b5d7$var$thenableState$1 = []);
    return $bcd00faefdd4b5d7$var$trackUsedThenable($bcd00faefdd4b5d7$var$thenableState$1, thenable, index);
}
function $bcd00faefdd4b5d7$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $bcd00faefdd4b5d7$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $bcd00faefdd4b5d7$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $bcd00faefdd4b5d7$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $bcd00faefdd4b5d7$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $bcd00faefdd4b5d7$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $bcd00faefdd4b5d7$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $bcd00faefdd4b5d7$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === (typeof elementType === "undefined" ? "undefined" : (0, $YtE9h._)(elementType)) && null !== elementType && elementType.$$typeof === $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE && $bcd00faefdd4b5d7$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $bcd00faefdd4b5d7$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $bcd00faefdd4b5d7$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $bcd00faefdd4b5d7$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $bcd00faefdd4b5d7$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $bcd00faefdd4b5d7$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild))) return newChild = $bcd00faefdd4b5d7$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $bcd00faefdd4b5d7$var$REACT_ELEMENT_TYPE:
                    return lanes = $bcd00faefdd4b5d7$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $bcd00faefdd4b5d7$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $bcd00faefdd4b5d7$var$REACT_PORTAL_TYPE:
                    return newChild = $bcd00faefdd4b5d7$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($bcd00faefdd4b5d7$var$isArrayImpl(newChild) || $bcd00faefdd4b5d7$var$getIteratorFn(newChild)) return newChild = $bcd00faefdd4b5d7$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $bcd00faefdd4b5d7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $bcd00faefdd4b5d7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $bcd00faefdd4b5d7$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild))) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $bcd00faefdd4b5d7$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $bcd00faefdd4b5d7$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($bcd00faefdd4b5d7$var$isArrayImpl(newChild) || $bcd00faefdd4b5d7$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $bcd00faefdd4b5d7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $bcd00faefdd4b5d7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $bcd00faefdd4b5d7$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild))) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $bcd00faefdd4b5d7$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $bcd00faefdd4b5d7$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($bcd00faefdd4b5d7$var$isArrayImpl(newChild) || $bcd00faefdd4b5d7$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $bcd00faefdd4b5d7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $bcd00faefdd4b5d7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $bcd00faefdd4b5d7$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $bcd00faefdd4b5d7$var$isHydrating && $bcd00faefdd4b5d7$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $bcd00faefdd4b5d7$var$isHydrating && $bcd00faefdd4b5d7$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $bcd00faefdd4b5d7$var$isHydrating && $bcd00faefdd4b5d7$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $bcd00faefdd4b5d7$var$isHydrating && $bcd00faefdd4b5d7$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $bcd00faefdd4b5d7$var$isHydrating && $bcd00faefdd4b5d7$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $bcd00faefdd4b5d7$var$isHydrating && $bcd00faefdd4b5d7$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild)) && null !== newChild && newChild.type === $bcd00faefdd4b5d7$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $bcd00faefdd4b5d7$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $bcd00faefdd4b5d7$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === (typeof key === "undefined" ? "undefined" : (0, $YtE9h._)(key)) && null !== key && key.$$typeof === $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE && $bcd00faefdd4b5d7$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $bcd00faefdd4b5d7$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $bcd00faefdd4b5d7$var$REACT_FRAGMENT_TYPE ? (lanes = $bcd00faefdd4b5d7$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $bcd00faefdd4b5d7$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $bcd00faefdd4b5d7$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $bcd00faefdd4b5d7$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $bcd00faefdd4b5d7$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($bcd00faefdd4b5d7$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($bcd00faefdd4b5d7$var$getIteratorFn(newChild)) {
                key = $bcd00faefdd4b5d7$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $bcd00faefdd4b5d7$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $bcd00faefdd4b5d7$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $bcd00faefdd4b5d7$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $YtE9h._)(newChild)) ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $bcd00faefdd4b5d7$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $bcd00faefdd4b5d7$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $bcd00faefdd4b5d7$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $bcd00faefdd4b5d7$var$SuspenseException) throw x;
            var fiber = $bcd00faefdd4b5d7$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $bcd00faefdd4b5d7$var$reconcileChildFibers = $bcd00faefdd4b5d7$var$createChildReconciler(!0), $bcd00faefdd4b5d7$var$mountChildFibers = $bcd00faefdd4b5d7$var$createChildReconciler(!1), $bcd00faefdd4b5d7$var$currentTreeHiddenStackCursor = $bcd00faefdd4b5d7$var$createCursor(null), $bcd00faefdd4b5d7$var$prevEntangledRenderLanesCursor = $bcd00faefdd4b5d7$var$createCursor(0);
function $bcd00faefdd4b5d7$var$pushHiddenContext(fiber, context) {
    fiber = $bcd00faefdd4b5d7$var$entangledRenderLanes;
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$prevEntangledRenderLanesCursor, fiber);
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$currentTreeHiddenStackCursor, context);
    $bcd00faefdd4b5d7$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $bcd00faefdd4b5d7$var$reuseHiddenContextOnStack() {
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$prevEntangledRenderLanesCursor, $bcd00faefdd4b5d7$var$entangledRenderLanes);
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$currentTreeHiddenStackCursor, $bcd00faefdd4b5d7$var$currentTreeHiddenStackCursor.current);
}
function $bcd00faefdd4b5d7$var$popHiddenContext() {
    $bcd00faefdd4b5d7$var$entangledRenderLanes = $bcd00faefdd4b5d7$var$prevEntangledRenderLanesCursor.current;
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$currentTreeHiddenStackCursor);
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$prevEntangledRenderLanesCursor);
}
var $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor = $bcd00faefdd4b5d7$var$createCursor(null), $bcd00faefdd4b5d7$var$shellBoundary = null;
function $bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseStackCursor, $bcd00faefdd4b5d7$var$suspenseStackCursor.current & 1);
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseHandlerStackCursor, handler);
    null === $bcd00faefdd4b5d7$var$shellBoundary && (null === current || null !== $bcd00faefdd4b5d7$var$currentTreeHiddenStackCursor.current ? $bcd00faefdd4b5d7$var$shellBoundary = handler : null !== current.memoizedState && ($bcd00faefdd4b5d7$var$shellBoundary = handler));
}
function $bcd00faefdd4b5d7$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseStackCursor, $bcd00faefdd4b5d7$var$suspenseStackCursor.current), $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseHandlerStackCursor, fiber), null === $bcd00faefdd4b5d7$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($bcd00faefdd4b5d7$var$shellBoundary = fiber);
        }
    } else $bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(fiber);
}
function $bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack() {
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseStackCursor, $bcd00faefdd4b5d7$var$suspenseStackCursor.current);
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseHandlerStackCursor, $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current);
}
function $bcd00faefdd4b5d7$var$popSuspenseHandler(fiber) {
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$suspenseHandlerStackCursor);
    $bcd00faefdd4b5d7$var$shellBoundary === fiber && ($bcd00faefdd4b5d7$var$shellBoundary = null);
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$suspenseStackCursor);
}
var $bcd00faefdd4b5d7$var$suspenseStackCursor = $bcd00faefdd4b5d7$var$createCursor(0);
function $bcd00faefdd4b5d7$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $bcd00faefdd4b5d7$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function AbortControllerLocal() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function addEventListener(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $bcd00faefdd4b5d7$var$scheduleCallback$2 = $go0bk.unstable_scheduleCallback, $bcd00faefdd4b5d7$var$NormalPriority = $go0bk.unstable_NormalPriority, $bcd00faefdd4b5d7$var$CacheContext = {
    $$typeof: $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $bcd00faefdd4b5d7$var$createCache() {
    return {
        controller: new $bcd00faefdd4b5d7$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $bcd00faefdd4b5d7$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $bcd00faefdd4b5d7$var$scheduleCallback$2($bcd00faefdd4b5d7$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $bcd00faefdd4b5d7$var$currentEntangledListeners = null, $bcd00faefdd4b5d7$var$currentEntangledPendingCount = 0, $bcd00faefdd4b5d7$var$currentEntangledLane = 0, $bcd00faefdd4b5d7$var$currentEntangledActionThenable = null;
function $bcd00faefdd4b5d7$var$entangleAsyncAction(transition, thenable) {
    if (null === $bcd00faefdd4b5d7$var$currentEntangledListeners) {
        var entangledListeners = $bcd00faefdd4b5d7$var$currentEntangledListeners = [];
        $bcd00faefdd4b5d7$var$currentEntangledPendingCount = 0;
        $bcd00faefdd4b5d7$var$currentEntangledLane = $bcd00faefdd4b5d7$var$requestTransitionLane();
        $bcd00faefdd4b5d7$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function then(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $bcd00faefdd4b5d7$var$currentEntangledPendingCount++;
    thenable.then($bcd00faefdd4b5d7$var$pingEngtangledActionScope, $bcd00faefdd4b5d7$var$pingEngtangledActionScope);
    return thenable;
}
function $bcd00faefdd4b5d7$var$pingEngtangledActionScope() {
    if (0 === --$bcd00faefdd4b5d7$var$currentEntangledPendingCount && null !== $bcd00faefdd4b5d7$var$currentEntangledListeners) {
        null !== $bcd00faefdd4b5d7$var$currentEntangledActionThenable && ($bcd00faefdd4b5d7$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $bcd00faefdd4b5d7$var$currentEntangledListeners;
        $bcd00faefdd4b5d7$var$currentEntangledListeners = null;
        $bcd00faefdd4b5d7$var$currentEntangledLane = 0;
        $bcd00faefdd4b5d7$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $bcd00faefdd4b5d7$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function then(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $bcd00faefdd4b5d7$var$prevOnStartTransitionFinish = $bcd00faefdd4b5d7$var$ReactSharedInternals.S;
$bcd00faefdd4b5d7$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $YtE9h._)(returnValue)) && null !== returnValue && "function" === typeof returnValue.then && $bcd00faefdd4b5d7$var$entangleAsyncAction(transition, returnValue);
    null !== $bcd00faefdd4b5d7$var$prevOnStartTransitionFinish && $bcd00faefdd4b5d7$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $bcd00faefdd4b5d7$var$resumedCache = $bcd00faefdd4b5d7$var$createCursor(null);
function $bcd00faefdd4b5d7$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $bcd00faefdd4b5d7$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $bcd00faefdd4b5d7$var$workInProgressRoot.pooledCache;
}
function $bcd00faefdd4b5d7$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$resumedCache, $bcd00faefdd4b5d7$var$resumedCache.current) : $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$resumedCache, prevCachePool.pool);
}
function $bcd00faefdd4b5d7$var$getSuspendedCache() {
    var cacheFromPool = $bcd00faefdd4b5d7$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $bcd00faefdd4b5d7$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $bcd00faefdd4b5d7$var$renderLanes = 0, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1 = null, $bcd00faefdd4b5d7$var$currentHook = null, $bcd00faefdd4b5d7$var$workInProgressHook = null, $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdate = !1, $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $bcd00faefdd4b5d7$var$localIdCounter = 0, $bcd00faefdd4b5d7$var$thenableIndexCounter = 0, $bcd00faefdd4b5d7$var$thenableState = null, $bcd00faefdd4b5d7$var$globalClientIdCounter = 0;
function $bcd00faefdd4b5d7$var$throwInvalidHookError() {
    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(321));
}
function $bcd00faefdd4b5d7$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$bcd00faefdd4b5d7$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $bcd00faefdd4b5d7$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $bcd00faefdd4b5d7$var$renderLanes = nextRenderLanes;
    $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $bcd00faefdd4b5d7$var$HooksDispatcherOnMount : $bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate;
    $bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $bcd00faefdd4b5d7$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $bcd00faefdd4b5d7$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $bcd00faefdd4b5d7$var$finishRenderingHooks(current) {
    $bcd00faefdd4b5d7$var$ReactSharedInternals.H = $bcd00faefdd4b5d7$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $bcd00faefdd4b5d7$var$currentHook && null !== $bcd00faefdd4b5d7$var$currentHook.next;
    $bcd00faefdd4b5d7$var$renderLanes = 0;
    $bcd00faefdd4b5d7$var$workInProgressHook = $bcd00faefdd4b5d7$var$currentHook = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1 = null;
    $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdate = !1;
    $bcd00faefdd4b5d7$var$thenableIndexCounter = 0;
    $bcd00faefdd4b5d7$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(300));
    null === current || $bcd00faefdd4b5d7$var$didReceiveUpdate || (current = current.dependencies, null !== current && $bcd00faefdd4b5d7$var$checkIfContextChanged(current) && ($bcd00faefdd4b5d7$var$didReceiveUpdate = !0));
}
function $bcd00faefdd4b5d7$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdateDuringThisPass && ($bcd00faefdd4b5d7$var$thenableState = null);
        $bcd00faefdd4b5d7$var$thenableIndexCounter = 0;
        $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $bcd00faefdd4b5d7$var$workInProgressHook = $bcd00faefdd4b5d7$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $bcd00faefdd4b5d7$var$ReactSharedInternals.H = $bcd00faefdd4b5d7$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $bcd00faefdd4b5d7$var$TransitionAwareHostComponent() {
    var dispatcher = $bcd00faefdd4b5d7$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $bcd00faefdd4b5d7$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $bcd00faefdd4b5d7$var$currentHook ? $bcd00faefdd4b5d7$var$currentHook.memoizedState : null) !== dispatcher && ($bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $bcd00faefdd4b5d7$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $bcd00faefdd4b5d7$var$localIdCounter;
    $bcd00faefdd4b5d7$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $bcd00faefdd4b5d7$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $bcd00faefdd4b5d7$var$resetHooksOnUnwind(workInProgress) {
    if ($bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdate = !1;
    }
    $bcd00faefdd4b5d7$var$renderLanes = 0;
    $bcd00faefdd4b5d7$var$workInProgressHook = $bcd00faefdd4b5d7$var$currentHook = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1 = null;
    $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $bcd00faefdd4b5d7$var$thenableIndexCounter = $bcd00faefdd4b5d7$var$localIdCounter = 0;
    $bcd00faefdd4b5d7$var$thenableState = null;
}
function $bcd00faefdd4b5d7$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $bcd00faefdd4b5d7$var$workInProgressHook ? $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.memoizedState = $bcd00faefdd4b5d7$var$workInProgressHook = hook : $bcd00faefdd4b5d7$var$workInProgressHook = $bcd00faefdd4b5d7$var$workInProgressHook.next = hook;
    return $bcd00faefdd4b5d7$var$workInProgressHook;
}
function $bcd00faefdd4b5d7$var$updateWorkInProgressHook() {
    if (null === $bcd00faefdd4b5d7$var$currentHook) {
        var nextCurrentHook = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $bcd00faefdd4b5d7$var$currentHook.next;
    var nextWorkInProgressHook = null === $bcd00faefdd4b5d7$var$workInProgressHook ? $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.memoizedState : $bcd00faefdd4b5d7$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $bcd00faefdd4b5d7$var$workInProgressHook = nextWorkInProgressHook, $bcd00faefdd4b5d7$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.alternate) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(467));
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(310));
        }
        $bcd00faefdd4b5d7$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $bcd00faefdd4b5d7$var$currentHook.memoizedState,
            baseState: $bcd00faefdd4b5d7$var$currentHook.baseState,
            baseQueue: $bcd00faefdd4b5d7$var$currentHook.baseQueue,
            queue: $bcd00faefdd4b5d7$var$currentHook.queue,
            next: null
        };
        null === $bcd00faefdd4b5d7$var$workInProgressHook ? $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.memoizedState = $bcd00faefdd4b5d7$var$workInProgressHook = nextCurrentHook : $bcd00faefdd4b5d7$var$workInProgressHook = $bcd00faefdd4b5d7$var$workInProgressHook.next = nextCurrentHook;
    }
    return $bcd00faefdd4b5d7$var$workInProgressHook;
}
var $bcd00faefdd4b5d7$var$createFunctionComponentUpdateQueue;
$bcd00faefdd4b5d7$var$createFunctionComponentUpdateQueue = function createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $bcd00faefdd4b5d7$var$useThenable(thenable) {
    var index = $bcd00faefdd4b5d7$var$thenableIndexCounter;
    $bcd00faefdd4b5d7$var$thenableIndexCounter += 1;
    null === $bcd00faefdd4b5d7$var$thenableState && ($bcd00faefdd4b5d7$var$thenableState = []);
    thenable = $bcd00faefdd4b5d7$var$trackUsedThenable($bcd00faefdd4b5d7$var$thenableState, thenable, index);
    index = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1;
    null === (null === $bcd00faefdd4b5d7$var$workInProgressHook ? index.memoizedState : $bcd00faefdd4b5d7$var$workInProgressHook.next) && (index = index.alternate, $bcd00faefdd4b5d7$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $bcd00faefdd4b5d7$var$HooksDispatcherOnMount : $bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $bcd00faefdd4b5d7$var$use(usable) {
    if (null !== usable && "object" === (typeof usable === "undefined" ? "undefined" : (0, $YtE9h._)(usable))) {
        if ("function" === typeof usable.then) return $bcd00faefdd4b5d7$var$useThenable(usable);
        if (usable.$$typeof === $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE) return $bcd00faefdd4b5d7$var$readContext(usable);
    }
    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(438, String(usable)));
}
function $bcd00faefdd4b5d7$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $bcd00faefdd4b5d7$var$createFunctionComponentUpdateQueue(), $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $bcd00faefdd4b5d7$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $bcd00faefdd4b5d7$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $bcd00faefdd4b5d7$var$updateReducer(reducer) {
    var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    return $bcd00faefdd4b5d7$var$updateReducerImpl(hook, $bcd00faefdd4b5d7$var$currentHook, reducer);
}
function $bcd00faefdd4b5d7$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($bcd00faefdd4b5d7$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $bcd00faefdd4b5d7$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($bcd00faefdd4b5d7$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $bcd00faefdd4b5d7$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.lanes |= revertLane, $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.lanes |= updateLane, $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$bcd00faefdd4b5d7$var$objectIs(pendingQueue, hook.memoizedState) && ($bcd00faefdd4b5d7$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $bcd00faefdd4b5d7$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $bcd00faefdd4b5d7$var$rerenderReducer(reducer) {
    var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $bcd00faefdd4b5d7$var$objectIs(newState, hook.memoizedState) || ($bcd00faefdd4b5d7$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $bcd00faefdd4b5d7$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $bcd00faefdd4b5d7$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$bcd00faefdd4b5d7$var$objectIs(($bcd00faefdd4b5d7$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $bcd00faefdd4b5d7$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $bcd00faefdd4b5d7$var$updateEffect($bcd00faefdd4b5d7$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $bcd00faefdd4b5d7$var$workInProgressHook && $bcd00faefdd4b5d7$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $bcd00faefdd4b5d7$var$pushEffect(9, $bcd00faefdd4b5d7$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $bcd00faefdd4b5d7$var$workInProgressRoot) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($bcd00faefdd4b5d7$var$renderLanes & 60) || $bcd00faefdd4b5d7$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $bcd00faefdd4b5d7$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $bcd00faefdd4b5d7$var$createFunctionComponentUpdateQueue(), $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $bcd00faefdd4b5d7$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $bcd00faefdd4b5d7$var$checkIfSnapshotChanged(inst) && $bcd00faefdd4b5d7$var$forceStoreRerender(fiber);
}
function $bcd00faefdd4b5d7$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $bcd00faefdd4b5d7$var$checkIfSnapshotChanged(inst) && $bcd00faefdd4b5d7$var$forceStoreRerender(fiber);
    });
}
function $bcd00faefdd4b5d7$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$bcd00faefdd4b5d7$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $bcd00faefdd4b5d7$var$forceStoreRerender(fiber) {
    var root = $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $bcd00faefdd4b5d7$var$mountStateImpl(initialState) {
    var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $bcd00faefdd4b5d7$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $bcd00faefdd4b5d7$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $bcd00faefdd4b5d7$var$updateReducerImpl(hook, $bcd00faefdd4b5d7$var$currentHook, "function" === typeof reducer ? reducer : $bcd00faefdd4b5d7$var$basicStateReducer);
}
function $bcd00faefdd4b5d7$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($bcd00faefdd4b5d7$var$isRenderPhaseUpdate(fiber)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function then(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $bcd00faefdd4b5d7$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $bcd00faefdd4b5d7$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $bcd00faefdd4b5d7$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $bcd00faefdd4b5d7$var$ReactSharedInternals.T, currentTransition = {};
        $bcd00faefdd4b5d7$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $bcd00faefdd4b5d7$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $bcd00faefdd4b5d7$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $bcd00faefdd4b5d7$var$onActionError(actionQueue, node, error);
        } finally{
            $bcd00faefdd4b5d7$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $bcd00faefdd4b5d7$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $bcd00faefdd4b5d7$var$onActionError(actionQueue, node, error$60);
    }
}
function $bcd00faefdd4b5d7$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $YtE9h._)(returnValue)) && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $bcd00faefdd4b5d7$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $bcd00faefdd4b5d7$var$onActionError(actionQueue, node, error);
    }) : $bcd00faefdd4b5d7$var$onActionSuccess(actionQueue, node, returnValue);
}
function $bcd00faefdd4b5d7$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $bcd00faefdd4b5d7$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $bcd00faefdd4b5d7$var$runActionStateAction(actionQueue, nextState)));
}
function $bcd00faefdd4b5d7$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $bcd00faefdd4b5d7$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $bcd00faefdd4b5d7$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $bcd00faefdd4b5d7$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $bcd00faefdd4b5d7$var$mountActionState(action, initialStateProp) {
    if ($bcd00faefdd4b5d7$var$isHydrating) {
        var ssrFormState = $bcd00faefdd4b5d7$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1;
                if ($bcd00faefdd4b5d7$var$isHydrating) {
                    if ($bcd00faefdd4b5d7$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $bcd00faefdd4b5d7$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $bcd00faefdd4b5d7$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $bcd00faefdd4b5d7$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $bcd00faefdd4b5d7$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $bcd00faefdd4b5d7$var$dispatchSetState.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $bcd00faefdd4b5d7$var$mountStateImpl(!1);
    inRootOrSingleton = $bcd00faefdd4b5d7$var$dispatchOptimisticSetState.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $bcd00faefdd4b5d7$var$dispatchActionState.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $bcd00faefdd4b5d7$var$updateActionState(action) {
    var stateHook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    return $bcd00faefdd4b5d7$var$updateActionStateImpl(stateHook, $bcd00faefdd4b5d7$var$currentHook, action);
}
function $bcd00faefdd4b5d7$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $bcd00faefdd4b5d7$var$updateReducerImpl(stateHook, currentStateHook, $bcd00faefdd4b5d7$var$actionStateReducer)[0];
    stateHook = $bcd00faefdd4b5d7$var$updateReducer($bcd00faefdd4b5d7$var$basicStateReducer)[0];
    currentStateHook = "object" === (typeof currentStateHook === "undefined" ? "undefined" : (0, $YtE9h._)(currentStateHook)) && null !== currentStateHook && "function" === typeof currentStateHook.then ? $bcd00faefdd4b5d7$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.flags |= 2048, $bcd00faefdd4b5d7$var$pushEffect(9, $bcd00faefdd4b5d7$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $bcd00faefdd4b5d7$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $bcd00faefdd4b5d7$var$rerenderActionState(action) {
    var stateHook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook(), currentStateHook = $bcd00faefdd4b5d7$var$currentHook;
    if (null !== currentStateHook) return $bcd00faefdd4b5d7$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $bcd00faefdd4b5d7$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $bcd00faefdd4b5d7$var$createFunctionComponentUpdateQueue(), $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $bcd00faefdd4b5d7$var$updateRef() {
    return $bcd00faefdd4b5d7$var$updateWorkInProgressHook().memoizedState;
}
function $bcd00faefdd4b5d7$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
    $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $bcd00faefdd4b5d7$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $bcd00faefdd4b5d7$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $bcd00faefdd4b5d7$var$currentHook && null !== deps && $bcd00faefdd4b5d7$var$areHookInputsEqual(deps, $bcd00faefdd4b5d7$var$currentHook.memoizedState.deps) ? hook.memoizedState = $bcd00faefdd4b5d7$var$pushEffect(hookFlags, create, inst, deps) : ($bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $bcd00faefdd4b5d7$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $bcd00faefdd4b5d7$var$mountEffect(create, deps) {
    $bcd00faefdd4b5d7$var$mountEffectImpl(8390656, 8, create, deps);
}
function $bcd00faefdd4b5d7$var$updateEffect(create, deps) {
    $bcd00faefdd4b5d7$var$updateEffectImpl(2048, 8, create, deps);
}
function $bcd00faefdd4b5d7$var$updateInsertionEffect(create, deps) {
    return $bcd00faefdd4b5d7$var$updateEffectImpl(4, 2, create, deps);
}
function $bcd00faefdd4b5d7$var$updateLayoutEffect(create, deps) {
    return $bcd00faefdd4b5d7$var$updateEffectImpl(4, 4, create, deps);
}
function $bcd00faefdd4b5d7$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $bcd00faefdd4b5d7$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $bcd00faefdd4b5d7$var$updateEffectImpl(4, 4, $bcd00faefdd4b5d7$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $bcd00faefdd4b5d7$var$mountDebugValue() {}
function $bcd00faefdd4b5d7$var$updateCallback(callback, deps) {
    var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $bcd00faefdd4b5d7$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $bcd00faefdd4b5d7$var$updateMemo(nextCreate, deps) {
    var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $bcd00faefdd4b5d7$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $bcd00faefdd4b5d7$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($bcd00faefdd4b5d7$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $bcd00faefdd4b5d7$var$requestDeferredLane();
    $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.lanes |= hook;
    $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $bcd00faefdd4b5d7$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($bcd00faefdd4b5d7$var$objectIs(value, prevValue)) return value;
    if (null !== $bcd00faefdd4b5d7$var$currentTreeHiddenStackCursor.current) return hook = $bcd00faefdd4b5d7$var$mountDeferredValueImpl(hook, value, initialValue), $bcd00faefdd4b5d7$var$objectIs(hook, prevValue) || ($bcd00faefdd4b5d7$var$didReceiveUpdate = !0), hook;
    if (0 === ($bcd00faefdd4b5d7$var$renderLanes & 42)) return $bcd00faefdd4b5d7$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $bcd00faefdd4b5d7$var$requestDeferredLane();
    $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1.lanes |= hook;
    $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $bcd00faefdd4b5d7$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p;
    $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $bcd00faefdd4b5d7$var$ReactSharedInternals.T, currentTransition = {};
    $bcd00faefdd4b5d7$var$ReactSharedInternals.T = currentTransition;
    $bcd00faefdd4b5d7$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $bcd00faefdd4b5d7$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $YtE9h._)(returnValue)) && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $bcd00faefdd4b5d7$var$chainThenableValue(returnValue, finishedState);
            $bcd00faefdd4b5d7$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $bcd00faefdd4b5d7$var$requestUpdateLane(fiber));
        } else $bcd00faefdd4b5d7$var$dispatchSetStateInternal(fiber, queue, finishedState, $bcd00faefdd4b5d7$var$requestUpdateLane(fiber));
    } catch (error) {
        $bcd00faefdd4b5d7$var$dispatchSetStateInternal(fiber, queue, {
            then: function then() {},
            status: "rejected",
            reason: error
        }, $bcd00faefdd4b5d7$var$requestUpdateLane());
    } finally{
        $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = previousPriority, $bcd00faefdd4b5d7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $bcd00faefdd4b5d7$var$noop$2() {}
function $bcd00faefdd4b5d7$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(476));
    var queue = $bcd00faefdd4b5d7$var$ensureFormComponentIsStateful(formFiber).queue;
    $bcd00faefdd4b5d7$var$startTransition(formFiber, queue, pendingState, $bcd00faefdd4b5d7$var$sharedNotPendingObject, null === action ? $bcd00faefdd4b5d7$var$noop$2 : function() {
        $bcd00faefdd4b5d7$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $bcd00faefdd4b5d7$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $bcd00faefdd4b5d7$var$sharedNotPendingObject,
        baseState: $bcd00faefdd4b5d7$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $bcd00faefdd4b5d7$var$basicStateReducer,
            lastRenderedState: $bcd00faefdd4b5d7$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $bcd00faefdd4b5d7$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $bcd00faefdd4b5d7$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $bcd00faefdd4b5d7$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $bcd00faefdd4b5d7$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $bcd00faefdd4b5d7$var$requestUpdateLane());
}
function $bcd00faefdd4b5d7$var$useHostTransitionStatus() {
    return $bcd00faefdd4b5d7$var$readContext($bcd00faefdd4b5d7$var$HostTransitionContext);
}
function $bcd00faefdd4b5d7$var$updateId() {
    return $bcd00faefdd4b5d7$var$updateWorkInProgressHook().memoizedState;
}
function $bcd00faefdd4b5d7$var$updateRefresh() {
    return $bcd00faefdd4b5d7$var$updateWorkInProgressHook().memoizedState;
}
function $bcd00faefdd4b5d7$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $bcd00faefdd4b5d7$var$requestUpdateLane();
                fiber = $bcd00faefdd4b5d7$var$createUpdate(lane);
                var root$63 = $bcd00faefdd4b5d7$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root$63, provider, lane), $bcd00faefdd4b5d7$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $bcd00faefdd4b5d7$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $bcd00faefdd4b5d7$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $bcd00faefdd4b5d7$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $bcd00faefdd4b5d7$var$isRenderPhaseUpdate(fiber) ? $bcd00faefdd4b5d7$var$enqueueRenderPhaseUpdate(queue, action) : (action = $bcd00faefdd4b5d7$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(action, fiber, lane), $bcd00faefdd4b5d7$var$entangleTransitionUpdate(action, queue, lane)));
}
function $bcd00faefdd4b5d7$var$dispatchSetState(fiber, queue, action) {
    var lane = $bcd00faefdd4b5d7$var$requestUpdateLane();
    $bcd00faefdd4b5d7$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $bcd00faefdd4b5d7$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bcd00faefdd4b5d7$var$isRenderPhaseUpdate(fiber)) $bcd00faefdd4b5d7$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($bcd00faefdd4b5d7$var$objectIs(eagerState, currentState)) return $bcd00faefdd4b5d7$var$enqueueUpdate$1(fiber, queue, update, 0), null === $bcd00faefdd4b5d7$var$workInProgressRoot && $bcd00faefdd4b5d7$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $bcd00faefdd4b5d7$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(action, fiber, lane), $bcd00faefdd4b5d7$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $bcd00faefdd4b5d7$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $bcd00faefdd4b5d7$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($bcd00faefdd4b5d7$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $bcd00faefdd4b5d7$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $bcd00faefdd4b5d7$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1;
}
function $bcd00faefdd4b5d7$var$enqueueRenderPhaseUpdate(queue, update) {
    $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdateDuringThisPass = $bcd00faefdd4b5d7$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $bcd00faefdd4b5d7$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $bcd00faefdd4b5d7$var$markRootEntangled(root, lane);
    }
}
var $bcd00faefdd4b5d7$var$ContextOnlyDispatcher = {
    readContext: $bcd00faefdd4b5d7$var$readContext,
    use: $bcd00faefdd4b5d7$var$use,
    useCallback: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useContext: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useEffect: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useImperativeHandle: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useLayoutEffect: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useInsertionEffect: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useMemo: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useReducer: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useRef: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useState: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useDebugValue: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useDeferredValue: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useTransition: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useSyncExternalStore: $bcd00faefdd4b5d7$var$throwInvalidHookError,
    useId: $bcd00faefdd4b5d7$var$throwInvalidHookError
};
$bcd00faefdd4b5d7$var$ContextOnlyDispatcher.useCacheRefresh = $bcd00faefdd4b5d7$var$throwInvalidHookError;
$bcd00faefdd4b5d7$var$ContextOnlyDispatcher.useMemoCache = $bcd00faefdd4b5d7$var$throwInvalidHookError;
$bcd00faefdd4b5d7$var$ContextOnlyDispatcher.useHostTransitionStatus = $bcd00faefdd4b5d7$var$throwInvalidHookError;
$bcd00faefdd4b5d7$var$ContextOnlyDispatcher.useFormState = $bcd00faefdd4b5d7$var$throwInvalidHookError;
$bcd00faefdd4b5d7$var$ContextOnlyDispatcher.useActionState = $bcd00faefdd4b5d7$var$throwInvalidHookError;
$bcd00faefdd4b5d7$var$ContextOnlyDispatcher.useOptimistic = $bcd00faefdd4b5d7$var$throwInvalidHookError;
var $bcd00faefdd4b5d7$var$HooksDispatcherOnMount = {
    readContext: $bcd00faefdd4b5d7$var$readContext,
    use: $bcd00faefdd4b5d7$var$use,
    useCallback: function useCallback(callback, deps) {
        $bcd00faefdd4b5d7$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $bcd00faefdd4b5d7$var$readContext,
    useEffect: $bcd00faefdd4b5d7$var$mountEffect,
    useImperativeHandle: function useImperativeHandle(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $bcd00faefdd4b5d7$var$mountEffectImpl(4194308, 4, $bcd00faefdd4b5d7$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function useLayoutEffect(create, deps) {
        return $bcd00faefdd4b5d7$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function useInsertionEffect(create, deps) {
        $bcd00faefdd4b5d7$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function useMemo(nextCreate, deps) {
        var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function useReducer(reducer, initialArg, init) {
        var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($bcd00faefdd4b5d7$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $bcd00faefdd4b5d7$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $bcd00faefdd4b5d7$var$dispatchReducerAction.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function useRef(initialValue) {
        var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function useState(initialState) {
        initialState = $bcd00faefdd4b5d7$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $bcd00faefdd4b5d7$var$dispatchSetState.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $bcd00faefdd4b5d7$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
        return $bcd00faefdd4b5d7$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function useTransition() {
        var stateHook = $bcd00faefdd4b5d7$var$mountStateImpl(!1);
        stateHook = $bcd00faefdd4b5d7$var$startTransition.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $bcd00faefdd4b5d7$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
        if ($bcd00faefdd4b5d7$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $bcd00faefdd4b5d7$var$workInProgressRoot) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(349));
            0 !== ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 60) || $bcd00faefdd4b5d7$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $bcd00faefdd4b5d7$var$mountEffect($bcd00faefdd4b5d7$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $bcd00faefdd4b5d7$var$pushEffect(9, $bcd00faefdd4b5d7$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function useId() {
        var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook(), identifierPrefix = $bcd00faefdd4b5d7$var$workInProgressRoot.identifierPrefix;
        if ($bcd00faefdd4b5d7$var$isHydrating) {
            var JSCompiler_inline_result = $bcd00faefdd4b5d7$var$treeContextOverflow;
            var idWithLeadingBit = $bcd00faefdd4b5d7$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $bcd00faefdd4b5d7$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $bcd00faefdd4b5d7$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $bcd00faefdd4b5d7$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function useCacheRefresh() {
        return $bcd00faefdd4b5d7$var$mountWorkInProgressHook().memoizedState = $bcd00faefdd4b5d7$var$refreshCache.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1);
    }
};
$bcd00faefdd4b5d7$var$HooksDispatcherOnMount.useMemoCache = $bcd00faefdd4b5d7$var$useMemoCache;
$bcd00faefdd4b5d7$var$HooksDispatcherOnMount.useHostTransitionStatus = $bcd00faefdd4b5d7$var$useHostTransitionStatus;
$bcd00faefdd4b5d7$var$HooksDispatcherOnMount.useFormState = $bcd00faefdd4b5d7$var$mountActionState;
$bcd00faefdd4b5d7$var$HooksDispatcherOnMount.useActionState = $bcd00faefdd4b5d7$var$mountActionState;
$bcd00faefdd4b5d7$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $bcd00faefdd4b5d7$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $bcd00faefdd4b5d7$var$dispatchOptimisticSetState.bind(null, $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate = {
    readContext: $bcd00faefdd4b5d7$var$readContext,
    use: $bcd00faefdd4b5d7$var$use,
    useCallback: $bcd00faefdd4b5d7$var$updateCallback,
    useContext: $bcd00faefdd4b5d7$var$readContext,
    useEffect: $bcd00faefdd4b5d7$var$updateEffect,
    useImperativeHandle: $bcd00faefdd4b5d7$var$updateImperativeHandle,
    useInsertionEffect: $bcd00faefdd4b5d7$var$updateInsertionEffect,
    useLayoutEffect: $bcd00faefdd4b5d7$var$updateLayoutEffect,
    useMemo: $bcd00faefdd4b5d7$var$updateMemo,
    useReducer: $bcd00faefdd4b5d7$var$updateReducer,
    useRef: $bcd00faefdd4b5d7$var$updateRef,
    useState: function useState() {
        return $bcd00faefdd4b5d7$var$updateReducer($bcd00faefdd4b5d7$var$basicStateReducer);
    },
    useDebugValue: $bcd00faefdd4b5d7$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
        return $bcd00faefdd4b5d7$var$updateDeferredValueImpl(hook, $bcd00faefdd4b5d7$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function useTransition() {
        var booleanOrThenable = $bcd00faefdd4b5d7$var$updateReducer($bcd00faefdd4b5d7$var$basicStateReducer)[0], start = $bcd00faefdd4b5d7$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $bcd00faefdd4b5d7$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $bcd00faefdd4b5d7$var$updateSyncExternalStore,
    useId: $bcd00faefdd4b5d7$var$updateId
};
$bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate.useCacheRefresh = $bcd00faefdd4b5d7$var$updateRefresh;
$bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate.useMemoCache = $bcd00faefdd4b5d7$var$useMemoCache;
$bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $bcd00faefdd4b5d7$var$useHostTransitionStatus;
$bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate.useFormState = $bcd00faefdd4b5d7$var$updateActionState;
$bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate.useActionState = $bcd00faefdd4b5d7$var$updateActionState;
$bcd00faefdd4b5d7$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    return $bcd00faefdd4b5d7$var$updateOptimisticImpl(hook, $bcd00faefdd4b5d7$var$currentHook, passthrough, reducer);
};
var $bcd00faefdd4b5d7$var$HooksDispatcherOnRerender = {
    readContext: $bcd00faefdd4b5d7$var$readContext,
    use: $bcd00faefdd4b5d7$var$use,
    useCallback: $bcd00faefdd4b5d7$var$updateCallback,
    useContext: $bcd00faefdd4b5d7$var$readContext,
    useEffect: $bcd00faefdd4b5d7$var$updateEffect,
    useImperativeHandle: $bcd00faefdd4b5d7$var$updateImperativeHandle,
    useInsertionEffect: $bcd00faefdd4b5d7$var$updateInsertionEffect,
    useLayoutEffect: $bcd00faefdd4b5d7$var$updateLayoutEffect,
    useMemo: $bcd00faefdd4b5d7$var$updateMemo,
    useReducer: $bcd00faefdd4b5d7$var$rerenderReducer,
    useRef: $bcd00faefdd4b5d7$var$updateRef,
    useState: function useState() {
        return $bcd00faefdd4b5d7$var$rerenderReducer($bcd00faefdd4b5d7$var$basicStateReducer);
    },
    useDebugValue: $bcd00faefdd4b5d7$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
        return null === $bcd00faefdd4b5d7$var$currentHook ? $bcd00faefdd4b5d7$var$mountDeferredValueImpl(hook, value, initialValue) : $bcd00faefdd4b5d7$var$updateDeferredValueImpl(hook, $bcd00faefdd4b5d7$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function useTransition() {
        var booleanOrThenable = $bcd00faefdd4b5d7$var$rerenderReducer($bcd00faefdd4b5d7$var$basicStateReducer)[0], start = $bcd00faefdd4b5d7$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $bcd00faefdd4b5d7$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $bcd00faefdd4b5d7$var$updateSyncExternalStore,
    useId: $bcd00faefdd4b5d7$var$updateId
};
$bcd00faefdd4b5d7$var$HooksDispatcherOnRerender.useCacheRefresh = $bcd00faefdd4b5d7$var$updateRefresh;
$bcd00faefdd4b5d7$var$HooksDispatcherOnRerender.useMemoCache = $bcd00faefdd4b5d7$var$useMemoCache;
$bcd00faefdd4b5d7$var$HooksDispatcherOnRerender.useHostTransitionStatus = $bcd00faefdd4b5d7$var$useHostTransitionStatus;
$bcd00faefdd4b5d7$var$HooksDispatcherOnRerender.useFormState = $bcd00faefdd4b5d7$var$rerenderActionState;
$bcd00faefdd4b5d7$var$HooksDispatcherOnRerender.useActionState = $bcd00faefdd4b5d7$var$rerenderActionState;
$bcd00faefdd4b5d7$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $bcd00faefdd4b5d7$var$updateWorkInProgressHook();
    if (null !== $bcd00faefdd4b5d7$var$currentHook) return $bcd00faefdd4b5d7$var$updateOptimisticImpl(hook, $bcd00faefdd4b5d7$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $bcd00faefdd4b5d7$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $bcd00faefdd4b5d7$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $bcd00faefdd4b5d7$var$classComponentUpdater = {
    isMounted: function isMounted(component) {
        return (component = component._reactInternals) ? $bcd00faefdd4b5d7$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function enqueueSetState(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $bcd00faefdd4b5d7$var$requestUpdateLane(), update = $bcd00faefdd4b5d7$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $bcd00faefdd4b5d7$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(payload, inst, lane), $bcd00faefdd4b5d7$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $bcd00faefdd4b5d7$var$requestUpdateLane(), update = $bcd00faefdd4b5d7$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $bcd00faefdd4b5d7$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(payload, inst, lane), $bcd00faefdd4b5d7$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
        inst = inst._reactInternals;
        var lane = $bcd00faefdd4b5d7$var$requestUpdateLane(), update = $bcd00faefdd4b5d7$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $bcd00faefdd4b5d7$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(callback, inst, lane), $bcd00faefdd4b5d7$var$entangleTransitions(callback, inst, lane));
    }
};
function $bcd00faefdd4b5d7$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$bcd00faefdd4b5d7$var$shallowEqual(oldProps, newProps) || !$bcd00faefdd4b5d7$var$shallowEqual(oldState, newState) : !0;
}
function $bcd00faefdd4b5d7$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $bcd00faefdd4b5d7$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $bcd00faefdd4b5d7$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $bcd00faefdd4b5d7$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $bcd00faefdd4b5d7$var$reportGlobalError = "function" === typeof reportError ? reportError : function reportGlobalError(error) {
    if ("object" === (typeof window === "undefined" ? "undefined" : (0, $YtE9h._)(window)) && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === (typeof error === "undefined" ? "undefined" : (0, $YtE9h._)(error)) && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === (typeof $ibRPI === "undefined" ? "undefined" : (0, $YtE9h._)($ibRPI)) && "function" === typeof $ibRPI.emit) {
        $ibRPI.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $bcd00faefdd4b5d7$var$defaultOnUncaughtError(error) {
    $bcd00faefdd4b5d7$var$reportGlobalError(error);
}
function $bcd00faefdd4b5d7$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $bcd00faefdd4b5d7$var$defaultOnRecoverableError(error) {
    $bcd00faefdd4b5d7$var$reportGlobalError(error);
}
function $bcd00faefdd4b5d7$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $bcd00faefdd4b5d7$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $bcd00faefdd4b5d7$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $bcd00faefdd4b5d7$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $bcd00faefdd4b5d7$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $bcd00faefdd4b5d7$var$createClassErrorUpdate(lane) {
    lane = $bcd00faefdd4b5d7$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $bcd00faefdd4b5d7$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $bcd00faefdd4b5d7$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $bcd00faefdd4b5d7$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed ? $bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $bcd00faefdd4b5d7$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $bcd00faefdd4b5d7$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $bcd00faefdd4b5d7$var$shellBoundary ? $bcd00faefdd4b5d7$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $bcd00faefdd4b5d7$var$workInProgressRootExitStatus && ($bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $bcd00faefdd4b5d7$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $bcd00faefdd4b5d7$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $bcd00faefdd4b5d7$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $bcd00faefdd4b5d7$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $bcd00faefdd4b5d7$var$attachPingListener(root, value, rootRenderLanes);
        $bcd00faefdd4b5d7$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($bcd00faefdd4b5d7$var$isHydrating) return returnFiber = $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $bcd00faefdd4b5d7$var$HydrationMismatchException && (root = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(422), {
        cause: value
    }), $bcd00faefdd4b5d7$var$queueHydrationError($bcd00faefdd4b5d7$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $bcd00faefdd4b5d7$var$HydrationMismatchException && (returnFiber = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(423), {
        cause: value
    }), $bcd00faefdd4b5d7$var$queueHydrationError($bcd00faefdd4b5d7$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $bcd00faefdd4b5d7$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $bcd00faefdd4b5d7$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $bcd00faefdd4b5d7$var$workInProgressRootExitStatus && ($bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $bcd00faefdd4b5d7$var$workInProgressRootConcurrentErrors ? $bcd00faefdd4b5d7$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $bcd00faefdd4b5d7$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $bcd00faefdd4b5d7$var$workInProgressRootExitStatus && ($bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $bcd00faefdd4b5d7$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $bcd00faefdd4b5d7$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed || !$bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $bcd00faefdd4b5d7$var$createClassErrorUpdate(rootRenderLanes), $bcd00faefdd4b5d7$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $bcd00faefdd4b5d7$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $bcd00faefdd4b5d7$var$SelectiveHydrationException = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(461)), $bcd00faefdd4b5d7$var$didReceiveUpdate = !1;
function $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $bcd00faefdd4b5d7$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $bcd00faefdd4b5d7$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $bcd00faefdd4b5d7$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $bcd00faefdd4b5d7$var$prepareToReadContext(workInProgress);
    nextProps = $bcd00faefdd4b5d7$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $bcd00faefdd4b5d7$var$checkDidRenderIdHook();
    if (null !== current && !$bcd00faefdd4b5d7$var$didReceiveUpdate) return $bcd00faefdd4b5d7$var$bailoutHooks(current, workInProgress, renderLanes), $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $bcd00faefdd4b5d7$var$isHydrating && key && $bcd00faefdd4b5d7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $bcd00faefdd4b5d7$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$bcd00faefdd4b5d7$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $bcd00faefdd4b5d7$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $bcd00faefdd4b5d7$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$bcd00faefdd4b5d7$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $bcd00faefdd4b5d7$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $bcd00faefdd4b5d7$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $bcd00faefdd4b5d7$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($bcd00faefdd4b5d7$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($bcd00faefdd4b5d7$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $bcd00faefdd4b5d7$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($bcd00faefdd4b5d7$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $bcd00faefdd4b5d7$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $bcd00faefdd4b5d7$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $bcd00faefdd4b5d7$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $bcd00faefdd4b5d7$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $bcd00faefdd4b5d7$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $bcd00faefdd4b5d7$var$pushHiddenContext(workInProgress, prevState) : $bcd00faefdd4b5d7$var$reuseHiddenContextOnStack(), $bcd00faefdd4b5d7$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $bcd00faefdd4b5d7$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($bcd00faefdd4b5d7$var$pushTransition(workInProgress, prevState.cachePool), $bcd00faefdd4b5d7$var$pushHiddenContext(workInProgress, prevState), $bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $bcd00faefdd4b5d7$var$pushTransition(workInProgress, null), $bcd00faefdd4b5d7$var$reuseHiddenContextOnStack(), $bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(workInProgress));
    $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $bcd00faefdd4b5d7$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $bcd00faefdd4b5d7$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $bcd00faefdd4b5d7$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $bcd00faefdd4b5d7$var$pushTransition(workInProgress, null);
    $bcd00faefdd4b5d7$var$reuseHiddenContextOnStack();
    $bcd00faefdd4b5d7$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $bcd00faefdd4b5d7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $bcd00faefdd4b5d7$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== (typeof ref === "undefined" ? "undefined" : (0, $YtE9h._)(ref))) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $bcd00faefdd4b5d7$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $bcd00faefdd4b5d7$var$prepareToReadContext(workInProgress);
    Component = $bcd00faefdd4b5d7$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $bcd00faefdd4b5d7$var$checkDidRenderIdHook();
    if (null !== current && !$bcd00faefdd4b5d7$var$didReceiveUpdate) return $bcd00faefdd4b5d7$var$bailoutHooks(current, workInProgress, renderLanes), $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $bcd00faefdd4b5d7$var$isHydrating && nextProps && $bcd00faefdd4b5d7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $bcd00faefdd4b5d7$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $bcd00faefdd4b5d7$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $bcd00faefdd4b5d7$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $bcd00faefdd4b5d7$var$finishRenderingHooks(current);
    Component = $bcd00faefdd4b5d7$var$checkDidRenderIdHook();
    if (null !== current && !$bcd00faefdd4b5d7$var$didReceiveUpdate) return $bcd00faefdd4b5d7$var$bailoutHooks(current, workInProgress, renderLanes), $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $bcd00faefdd4b5d7$var$isHydrating && Component && $bcd00faefdd4b5d7$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $bcd00faefdd4b5d7$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $bcd00faefdd4b5d7$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $bcd00faefdd4b5d7$var$emptyContextObject, contextType = Component.contextType;
        "object" === (typeof contextType === "undefined" ? "undefined" : (0, $YtE9h._)(contextType)) && null !== contextType && (context = $bcd00faefdd4b5d7$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $bcd00faefdd4b5d7$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $bcd00faefdd4b5d7$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === (typeof contextType === "undefined" ? "undefined" : (0, $YtE9h._)(contextType)) && null !== contextType ? $bcd00faefdd4b5d7$var$readContext(contextType) : $bcd00faefdd4b5d7$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($bcd00faefdd4b5d7$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $bcd00faefdd4b5d7$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $bcd00faefdd4b5d7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $bcd00faefdd4b5d7$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $bcd00faefdd4b5d7$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $bcd00faefdd4b5d7$var$emptyContextObject;
        "object" === (typeof contextType$jscomp$0 === "undefined" ? "undefined" : (0, $YtE9h._)(contextType$jscomp$0)) && null !== contextType$jscomp$0 && (contextType = $bcd00faefdd4b5d7$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $bcd00faefdd4b5d7$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $bcd00faefdd4b5d7$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $bcd00faefdd4b5d7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $bcd00faefdd4b5d7$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $bcd00faefdd4b5d7$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($bcd00faefdd4b5d7$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $bcd00faefdd4b5d7$var$hasForceUpdate || $bcd00faefdd4b5d7$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $bcd00faefdd4b5d7$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $bcd00faefdd4b5d7$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $bcd00faefdd4b5d7$var$emptyContextObject;
        "object" === (typeof oldContext === "undefined" ? "undefined" : (0, $YtE9h._)(oldContext)) && null !== oldContext && (oldProps = $bcd00faefdd4b5d7$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $bcd00faefdd4b5d7$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $bcd00faefdd4b5d7$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $bcd00faefdd4b5d7$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $bcd00faefdd4b5d7$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $bcd00faefdd4b5d7$var$hasForceUpdate || null !== current && null !== current.dependencies && $bcd00faefdd4b5d7$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($bcd00faefdd4b5d7$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $bcd00faefdd4b5d7$var$hasForceUpdate || $bcd00faefdd4b5d7$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $bcd00faefdd4b5d7$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $bcd00faefdd4b5d7$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $bcd00faefdd4b5d7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $bcd00faefdd4b5d7$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $bcd00faefdd4b5d7$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $bcd00faefdd4b5d7$var$resetHydrationState();
    workInProgress.flags |= 256;
    $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $bcd00faefdd4b5d7$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $bcd00faefdd4b5d7$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $bcd00faefdd4b5d7$var$getSuspendedCache()
    };
}
function $bcd00faefdd4b5d7$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $bcd00faefdd4b5d7$var$workInProgressDeferredLane);
    return current;
}
function $bcd00faefdd4b5d7$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($bcd00faefdd4b5d7$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($bcd00faefdd4b5d7$var$isHydrating) {
            showFallback ? $bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($bcd00faefdd4b5d7$var$isHydrating) {
                var nextInstance = $bcd00faefdd4b5d7$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $bcd00faefdd4b5d7$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $bcd00faefdd4b5d7$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $bcd00faefdd4b5d7$var$treeContextProvider ? {
                            id: $bcd00faefdd4b5d7$var$treeContextId,
                            overflow: $bcd00faefdd4b5d7$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $bcd00faefdd4b5d7$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $bcd00faefdd4b5d7$var$hydrationParentFiber = workInProgress, $bcd00faefdd4b5d7$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $bcd00faefdd4b5d7$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $bcd00faefdd4b5d7$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $bcd00faefdd4b5d7$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $bcd00faefdd4b5d7$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $bcd00faefdd4b5d7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $bcd00faefdd4b5d7$var$SUSPENDED_MARKER, nextProps;
        $bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $bcd00faefdd4b5d7$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $bcd00faefdd4b5d7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $bcd00faefdd4b5d7$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $bcd00faefdd4b5d7$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $bcd00faefdd4b5d7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $bcd00faefdd4b5d7$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $bcd00faefdd4b5d7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $bcd00faefdd4b5d7$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $bcd00faefdd4b5d7$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $bcd00faefdd4b5d7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($bcd00faefdd4b5d7$var$didReceiveUpdate || $bcd00faefdd4b5d7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $bcd00faefdd4b5d7$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $bcd00faefdd4b5d7$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(current, nextProps), $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $bcd00faefdd4b5d7$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $bcd00faefdd4b5d7$var$renderDidSuspendDelayIfPossible();
            workInProgress = $bcd00faefdd4b5d7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $bcd00faefdd4b5d7$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$getNextHydratable(nextInstance.nextSibling), $bcd00faefdd4b5d7$var$hydrationParentFiber = workInProgress, $bcd00faefdd4b5d7$var$isHydrating = !0, $bcd00faefdd4b5d7$var$hydrationErrors = null, $bcd00faefdd4b5d7$var$rootOrSingletonContext = !1, null !== current && ($bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex++] = $bcd00faefdd4b5d7$var$treeContextId, $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex++] = $bcd00faefdd4b5d7$var$treeContextOverflow, $bcd00faefdd4b5d7$var$idStack[$bcd00faefdd4b5d7$var$idStackIndex++] = $bcd00faefdd4b5d7$var$treeContextProvider, $bcd00faefdd4b5d7$var$treeContextId = current.id, $bcd00faefdd4b5d7$var$treeContextOverflow = current.overflow, $bcd00faefdd4b5d7$var$treeContextProvider = workInProgress), workInProgress = $bcd00faefdd4b5d7$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $bcd00faefdd4b5d7$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $bcd00faefdd4b5d7$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $bcd00faefdd4b5d7$var$createWorkInProgress(digest, showFallback) : (showFallback = $bcd00faefdd4b5d7$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $bcd00faefdd4b5d7$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $bcd00faefdd4b5d7$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $bcd00faefdd4b5d7$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $bcd00faefdd4b5d7$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $bcd00faefdd4b5d7$var$SUSPENDED_MARKER, nextProps;
    $bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $bcd00faefdd4b5d7$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $bcd00faefdd4b5d7$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $bcd00faefdd4b5d7$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $bcd00faefdd4b5d7$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $bcd00faefdd4b5d7$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $bcd00faefdd4b5d7$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $bcd00faefdd4b5d7$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $bcd00faefdd4b5d7$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $bcd00faefdd4b5d7$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $bcd00faefdd4b5d7$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $bcd00faefdd4b5d7$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $bcd00faefdd4b5d7$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $bcd00faefdd4b5d7$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $bcd00faefdd4b5d7$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $bcd00faefdd4b5d7$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $bcd00faefdd4b5d7$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $bcd00faefdd4b5d7$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $bcd00faefdd4b5d7$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $bcd00faefdd4b5d7$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $bcd00faefdd4b5d7$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($bcd00faefdd4b5d7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $bcd00faefdd4b5d7$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $bcd00faefdd4b5d7$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $bcd00faefdd4b5d7$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $bcd00faefdd4b5d7$var$checkIfContextChanged(current) ? !0 : !1;
}
function $bcd00faefdd4b5d7$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $bcd00faefdd4b5d7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $bcd00faefdd4b5d7$var$pushProvider(workInProgress, $bcd00faefdd4b5d7$var$CacheContext, current.memoizedState.cache);
            $bcd00faefdd4b5d7$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $bcd00faefdd4b5d7$var$pushHostContext(workInProgress);
            break;
        case 4:
            $bcd00faefdd4b5d7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $bcd00faefdd4b5d7$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $bcd00faefdd4b5d7$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $bcd00faefdd4b5d7$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($bcd00faefdd4b5d7$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $bcd00faefdd4b5d7$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseStackCursor, $bcd00faefdd4b5d7$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $bcd00faefdd4b5d7$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $bcd00faefdd4b5d7$var$pushProvider(workInProgress, $bcd00faefdd4b5d7$var$CacheContext, current.memoizedState.cache);
    }
    return $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $bcd00faefdd4b5d7$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $bcd00faefdd4b5d7$var$didReceiveUpdate = !0;
        else {
            if (!$bcd00faefdd4b5d7$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $bcd00faefdd4b5d7$var$didReceiveUpdate = !1, $bcd00faefdd4b5d7$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $bcd00faefdd4b5d7$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $bcd00faefdd4b5d7$var$didReceiveUpdate = !1, $bcd00faefdd4b5d7$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $bcd00faefdd4b5d7$var$pushTreeId(workInProgress, $bcd00faefdd4b5d7$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $bcd00faefdd4b5d7$var$shouldConstruct(lazyComponent) ? (current = $bcd00faefdd4b5d7$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $bcd00faefdd4b5d7$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $bcd00faefdd4b5d7$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $bcd00faefdd4b5d7$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $bcd00faefdd4b5d7$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $bcd00faefdd4b5d7$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $bcd00faefdd4b5d7$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $bcd00faefdd4b5d7$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $bcd00faefdd4b5d7$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $bcd00faefdd4b5d7$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $bcd00faefdd4b5d7$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $bcd00faefdd4b5d7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $bcd00faefdd4b5d7$var$cloneUpdateQueue(current, workInProgress);
                $bcd00faefdd4b5d7$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $bcd00faefdd4b5d7$var$pushProvider(workInProgress, $bcd00faefdd4b5d7$var$CacheContext, nextProps);
                nextProps !== init.cache && $bcd00faefdd4b5d7$var$propagateContextChanges(workInProgress, [
                    $bcd00faefdd4b5d7$var$CacheContext
                ], renderLanes, !0);
                $bcd00faefdd4b5d7$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $bcd00faefdd4b5d7$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(424)), workInProgress);
                        $bcd00faefdd4b5d7$var$queueHydrationError(lazyComponent);
                        workInProgress = $bcd00faefdd4b5d7$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $bcd00faefdd4b5d7$var$hydrationParentFiber = workInProgress, $bcd00faefdd4b5d7$var$isHydrating = !0, $bcd00faefdd4b5d7$var$hydrationErrors = null, $bcd00faefdd4b5d7$var$rootOrSingletonContext = !0, renderLanes = $bcd00faefdd4b5d7$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $bcd00faefdd4b5d7$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $bcd00faefdd4b5d7$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $bcd00faefdd4b5d7$var$markRef(current, workInProgress), null === current ? (renderLanes = $bcd00faefdd4b5d7$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $bcd00faefdd4b5d7$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $bcd00faefdd4b5d7$var$getOwnerDocumentFromRootContainer($bcd00faefdd4b5d7$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$bcd00faefdd4b5d7$var$internalInstanceKey] = workInProgress, lazyComponent[$bcd00faefdd4b5d7$var$internalPropsKey] = current, $bcd00faefdd4b5d7$var$setInitialProperties(lazyComponent, renderLanes, current), $bcd00faefdd4b5d7$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $bcd00faefdd4b5d7$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $bcd00faefdd4b5d7$var$pushHostContext(workInProgress), null === current && $bcd00faefdd4b5d7$var$isHydrating && (lazyComponent = workInProgress.stateNode = $bcd00faefdd4b5d7$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $bcd00faefdd4b5d7$var$rootInstanceStackCursor.current), $bcd00faefdd4b5d7$var$hydrationParentFiber = workInProgress, $bcd00faefdd4b5d7$var$rootOrSingletonContext = !0, $bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $bcd00faefdd4b5d7$var$isHydrating ? $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $bcd00faefdd4b5d7$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $bcd00faefdd4b5d7$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $bcd00faefdd4b5d7$var$isHydrating) {
                if (init = lazyComponent = $bcd00faefdd4b5d7$var$nextHydratableInstance) lazyComponent = $bcd00faefdd4b5d7$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $bcd00faefdd4b5d7$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $bcd00faefdd4b5d7$var$hydrationParentFiber = workInProgress, $bcd00faefdd4b5d7$var$nextHydratableInstance = $bcd00faefdd4b5d7$var$getNextHydratable(lazyComponent.firstChild), $bcd00faefdd4b5d7$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(workInProgress);
            }
            $bcd00faefdd4b5d7$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $bcd00faefdd4b5d7$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $bcd00faefdd4b5d7$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $bcd00faefdd4b5d7$var$renderWithHooks(current, workInProgress, $bcd00faefdd4b5d7$var$TransitionAwareHostComponent, null, null, renderLanes), $bcd00faefdd4b5d7$var$HostTransitionContext._currentValue = init);
            $bcd00faefdd4b5d7$var$markRef(current, workInProgress);
            $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $bcd00faefdd4b5d7$var$isHydrating) {
                if (current = renderLanes = $bcd00faefdd4b5d7$var$nextHydratableInstance) renderLanes = $bcd00faefdd4b5d7$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $bcd00faefdd4b5d7$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $bcd00faefdd4b5d7$var$hydrationParentFiber = workInProgress, $bcd00faefdd4b5d7$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $bcd00faefdd4b5d7$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $bcd00faefdd4b5d7$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $bcd00faefdd4b5d7$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $bcd00faefdd4b5d7$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $bcd00faefdd4b5d7$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $bcd00faefdd4b5d7$var$prepareToReadContext(workInProgress), init = $bcd00faefdd4b5d7$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $bcd00faefdd4b5d7$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $bcd00faefdd4b5d7$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $bcd00faefdd4b5d7$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $bcd00faefdd4b5d7$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $bcd00faefdd4b5d7$var$prepareToReadContext(workInProgress), lazyComponent = $bcd00faefdd4b5d7$var$readContext($bcd00faefdd4b5d7$var$CacheContext), null === current ? (init = $bcd00faefdd4b5d7$var$peekCacheFromPool(), null === init && (init = $bcd00faefdd4b5d7$var$workInProgressRoot, nextProps = $bcd00faefdd4b5d7$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $bcd00faefdd4b5d7$var$initializeUpdateQueue(workInProgress), $bcd00faefdd4b5d7$var$pushProvider(workInProgress, $bcd00faefdd4b5d7$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($bcd00faefdd4b5d7$var$cloneUpdateQueue(current, workInProgress), $bcd00faefdd4b5d7$var$processUpdateQueue(workInProgress, null, null, renderLanes), $bcd00faefdd4b5d7$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $bcd00faefdd4b5d7$var$pushProvider(workInProgress, $bcd00faefdd4b5d7$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $bcd00faefdd4b5d7$var$pushProvider(workInProgress, $bcd00faefdd4b5d7$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $bcd00faefdd4b5d7$var$propagateContextChanges(workInProgress, [
                $bcd00faefdd4b5d7$var$CacheContext
            ], renderLanes, !0))), $bcd00faefdd4b5d7$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $bcd00faefdd4b5d7$var$valueCursor = $bcd00faefdd4b5d7$var$createCursor(null), $bcd00faefdd4b5d7$var$currentlyRenderingFiber = null, $bcd00faefdd4b5d7$var$lastContextDependency = null;
function $bcd00faefdd4b5d7$var$pushProvider(providerFiber, context, nextValue) {
    $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $bcd00faefdd4b5d7$var$popProvider(context) {
    context._currentValue = $bcd00faefdd4b5d7$var$valueCursor.current;
    $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$valueCursor);
}
function $bcd00faefdd4b5d7$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $bcd00faefdd4b5d7$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $bcd00faefdd4b5d7$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $bcd00faefdd4b5d7$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $bcd00faefdd4b5d7$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $bcd00faefdd4b5d7$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $bcd00faefdd4b5d7$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($bcd00faefdd4b5d7$var$HostTransitionContext) : current = [
                $bcd00faefdd4b5d7$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $bcd00faefdd4b5d7$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $bcd00faefdd4b5d7$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$bcd00faefdd4b5d7$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $bcd00faefdd4b5d7$var$prepareToReadContext(workInProgress) {
    $bcd00faefdd4b5d7$var$currentlyRenderingFiber = workInProgress;
    $bcd00faefdd4b5d7$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $bcd00faefdd4b5d7$var$readContext(context) {
    return $bcd00faefdd4b5d7$var$readContextForConsumer($bcd00faefdd4b5d7$var$currentlyRenderingFiber, context);
}
function $bcd00faefdd4b5d7$var$readContextDuringReconciliation(consumer, context) {
    null === $bcd00faefdd4b5d7$var$currentlyRenderingFiber && $bcd00faefdd4b5d7$var$prepareToReadContext(consumer);
    return $bcd00faefdd4b5d7$var$readContextForConsumer(consumer, context);
}
function $bcd00faefdd4b5d7$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $bcd00faefdd4b5d7$var$lastContextDependency) {
        if (null === consumer) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(308));
        $bcd00faefdd4b5d7$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $bcd00faefdd4b5d7$var$lastContextDependency = $bcd00faefdd4b5d7$var$lastContextDependency.next = context;
    return value;
}
var $bcd00faefdd4b5d7$var$hasForceUpdate = !1;
function $bcd00faefdd4b5d7$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $bcd00faefdd4b5d7$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $bcd00faefdd4b5d7$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $bcd00faefdd4b5d7$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($bcd00faefdd4b5d7$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $bcd00faefdd4b5d7$var$getRootForUpdatedFiber(fiber);
        $bcd00faefdd4b5d7$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $bcd00faefdd4b5d7$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $bcd00faefdd4b5d7$var$getRootForUpdatedFiber(fiber);
}
function $bcd00faefdd4b5d7$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $bcd00faefdd4b5d7$var$markRootEntangled(root, lane);
    }
}
function $bcd00faefdd4b5d7$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $bcd00faefdd4b5d7$var$didReadFromEntangledAsyncAction = !1;
function $bcd00faefdd4b5d7$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($bcd00faefdd4b5d7$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $bcd00faefdd4b5d7$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $bcd00faefdd4b5d7$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $bcd00faefdd4b5d7$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $bcd00faefdd4b5d7$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $bcd00faefdd4b5d7$var$currentEntangledLane && ($bcd00faefdd4b5d7$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $bcd00faefdd4b5d7$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $bcd00faefdd4b5d7$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $bcd00faefdd4b5d7$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $bcd00faefdd4b5d7$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$bcd00faefdd4b5d7$var$callCallback(callbacks[updateQueue], context);
}
function $bcd00faefdd4b5d7$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $bcd00faefdd4b5d7$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $bcd00faefdd4b5d7$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $bcd00faefdd4b5d7$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $bcd00faefdd4b5d7$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $bcd00faefdd4b5d7$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $bcd00faefdd4b5d7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $bcd00faefdd4b5d7$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $bcd00faefdd4b5d7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $bcd00faefdd4b5d7$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $bcd00faefdd4b5d7$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $bcd00faefdd4b5d7$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $bcd00faefdd4b5d7$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $bcd00faefdd4b5d7$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $bcd00faefdd4b5d7$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$bcd00faefdd4b5d7$var$internalPropsKey] = newProps;
    } catch (error) {
        $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $bcd00faefdd4b5d7$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $bcd00faefdd4b5d7$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $bcd00faefdd4b5d7$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $bcd00faefdd4b5d7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $bcd00faefdd4b5d7$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($bcd00faefdd4b5d7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$bcd00faefdd4b5d7$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $bcd00faefdd4b5d7$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($bcd00faefdd4b5d7$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$bcd00faefdd4b5d7$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden = !1, $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden = !1, $bcd00faefdd4b5d7$var$needsFormReset = !1, $bcd00faefdd4b5d7$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $bcd00faefdd4b5d7$var$nextEffect = null, $bcd00faefdd4b5d7$var$shouldFireAfterActiveInstanceBlur = !1;
function $bcd00faefdd4b5d7$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $bcd00faefdd4b5d7$var$eventsEnabled = $bcd00faefdd4b5d7$var$_enabled;
    root = $bcd00faefdd4b5d7$var$getActiveElementDeep(root);
    if ($bcd00faefdd4b5d7$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $bcd00faefdd4b5d7$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $bcd00faefdd4b5d7$var$_enabled = !1;
    for($bcd00faefdd4b5d7$var$nextEffect = firstChild; null !== $bcd00faefdd4b5d7$var$nextEffect;)if (firstChild = $bcd00faefdd4b5d7$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $bcd00faefdd4b5d7$var$nextEffect = root;
    else for(; null !== $bcd00faefdd4b5d7$var$nextEffect;){
        firstChild = $bcd00faefdd4b5d7$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $bcd00faefdd4b5d7$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $bcd00faefdd4b5d7$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $bcd00faefdd4b5d7$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $bcd00faefdd4b5d7$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $bcd00faefdd4b5d7$var$nextEffect = root;
            break;
        }
        $bcd00faefdd4b5d7$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $bcd00faefdd4b5d7$var$shouldFireAfterActiveInstanceBlur;
    $bcd00faefdd4b5d7$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $bcd00faefdd4b5d7$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $bcd00faefdd4b5d7$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $bcd00faefdd4b5d7$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $bcd00faefdd4b5d7$var$commitClassCallbacks(finishedWork);
            flags & 512 && $bcd00faefdd4b5d7$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $bcd00faefdd4b5d7$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $bcd00faefdd4b5d7$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $bcd00faefdd4b5d7$var$commitHostMount(finishedWork);
            flags & 512 && $bcd00faefdd4b5d7$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $bcd00faefdd4b5d7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden;
                $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden = prevProps;
                ($bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $bcd00faefdd4b5d7$var$safelyAttachRef(finishedWork, finishedWork.return) : $bcd00faefdd4b5d7$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $bcd00faefdd4b5d7$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $bcd00faefdd4b5d7$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $bcd00faefdd4b5d7$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $bcd00faefdd4b5d7$var$hostParent = null, $bcd00faefdd4b5d7$var$hostParentIsContainer = !1;
function $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$bcd00faefdd4b5d7$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $bcd00faefdd4b5d7$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($bcd00faefdd4b5d7$var$injectedHook && "function" === typeof $bcd00faefdd4b5d7$var$injectedHook.onCommitFiberUnmount) try {
        $bcd00faefdd4b5d7$var$injectedHook.onCommitFiberUnmount($bcd00faefdd4b5d7$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || $bcd00faefdd4b5d7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || $bcd00faefdd4b5d7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $bcd00faefdd4b5d7$var$hostParent, prevHostParentIsContainer = $bcd00faefdd4b5d7$var$hostParentIsContainer;
            $bcd00faefdd4b5d7$var$hostParent = deletedFiber.stateNode;
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $bcd00faefdd4b5d7$var$detachDeletedInstance(deletedFiber);
            $bcd00faefdd4b5d7$var$hostParent = prevHostParent;
            $bcd00faefdd4b5d7$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || $bcd00faefdd4b5d7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $bcd00faefdd4b5d7$var$hostParent;
            var prevHostParentIsContainer$119 = $bcd00faefdd4b5d7$var$hostParentIsContainer;
            $bcd00faefdd4b5d7$var$hostParent = null;
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $bcd00faefdd4b5d7$var$hostParent = prevHostParentIsContainer;
            $bcd00faefdd4b5d7$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $bcd00faefdd4b5d7$var$hostParent) {
                if ($bcd00faefdd4b5d7$var$hostParentIsContainer) try {
                    finishedRoot = $bcd00faefdd4b5d7$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $bcd00faefdd4b5d7$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $bcd00faefdd4b5d7$var$hostParent && ($bcd00faefdd4b5d7$var$hostParentIsContainer ? (nearestMountedAncestor = $bcd00faefdd4b5d7$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $bcd00faefdd4b5d7$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $bcd00faefdd4b5d7$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $bcd00faefdd4b5d7$var$retryIfBlockedOn(nearestMountedAncestor)) : $bcd00faefdd4b5d7$var$clearSuspenseBoundary($bcd00faefdd4b5d7$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $bcd00faefdd4b5d7$var$hostParent;
            prevHostParentIsContainer = $bcd00faefdd4b5d7$var$hostParentIsContainer;
            $bcd00faefdd4b5d7$var$hostParent = deletedFiber.stateNode.containerInfo;
            $bcd00faefdd4b5d7$var$hostParentIsContainer = !0;
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $bcd00faefdd4b5d7$var$hostParent = prevHostParent;
            $bcd00faefdd4b5d7$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || ($bcd00faefdd4b5d7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $bcd00faefdd4b5d7$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || $bcd00faefdd4b5d7$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden = (prevHostParent = $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $bcd00faefdd4b5d7$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $bcd00faefdd4b5d7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $bcd00faefdd4b5d7$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $bcd00faefdd4b5d7$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $bcd00faefdd4b5d7$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $bcd00faefdd4b5d7$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $bcd00faefdd4b5d7$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $bcd00faefdd4b5d7$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $bcd00faefdd4b5d7$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $bcd00faefdd4b5d7$var$hostParent = parent.stateNode;
                    $bcd00faefdd4b5d7$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $bcd00faefdd4b5d7$var$hostParent = parent.stateNode.containerInfo;
                    $bcd00faefdd4b5d7$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $bcd00faefdd4b5d7$var$hostParent = parent.stateNode.containerInfo;
                    $bcd00faefdd4b5d7$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $bcd00faefdd4b5d7$var$hostParent) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(160));
        $bcd00faefdd4b5d7$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $bcd00faefdd4b5d7$var$hostParent = null;
        $bcd00faefdd4b5d7$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$bcd00faefdd4b5d7$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $bcd00faefdd4b5d7$var$currentHoistableRoot = null;
function $bcd00faefdd4b5d7$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($bcd00faefdd4b5d7$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $bcd00faefdd4b5d7$var$commitHookEffectListMount(3, finishedWork), $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || null === current || $bcd00faefdd4b5d7$var$safelyDetachRef(current, current.return));
            flags & 64 && $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $bcd00faefdd4b5d7$var$currentHoistableRoot;
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || null === current || $bcd00faefdd4b5d7$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$bcd00faefdd4b5d7$var$internalHoistableMarker] || currentResource[$bcd00faefdd4b5d7$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $bcd00faefdd4b5d7$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$bcd00faefdd4b5d7$var$internalInstanceKey] = finishedWork;
                                        $bcd00faefdd4b5d7$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $bcd00faefdd4b5d7$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $bcd00faefdd4b5d7$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $bcd00faefdd4b5d7$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $bcd00faefdd4b5d7$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$bcd00faefdd4b5d7$var$internalInstanceKey] = finishedWork;
                                $bcd00faefdd4b5d7$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $bcd00faefdd4b5d7$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $bcd00faefdd4b5d7$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $bcd00faefdd4b5d7$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $bcd00faefdd4b5d7$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $bcd00faefdd4b5d7$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$bcd00faefdd4b5d7$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $bcd00faefdd4b5d7$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$bcd00faefdd4b5d7$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$bcd00faefdd4b5d7$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || null === current || $bcd00faefdd4b5d7$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $bcd00faefdd4b5d7$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $bcd00faefdd4b5d7$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($bcd00faefdd4b5d7$var$needsFormReset = !0);
            break;
        case 6:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $bcd00faefdd4b5d7$var$tagCaches = null;
            hoistableRoot = $bcd00faefdd4b5d7$var$currentHoistableRoot;
            $bcd00faefdd4b5d7$var$currentHoistableRoot = $bcd00faefdd4b5d7$var$getHoistableRoot(root.containerInfo);
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$currentHoistableRoot = hoistableRoot;
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $bcd00faefdd4b5d7$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $bcd00faefdd4b5d7$var$needsFormReset && ($bcd00faefdd4b5d7$var$needsFormReset = !1, $bcd00faefdd4b5d7$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $bcd00faefdd4b5d7$var$currentHoistableRoot;
            $bcd00faefdd4b5d7$var$currentHoistableRoot = $bcd00faefdd4b5d7$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            $bcd00faefdd4b5d7$var$currentHoistableRoot = flags;
            break;
        case 12:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($bcd00faefdd4b5d7$var$globalMostRecentFallbackTime = $bcd00faefdd4b5d7$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $bcd00faefdd4b5d7$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden || null === current || $bcd00faefdd4b5d7$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden;
            type = $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden;
            $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden = nodeName || node;
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden = type || nextNode;
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden = type;
            $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden = nodeName;
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $bcd00faefdd4b5d7$var$offscreenSubtreeIsHidden || $bcd00faefdd4b5d7$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $bcd00faefdd4b5d7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $bcd00faefdd4b5d7$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $bcd00faefdd4b5d7$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $bcd00faefdd4b5d7$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $bcd00faefdd4b5d7$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $bcd00faefdd4b5d7$var$recursivelyTraverseMutationEffects(root, finishedWork), $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork);
    }
}
function $bcd00faefdd4b5d7$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($bcd00faefdd4b5d7$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $bcd00faefdd4b5d7$var$getHostSibling(finishedWork);
                        $bcd00faefdd4b5d7$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($bcd00faefdd4b5d7$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $bcd00faefdd4b5d7$var$getHostSibling(finishedWork);
                        $bcd00faefdd4b5d7$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $bcd00faefdd4b5d7$var$getHostSibling(finishedWork);
                        $bcd00faefdd4b5d7$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $bcd00faefdd4b5d7$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $bcd00faefdd4b5d7$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $bcd00faefdd4b5d7$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$bcd00faefdd4b5d7$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $bcd00faefdd4b5d7$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $bcd00faefdd4b5d7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $bcd00faefdd4b5d7$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $bcd00faefdd4b5d7$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $bcd00faefdd4b5d7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $bcd00faefdd4b5d7$var$safelyDetachRef(finishedWork, finishedWork.return);
                $bcd00faefdd4b5d7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $bcd00faefdd4b5d7$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $bcd00faefdd4b5d7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $bcd00faefdd4b5d7$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $bcd00faefdd4b5d7$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$bcd00faefdd4b5d7$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $bcd00faefdd4b5d7$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $bcd00faefdd4b5d7$var$commitClassCallbacks(finishedWork);
                $bcd00faefdd4b5d7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $bcd00faefdd4b5d7$var$commitHostMount(finishedWork);
                $bcd00faefdd4b5d7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $bcd00faefdd4b5d7$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $bcd00faefdd4b5d7$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $bcd00faefdd4b5d7$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $bcd00faefdd4b5d7$var$releaseCache(previousCache));
}
function $bcd00faefdd4b5d7$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $bcd00faefdd4b5d7$var$releaseCache(current));
}
function $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$bcd00faefdd4b5d7$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $bcd00faefdd4b5d7$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $bcd00faefdd4b5d7$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $bcd00faefdd4b5d7$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $bcd00faefdd4b5d7$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $bcd00faefdd4b5d7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $bcd00faefdd4b5d7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $bcd00faefdd4b5d7$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $bcd00faefdd4b5d7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $bcd00faefdd4b5d7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $bcd00faefdd4b5d7$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $bcd00faefdd4b5d7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $bcd00faefdd4b5d7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $bcd00faefdd4b5d7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $bcd00faefdd4b5d7$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $bcd00faefdd4b5d7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $bcd00faefdd4b5d7$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $bcd00faefdd4b5d7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $bcd00faefdd4b5d7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $bcd00faefdd4b5d7$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $bcd00faefdd4b5d7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $bcd00faefdd4b5d7$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $bcd00faefdd4b5d7$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $bcd00faefdd4b5d7$var$suspenseyCommitFlag = 8192;
function $bcd00faefdd4b5d7$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $bcd00faefdd4b5d7$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$bcd00faefdd4b5d7$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $bcd00faefdd4b5d7$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $bcd00faefdd4b5d7$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $bcd00faefdd4b5d7$var$suspenseyCommitFlag && null !== fiber.memoizedState && $bcd00faefdd4b5d7$var$suspendResource($bcd00faefdd4b5d7$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $bcd00faefdd4b5d7$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $bcd00faefdd4b5d7$var$currentHoistableRoot;
            $bcd00faefdd4b5d7$var$currentHoistableRoot = $bcd00faefdd4b5d7$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $bcd00faefdd4b5d7$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $bcd00faefdd4b5d7$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $bcd00faefdd4b5d7$var$suspenseyCommitFlag, $bcd00faefdd4b5d7$var$suspenseyCommitFlag = 16777216, $bcd00faefdd4b5d7$var$recursivelyAccumulateSuspenseyCommit(fiber), $bcd00faefdd4b5d7$var$suspenseyCommitFlag = previousHoistableRoot) : $bcd00faefdd4b5d7$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $bcd00faefdd4b5d7$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $bcd00faefdd4b5d7$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $bcd00faefdd4b5d7$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $bcd00faefdd4b5d7$var$nextEffect = childToDelete;
            $bcd00faefdd4b5d7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $bcd00faefdd4b5d7$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$bcd00faefdd4b5d7$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $bcd00faefdd4b5d7$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $bcd00faefdd4b5d7$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $bcd00faefdd4b5d7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $bcd00faefdd4b5d7$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $bcd00faefdd4b5d7$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $bcd00faefdd4b5d7$var$nextEffect = childToDelete;
            $bcd00faefdd4b5d7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $bcd00faefdd4b5d7$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $bcd00faefdd4b5d7$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $bcd00faefdd4b5d7$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $bcd00faefdd4b5d7$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $bcd00faefdd4b5d7$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $bcd00faefdd4b5d7$var$nextEffect;){
        var fiber = $bcd00faefdd4b5d7$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $bcd00faefdd4b5d7$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $bcd00faefdd4b5d7$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $bcd00faefdd4b5d7$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $bcd00faefdd4b5d7$var$nextEffect;){
            cache = $bcd00faefdd4b5d7$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $bcd00faefdd4b5d7$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $bcd00faefdd4b5d7$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $bcd00faefdd4b5d7$var$nextEffect = sibling;
                break a;
            }
            $bcd00faefdd4b5d7$var$nextEffect = returnFiber;
        }
    }
}
function $bcd00faefdd4b5d7$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $bcd00faefdd4b5d7$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $bcd00faefdd4b5d7$var$FiberNode(tag, pendingProps, key, mode);
}
function $bcd00faefdd4b5d7$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $bcd00faefdd4b5d7$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $bcd00faefdd4b5d7$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $bcd00faefdd4b5d7$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $bcd00faefdd4b5d7$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $bcd00faefdd4b5d7$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $bcd00faefdd4b5d7$var$isHostHoistableType(type, pendingProps, $bcd00faefdd4b5d7$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $bcd00faefdd4b5d7$var$REACT_FRAGMENT_TYPE:
            return $bcd00faefdd4b5d7$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $bcd00faefdd4b5d7$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $bcd00faefdd4b5d7$var$REACT_PROFILER_TYPE:
            return type = $bcd00faefdd4b5d7$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $bcd00faefdd4b5d7$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $bcd00faefdd4b5d7$var$REACT_SUSPENSE_TYPE:
            return type = $bcd00faefdd4b5d7$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $bcd00faefdd4b5d7$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $bcd00faefdd4b5d7$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $bcd00faefdd4b5d7$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $bcd00faefdd4b5d7$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $bcd00faefdd4b5d7$var$REACT_OFFSCREEN_TYPE:
            return $bcd00faefdd4b5d7$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === (typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type)) && null !== type) switch(type.$$typeof){
                case $bcd00faefdd4b5d7$var$REACT_PROVIDER_TYPE:
                case $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $bcd00faefdd4b5d7$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $bcd00faefdd4b5d7$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $bcd00faefdd4b5d7$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $bcd00faefdd4b5d7$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(130, null === type ? "null" : typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type), ""));
            owner = null;
    }
    key = $bcd00faefdd4b5d7$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $bcd00faefdd4b5d7$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $bcd00faefdd4b5d7$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $bcd00faefdd4b5d7$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $bcd00faefdd4b5d7$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $bcd00faefdd4b5d7$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function detach() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function attach() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $bcd00faefdd4b5d7$var$createFiberFromText(content, mode, lanes) {
    content = $bcd00faefdd4b5d7$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $bcd00faefdd4b5d7$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $bcd00faefdd4b5d7$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $bcd00faefdd4b5d7$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $bcd00faefdd4b5d7$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$bcd00faefdd4b5d7$var$preloadResource(resource)) {
        resource = $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 4194176) === $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes ? null !== $bcd00faefdd4b5d7$var$shellBoundary : ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 62914560) !== $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes && 0 === ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 536870912) || resource !== $bcd00faefdd4b5d7$var$shellBoundary)) throw $bcd00faefdd4b5d7$var$suspendedThenable = $bcd00faefdd4b5d7$var$noopSuspenseyCommitThenable, $bcd00faefdd4b5d7$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $bcd00faefdd4b5d7$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $bcd00faefdd4b5d7$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $bcd00faefdd4b5d7$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $bcd00faefdd4b5d7$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$bcd00faefdd4b5d7$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $bcd00faefdd4b5d7$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $bcd00faefdd4b5d7$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $bcd00faefdd4b5d7$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), null;
        case 1:
            return $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $bcd00faefdd4b5d7$var$popProvider($bcd00faefdd4b5d7$var$CacheContext);
            $bcd00faefdd4b5d7$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $bcd00faefdd4b5d7$var$popHydrationState(workInProgress) ? $bcd00faefdd4b5d7$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $bcd00faefdd4b5d7$var$hydrationErrors && ($bcd00faefdd4b5d7$var$queueRecoverableErrors($bcd00faefdd4b5d7$var$hydrationErrors), $bcd00faefdd4b5d7$var$hydrationErrors = null));
            $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($bcd00faefdd4b5d7$var$markUpdate(workInProgress), null !== renderLanes ? ($bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), $bcd00faefdd4b5d7$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($bcd00faefdd4b5d7$var$markUpdate(workInProgress), $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), $bcd00faefdd4b5d7$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $bcd00faefdd4b5d7$var$markUpdate(workInProgress), $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $bcd00faefdd4b5d7$var$popHostContext(workInProgress);
            renderLanes = $bcd00faefdd4b5d7$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $bcd00faefdd4b5d7$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(166));
                    $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $bcd00faefdd4b5d7$var$contextStackCursor.current;
                $bcd00faefdd4b5d7$var$popHydrationState(workInProgress) ? $bcd00faefdd4b5d7$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $bcd00faefdd4b5d7$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $bcd00faefdd4b5d7$var$markUpdate(workInProgress));
            }
            $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $bcd00faefdd4b5d7$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $bcd00faefdd4b5d7$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(166));
                    $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $bcd00faefdd4b5d7$var$contextStackCursor.current;
                if ($bcd00faefdd4b5d7$var$popHydrationState(workInProgress)) $bcd00faefdd4b5d7$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $bcd00faefdd4b5d7$var$getOwnerDocumentFromRootContainer($bcd00faefdd4b5d7$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$bcd00faefdd4b5d7$var$internalInstanceKey] = workInProgress;
                    current[$bcd00faefdd4b5d7$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($bcd00faefdd4b5d7$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $bcd00faefdd4b5d7$var$markUpdate(workInProgress);
                }
            }
            $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $bcd00faefdd4b5d7$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(166));
                current = $bcd00faefdd4b5d7$var$rootInstanceStackCursor.current;
                if ($bcd00faefdd4b5d7$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $bcd00faefdd4b5d7$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$bcd00faefdd4b5d7$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $bcd00faefdd4b5d7$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $bcd00faefdd4b5d7$var$throwOnHydrationMismatch(workInProgress);
                } else current = $bcd00faefdd4b5d7$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$bcd00faefdd4b5d7$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $bcd00faefdd4b5d7$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(317));
                        type[$bcd00faefdd4b5d7$var$internalInstanceKey] = workInProgress;
                    } else $bcd00faefdd4b5d7$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $bcd00faefdd4b5d7$var$hydrationErrors && ($bcd00faefdd4b5d7$var$queueRecoverableErrors($bcd00faefdd4b5d7$var$hydrationErrors), $bcd00faefdd4b5d7$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $bcd00faefdd4b5d7$var$popSuspenseHandler(workInProgress), workInProgress;
                    $bcd00faefdd4b5d7$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $bcd00faefdd4b5d7$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $bcd00faefdd4b5d7$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $bcd00faefdd4b5d7$var$popHostContainer(), null === current && $bcd00faefdd4b5d7$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), null;
        case 10:
            return $bcd00faefdd4b5d7$var$popProvider(workInProgress.type), $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), null;
        case 19:
            $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $bcd00faefdd4b5d7$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $bcd00faefdd4b5d7$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $bcd00faefdd4b5d7$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $bcd00faefdd4b5d7$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $bcd00faefdd4b5d7$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$bcd00faefdd4b5d7$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseStackCursor, $bcd00faefdd4b5d7$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $bcd00faefdd4b5d7$var$now() > $bcd00faefdd4b5d7$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $bcd00faefdd4b5d7$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $bcd00faefdd4b5d7$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $bcd00faefdd4b5d7$var$scheduleRetryEffect(workInProgress, current), $bcd00faefdd4b5d7$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$bcd00faefdd4b5d7$var$isHydrating) return $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), null;
                    } else 2 * $bcd00faefdd4b5d7$var$now() - type.renderingStartTime > $bcd00faefdd4b5d7$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $bcd00faefdd4b5d7$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $bcd00faefdd4b5d7$var$now(), workInProgress.sibling = null, current = $bcd00faefdd4b5d7$var$suspenseStackCursor.current, $bcd00faefdd4b5d7$var$push($bcd00faefdd4b5d7$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $bcd00faefdd4b5d7$var$popSuspenseHandler(workInProgress), $bcd00faefdd4b5d7$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $bcd00faefdd4b5d7$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $bcd00faefdd4b5d7$var$popProvider($bcd00faefdd4b5d7$var$CacheContext), $bcd00faefdd4b5d7$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $bcd00faefdd4b5d7$var$unwindWork(current, workInProgress) {
    $bcd00faefdd4b5d7$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $bcd00faefdd4b5d7$var$popProvider($bcd00faefdd4b5d7$var$CacheContext), $bcd00faefdd4b5d7$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $bcd00faefdd4b5d7$var$popHostContext(workInProgress), null;
        case 13:
            $bcd00faefdd4b5d7$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(340));
                $bcd00faefdd4b5d7$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$suspenseStackCursor), null;
        case 4:
            return $bcd00faefdd4b5d7$var$popHostContainer(), null;
        case 10:
            return $bcd00faefdd4b5d7$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $bcd00faefdd4b5d7$var$popSuspenseHandler(workInProgress), $bcd00faefdd4b5d7$var$popHiddenContext(), null !== current && $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $bcd00faefdd4b5d7$var$popProvider($bcd00faefdd4b5d7$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $bcd00faefdd4b5d7$var$unwindInterruptedWork(current, interruptedWork) {
    $bcd00faefdd4b5d7$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $bcd00faefdd4b5d7$var$popProvider($bcd00faefdd4b5d7$var$CacheContext);
            $bcd00faefdd4b5d7$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $bcd00faefdd4b5d7$var$popHostContext(interruptedWork);
            break;
        case 4:
            $bcd00faefdd4b5d7$var$popHostContainer();
            break;
        case 13:
            $bcd00faefdd4b5d7$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$suspenseStackCursor);
            break;
        case 10:
            $bcd00faefdd4b5d7$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $bcd00faefdd4b5d7$var$popSuspenseHandler(interruptedWork);
            $bcd00faefdd4b5d7$var$popHiddenContext();
            null !== current && $bcd00faefdd4b5d7$var$pop($bcd00faefdd4b5d7$var$resumedCache);
            break;
        case 24:
            $bcd00faefdd4b5d7$var$popProvider($bcd00faefdd4b5d7$var$CacheContext);
    }
}
var $bcd00faefdd4b5d7$var$DefaultAsyncDispatcher = {
    getCacheForType: function getCacheForType(resourceType) {
        var cache = $bcd00faefdd4b5d7$var$readContext($bcd00faefdd4b5d7$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $bcd00faefdd4b5d7$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $bcd00faefdd4b5d7$var$executionContext = 0, $bcd00faefdd4b5d7$var$workInProgressRoot = null, $bcd00faefdd4b5d7$var$workInProgress = null, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes = 0, $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0, $bcd00faefdd4b5d7$var$workInProgressThrownValue = null, $bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings = !1, $bcd00faefdd4b5d7$var$workInProgressRootIsPrerendering = !1, $bcd00faefdd4b5d7$var$workInProgressRootDidAttachPingListener = !1, $bcd00faefdd4b5d7$var$entangledRenderLanes = 0, $bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 0, $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes = 0, $bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes = 0, $bcd00faefdd4b5d7$var$workInProgressRootPingedLanes = 0, $bcd00faefdd4b5d7$var$workInProgressDeferredLane = 0, $bcd00faefdd4b5d7$var$workInProgressSuspendedRetryLanes = 0, $bcd00faefdd4b5d7$var$workInProgressRootConcurrentErrors = null, $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors = null, $bcd00faefdd4b5d7$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $bcd00faefdd4b5d7$var$globalMostRecentFallbackTime = 0, $bcd00faefdd4b5d7$var$workInProgressRootRenderTargetTime = Infinity, $bcd00faefdd4b5d7$var$workInProgressTransitions = null, $bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed = null, $bcd00faefdd4b5d7$var$rootDoesHavePassiveEffects = !1, $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects = null, $bcd00faefdd4b5d7$var$pendingPassiveEffectsLanes = 0, $bcd00faefdd4b5d7$var$pendingPassiveEffectsRemainingLanes = 0, $bcd00faefdd4b5d7$var$pendingPassiveTransitions = null, $bcd00faefdd4b5d7$var$nestedUpdateCount = 0, $bcd00faefdd4b5d7$var$rootWithNestedUpdates = null;
function $bcd00faefdd4b5d7$var$requestUpdateLane() {
    if (0 !== ($bcd00faefdd4b5d7$var$executionContext & 2) && 0 !== $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes) return $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & -$bcd00faefdd4b5d7$var$workInProgressRootRenderLanes;
    if (null !== $bcd00faefdd4b5d7$var$ReactSharedInternals.T) {
        var actionScopeLane = $bcd00faefdd4b5d7$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $bcd00faefdd4b5d7$var$requestTransitionLane();
    }
    return $bcd00faefdd4b5d7$var$resolveUpdatePriority();
}
function $bcd00faefdd4b5d7$var$requestDeferredLane() {
    0 === $bcd00faefdd4b5d7$var$workInProgressDeferredLane && ($bcd00faefdd4b5d7$var$workInProgressDeferredLane = 0 === ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 536870912) || $bcd00faefdd4b5d7$var$isHydrating ? $bcd00faefdd4b5d7$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $bcd00faefdd4b5d7$var$workInProgressDeferredLane;
}
function $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $bcd00faefdd4b5d7$var$workInProgressRoot && 2 === $bcd00faefdd4b5d7$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $bcd00faefdd4b5d7$var$prepareFreshStack(root, 0), $bcd00faefdd4b5d7$var$markRootSuspended(root, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes, $bcd00faefdd4b5d7$var$workInProgressDeferredLane, !1);
    $bcd00faefdd4b5d7$var$markRootUpdated$1(root, lane);
    if (0 === ($bcd00faefdd4b5d7$var$executionContext & 2) || root !== $bcd00faefdd4b5d7$var$workInProgressRoot) root === $bcd00faefdd4b5d7$var$workInProgressRoot && (0 === ($bcd00faefdd4b5d7$var$executionContext & 2) && ($bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $bcd00faefdd4b5d7$var$workInProgressRootExitStatus && $bcd00faefdd4b5d7$var$markRootSuspended(root, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes, $bcd00faefdd4b5d7$var$workInProgressDeferredLane, !1)), $bcd00faefdd4b5d7$var$ensureRootIsScheduled(root);
}
function $bcd00faefdd4b5d7$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($bcd00faefdd4b5d7$var$executionContext & 6)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $bcd00faefdd4b5d7$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $bcd00faefdd4b5d7$var$renderRootConcurrent(root$jscomp$0, lanes) : $bcd00faefdd4b5d7$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $bcd00faefdd4b5d7$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $bcd00faefdd4b5d7$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $bcd00faefdd4b5d7$var$markRootSuspended(root$jscomp$0, lanes, 0, !$bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$bcd00faefdd4b5d7$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $bcd00faefdd4b5d7$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $bcd00faefdd4b5d7$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($bcd00faefdd4b5d7$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $bcd00faefdd4b5d7$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($bcd00faefdd4b5d7$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors;
                            $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $bcd00faefdd4b5d7$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $bcd00faefdd4b5d7$var$prepareFreshStack(root$jscomp$0, 0);
                $bcd00faefdd4b5d7$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $bcd00faefdd4b5d7$var$markRootSuspended(shouldTimeSlice, lanes, $bcd00faefdd4b5d7$var$workInProgressDeferredLane, !$bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $bcd00faefdd4b5d7$var$globalMostRecentFallbackTime + 300 - $bcd00faefdd4b5d7$var$now(), 10 < renderWasConcurrent)) {
                    $bcd00faefdd4b5d7$var$markRootSuspended(shouldTimeSlice, lanes, $bcd00faefdd4b5d7$var$workInProgressDeferredLane, !$bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $bcd00faefdd4b5d7$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $bcd00faefdd4b5d7$var$scheduleTimeout($bcd00faefdd4b5d7$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors, $bcd00faefdd4b5d7$var$workInProgressTransitions, $bcd00faefdd4b5d7$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $bcd00faefdd4b5d7$var$workInProgressDeferredLane, $bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes, $bcd00faefdd4b5d7$var$workInProgressSuspendedRetryLanes, $bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $bcd00faefdd4b5d7$var$commitRootWhenReady(shouldTimeSlice, forceSync, $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors, $bcd00faefdd4b5d7$var$workInProgressTransitions, $bcd00faefdd4b5d7$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $bcd00faefdd4b5d7$var$workInProgressDeferredLane, $bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes, $bcd00faefdd4b5d7$var$workInProgressSuspendedRetryLanes, $bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $bcd00faefdd4b5d7$var$ensureRootIsScheduled(root$jscomp$0);
}
function $bcd00faefdd4b5d7$var$queueRecoverableErrors(errors) {
    null === $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors ? $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors = errors : $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors.push.apply($bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors, errors);
}
function $bcd00faefdd4b5d7$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($bcd00faefdd4b5d7$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $bcd00faefdd4b5d7$var$noop
        }, $bcd00faefdd4b5d7$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $bcd00faefdd4b5d7$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($bcd00faefdd4b5d7$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $bcd00faefdd4b5d7$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $bcd00faefdd4b5d7$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $bcd00faefdd4b5d7$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$bcd00faefdd4b5d7$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $bcd00faefdd4b5d7$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$bcd00faefdd4b5d7$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $bcd00faefdd4b5d7$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $bcd00faefdd4b5d7$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $bcd00faefdd4b5d7$var$flushSyncWork$1() {
    return 0 === ($bcd00faefdd4b5d7$var$executionContext & 6) ? ($bcd00faefdd4b5d7$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $bcd00faefdd4b5d7$var$resetWorkInProgressStack() {
    if (null !== $bcd00faefdd4b5d7$var$workInProgress) {
        if (0 === $bcd00faefdd4b5d7$var$workInProgressSuspendedReason) var interruptedWork = $bcd00faefdd4b5d7$var$workInProgress.return;
        else interruptedWork = $bcd00faefdd4b5d7$var$workInProgress, $bcd00faefdd4b5d7$var$lastContextDependency = $bcd00faefdd4b5d7$var$currentlyRenderingFiber = null, $bcd00faefdd4b5d7$var$resetHooksOnUnwind(interruptedWork), $bcd00faefdd4b5d7$var$thenableState$1 = null, $bcd00faefdd4b5d7$var$thenableIndexCounter$1 = 0, interruptedWork = $bcd00faefdd4b5d7$var$workInProgress;
        for(; null !== interruptedWork;)$bcd00faefdd4b5d7$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $bcd00faefdd4b5d7$var$workInProgress = null;
    }
}
function $bcd00faefdd4b5d7$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $bcd00faefdd4b5d7$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $bcd00faefdd4b5d7$var$resetWorkInProgressStack();
    $bcd00faefdd4b5d7$var$workInProgressRoot = root;
    $bcd00faefdd4b5d7$var$workInProgress = timeoutHandle = $bcd00faefdd4b5d7$var$createWorkInProgress(root.current, null);
    $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes = lanes;
    $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0;
    $bcd00faefdd4b5d7$var$workInProgressThrownValue = null;
    $bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $bcd00faefdd4b5d7$var$workInProgressRootIsPrerendering = $bcd00faefdd4b5d7$var$checkIfRootIsPrerendering(root, lanes);
    $bcd00faefdd4b5d7$var$workInProgressRootDidAttachPingListener = !1;
    $bcd00faefdd4b5d7$var$workInProgressSuspendedRetryLanes = $bcd00faefdd4b5d7$var$workInProgressDeferredLane = $bcd00faefdd4b5d7$var$workInProgressRootPingedLanes = $bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes = $bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes = $bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 0;
    $bcd00faefdd4b5d7$var$workInProgressRootRecoverableErrors = $bcd00faefdd4b5d7$var$workInProgressRootConcurrentErrors = null;
    $bcd00faefdd4b5d7$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $bcd00faefdd4b5d7$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $bcd00faefdd4b5d7$var$entangledRenderLanes = lanes;
    $bcd00faefdd4b5d7$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $bcd00faefdd4b5d7$var$handleThrow(root, thrownValue) {
    $bcd00faefdd4b5d7$var$currentlyRenderingFiber$1 = null;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.H = $bcd00faefdd4b5d7$var$ContextOnlyDispatcher;
    thrownValue === $bcd00faefdd4b5d7$var$SuspenseException ? (thrownValue = $bcd00faefdd4b5d7$var$getSuspendedThenable(), $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 3) : thrownValue === $bcd00faefdd4b5d7$var$SuspenseyCommitException ? (thrownValue = $bcd00faefdd4b5d7$var$getSuspendedThenable(), $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 4) : $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = thrownValue === $bcd00faefdd4b5d7$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === (typeof thrownValue === "undefined" ? "undefined" : (0, $YtE9h._)(thrownValue)) && "function" === typeof thrownValue.then ? 6 : 1;
    $bcd00faefdd4b5d7$var$workInProgressThrownValue = thrownValue;
    null === $bcd00faefdd4b5d7$var$workInProgress && ($bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 1, $bcd00faefdd4b5d7$var$logUncaughtError(root, $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $bcd00faefdd4b5d7$var$pushDispatcher() {
    var prevDispatcher = $bcd00faefdd4b5d7$var$ReactSharedInternals.H;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.H = $bcd00faefdd4b5d7$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $bcd00faefdd4b5d7$var$ContextOnlyDispatcher : prevDispatcher;
}
function $bcd00faefdd4b5d7$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $bcd00faefdd4b5d7$var$ReactSharedInternals.A;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.A = $bcd00faefdd4b5d7$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $bcd00faefdd4b5d7$var$renderDidSuspendDelayIfPossible() {
    $bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 4;
    $bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings || ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 4194176) !== $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes && null !== $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current || ($bcd00faefdd4b5d7$var$workInProgressRootIsPrerendering = !0);
    0 === ($bcd00faefdd4b5d7$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($bcd00faefdd4b5d7$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $bcd00faefdd4b5d7$var$workInProgressRoot || $bcd00faefdd4b5d7$var$markRootSuspended($bcd00faefdd4b5d7$var$workInProgressRoot, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes, $bcd00faefdd4b5d7$var$workInProgressDeferredLane, !1);
}
function $bcd00faefdd4b5d7$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $bcd00faefdd4b5d7$var$executionContext;
    $bcd00faefdd4b5d7$var$executionContext |= 2;
    var prevDispatcher = $bcd00faefdd4b5d7$var$pushDispatcher(), prevAsyncDispatcher = $bcd00faefdd4b5d7$var$pushAsyncDispatcher();
    if ($bcd00faefdd4b5d7$var$workInProgressRoot !== root || $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes !== lanes) $bcd00faefdd4b5d7$var$workInProgressTransitions = null, $bcd00faefdd4b5d7$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $bcd00faefdd4b5d7$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $bcd00faefdd4b5d7$var$workInProgressSuspendedReason && null !== $bcd00faefdd4b5d7$var$workInProgress) {
            var unitOfWork = $bcd00faefdd4b5d7$var$workInProgress, thrownValue = $bcd00faefdd4b5d7$var$workInProgressThrownValue;
            switch($bcd00faefdd4b5d7$var$workInProgressSuspendedReason){
                case 8:
                    $bcd00faefdd4b5d7$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $bcd00faefdd4b5d7$var$workInProgressSuspendedReason;
                    $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0;
                    $bcd00faefdd4b5d7$var$workInProgressThrownValue = null;
                    $bcd00faefdd4b5d7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $bcd00faefdd4b5d7$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $bcd00faefdd4b5d7$var$workInProgressSuspendedReason, $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0, $bcd00faefdd4b5d7$var$workInProgressThrownValue = null, $bcd00faefdd4b5d7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $bcd00faefdd4b5d7$var$workLoopSync();
        exitStatus = $bcd00faefdd4b5d7$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $bcd00faefdd4b5d7$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $bcd00faefdd4b5d7$var$lastContextDependency = $bcd00faefdd4b5d7$var$currentlyRenderingFiber = null;
    $bcd00faefdd4b5d7$var$executionContext = prevExecutionContext;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.H = prevDispatcher;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $bcd00faefdd4b5d7$var$workInProgress && ($bcd00faefdd4b5d7$var$workInProgressRoot = null, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes = 0, $bcd00faefdd4b5d7$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $bcd00faefdd4b5d7$var$workLoopSync() {
    for(; null !== $bcd00faefdd4b5d7$var$workInProgress;)$bcd00faefdd4b5d7$var$performUnitOfWork($bcd00faefdd4b5d7$var$workInProgress);
}
function $bcd00faefdd4b5d7$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $bcd00faefdd4b5d7$var$executionContext;
    $bcd00faefdd4b5d7$var$executionContext |= 2;
    var prevDispatcher = $bcd00faefdd4b5d7$var$pushDispatcher(), prevAsyncDispatcher = $bcd00faefdd4b5d7$var$pushAsyncDispatcher();
    $bcd00faefdd4b5d7$var$workInProgressRoot !== root || $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes !== lanes ? ($bcd00faefdd4b5d7$var$workInProgressTransitions = null, $bcd00faefdd4b5d7$var$workInProgressRootRenderTargetTime = $bcd00faefdd4b5d7$var$now() + 500, $bcd00faefdd4b5d7$var$prepareFreshStack(root, lanes)) : $bcd00faefdd4b5d7$var$workInProgressRootIsPrerendering = $bcd00faefdd4b5d7$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $bcd00faefdd4b5d7$var$workInProgressSuspendedReason && null !== $bcd00faefdd4b5d7$var$workInProgress) {
            lanes = $bcd00faefdd4b5d7$var$workInProgress;
            var thrownValue = $bcd00faefdd4b5d7$var$workInProgressThrownValue;
            b: switch($bcd00faefdd4b5d7$var$workInProgressSuspendedReason){
                case 1:
                    $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0;
                    $bcd00faefdd4b5d7$var$workInProgressThrownValue = null;
                    $bcd00faefdd4b5d7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($bcd00faefdd4b5d7$var$isThenableResolved(thrownValue)) {
                        $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0;
                        $bcd00faefdd4b5d7$var$workInProgressThrownValue = null;
                        $bcd00faefdd4b5d7$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function lanes() {
                        2 === $bcd00faefdd4b5d7$var$workInProgressSuspendedReason && $bcd00faefdd4b5d7$var$workInProgressRoot === root && ($bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 7);
                        $bcd00faefdd4b5d7$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $bcd00faefdd4b5d7$var$isThenableResolved(thrownValue) ? ($bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0, $bcd00faefdd4b5d7$var$workInProgressThrownValue = null, $bcd00faefdd4b5d7$var$replaySuspendedUnitOfWork(lanes)) : ($bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0, $bcd00faefdd4b5d7$var$workInProgressThrownValue = null, $bcd00faefdd4b5d7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($bcd00faefdd4b5d7$var$workInProgress.tag){
                        case 26:
                            resource = $bcd00faefdd4b5d7$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $bcd00faefdd4b5d7$var$workInProgress;
                            if (resource ? $bcd00faefdd4b5d7$var$preloadResource(resource) : 1) {
                                $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0;
                                $bcd00faefdd4b5d7$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $bcd00faefdd4b5d7$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($bcd00faefdd4b5d7$var$workInProgress = returnFiber, $bcd00faefdd4b5d7$var$completeUnitOfWork(returnFiber)) : $bcd00faefdd4b5d7$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0;
                    $bcd00faefdd4b5d7$var$workInProgressThrownValue = null;
                    $bcd00faefdd4b5d7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $bcd00faefdd4b5d7$var$workInProgressSuspendedReason = 0;
                    $bcd00faefdd4b5d7$var$workInProgressThrownValue = null;
                    $bcd00faefdd4b5d7$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $bcd00faefdd4b5d7$var$resetWorkInProgressStack();
                    $bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(462));
            }
        }
        $bcd00faefdd4b5d7$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $bcd00faefdd4b5d7$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $bcd00faefdd4b5d7$var$lastContextDependency = $bcd00faefdd4b5d7$var$currentlyRenderingFiber = null;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.H = prevDispatcher;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $bcd00faefdd4b5d7$var$executionContext = prevExecutionContext;
    if (null !== $bcd00faefdd4b5d7$var$workInProgress) return 0;
    $bcd00faefdd4b5d7$var$workInProgressRoot = null;
    $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes = 0;
    $bcd00faefdd4b5d7$var$finishQueueingConcurrentUpdates();
    return $bcd00faefdd4b5d7$var$workInProgressRootExitStatus;
}
function $bcd00faefdd4b5d7$var$workLoopConcurrent() {
    for(; null !== $bcd00faefdd4b5d7$var$workInProgress && !$bcd00faefdd4b5d7$var$shouldYield();)$bcd00faefdd4b5d7$var$performUnitOfWork($bcd00faefdd4b5d7$var$workInProgress);
}
function $bcd00faefdd4b5d7$var$performUnitOfWork(unitOfWork) {
    var next = $bcd00faefdd4b5d7$var$beginWork(unitOfWork.alternate, unitOfWork, $bcd00faefdd4b5d7$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $bcd00faefdd4b5d7$var$completeUnitOfWork(unitOfWork) : $bcd00faefdd4b5d7$var$workInProgress = next;
}
function $bcd00faefdd4b5d7$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $bcd00faefdd4b5d7$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $bcd00faefdd4b5d7$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $bcd00faefdd4b5d7$var$resetHooksOnUnwind(next);
        default:
            $bcd00faefdd4b5d7$var$unwindInterruptedWork(current, next), next = $bcd00faefdd4b5d7$var$workInProgress = $bcd00faefdd4b5d7$var$resetWorkInProgress(next, $bcd00faefdd4b5d7$var$entangledRenderLanes), next = $bcd00faefdd4b5d7$var$beginWork(current, next, $bcd00faefdd4b5d7$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $bcd00faefdd4b5d7$var$completeUnitOfWork(unitOfWork) : $bcd00faefdd4b5d7$var$workInProgress = next;
}
function $bcd00faefdd4b5d7$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $bcd00faefdd4b5d7$var$lastContextDependency = $bcd00faefdd4b5d7$var$currentlyRenderingFiber = null;
    $bcd00faefdd4b5d7$var$resetHooksOnUnwind(unitOfWork);
    $bcd00faefdd4b5d7$var$thenableState$1 = null;
    $bcd00faefdd4b5d7$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($bcd00faefdd4b5d7$var$throwException(root, returnFiber, unitOfWork, thrownValue, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes)) {
            $bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 1;
            $bcd00faefdd4b5d7$var$logUncaughtError(root, $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(thrownValue, root.current));
            $bcd00faefdd4b5d7$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $bcd00faefdd4b5d7$var$workInProgress = returnFiber, error;
        $bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 1;
        $bcd00faefdd4b5d7$var$logUncaughtError(root, $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(thrownValue, root.current));
        $bcd00faefdd4b5d7$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($bcd00faefdd4b5d7$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($bcd00faefdd4b5d7$var$workInProgressRootIsPrerendering || 0 !== ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $bcd00faefdd4b5d7$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $bcd00faefdd4b5d7$var$unwindUnitOfWork(unitOfWork, root);
    } else $bcd00faefdd4b5d7$var$completeUnitOfWork(unitOfWork);
}
function $bcd00faefdd4b5d7$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $bcd00faefdd4b5d7$var$unwindUnitOfWork(completedWork, $bcd00faefdd4b5d7$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $bcd00faefdd4b5d7$var$completeWork(completedWork.alternate, completedWork, $bcd00faefdd4b5d7$var$entangledRenderLanes);
        if (null !== next) {
            $bcd00faefdd4b5d7$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $bcd00faefdd4b5d7$var$workInProgress = completedWork;
            return;
        }
        $bcd00faefdd4b5d7$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $bcd00faefdd4b5d7$var$workInProgressRootExitStatus && ($bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 5);
}
function $bcd00faefdd4b5d7$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $bcd00faefdd4b5d7$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $bcd00faefdd4b5d7$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $bcd00faefdd4b5d7$var$workInProgress = unitOfWork;
            return;
        }
        $bcd00faefdd4b5d7$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $bcd00faefdd4b5d7$var$workInProgressRootExitStatus = 6;
    $bcd00faefdd4b5d7$var$workInProgress = null;
}
function $bcd00faefdd4b5d7$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $bcd00faefdd4b5d7$var$ReactSharedInternals.T, previousUpdateLanePriority = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p;
    try {
        $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = 2, $bcd00faefdd4b5d7$var$ReactSharedInternals.T = null, $bcd00faefdd4b5d7$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $bcd00faefdd4b5d7$var$ReactSharedInternals.T = prevTransition, $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $bcd00faefdd4b5d7$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $bcd00faefdd4b5d7$var$flushPassiveEffects();
    while (null !== $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects);
    if (0 !== ($bcd00faefdd4b5d7$var$executionContext & 6)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $bcd00faefdd4b5d7$var$concurrentlyUpdatedLanes;
    $bcd00faefdd4b5d7$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $bcd00faefdd4b5d7$var$workInProgressRoot && ($bcd00faefdd4b5d7$var$workInProgress = $bcd00faefdd4b5d7$var$workInProgressRoot = null, $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $bcd00faefdd4b5d7$var$rootDoesHavePassiveEffects || ($bcd00faefdd4b5d7$var$rootDoesHavePassiveEffects = !0, $bcd00faefdd4b5d7$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $bcd00faefdd4b5d7$var$pendingPassiveTransitions = transitions, $bcd00faefdd4b5d7$var$scheduleCallback$1($bcd00faefdd4b5d7$var$NormalPriority$1, function() {
        $bcd00faefdd4b5d7$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $bcd00faefdd4b5d7$var$ReactSharedInternals.T, $bcd00faefdd4b5d7$var$ReactSharedInternals.T = null, spawnedLane = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p, $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = 2, updatedLanes = $bcd00faefdd4b5d7$var$executionContext, $bcd00faefdd4b5d7$var$executionContext |= 4, $bcd00faefdd4b5d7$var$commitBeforeMutationEffects(root, finishedWork), $bcd00faefdd4b5d7$var$commitMutationEffectsOnFiber(finishedWork, root), $bcd00faefdd4b5d7$var$restoreSelection($bcd00faefdd4b5d7$var$selectionInformation, root.containerInfo), $bcd00faefdd4b5d7$var$_enabled = !!$bcd00faefdd4b5d7$var$eventsEnabled, $bcd00faefdd4b5d7$var$selectionInformation = $bcd00faefdd4b5d7$var$eventsEnabled = null, root.current = finishedWork, $bcd00faefdd4b5d7$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $bcd00faefdd4b5d7$var$requestPaint(), $bcd00faefdd4b5d7$var$executionContext = updatedLanes, $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = spawnedLane, $bcd00faefdd4b5d7$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $bcd00faefdd4b5d7$var$rootDoesHavePassiveEffects ? ($bcd00faefdd4b5d7$var$rootDoesHavePassiveEffects = !1, $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects = root, $bcd00faefdd4b5d7$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $bcd00faefdd4b5d7$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $bcd00faefdd4b5d7$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $bcd00faefdd4b5d7$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($bcd00faefdd4b5d7$var$pendingPassiveEffectsLanes & 3) && $bcd00faefdd4b5d7$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $bcd00faefdd4b5d7$var$rootWithNestedUpdates ? $bcd00faefdd4b5d7$var$nestedUpdateCount++ : ($bcd00faefdd4b5d7$var$nestedUpdateCount = 0, $bcd00faefdd4b5d7$var$rootWithNestedUpdates = root) : $bcd00faefdd4b5d7$var$nestedUpdateCount = 0;
    $bcd00faefdd4b5d7$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $bcd00faefdd4b5d7$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $bcd00faefdd4b5d7$var$releaseCache(remainingLanes)));
}
function $bcd00faefdd4b5d7$var$flushPassiveEffects() {
    if (null !== $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects) {
        var root$170 = $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects, remainingLanes = $bcd00faefdd4b5d7$var$pendingPassiveEffectsRemainingLanes;
        $bcd00faefdd4b5d7$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $bcd00faefdd4b5d7$var$lanesToEventPriority($bcd00faefdd4b5d7$var$pendingPassiveEffectsLanes), prevTransition = $bcd00faefdd4b5d7$var$ReactSharedInternals.T, previousPriority = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p;
        try {
            $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $bcd00faefdd4b5d7$var$ReactSharedInternals.T = null;
            if (null === $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $bcd00faefdd4b5d7$var$pendingPassiveTransitions;
                $bcd00faefdd4b5d7$var$pendingPassiveTransitions = null;
                var root = $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects, lanes = $bcd00faefdd4b5d7$var$pendingPassiveEffectsLanes;
                $bcd00faefdd4b5d7$var$rootWithPendingPassiveEffects = null;
                $bcd00faefdd4b5d7$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($bcd00faefdd4b5d7$var$executionContext & 6)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(331));
                var prevExecutionContext = $bcd00faefdd4b5d7$var$executionContext;
                $bcd00faefdd4b5d7$var$executionContext |= 4;
                $bcd00faefdd4b5d7$var$commitPassiveUnmountOnFiber(root.current);
                $bcd00faefdd4b5d7$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $bcd00faefdd4b5d7$var$executionContext = prevExecutionContext;
                $bcd00faefdd4b5d7$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($bcd00faefdd4b5d7$var$injectedHook && "function" === typeof $bcd00faefdd4b5d7$var$injectedHook.onPostCommitFiberRoot) try {
                    $bcd00faefdd4b5d7$var$injectedHook.onPostCommitFiberRoot($bcd00faefdd4b5d7$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = previousPriority, $bcd00faefdd4b5d7$var$ReactSharedInternals.T = prevTransition, $bcd00faefdd4b5d7$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $bcd00faefdd4b5d7$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $bcd00faefdd4b5d7$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $bcd00faefdd4b5d7$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($bcd00faefdd4b5d7$var$markRootUpdated$1(rootFiber, 2), $bcd00faefdd4b5d7$var$ensureRootIsScheduled(rootFiber));
}
function $bcd00faefdd4b5d7$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $bcd00faefdd4b5d7$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $bcd00faefdd4b5d7$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed || !$bcd00faefdd4b5d7$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $bcd00faefdd4b5d7$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $bcd00faefdd4b5d7$var$createClassErrorUpdate(2);
                instance = $bcd00faefdd4b5d7$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($bcd00faefdd4b5d7$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $bcd00faefdd4b5d7$var$markRootUpdated$1(instance, 2), $bcd00faefdd4b5d7$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $bcd00faefdd4b5d7$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $bcd00faefdd4b5d7$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($bcd00faefdd4b5d7$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $bcd00faefdd4b5d7$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $bcd00faefdd4b5d7$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $bcd00faefdd4b5d7$var$workInProgressRoot === root && ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $bcd00faefdd4b5d7$var$workInProgressRootExitStatus || 3 === $bcd00faefdd4b5d7$var$workInProgressRootExitStatus && ($bcd00faefdd4b5d7$var$workInProgressRootRenderLanes & 62914560) === $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes && 300 > $bcd00faefdd4b5d7$var$now() - $bcd00faefdd4b5d7$var$globalMostRecentFallbackTime ? 0 === ($bcd00faefdd4b5d7$var$executionContext & 2) && $bcd00faefdd4b5d7$var$prepareFreshStack(root, 0) : $bcd00faefdd4b5d7$var$workInProgressRootPingedLanes |= pingedLanes, $bcd00faefdd4b5d7$var$workInProgressSuspendedRetryLanes === $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes && ($bcd00faefdd4b5d7$var$workInProgressSuspendedRetryLanes = 0));
    $bcd00faefdd4b5d7$var$ensureRootIsScheduled(root);
}
function $bcd00faefdd4b5d7$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $bcd00faefdd4b5d7$var$claimNextRetryLane());
    boundaryFiber = $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($bcd00faefdd4b5d7$var$markRootUpdated$1(boundaryFiber, retryLane), $bcd00faefdd4b5d7$var$ensureRootIsScheduled(boundaryFiber));
}
function $bcd00faefdd4b5d7$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $bcd00faefdd4b5d7$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $bcd00faefdd4b5d7$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $bcd00faefdd4b5d7$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $bcd00faefdd4b5d7$var$scheduleCallback$1(priorityLevel, callback) {
    return $bcd00faefdd4b5d7$var$scheduleCallback$3(priorityLevel, callback);
}
var $bcd00faefdd4b5d7$var$firstScheduledRoot = null, $bcd00faefdd4b5d7$var$lastScheduledRoot = null, $bcd00faefdd4b5d7$var$didScheduleMicrotask = !1, $bcd00faefdd4b5d7$var$mightHavePendingSyncWork = !1, $bcd00faefdd4b5d7$var$isFlushingWork = !1, $bcd00faefdd4b5d7$var$currentEventTransitionLane = 0;
function $bcd00faefdd4b5d7$var$ensureRootIsScheduled(root) {
    root !== $bcd00faefdd4b5d7$var$lastScheduledRoot && null === root.next && (null === $bcd00faefdd4b5d7$var$lastScheduledRoot ? $bcd00faefdd4b5d7$var$firstScheduledRoot = $bcd00faefdd4b5d7$var$lastScheduledRoot = root : $bcd00faefdd4b5d7$var$lastScheduledRoot = $bcd00faefdd4b5d7$var$lastScheduledRoot.next = root);
    $bcd00faefdd4b5d7$var$mightHavePendingSyncWork = !0;
    $bcd00faefdd4b5d7$var$didScheduleMicrotask || ($bcd00faefdd4b5d7$var$didScheduleMicrotask = !0, $bcd00faefdd4b5d7$var$scheduleImmediateTask($bcd00faefdd4b5d7$var$processRootScheduleInMicrotask));
}
function $bcd00faefdd4b5d7$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$bcd00faefdd4b5d7$var$isFlushingWork && $bcd00faefdd4b5d7$var$mightHavePendingSyncWork) {
        $bcd00faefdd4b5d7$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $bcd00faefdd4b5d7$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $bcd00faefdd4b5d7$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $bcd00faefdd4b5d7$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $bcd00faefdd4b5d7$var$getNextLanes(root$172, root$172 === $bcd00faefdd4b5d7$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $bcd00faefdd4b5d7$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $bcd00faefdd4b5d7$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $bcd00faefdd4b5d7$var$isFlushingWork = !1;
    }
}
function $bcd00faefdd4b5d7$var$processRootScheduleInMicrotask() {
    $bcd00faefdd4b5d7$var$mightHavePendingSyncWork = $bcd00faefdd4b5d7$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $bcd00faefdd4b5d7$var$currentEventTransitionLane && ($bcd00faefdd4b5d7$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $bcd00faefdd4b5d7$var$currentEventTransitionLane), $bcd00faefdd4b5d7$var$currentEventTransitionLane = 0);
    for(var currentTime = $bcd00faefdd4b5d7$var$now(), prev = null, root = $bcd00faefdd4b5d7$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $bcd00faefdd4b5d7$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $bcd00faefdd4b5d7$var$firstScheduledRoot = next : prev.next = next, null === next && ($bcd00faefdd4b5d7$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $bcd00faefdd4b5d7$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $bcd00faefdd4b5d7$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $bcd00faefdd4b5d7$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $bcd00faefdd4b5d7$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $bcd00faefdd4b5d7$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $bcd00faefdd4b5d7$var$workInProgressRoot;
    suspendedLanes = $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes;
    suspendedLanes = $bcd00faefdd4b5d7$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $bcd00faefdd4b5d7$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $bcd00faefdd4b5d7$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $bcd00faefdd4b5d7$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $bcd00faefdd4b5d7$var$cancelCallback$1(pingedLanes);
        switch($bcd00faefdd4b5d7$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $bcd00faefdd4b5d7$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $bcd00faefdd4b5d7$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $bcd00faefdd4b5d7$var$IdlePriority;
                break;
            default:
                suspendedLanes = $bcd00faefdd4b5d7$var$NormalPriority$1;
        }
        pingedLanes = $bcd00faefdd4b5d7$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $bcd00faefdd4b5d7$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $bcd00faefdd4b5d7$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $bcd00faefdd4b5d7$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($bcd00faefdd4b5d7$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $bcd00faefdd4b5d7$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $bcd00faefdd4b5d7$var$getNextLanes(root, root === $bcd00faefdd4b5d7$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $bcd00faefdd4b5d7$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $bcd00faefdd4b5d7$var$scheduleTaskForRootDuringMicrotask(root, $bcd00faefdd4b5d7$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $bcd00faefdd4b5d7$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $bcd00faefdd4b5d7$var$performSyncWorkOnRoot(root, lanes) {
    if ($bcd00faefdd4b5d7$var$flushPassiveEffects()) return null;
    $bcd00faefdd4b5d7$var$performWorkOnRoot(root, lanes, !0);
}
function $bcd00faefdd4b5d7$var$scheduleImmediateTask(cb) {
    $bcd00faefdd4b5d7$var$scheduleMicrotask(function() {
        0 !== ($bcd00faefdd4b5d7$var$executionContext & 6) ? $bcd00faefdd4b5d7$var$scheduleCallback$3($bcd00faefdd4b5d7$var$ImmediatePriority, cb) : cb();
    });
}
function $bcd00faefdd4b5d7$var$requestTransitionLane() {
    0 === $bcd00faefdd4b5d7$var$currentEventTransitionLane && ($bcd00faefdd4b5d7$var$currentEventTransitionLane = $bcd00faefdd4b5d7$var$claimNextTransitionLane());
    return $bcd00faefdd4b5d7$var$currentEventTransitionLane;
}
function $bcd00faefdd4b5d7$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === (typeof actionProp === "undefined" ? "undefined" : (0, $YtE9h._)(actionProp)) || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $bcd00faefdd4b5d7$var$sanitizeURL("" + actionProp);
}
function $bcd00faefdd4b5d7$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $bcd00faefdd4b5d7$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $bcd00faefdd4b5d7$var$coerceFormActionProp((nativeEventTarget[$bcd00faefdd4b5d7$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$bcd00faefdd4b5d7$var$internalPropsKey] || null) ? $bcd00faefdd4b5d7$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $bcd00faefdd4b5d7$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function listener() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $bcd00faefdd4b5d7$var$currentEventTransitionLane) {
                                var formData = submitter ? $bcd00faefdd4b5d7$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $bcd00faefdd4b5d7$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $bcd00faefdd4b5d7$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $bcd00faefdd4b5d7$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $bcd00faefdd4b5d7$var$i$jscomp$inline_1439 = 0; $bcd00faefdd4b5d7$var$i$jscomp$inline_1439 < $bcd00faefdd4b5d7$var$simpleEventPluginEvents.length; $bcd00faefdd4b5d7$var$i$jscomp$inline_1439++){
    var $bcd00faefdd4b5d7$var$eventName$jscomp$inline_1440 = $bcd00faefdd4b5d7$var$simpleEventPluginEvents[$bcd00faefdd4b5d7$var$i$jscomp$inline_1439], $bcd00faefdd4b5d7$var$domEventName$jscomp$inline_1441 = $bcd00faefdd4b5d7$var$eventName$jscomp$inline_1440.toLowerCase(), $bcd00faefdd4b5d7$var$capitalizedEvent$jscomp$inline_1442 = $bcd00faefdd4b5d7$var$eventName$jscomp$inline_1440[0].toUpperCase() + $bcd00faefdd4b5d7$var$eventName$jscomp$inline_1440.slice(1);
    $bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$domEventName$jscomp$inline_1441, "on" + $bcd00faefdd4b5d7$var$capitalizedEvent$jscomp$inline_1442);
}
$bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$ANIMATION_END, "onAnimationEnd");
$bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$ANIMATION_ITERATION, "onAnimationIteration");
$bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$ANIMATION_START, "onAnimationStart");
$bcd00faefdd4b5d7$var$registerSimpleEvent("dblclick", "onDoubleClick");
$bcd00faefdd4b5d7$var$registerSimpleEvent("focusin", "onFocus");
$bcd00faefdd4b5d7$var$registerSimpleEvent("focusout", "onBlur");
$bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$TRANSITION_RUN, "onTransitionRun");
$bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$TRANSITION_START, "onTransitionStart");
$bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$TRANSITION_CANCEL, "onTransitionCancel");
$bcd00faefdd4b5d7$var$registerSimpleEvent($bcd00faefdd4b5d7$var$TRANSITION_END, "onTransitionEnd");
$bcd00faefdd4b5d7$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$bcd00faefdd4b5d7$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$bcd00faefdd4b5d7$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$bcd00faefdd4b5d7$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$bcd00faefdd4b5d7$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$bcd00faefdd4b5d7$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$bcd00faefdd4b5d7$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$bcd00faefdd4b5d7$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$bcd00faefdd4b5d7$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$bcd00faefdd4b5d7$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $bcd00faefdd4b5d7$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $bcd00faefdd4b5d7$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($bcd00faefdd4b5d7$var$mediaEventTypes));
function $bcd00faefdd4b5d7$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $bcd00faefdd4b5d7$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $bcd00faefdd4b5d7$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$bcd00faefdd4b5d7$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$bcd00faefdd4b5d7$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($bcd00faefdd4b5d7$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $bcd00faefdd4b5d7$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $bcd00faefdd4b5d7$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $bcd00faefdd4b5d7$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $bcd00faefdd4b5d7$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$bcd00faefdd4b5d7$var$listeningMarker]) {
        rootContainerElement[$bcd00faefdd4b5d7$var$listeningMarker] = !0;
        $bcd00faefdd4b5d7$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($bcd00faefdd4b5d7$var$nonDelegatedEvents.has(domEventName) || $bcd00faefdd4b5d7$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $bcd00faefdd4b5d7$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$bcd00faefdd4b5d7$var$listeningMarker] || (ownerDocument[$bcd00faefdd4b5d7$var$listeningMarker] = !0, $bcd00faefdd4b5d7$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $bcd00faefdd4b5d7$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($bcd00faefdd4b5d7$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $bcd00faefdd4b5d7$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $bcd00faefdd4b5d7$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $bcd00faefdd4b5d7$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$bcd00faefdd4b5d7$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $bcd00faefdd4b5d7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $bcd00faefdd4b5d7$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $bcd00faefdd4b5d7$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $bcd00faefdd4b5d7$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $bcd00faefdd4b5d7$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $bcd00faefdd4b5d7$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticTouchEvent;
                        break;
                    case $bcd00faefdd4b5d7$var$ANIMATION_END:
                    case $bcd00faefdd4b5d7$var$ANIMATION_ITERATION:
                    case $bcd00faefdd4b5d7$var$ANIMATION_START:
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticAnimationEvent;
                        break;
                    case $bcd00faefdd4b5d7$var$TRANSITION_END:
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $bcd00faefdd4b5d7$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $bcd00faefdd4b5d7$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($bcd00faefdd4b5d7$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $bcd00faefdd4b5d7$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($bcd00faefdd4b5d7$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$bcd00faefdd4b5d7$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $bcd00faefdd4b5d7$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $bcd00faefdd4b5d7$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $bcd00faefdd4b5d7$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $bcd00faefdd4b5d7$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $bcd00faefdd4b5d7$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $bcd00faefdd4b5d7$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $bcd00faefdd4b5d7$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $bcd00faefdd4b5d7$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $bcd00faefdd4b5d7$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $bcd00faefdd4b5d7$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $bcd00faefdd4b5d7$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $bcd00faefdd4b5d7$var$getParent(inCapturePhase);
                                reactEventName = $bcd00faefdd4b5d7$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $bcd00faefdd4b5d7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $bcd00faefdd4b5d7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $bcd00faefdd4b5d7$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $bcd00faefdd4b5d7$var$getTargetInstForChangeEvent;
                else if ($bcd00faefdd4b5d7$var$isTextInputElement(reactName)) {
                    if ($bcd00faefdd4b5d7$var$isInputEventSupported) getTargetInstFunc = $bcd00faefdd4b5d7$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $bcd00faefdd4b5d7$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $bcd00faefdd4b5d7$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $bcd00faefdd4b5d7$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $bcd00faefdd4b5d7$var$getTargetInstForChangeEvent) : getTargetInstFunc = $bcd00faefdd4b5d7$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $bcd00faefdd4b5d7$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $bcd00faefdd4b5d7$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $bcd00faefdd4b5d7$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($bcd00faefdd4b5d7$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $bcd00faefdd4b5d7$var$activeElement = handleEventFunc, $bcd00faefdd4b5d7$var$activeElementInst = targetInst, $bcd00faefdd4b5d7$var$lastSelection = null;
                    break;
                case "focusout":
                    $bcd00faefdd4b5d7$var$lastSelection = $bcd00faefdd4b5d7$var$activeElementInst = $bcd00faefdd4b5d7$var$activeElement = null;
                    break;
                case "mousedown":
                    $bcd00faefdd4b5d7$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $bcd00faefdd4b5d7$var$mouseDown = !1;
                    $bcd00faefdd4b5d7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($bcd00faefdd4b5d7$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $bcd00faefdd4b5d7$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($bcd00faefdd4b5d7$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $bcd00faefdd4b5d7$var$isComposing ? $bcd00faefdd4b5d7$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($bcd00faefdd4b5d7$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($bcd00faefdd4b5d7$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $bcd00faefdd4b5d7$var$isComposing && (fallbackData = $bcd00faefdd4b5d7$var$getData()) : ($bcd00faefdd4b5d7$var$root = nativeEventTarget, $bcd00faefdd4b5d7$var$startText = "value" in $bcd00faefdd4b5d7$var$root ? $bcd00faefdd4b5d7$var$root.value : $bcd00faefdd4b5d7$var$root.textContent, $bcd00faefdd4b5d7$var$isComposing = !0)), handleEventFunc = $bcd00faefdd4b5d7$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $bcd00faefdd4b5d7$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $bcd00faefdd4b5d7$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $bcd00faefdd4b5d7$var$canUseTextInputEvent ? $bcd00faefdd4b5d7$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $bcd00faefdd4b5d7$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $bcd00faefdd4b5d7$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $bcd00faefdd4b5d7$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $bcd00faefdd4b5d7$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $bcd00faefdd4b5d7$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $bcd00faefdd4b5d7$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $bcd00faefdd4b5d7$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $bcd00faefdd4b5d7$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($bcd00faefdd4b5d7$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $bcd00faefdd4b5d7$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($bcd00faefdd4b5d7$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $bcd00faefdd4b5d7$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $bcd00faefdd4b5d7$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $bcd00faefdd4b5d7$var$getListener(target, registrationName), null != stateNode && listeners.unshift($bcd00faefdd4b5d7$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $bcd00faefdd4b5d7$var$getListener(target, registrationName), null != stateNode && listeners.push($bcd00faefdd4b5d7$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $bcd00faefdd4b5d7$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $bcd00faefdd4b5d7$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $bcd00faefdd4b5d7$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($bcd00faefdd4b5d7$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($bcd00faefdd4b5d7$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $bcd00faefdd4b5d7$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $bcd00faefdd4b5d7$var$normalizeMarkupForTextOrAttribute(clientText);
    return $bcd00faefdd4b5d7$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $bcd00faefdd4b5d7$var$noop$1() {}
function $bcd00faefdd4b5d7$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $bcd00faefdd4b5d7$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value))) && "body" !== tag && $bcd00faefdd4b5d7$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $bcd00faefdd4b5d7$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $bcd00faefdd4b5d7$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $bcd00faefdd4b5d7$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $bcd00faefdd4b5d7$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $bcd00faefdd4b5d7$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $bcd00faefdd4b5d7$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $bcd00faefdd4b5d7$var$setProp(domElement, tag, "name", props.name, props, null), $bcd00faefdd4b5d7$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $bcd00faefdd4b5d7$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $bcd00faefdd4b5d7$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($bcd00faefdd4b5d7$var$setProp(domElement, tag, "encType", props.encType, props, null), $bcd00faefdd4b5d7$var$setProp(domElement, tag, "method", props.method, props, null), $bcd00faefdd4b5d7$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $bcd00faefdd4b5d7$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $bcd00faefdd4b5d7$var$noop$1);
            break;
        case "onScroll":
            null != value && $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) || !("__html" in value)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value));
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value));
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value))) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $bcd00faefdd4b5d7$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("toggle", domElement);
            $bcd00faefdd4b5d7$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $bcd00faefdd4b5d7$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $bcd00faefdd4b5d7$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $bcd00faefdd4b5d7$var$aliases.get(key) || key, $bcd00faefdd4b5d7$var$setValueForAttribute(domElement, key, value);
    }
}
function $bcd00faefdd4b5d7$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $bcd00faefdd4b5d7$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) || !("__html" in value)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $bcd00faefdd4b5d7$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value))) && $bcd00faefdd4b5d7$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $bcd00faefdd4b5d7$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$bcd00faefdd4b5d7$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$bcd00faefdd4b5d7$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $bcd00faefdd4b5d7$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $bcd00faefdd4b5d7$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("error", domElement);
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(137, tag));
                    default:
                        $bcd00faefdd4b5d7$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $bcd00faefdd4b5d7$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $bcd00faefdd4b5d7$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $bcd00faefdd4b5d7$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $bcd00faefdd4b5d7$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $bcd00faefdd4b5d7$var$track(domElement);
            return;
        case "select":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $bcd00faefdd4b5d7$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $bcd00faefdd4b5d7$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(91));
                    break;
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $bcd00faefdd4b5d7$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $bcd00faefdd4b5d7$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== (typeof hasSrc === "undefined" ? "undefined" : (0, $YtE9h._)(hasSrc));
                    break;
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("cancel", domElement);
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $bcd00faefdd4b5d7$var$mediaEventTypes.length; hasSrc++)$bcd00faefdd4b5d7$var$listenToNonDelegatedEvent($bcd00faefdd4b5d7$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("error", domElement);
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("error", domElement), $bcd00faefdd4b5d7$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(137, tag));
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($bcd00faefdd4b5d7$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $bcd00faefdd4b5d7$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $bcd00faefdd4b5d7$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $bcd00faefdd4b5d7$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $bcd00faefdd4b5d7$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $bcd00faefdd4b5d7$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $bcd00faefdd4b5d7$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $bcd00faefdd4b5d7$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $bcd00faefdd4b5d7$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $bcd00faefdd4b5d7$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $bcd00faefdd4b5d7$var$updateOptions(domElement, !!lastProps, tag, !0) : $bcd00faefdd4b5d7$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $bcd00faefdd4b5d7$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $bcd00faefdd4b5d7$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== (typeof propKey$203 === "undefined" ? "undefined" : (0, $YtE9h._)(propKey$203));
                    break;
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $bcd00faefdd4b5d7$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $bcd00faefdd4b5d7$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($bcd00faefdd4b5d7$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $bcd00faefdd4b5d7$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $bcd00faefdd4b5d7$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $bcd00faefdd4b5d7$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $bcd00faefdd4b5d7$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $bcd00faefdd4b5d7$var$eventsEnabled = null, $bcd00faefdd4b5d7$var$selectionInformation = null;
function $bcd00faefdd4b5d7$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $bcd00faefdd4b5d7$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $bcd00faefdd4b5d7$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $bcd00faefdd4b5d7$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === (0, $YtE9h._)(props.children) || "object" === (0, $YtE9h._)(props.dangerouslySetInnerHTML) && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $bcd00faefdd4b5d7$var$currentPopstateTransitionEvent = null;
function $bcd00faefdd4b5d7$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $bcd00faefdd4b5d7$var$currentPopstateTransitionEvent) return !1;
        $bcd00faefdd4b5d7$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $bcd00faefdd4b5d7$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $bcd00faefdd4b5d7$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $bcd00faefdd4b5d7$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $bcd00faefdd4b5d7$var$localPromise = "function" === typeof Promise ? Promise : void 0, $bcd00faefdd4b5d7$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $bcd00faefdd4b5d7$var$localPromise ? function scheduleMicrotask(callback) {
    return $bcd00faefdd4b5d7$var$localPromise.resolve(null).then(callback).catch($bcd00faefdd4b5d7$var$handleErrorInNextTick);
} : $bcd00faefdd4b5d7$var$scheduleTimeout;
function $bcd00faefdd4b5d7$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $bcd00faefdd4b5d7$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $bcd00faefdd4b5d7$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $bcd00faefdd4b5d7$var$retryIfBlockedOn(suspenseInstance);
}
function $bcd00faefdd4b5d7$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $bcd00faefdd4b5d7$var$clearContainerSparingly(node);
                $bcd00faefdd4b5d7$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $bcd00faefdd4b5d7$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$bcd00faefdd4b5d7$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $bcd00faefdd4b5d7$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $bcd00faefdd4b5d7$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $bcd00faefdd4b5d7$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $bcd00faefdd4b5d7$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $bcd00faefdd4b5d7$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $bcd00faefdd4b5d7$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $bcd00faefdd4b5d7$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(451));
    }
}
var $bcd00faefdd4b5d7$var$preloadPropsMap = new Map(), $bcd00faefdd4b5d7$var$preconnectsSet = new Set();
function $bcd00faefdd4b5d7$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $bcd00faefdd4b5d7$var$previousDispatcher = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.d;
$bcd00faefdd4b5d7$var$ReactDOMSharedInternals.d = {
    f: $bcd00faefdd4b5d7$var$flushSyncWork,
    r: $bcd00faefdd4b5d7$var$requestFormReset,
    D: $bcd00faefdd4b5d7$var$prefetchDNS,
    C: $bcd00faefdd4b5d7$var$preconnect,
    L: $bcd00faefdd4b5d7$var$preload,
    m: $bcd00faefdd4b5d7$var$preloadModule,
    X: $bcd00faefdd4b5d7$var$preinitScript,
    S: $bcd00faefdd4b5d7$var$preinitStyle,
    M: $bcd00faefdd4b5d7$var$preinitModuleScript
};
function $bcd00faefdd4b5d7$var$flushSyncWork() {
    var previousWasRendering = $bcd00faefdd4b5d7$var$previousDispatcher.f(), wasRendering = $bcd00faefdd4b5d7$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $bcd00faefdd4b5d7$var$requestFormReset(form) {
    var formInst = $bcd00faefdd4b5d7$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $bcd00faefdd4b5d7$var$requestFormReset$1(formInst) : $bcd00faefdd4b5d7$var$previousDispatcher.r(form);
}
var $bcd00faefdd4b5d7$var$globalDocument = "undefined" === typeof document ? null : document;
function $bcd00faefdd4b5d7$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $bcd00faefdd4b5d7$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $bcd00faefdd4b5d7$var$preconnectsSet.has(limitedEscapedHref) || ($bcd00faefdd4b5d7$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $bcd00faefdd4b5d7$var$setInitialProperties(href, "link", rel), $bcd00faefdd4b5d7$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $bcd00faefdd4b5d7$var$prefetchDNS(href) {
    $bcd00faefdd4b5d7$var$previousDispatcher.D(href);
    $bcd00faefdd4b5d7$var$preconnectAs("dns-prefetch", href, null);
}
function $bcd00faefdd4b5d7$var$preconnect(href, crossOrigin) {
    $bcd00faefdd4b5d7$var$previousDispatcher.C(href, crossOrigin);
    $bcd00faefdd4b5d7$var$preconnectAs("preconnect", href, crossOrigin);
}
function $bcd00faefdd4b5d7$var$preload(href, as, options) {
    $bcd00faefdd4b5d7$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $bcd00faefdd4b5d7$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $bcd00faefdd4b5d7$var$getStyleKey(href);
                break;
            case "script":
                key = $bcd00faefdd4b5d7$var$getScriptKey(href);
        }
        $bcd00faefdd4b5d7$var$preloadPropsMap.has(key) || (href = $bcd00faefdd4b5d7$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $bcd00faefdd4b5d7$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($bcd00faefdd4b5d7$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($bcd00faefdd4b5d7$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $bcd00faefdd4b5d7$var$setInitialProperties(as, "link", href), $bcd00faefdd4b5d7$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $bcd00faefdd4b5d7$var$preloadModule(href, options) {
    $bcd00faefdd4b5d7$var$previousDispatcher.m(href, options);
    var ownerDocument = $bcd00faefdd4b5d7$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $bcd00faefdd4b5d7$var$getScriptKey(href);
        }
        if (!$bcd00faefdd4b5d7$var$preloadPropsMap.has(key) && (href = $bcd00faefdd4b5d7$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $bcd00faefdd4b5d7$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($bcd00faefdd4b5d7$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $bcd00faefdd4b5d7$var$setInitialProperties(as, "link", href);
            $bcd00faefdd4b5d7$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $bcd00faefdd4b5d7$var$preinitStyle(href, precedence, options) {
    $bcd00faefdd4b5d7$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $bcd00faefdd4b5d7$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $bcd00faefdd4b5d7$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $bcd00faefdd4b5d7$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($bcd00faefdd4b5d7$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $bcd00faefdd4b5d7$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $bcd00faefdd4b5d7$var$preloadPropsMap.get(key)) && $bcd00faefdd4b5d7$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $bcd00faefdd4b5d7$var$markNodeAsHoistable(link);
                $bcd00faefdd4b5d7$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $bcd00faefdd4b5d7$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $bcd00faefdd4b5d7$var$preinitScript(src, options) {
    $bcd00faefdd4b5d7$var$previousDispatcher.X(src, options);
    var ownerDocument = $bcd00faefdd4b5d7$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $bcd00faefdd4b5d7$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $bcd00faefdd4b5d7$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($bcd00faefdd4b5d7$var$getScriptSelectorFromKey(key)), resource || (src = $bcd00faefdd4b5d7$var$assign({
            src: src,
            async: !0
        }, options), (options = $bcd00faefdd4b5d7$var$preloadPropsMap.get(key)) && $bcd00faefdd4b5d7$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $bcd00faefdd4b5d7$var$markNodeAsHoistable(resource), $bcd00faefdd4b5d7$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $bcd00faefdd4b5d7$var$preinitModuleScript(src, options) {
    $bcd00faefdd4b5d7$var$previousDispatcher.M(src, options);
    var ownerDocument = $bcd00faefdd4b5d7$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $bcd00faefdd4b5d7$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $bcd00faefdd4b5d7$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($bcd00faefdd4b5d7$var$getScriptSelectorFromKey(key)), resource || (src = $bcd00faefdd4b5d7$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $bcd00faefdd4b5d7$var$preloadPropsMap.get(key)) && $bcd00faefdd4b5d7$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $bcd00faefdd4b5d7$var$markNodeAsHoistable(resource), $bcd00faefdd4b5d7$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $bcd00faefdd4b5d7$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $bcd00faefdd4b5d7$var$rootInstanceStackCursor.current) ? $bcd00faefdd4b5d7$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $bcd00faefdd4b5d7$var$getStyleKey(pendingProps.href), pendingProps = $bcd00faefdd4b5d7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $bcd00faefdd4b5d7$var$getStyleKey(pendingProps.href);
                var styles$242 = $bcd00faefdd4b5d7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($bcd00faefdd4b5d7$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $bcd00faefdd4b5d7$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $bcd00faefdd4b5d7$var$preloadPropsMap.set(type, pendingProps), styles$242 || $bcd00faefdd4b5d7$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== (typeof currentProps === "undefined" ? "undefined" : (0, $YtE9h._)(currentProps)) ? (currentProps = $bcd00faefdd4b5d7$var$getScriptKey(pendingProps), pendingProps = $bcd00faefdd4b5d7$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(444, type));
    }
}
function $bcd00faefdd4b5d7$var$getStyleKey(href) {
    return 'href="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $bcd00faefdd4b5d7$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $bcd00faefdd4b5d7$var$stylesheetPropsFromRawProps(rawProps) {
    return $bcd00faefdd4b5d7$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $bcd00faefdd4b5d7$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $bcd00faefdd4b5d7$var$setInitialProperties(key, "link", preloadProps), $bcd00faefdd4b5d7$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $bcd00faefdd4b5d7$var$getScriptKey(src) {
    return '[src="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $bcd00faefdd4b5d7$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $bcd00faefdd4b5d7$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $bcd00faefdd4b5d7$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $bcd00faefdd4b5d7$var$markNodeAsHoistable(instance), instance;
            var styleProps = $bcd00faefdd4b5d7$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $bcd00faefdd4b5d7$var$markNodeAsHoistable(instance);
            $bcd00faefdd4b5d7$var$setInitialProperties(instance, "style", styleProps);
            $bcd00faefdd4b5d7$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $bcd00faefdd4b5d7$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($bcd00faefdd4b5d7$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $bcd00faefdd4b5d7$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $bcd00faefdd4b5d7$var$stylesheetPropsFromRawProps(props);
            (styleProps = $bcd00faefdd4b5d7$var$preloadPropsMap.get(styleProps)) && $bcd00faefdd4b5d7$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $bcd00faefdd4b5d7$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $bcd00faefdd4b5d7$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $bcd00faefdd4b5d7$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $bcd00faefdd4b5d7$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($bcd00faefdd4b5d7$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $bcd00faefdd4b5d7$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $bcd00faefdd4b5d7$var$preloadPropsMap.get(instance$248)) instance = $bcd00faefdd4b5d7$var$assign({}, props), $bcd00faefdd4b5d7$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $bcd00faefdd4b5d7$var$markNodeAsHoistable(styleProps);
            $bcd00faefdd4b5d7$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $bcd00faefdd4b5d7$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $bcd00faefdd4b5d7$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $bcd00faefdd4b5d7$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $bcd00faefdd4b5d7$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $bcd00faefdd4b5d7$var$tagCaches = null;
function $bcd00faefdd4b5d7$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $bcd00faefdd4b5d7$var$tagCaches) {
        var cache = new Map();
        var caches = $bcd00faefdd4b5d7$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $bcd00faefdd4b5d7$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$bcd00faefdd4b5d7$var$internalHoistableMarker] || node[$bcd00faefdd4b5d7$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $bcd00faefdd4b5d7$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $bcd00faefdd4b5d7$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== (0, $YtE9h._)(props.async) && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $bcd00faefdd4b5d7$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $bcd00faefdd4b5d7$var$suspendedState = null;
function $bcd00faefdd4b5d7$var$noop() {}
function $bcd00faefdd4b5d7$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $bcd00faefdd4b5d7$var$suspendedState) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(475));
    var state = $bcd00faefdd4b5d7$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $bcd00faefdd4b5d7$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($bcd00faefdd4b5d7$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === (typeof hoistableRoot === "undefined" ? "undefined" : (0, $YtE9h._)(hoistableRoot)) && "function" === typeof hoistableRoot.then && (state.count++, state = $bcd00faefdd4b5d7$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $bcd00faefdd4b5d7$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $bcd00faefdd4b5d7$var$stylesheetPropsFromRawProps(props);
            (key = $bcd00faefdd4b5d7$var$preloadPropsMap.get(key)) && $bcd00faefdd4b5d7$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $bcd00faefdd4b5d7$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $bcd00faefdd4b5d7$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $bcd00faefdd4b5d7$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $bcd00faefdd4b5d7$var$waitForCommitToBeReady() {
    if (null === $bcd00faefdd4b5d7$var$suspendedState) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(475));
    var state = $bcd00faefdd4b5d7$var$suspendedState;
    state.stylesheets && 0 === state.count && $bcd00faefdd4b5d7$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $bcd00faefdd4b5d7$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $bcd00faefdd4b5d7$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $bcd00faefdd4b5d7$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $bcd00faefdd4b5d7$var$precedencesByRoot = null;
function $bcd00faefdd4b5d7$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $bcd00faefdd4b5d7$var$precedencesByRoot = new Map(), resources.forEach($bcd00faefdd4b5d7$var$insertStylesheetIntoRoot, state), $bcd00faefdd4b5d7$var$precedencesByRoot = null, $bcd00faefdd4b5d7$var$onUnsuspend.call(state));
}
function $bcd00faefdd4b5d7$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $bcd00faefdd4b5d7$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $bcd00faefdd4b5d7$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $bcd00faefdd4b5d7$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $bcd00faefdd4b5d7$var$HostTransitionContext = {
    $$typeof: $bcd00faefdd4b5d7$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $bcd00faefdd4b5d7$var$sharedNotPendingObject,
    _currentValue2: $bcd00faefdd4b5d7$var$sharedNotPendingObject,
    _threadCount: 0
};
function $bcd00faefdd4b5d7$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $bcd00faefdd4b5d7$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $bcd00faefdd4b5d7$var$createLaneMap(0);
    this.hiddenUpdates = $bcd00faefdd4b5d7$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $bcd00faefdd4b5d7$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $bcd00faefdd4b5d7$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $bcd00faefdd4b5d7$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $bcd00faefdd4b5d7$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $bcd00faefdd4b5d7$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $bcd00faefdd4b5d7$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $bcd00faefdd4b5d7$var$emptyContextObject;
    parentComponent = $bcd00faefdd4b5d7$var$emptyContextObject;
    return parentComponent;
}
function $bcd00faefdd4b5d7$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $bcd00faefdd4b5d7$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $bcd00faefdd4b5d7$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $bcd00faefdd4b5d7$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(element, rootFiber, lane), $bcd00faefdd4b5d7$var$entangleTransitions(element, rootFiber, lane));
}
function $bcd00faefdd4b5d7$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $bcd00faefdd4b5d7$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $bcd00faefdd4b5d7$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $bcd00faefdd4b5d7$var$markRetryLaneImpl(fiber, retryLane);
}
function $bcd00faefdd4b5d7$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $bcd00faefdd4b5d7$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $bcd00faefdd4b5d7$var$_enabled = !0;
function $bcd00faefdd4b5d7$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $bcd00faefdd4b5d7$var$ReactSharedInternals.T;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.T = null;
    var previousPriority = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p;
    try {
        $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = 2, $bcd00faefdd4b5d7$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = previousPriority, $bcd00faefdd4b5d7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $bcd00faefdd4b5d7$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $bcd00faefdd4b5d7$var$ReactSharedInternals.T;
    $bcd00faefdd4b5d7$var$ReactSharedInternals.T = null;
    var previousPriority = $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p;
    try {
        $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = 8, $bcd00faefdd4b5d7$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $bcd00faefdd4b5d7$var$ReactDOMSharedInternals.p = previousPriority, $bcd00faefdd4b5d7$var$ReactSharedInternals.T = prevTransition;
    }
}
function $bcd00faefdd4b5d7$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($bcd00faefdd4b5d7$var$_enabled) {
        var blockedOn = $bcd00faefdd4b5d7$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $bcd00faefdd4b5d7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $bcd00faefdd4b5d7$var$return_targetInst, targetContainer), $bcd00faefdd4b5d7$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($bcd00faefdd4b5d7$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($bcd00faefdd4b5d7$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $bcd00faefdd4b5d7$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $bcd00faefdd4b5d7$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $bcd00faefdd4b5d7$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $bcd00faefdd4b5d7$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $bcd00faefdd4b5d7$var$ensureRootIsScheduled(fiber);
                                0 === ($bcd00faefdd4b5d7$var$executionContext & 6) && ($bcd00faefdd4b5d7$var$workInProgressRootRenderTargetTime = $bcd00faefdd4b5d7$var$now() + 500, $bcd00faefdd4b5d7$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root, fiber, 2), $bcd00faefdd4b5d7$var$flushSyncWork$1(), $bcd00faefdd4b5d7$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $bcd00faefdd4b5d7$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $bcd00faefdd4b5d7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $bcd00faefdd4b5d7$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $bcd00faefdd4b5d7$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $bcd00faefdd4b5d7$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $bcd00faefdd4b5d7$var$getEventTarget(nativeEvent);
    return $bcd00faefdd4b5d7$var$findInstanceBlockingTarget(nativeEvent);
}
var $bcd00faefdd4b5d7$var$return_targetInst = null;
function $bcd00faefdd4b5d7$var$findInstanceBlockingTarget(targetNode) {
    $bcd00faefdd4b5d7$var$return_targetInst = null;
    targetNode = $bcd00faefdd4b5d7$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $bcd00faefdd4b5d7$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $bcd00faefdd4b5d7$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $bcd00faefdd4b5d7$var$return_targetInst = targetNode;
    return null;
}
function $bcd00faefdd4b5d7$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($bcd00faefdd4b5d7$var$getCurrentPriorityLevel()){
                case $bcd00faefdd4b5d7$var$ImmediatePriority:
                    return 2;
                case $bcd00faefdd4b5d7$var$UserBlockingPriority:
                    return 8;
                case $bcd00faefdd4b5d7$var$NormalPriority$1:
                case $bcd00faefdd4b5d7$var$LowPriority:
                    return 32;
                case $bcd00faefdd4b5d7$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $bcd00faefdd4b5d7$var$hasScheduledReplayAttempt = !1, $bcd00faefdd4b5d7$var$queuedFocus = null, $bcd00faefdd4b5d7$var$queuedDrag = null, $bcd00faefdd4b5d7$var$queuedMouse = null, $bcd00faefdd4b5d7$var$queuedPointers = new Map(), $bcd00faefdd4b5d7$var$queuedPointerCaptures = new Map(), $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets = [], $bcd00faefdd4b5d7$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $bcd00faefdd4b5d7$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $bcd00faefdd4b5d7$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $bcd00faefdd4b5d7$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $bcd00faefdd4b5d7$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $bcd00faefdd4b5d7$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $bcd00faefdd4b5d7$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $bcd00faefdd4b5d7$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $bcd00faefdd4b5d7$var$getInstanceFromNode(blockedOn), null !== blockedOn && $bcd00faefdd4b5d7$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $bcd00faefdd4b5d7$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $bcd00faefdd4b5d7$var$queuedFocus = $bcd00faefdd4b5d7$var$accumulateOrCreateContinuousQueuedReplayableEvent($bcd00faefdd4b5d7$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $bcd00faefdd4b5d7$var$queuedDrag = $bcd00faefdd4b5d7$var$accumulateOrCreateContinuousQueuedReplayableEvent($bcd00faefdd4b5d7$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $bcd00faefdd4b5d7$var$queuedMouse = $bcd00faefdd4b5d7$var$accumulateOrCreateContinuousQueuedReplayableEvent($bcd00faefdd4b5d7$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $bcd00faefdd4b5d7$var$queuedPointers.set(pointerId, $bcd00faefdd4b5d7$var$accumulateOrCreateContinuousQueuedReplayableEvent($bcd00faefdd4b5d7$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $bcd00faefdd4b5d7$var$queuedPointerCaptures.set(pointerId, $bcd00faefdd4b5d7$var$accumulateOrCreateContinuousQueuedReplayableEvent($bcd00faefdd4b5d7$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $bcd00faefdd4b5d7$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $bcd00faefdd4b5d7$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $bcd00faefdd4b5d7$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $bcd00faefdd4b5d7$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $bcd00faefdd4b5d7$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $bcd00faefdd4b5d7$var$requestUpdateLane(), root = $bcd00faefdd4b5d7$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $bcd00faefdd4b5d7$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $bcd00faefdd4b5d7$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $bcd00faefdd4b5d7$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $bcd00faefdd4b5d7$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $bcd00faefdd4b5d7$var$currentReplayingEvent = null;
        } else return targetContainers = $bcd00faefdd4b5d7$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $bcd00faefdd4b5d7$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $bcd00faefdd4b5d7$var$replayUnblockedEvents() {
    $bcd00faefdd4b5d7$var$hasScheduledReplayAttempt = !1;
    null !== $bcd00faefdd4b5d7$var$queuedFocus && $bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEvent($bcd00faefdd4b5d7$var$queuedFocus) && ($bcd00faefdd4b5d7$var$queuedFocus = null);
    null !== $bcd00faefdd4b5d7$var$queuedDrag && $bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEvent($bcd00faefdd4b5d7$var$queuedDrag) && ($bcd00faefdd4b5d7$var$queuedDrag = null);
    null !== $bcd00faefdd4b5d7$var$queuedMouse && $bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEvent($bcd00faefdd4b5d7$var$queuedMouse) && ($bcd00faefdd4b5d7$var$queuedMouse = null);
    $bcd00faefdd4b5d7$var$queuedPointers.forEach($bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEventInMap);
    $bcd00faefdd4b5d7$var$queuedPointerCaptures.forEach($bcd00faefdd4b5d7$var$attemptReplayContinuousQueuedEventInMap);
}
function $bcd00faefdd4b5d7$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $bcd00faefdd4b5d7$var$hasScheduledReplayAttempt || ($bcd00faefdd4b5d7$var$hasScheduledReplayAttempt = !0, $go0bk.unstable_scheduleCallback($go0bk.unstable_NormalPriority, $bcd00faefdd4b5d7$var$replayUnblockedEvents)));
}
var $bcd00faefdd4b5d7$var$lastScheduledReplayQueue = null;
function $bcd00faefdd4b5d7$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $bcd00faefdd4b5d7$var$lastScheduledReplayQueue !== formReplayingQueue && ($bcd00faefdd4b5d7$var$lastScheduledReplayQueue = formReplayingQueue, $go0bk.unstable_scheduleCallback($go0bk.unstable_NormalPriority, function() {
        $bcd00faefdd4b5d7$var$lastScheduledReplayQueue === formReplayingQueue && ($bcd00faefdd4b5d7$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $bcd00faefdd4b5d7$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $bcd00faefdd4b5d7$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $bcd00faefdd4b5d7$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $bcd00faefdd4b5d7$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $bcd00faefdd4b5d7$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $bcd00faefdd4b5d7$var$queuedFocus && $bcd00faefdd4b5d7$var$scheduleCallbackIfUnblocked($bcd00faefdd4b5d7$var$queuedFocus, unblocked);
    null !== $bcd00faefdd4b5d7$var$queuedDrag && $bcd00faefdd4b5d7$var$scheduleCallbackIfUnblocked($bcd00faefdd4b5d7$var$queuedDrag, unblocked);
    null !== $bcd00faefdd4b5d7$var$queuedMouse && $bcd00faefdd4b5d7$var$scheduleCallbackIfUnblocked($bcd00faefdd4b5d7$var$queuedMouse, unblocked);
    $bcd00faefdd4b5d7$var$queuedPointers.forEach(unblock);
    $bcd00faefdd4b5d7$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets.length && (i = $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$bcd00faefdd4b5d7$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$bcd00faefdd4b5d7$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $bcd00faefdd4b5d7$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$bcd00faefdd4b5d7$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $bcd00faefdd4b5d7$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $bcd00faefdd4b5d7$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $bcd00faefdd4b5d7$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$bcd00faefdd4b5d7$var$ReactDOMHydrationRoot.prototype.render = $bcd00faefdd4b5d7$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(409));
    var current = root.current, lane = $bcd00faefdd4b5d7$var$requestUpdateLane();
    $bcd00faefdd4b5d7$var$updateContainerImpl(current, lane, children, root, null, null);
};
$bcd00faefdd4b5d7$var$ReactDOMHydrationRoot.prototype.unmount = $bcd00faefdd4b5d7$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $bcd00faefdd4b5d7$var$flushPassiveEffects();
        $bcd00faefdd4b5d7$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $bcd00faefdd4b5d7$var$flushSyncWork$1();
        container[$bcd00faefdd4b5d7$var$internalContainerInstanceKey] = null;
    }
};
function $bcd00faefdd4b5d7$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$bcd00faefdd4b5d7$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $bcd00faefdd4b5d7$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets[i].priority; i++);
        $bcd00faefdd4b5d7$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $bcd00faefdd4b5d7$var$attemptExplicitHydrationTarget(target);
    }
};
var $bcd00faefdd4b5d7$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $fIwXP.version;
if ("19.0.0" !== $bcd00faefdd4b5d7$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(527, $bcd00faefdd4b5d7$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$bcd00faefdd4b5d7$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $bcd00faefdd4b5d7$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $bcd00faefdd4b5d7$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $bcd00faefdd4b5d7$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $bcd00faefdd4b5d7$var$ReactSharedInternals,
    findFiberByHostInstance: $bcd00faefdd4b5d7$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $bcd00faefdd4b5d7$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$bcd00faefdd4b5d7$var$hook$jscomp$inline_2166.isDisabled && $bcd00faefdd4b5d7$var$hook$jscomp$inline_2166.supportsFiber) try {
        $bcd00faefdd4b5d7$var$rendererID = $bcd00faefdd4b5d7$var$hook$jscomp$inline_2166.inject($bcd00faefdd4b5d7$var$internals$jscomp$inline_2165), $bcd00faefdd4b5d7$var$injectedHook = $bcd00faefdd4b5d7$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$bcd00faefdd4b5d7$export$882461b6382ed46c = function(container, options) {
    if (!$bcd00faefdd4b5d7$var$isValidContainer(container)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $bcd00faefdd4b5d7$var$defaultOnUncaughtError, onCaughtError = $bcd00faefdd4b5d7$var$defaultOnCaughtError, onRecoverableError = $bcd00faefdd4b5d7$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $bcd00faefdd4b5d7$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$bcd00faefdd4b5d7$var$internalContainerInstanceKey] = options.current;
    $bcd00faefdd4b5d7$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $bcd00faefdd4b5d7$var$ReactDOMRoot(options);
};
$bcd00faefdd4b5d7$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$bcd00faefdd4b5d7$var$isValidContainer(container)) throw Error($bcd00faefdd4b5d7$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $bcd00faefdd4b5d7$var$defaultOnUncaughtError, onCaughtError = $bcd00faefdd4b5d7$var$defaultOnCaughtError, onRecoverableError = $bcd00faefdd4b5d7$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $bcd00faefdd4b5d7$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $bcd00faefdd4b5d7$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $bcd00faefdd4b5d7$var$requestUpdateLane();
    identifierPrefix = $bcd00faefdd4b5d7$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $bcd00faefdd4b5d7$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $bcd00faefdd4b5d7$var$markRootUpdated$1(initialChildren, isStrictMode);
    $bcd00faefdd4b5d7$var$ensureRootIsScheduled(initialChildren);
    container[$bcd00faefdd4b5d7$var$internalContainerInstanceKey] = initialChildren.current;
    $bcd00faefdd4b5d7$var$listenToAllSupportedEvents(container);
    return new $bcd00faefdd4b5d7$var$ReactDOMHydrationRoot(initialChildren);
};
$bcd00faefdd4b5d7$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("go0bk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2eTxD"));

});
parcelRegister("2eTxD", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $1a17f8fbd958c1eb$export$c4744153514ff05d; }, function (v) { return $1a17f8fbd958c1eb$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $1a17f8fbd958c1eb$export$3e506c1ccc9cc1a7; }, function (v) { return $1a17f8fbd958c1eb$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $1a17f8fbd958c1eb$export$e26fe2ed2fa76875; }, function (v) { return $1a17f8fbd958c1eb$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $1a17f8fbd958c1eb$export$502329bbf4b505b1; }, function (v) { return $1a17f8fbd958c1eb$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $1a17f8fbd958c1eb$export$6e3807111c4874c4; }, function (v) { return $1a17f8fbd958c1eb$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $1a17f8fbd958c1eb$export$c27134553091fb3a; }, function (v) { return $1a17f8fbd958c1eb$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $1a17f8fbd958c1eb$export$33ee1acdc04fd2a2; }, function (v) { return $1a17f8fbd958c1eb$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $1a17f8fbd958c1eb$export$b00a404bbd5edef2; }, function (v) { return $1a17f8fbd958c1eb$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $1a17f8fbd958c1eb$export$8352ce38b91d0c62; }, function (v) { return $1a17f8fbd958c1eb$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $1a17f8fbd958c1eb$export$d66a1c1c77bd778b; }, function (v) { return $1a17f8fbd958c1eb$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $1a17f8fbd958c1eb$export$d3dfb8e4810cb555; }, function (v) { return $1a17f8fbd958c1eb$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $1a17f8fbd958c1eb$export$839f9183b0465a69; }, function (v) { return $1a17f8fbd958c1eb$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $1a17f8fbd958c1eb$export$72fdf0e06517287b; }, function (v) { return $1a17f8fbd958c1eb$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $1a17f8fbd958c1eb$export$4b844e58a3e414b4; }, function (v) { return $1a17f8fbd958c1eb$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $1a17f8fbd958c1eb$export$816d2913ae6b83b1; }, function (v) { return $1a17f8fbd958c1eb$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $1a17f8fbd958c1eb$export$61bcfe829111a1d0; }, function (v) { return $1a17f8fbd958c1eb$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $1a17f8fbd958c1eb$export$7ee8c9beb337bc3f; }, function (v) { return $1a17f8fbd958c1eb$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $1a17f8fbd958c1eb$export$b5836b71941fa3ed; }, function (v) { return $1a17f8fbd958c1eb$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $1a17f8fbd958c1eb$export$cf845f2c119da08a; }, function (v) { return $1a17f8fbd958c1eb$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $YtE9h = parcelRequire("YtE9h");
var $1a17f8fbd958c1eb$export$c4744153514ff05d;
var $1a17f8fbd958c1eb$export$3e506c1ccc9cc1a7;
var $1a17f8fbd958c1eb$export$e26fe2ed2fa76875;
var $1a17f8fbd958c1eb$export$502329bbf4b505b1;
var $1a17f8fbd958c1eb$export$6e3807111c4874c4;
var $1a17f8fbd958c1eb$export$c27134553091fb3a;
var $1a17f8fbd958c1eb$export$33ee1acdc04fd2a2;
var $1a17f8fbd958c1eb$export$b00a404bbd5edef2;
var $1a17f8fbd958c1eb$export$8352ce38b91d0c62;
var $1a17f8fbd958c1eb$export$d66a1c1c77bd778b;
var $1a17f8fbd958c1eb$export$d3dfb8e4810cb555;
var $1a17f8fbd958c1eb$export$839f9183b0465a69;
var $1a17f8fbd958c1eb$export$72fdf0e06517287b;
var $1a17f8fbd958c1eb$export$4b844e58a3e414b4;
var $1a17f8fbd958c1eb$export$816d2913ae6b83b1;
var $1a17f8fbd958c1eb$export$61bcfe829111a1d0;
var $1a17f8fbd958c1eb$export$7ee8c9beb337bc3f;
var $1a17f8fbd958c1eb$export$b5836b71941fa3ed;
var $1a17f8fbd958c1eb$export$cf845f2c119da08a;
"use strict";
function $1a17f8fbd958c1eb$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $1a17f8fbd958c1eb$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $1a17f8fbd958c1eb$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $1a17f8fbd958c1eb$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $1a17f8fbd958c1eb$var$compare(left, last)) rightIndex < length && 0 > $1a17f8fbd958c1eb$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $1a17f8fbd958c1eb$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $1a17f8fbd958c1eb$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$1a17f8fbd958c1eb$export$c4744153514ff05d = void 0;
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $YtE9h._)(performance)) && "function" === typeof performance.now) {
    var $1a17f8fbd958c1eb$var$localPerformance = performance;
    $1a17f8fbd958c1eb$export$c4744153514ff05d = function() {
        return $1a17f8fbd958c1eb$var$localPerformance.now();
    };
} else {
    var $1a17f8fbd958c1eb$var$localDate = Date, $1a17f8fbd958c1eb$var$initialTime = $1a17f8fbd958c1eb$var$localDate.now();
    $1a17f8fbd958c1eb$export$c4744153514ff05d = function() {
        return $1a17f8fbd958c1eb$var$localDate.now() - $1a17f8fbd958c1eb$var$initialTime;
    };
}
var $1a17f8fbd958c1eb$var$taskQueue = [], $1a17f8fbd958c1eb$var$timerQueue = [], $1a17f8fbd958c1eb$var$taskIdCounter = 1, $1a17f8fbd958c1eb$var$currentTask = null, $1a17f8fbd958c1eb$var$currentPriorityLevel = 3, $1a17f8fbd958c1eb$var$isPerformingWork = !1, $1a17f8fbd958c1eb$var$isHostCallbackScheduled = !1, $1a17f8fbd958c1eb$var$isHostTimeoutScheduled = !1, $1a17f8fbd958c1eb$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $1a17f8fbd958c1eb$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $1a17f8fbd958c1eb$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $1a17f8fbd958c1eb$var$advanceTimers(currentTime) {
    for(var timer = $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$timerQueue); null !== timer;){
        if (null === timer.callback) $1a17f8fbd958c1eb$var$pop($1a17f8fbd958c1eb$var$timerQueue);
        else if (timer.startTime <= currentTime) $1a17f8fbd958c1eb$var$pop($1a17f8fbd958c1eb$var$timerQueue), timer.sortIndex = timer.expirationTime, $1a17f8fbd958c1eb$var$push($1a17f8fbd958c1eb$var$taskQueue, timer);
        else break;
        timer = $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$timerQueue);
    }
}
function $1a17f8fbd958c1eb$var$handleTimeout(currentTime) {
    $1a17f8fbd958c1eb$var$isHostTimeoutScheduled = !1;
    $1a17f8fbd958c1eb$var$advanceTimers(currentTime);
    if (!$1a17f8fbd958c1eb$var$isHostCallbackScheduled) {
        if (null !== $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$taskQueue)) $1a17f8fbd958c1eb$var$isHostCallbackScheduled = !0, $1a17f8fbd958c1eb$var$requestHostCallback();
        else {
            var firstTimer = $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$timerQueue);
            null !== firstTimer && $1a17f8fbd958c1eb$var$requestHostTimeout($1a17f8fbd958c1eb$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $1a17f8fbd958c1eb$var$isMessageLoopRunning = !1, $1a17f8fbd958c1eb$var$taskTimeoutID = -1, $1a17f8fbd958c1eb$var$frameInterval = 5, $1a17f8fbd958c1eb$var$startTime = -1;
function $1a17f8fbd958c1eb$var$shouldYieldToHost() {
    return $1a17f8fbd958c1eb$export$c4744153514ff05d() - $1a17f8fbd958c1eb$var$startTime < $1a17f8fbd958c1eb$var$frameInterval ? !1 : !0;
}
function $1a17f8fbd958c1eb$var$performWorkUntilDeadline() {
    if ($1a17f8fbd958c1eb$var$isMessageLoopRunning) {
        var currentTime = $1a17f8fbd958c1eb$export$c4744153514ff05d();
        $1a17f8fbd958c1eb$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $1a17f8fbd958c1eb$var$isHostCallbackScheduled = !1;
                $1a17f8fbd958c1eb$var$isHostTimeoutScheduled && ($1a17f8fbd958c1eb$var$isHostTimeoutScheduled = !1, $1a17f8fbd958c1eb$var$localClearTimeout($1a17f8fbd958c1eb$var$taskTimeoutID), $1a17f8fbd958c1eb$var$taskTimeoutID = -1);
                $1a17f8fbd958c1eb$var$isPerformingWork = !0;
                var previousPriorityLevel = $1a17f8fbd958c1eb$var$currentPriorityLevel;
                try {
                    b: {
                        $1a17f8fbd958c1eb$var$advanceTimers(currentTime);
                        for($1a17f8fbd958c1eb$var$currentTask = $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$taskQueue); null !== $1a17f8fbd958c1eb$var$currentTask && !($1a17f8fbd958c1eb$var$currentTask.expirationTime > currentTime && $1a17f8fbd958c1eb$var$shouldYieldToHost());){
                            var callback = $1a17f8fbd958c1eb$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $1a17f8fbd958c1eb$var$currentTask.callback = null;
                                $1a17f8fbd958c1eb$var$currentPriorityLevel = $1a17f8fbd958c1eb$var$currentTask.priorityLevel;
                                var continuationCallback = callback($1a17f8fbd958c1eb$var$currentTask.expirationTime <= currentTime);
                                currentTime = $1a17f8fbd958c1eb$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $1a17f8fbd958c1eb$var$currentTask.callback = continuationCallback;
                                    $1a17f8fbd958c1eb$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $1a17f8fbd958c1eb$var$currentTask === $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$taskQueue) && $1a17f8fbd958c1eb$var$pop($1a17f8fbd958c1eb$var$taskQueue);
                                $1a17f8fbd958c1eb$var$advanceTimers(currentTime);
                            } else $1a17f8fbd958c1eb$var$pop($1a17f8fbd958c1eb$var$taskQueue);
                            $1a17f8fbd958c1eb$var$currentTask = $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$taskQueue);
                        }
                        if (null !== $1a17f8fbd958c1eb$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$timerQueue);
                            null !== firstTimer && $1a17f8fbd958c1eb$var$requestHostTimeout($1a17f8fbd958c1eb$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $1a17f8fbd958c1eb$var$currentTask = null, $1a17f8fbd958c1eb$var$currentPriorityLevel = previousPriorityLevel, $1a17f8fbd958c1eb$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $1a17f8fbd958c1eb$var$schedulePerformWorkUntilDeadline() : $1a17f8fbd958c1eb$var$isMessageLoopRunning = !1;
        }
    }
}
var $1a17f8fbd958c1eb$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $1a17f8fbd958c1eb$var$localSetImmediate) $1a17f8fbd958c1eb$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
    $1a17f8fbd958c1eb$var$localSetImmediate($1a17f8fbd958c1eb$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1a17f8fbd958c1eb$var$channel = new MessageChannel(), $1a17f8fbd958c1eb$var$port = $1a17f8fbd958c1eb$var$channel.port2;
    $1a17f8fbd958c1eb$var$channel.port1.onmessage = $1a17f8fbd958c1eb$var$performWorkUntilDeadline;
    $1a17f8fbd958c1eb$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
        $1a17f8fbd958c1eb$var$port.postMessage(null);
    };
} else $1a17f8fbd958c1eb$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
    $1a17f8fbd958c1eb$var$localSetTimeout($1a17f8fbd958c1eb$var$performWorkUntilDeadline, 0);
};
function $1a17f8fbd958c1eb$var$requestHostCallback() {
    $1a17f8fbd958c1eb$var$isMessageLoopRunning || ($1a17f8fbd958c1eb$var$isMessageLoopRunning = !0, $1a17f8fbd958c1eb$var$schedulePerformWorkUntilDeadline());
}
function $1a17f8fbd958c1eb$var$requestHostTimeout(callback, ms) {
    $1a17f8fbd958c1eb$var$taskTimeoutID = $1a17f8fbd958c1eb$var$localSetTimeout(function() {
        callback($1a17f8fbd958c1eb$export$c4744153514ff05d());
    }, ms);
}
$1a17f8fbd958c1eb$export$3e506c1ccc9cc1a7 = 5;
$1a17f8fbd958c1eb$export$e26fe2ed2fa76875 = 1;
$1a17f8fbd958c1eb$export$502329bbf4b505b1 = 4;
$1a17f8fbd958c1eb$export$6e3807111c4874c4 = 3;
$1a17f8fbd958c1eb$export$c27134553091fb3a = null;
$1a17f8fbd958c1eb$export$33ee1acdc04fd2a2 = 2;
$1a17f8fbd958c1eb$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$1a17f8fbd958c1eb$export$8352ce38b91d0c62 = function() {
    $1a17f8fbd958c1eb$var$isHostCallbackScheduled || $1a17f8fbd958c1eb$var$isPerformingWork || ($1a17f8fbd958c1eb$var$isHostCallbackScheduled = !0, $1a17f8fbd958c1eb$var$requestHostCallback());
};
$1a17f8fbd958c1eb$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1a17f8fbd958c1eb$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$1a17f8fbd958c1eb$export$d3dfb8e4810cb555 = function() {
    return $1a17f8fbd958c1eb$var$currentPriorityLevel;
};
$1a17f8fbd958c1eb$export$839f9183b0465a69 = function() {
    return $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$taskQueue);
};
$1a17f8fbd958c1eb$export$72fdf0e06517287b = function(eventHandler) {
    switch($1a17f8fbd958c1eb$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $1a17f8fbd958c1eb$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $1a17f8fbd958c1eb$var$currentPriorityLevel;
    $1a17f8fbd958c1eb$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $1a17f8fbd958c1eb$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$1a17f8fbd958c1eb$export$4b844e58a3e414b4 = function() {};
$1a17f8fbd958c1eb$export$816d2913ae6b83b1 = function() {};
$1a17f8fbd958c1eb$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $1a17f8fbd958c1eb$var$currentPriorityLevel;
    $1a17f8fbd958c1eb$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $1a17f8fbd958c1eb$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$1a17f8fbd958c1eb$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $1a17f8fbd958c1eb$export$c4744153514ff05d();
    "object" === (typeof options === "undefined" ? "undefined" : (0, $YtE9h._)(options)) && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $1a17f8fbd958c1eb$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $1a17f8fbd958c1eb$var$push($1a17f8fbd958c1eb$var$timerQueue, priorityLevel), null === $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$taskQueue) && priorityLevel === $1a17f8fbd958c1eb$var$peek($1a17f8fbd958c1eb$var$timerQueue) && ($1a17f8fbd958c1eb$var$isHostTimeoutScheduled ? ($1a17f8fbd958c1eb$var$localClearTimeout($1a17f8fbd958c1eb$var$taskTimeoutID), $1a17f8fbd958c1eb$var$taskTimeoutID = -1) : $1a17f8fbd958c1eb$var$isHostTimeoutScheduled = !0, $1a17f8fbd958c1eb$var$requestHostTimeout($1a17f8fbd958c1eb$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $1a17f8fbd958c1eb$var$push($1a17f8fbd958c1eb$var$taskQueue, priorityLevel), $1a17f8fbd958c1eb$var$isHostCallbackScheduled || $1a17f8fbd958c1eb$var$isPerformingWork || ($1a17f8fbd958c1eb$var$isHostCallbackScheduled = !0, $1a17f8fbd958c1eb$var$requestHostCallback()));
    return priorityLevel;
};
$1a17f8fbd958c1eb$export$b5836b71941fa3ed = $1a17f8fbd958c1eb$var$shouldYieldToHost;
$1a17f8fbd958c1eb$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $1a17f8fbd958c1eb$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $1a17f8fbd958c1eb$var$currentPriorityLevel;
        $1a17f8fbd958c1eb$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $1a17f8fbd958c1eb$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("9F3H4", function(module, exports) {
'use strict';
function $708acee34f03ee3d$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($708acee34f03ee3d$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$708acee34f03ee3d$var$checkDCE();

module.exports = (parcelRequire("gu98I"));

});
parcelRegister("gu98I", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $c00689a08255ad8b$export$69ce8ef3fe5cead0; }, function (v) { return $c00689a08255ad8b$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $c00689a08255ad8b$export$d39a5bbd09211389; }, function (v) { return $c00689a08255ad8b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c00689a08255ad8b$export$cd75ccfd720a3cd4; }, function (v) { return $c00689a08255ad8b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $c00689a08255ad8b$export$a0816fa17a9e79be; }, function (v) { return $c00689a08255ad8b$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $c00689a08255ad8b$export$7292efcadded39f3; }, function (v) { return $c00689a08255ad8b$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $c00689a08255ad8b$export$da407abadb9b8f86; }, function (v) { return $c00689a08255ad8b$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $c00689a08255ad8b$export$314cfea32580671c; }, function (v) { return $c00689a08255ad8b$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $c00689a08255ad8b$export$513ccb98c53b8039; }, function (v) { return $c00689a08255ad8b$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $c00689a08255ad8b$export$dbca993bc2d264a; }, function (v) { return $c00689a08255ad8b$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $c00689a08255ad8b$export$4797a8006f0655d0; }, function (v) { return $c00689a08255ad8b$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c00689a08255ad8b$export$c78a37762a8d58e1; }, function (v) { return $c00689a08255ad8b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $c00689a08255ad8b$export$606f11b2eb45ecc6; }, function (v) { return $c00689a08255ad8b$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $c00689a08255ad8b$export$f7e8a0bf92324b1e; }, function (v) { return $c00689a08255ad8b$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $c00689a08255ad8b$export$83d89fbfd8236492; }, function (v) { return $c00689a08255ad8b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $YtE9h = parcelRequire("YtE9h");
var $c00689a08255ad8b$export$69ce8ef3fe5cead0;
var $c00689a08255ad8b$export$d39a5bbd09211389;
var $c00689a08255ad8b$export$cd75ccfd720a3cd4;
var $c00689a08255ad8b$export$a0816fa17a9e79be;
var $c00689a08255ad8b$export$7292efcadded39f3;
var $c00689a08255ad8b$export$da407abadb9b8f86;
var $c00689a08255ad8b$export$314cfea32580671c;
var $c00689a08255ad8b$export$513ccb98c53b8039;
var $c00689a08255ad8b$export$dbca993bc2d264a;
var $c00689a08255ad8b$export$4797a8006f0655d0;
var $c00689a08255ad8b$export$c78a37762a8d58e1;
var $c00689a08255ad8b$export$606f11b2eb45ecc6;
var $c00689a08255ad8b$export$f7e8a0bf92324b1e;
var $c00689a08255ad8b$export$83d89fbfd8236492;
"use strict";

var $fIwXP = parcelRequire("fIwXP");
function $c00689a08255ad8b$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $c00689a08255ad8b$var$noop() {}
var $c00689a08255ad8b$var$Internals = {
    d: {
        f: $c00689a08255ad8b$var$noop,
        r: function r() {
            throw Error($c00689a08255ad8b$var$formatProdErrorMessage(522));
        },
        D: $c00689a08255ad8b$var$noop,
        C: $c00689a08255ad8b$var$noop,
        L: $c00689a08255ad8b$var$noop,
        m: $c00689a08255ad8b$var$noop,
        X: $c00689a08255ad8b$var$noop,
        S: $c00689a08255ad8b$var$noop,
        M: $c00689a08255ad8b$var$noop
    },
    p: 0,
    findDOMNode: null
}, $c00689a08255ad8b$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $c00689a08255ad8b$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c00689a08255ad8b$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $c00689a08255ad8b$var$ReactSharedInternals = $fIwXP.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $c00689a08255ad8b$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$c00689a08255ad8b$export$69ce8ef3fe5cead0 = $c00689a08255ad8b$var$Internals;
$c00689a08255ad8b$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($c00689a08255ad8b$var$formatProdErrorMessage(299));
    return $c00689a08255ad8b$var$createPortal$1(children, container, null, key);
};
$c00689a08255ad8b$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $c00689a08255ad8b$var$ReactSharedInternals.T, previousUpdatePriority = $c00689a08255ad8b$var$Internals.p;
    try {
        if ($c00689a08255ad8b$var$ReactSharedInternals.T = null, $c00689a08255ad8b$var$Internals.p = 2, fn) return fn();
    } finally{
        $c00689a08255ad8b$var$ReactSharedInternals.T = previousTransition, $c00689a08255ad8b$var$Internals.p = previousUpdatePriority, $c00689a08255ad8b$var$Internals.d.f();
    }
};
$c00689a08255ad8b$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $c00689a08255ad8b$var$Internals.d.C(href, options));
};
$c00689a08255ad8b$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $c00689a08255ad8b$var$Internals.d.D(href);
};
$c00689a08255ad8b$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $c00689a08255ad8b$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $c00689a08255ad8b$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $c00689a08255ad8b$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$c00689a08255ad8b$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === (typeof options === "undefined" ? "undefined" : (0, $YtE9h._)(options)) && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $c00689a08255ad8b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $c00689a08255ad8b$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $c00689a08255ad8b$var$Internals.d.M(href);
    }
};
$c00689a08255ad8b$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === (typeof options === "undefined" ? "undefined" : (0, $YtE9h._)(options)) && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $c00689a08255ad8b$var$getCrossOriginStringAs(as, options.crossOrigin);
        $c00689a08255ad8b$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$c00689a08255ad8b$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $c00689a08255ad8b$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $c00689a08255ad8b$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $c00689a08255ad8b$var$Internals.d.m(href);
    }
};
$c00689a08255ad8b$export$4797a8006f0655d0 = function(form) {
    $c00689a08255ad8b$var$Internals.d.r(form);
};
$c00689a08255ad8b$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$c00689a08255ad8b$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $c00689a08255ad8b$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$c00689a08255ad8b$export$f7e8a0bf92324b1e = function() {
    return $c00689a08255ad8b$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$c00689a08255ad8b$export$83d89fbfd8236492 = "19.0.0";

});



parcelRegister("abvdI", function(module, exports) {

$parcel$export(module.exports, "createBrowserRouter", function () { return $76a326218c469af1$export$1f3f55432a00e06d; });
$parcel$export(module.exports, "RouterProvider", function () { return $76a326218c469af1$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "Link", function () { return $76a326218c469af1$export$a6c7ac8248d6e38a; });
/**
 * React Router DOM v6.29.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7k5I8 = parcelRequire("7k5I8");

var $bB0zn = parcelRequire("bB0zn");

var $kB67t = parcelRequire("kB67t");

var $lFlDF = parcelRequire("lFlDF");

var $fIwXP = parcelRequire("fIwXP");

var $9F3H4 = parcelRequire("9F3H4");

var $iU7ml = parcelRequire("iU7ml");
var $dAaLE = parcelRequire("dAaLE");

var $iU7ml = parcelRequire("iU7ml");
function $76a326218c469af1$var$_extends() {
    $76a326218c469af1$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $76a326218c469af1$var$_extends.apply(this, arguments);
}
function $76a326218c469af1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $76a326218c469af1$var$defaultMethod = "get";
var $76a326218c469af1$var$defaultEncType = "application/x-www-form-urlencoded";
function $76a326218c469af1$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $76a326218c469af1$var$isButtonElement(object) {
    return $76a326218c469af1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $76a326218c469af1$var$isFormElement(object) {
    return $76a326218c469af1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $76a326218c469af1$var$isInputElement(object) {
    return $76a326218c469af1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $76a326218c469af1$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $76a326218c469af1$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$76a326218c469af1$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $76a326218c469af1$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $76a326218c469af1$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $76a326218c469af1$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $76a326218c469af1$var$_formDataSupportsSubmitter = null;
function $76a326218c469af1$var$isFormDataSubmitterSupported() {
    if ($76a326218c469af1$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $76a326218c469af1$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $76a326218c469af1$var$_formDataSupportsSubmitter = true;
    }
    return $76a326218c469af1$var$_formDataSupportsSubmitter;
}
var $76a326218c469af1$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $76a326218c469af1$var$getFormEncType(encType) {
    if (encType != null && !$76a326218c469af1$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $76a326218c469af1$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($76a326218c469af1$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $iU7ml.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $76a326218c469af1$var$defaultMethod;
        encType = $76a326218c469af1$var$getFormEncType(target.getAttribute("enctype")) || $76a326218c469af1$var$defaultEncType;
        formData = new FormData(target);
    } else if ($76a326218c469af1$var$isButtonElement(target) || $76a326218c469af1$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $iU7ml.stripBasename)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $76a326218c469af1$var$defaultMethod;
        encType = $76a326218c469af1$var$getFormEncType(target.getAttribute("formenctype")) || $76a326218c469af1$var$getFormEncType(form.getAttribute("enctype")) || $76a326218c469af1$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$76a326218c469af1$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($76a326218c469af1$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $76a326218c469af1$var$defaultMethod;
        action = null;
        encType = $76a326218c469af1$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $76a326218c469af1$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $76a326218c469af1$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $76a326218c469af1$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var $76a326218c469af1$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $76a326218c469af1$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $76a326218c469af1$export$1f3f55432a00e06d(routes, opts) {
    return (0, $iU7ml.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $76a326218c469af1$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $iU7ml.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $76a326218c469af1$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $dAaLE.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $76a326218c469af1$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $iU7ml.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $76a326218c469af1$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $iU7ml.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $76a326218c469af1$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $dAaLE.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $76a326218c469af1$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $76a326218c469af1$var$_extends({}, state, {
        errors: $76a326218c469af1$var$deserializeErrors(state.errors)
    });
    return state;
}
function $76a326218c469af1$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $iU7ml.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $76a326218c469af1$export$7ad602f0e94e62d1 = /*#__PURE__*/ $fIwXP.createContext({
    isTransitioning: false
});
var $76a326218c469af1$export$148fd98d095596d4 = /*#__PURE__*/ $fIwXP.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $76a326218c469af1$var$START_TRANSITION = "startTransition";
var $76a326218c469af1$var$startTransitionImpl = $fIwXP[$76a326218c469af1$var$START_TRANSITION];
var $76a326218c469af1$var$FLUSH_SYNC = "flushSync";
var $76a326218c469af1$var$flushSyncImpl = $9F3H4[$76a326218c469af1$var$FLUSH_SYNC];
var $76a326218c469af1$var$USE_ID = "useId";
var $76a326218c469af1$var$useIdImpl = $fIwXP[$76a326218c469af1$var$USE_ID];
function $76a326218c469af1$var$startTransitionSafe(cb) {
    if ($76a326218c469af1$var$startTransitionImpl) $76a326218c469af1$var$startTransitionImpl(cb);
    else cb();
}
function $76a326218c469af1$var$flushSyncSafe(cb) {
    if ($76a326218c469af1$var$flushSyncImpl) $76a326218c469af1$var$flushSyncImpl(cb);
    else cb();
}
var $76a326218c469af1$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $bB0zn._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $76a326218c469af1$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $kB67t._)($fIwXP.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $kB67t._)($fIwXP.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $kB67t._)($fIwXP.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $kB67t._)($fIwXP.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $kB67t._)($fIwXP.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $kB67t._)($fIwXP.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $fIwXP.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $fIwXP.useCallback(function(cb) {
        if (v7_startTransition) $76a326218c469af1$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $fIwXP.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.flushSync, viewTransitionOpts = _ref2.viewTransitionOpts;
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        var isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $76a326218c469af1$var$flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $76a326218c469af1$var$flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                $76a326218c469af1$var$flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished.finally(function() {
                $76a326218c469af1$var$flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $76a326218c469af1$var$flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $fIwXP.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $fIwXP.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $76a326218c469af1$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $fIwXP.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, $7k5I8._)(function() {
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $fIwXP.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $fIwXP.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $fIwXP.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $fIwXP.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $fIwXP.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    var routerFuture = $fIwXP.useMemo(function() {
        return {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        };
    }, [
        router.future.v7_relativeSplatPath
    ]);
    $fIwXP.useEffect(function() {
        return (0, $dAaLE.UNSAFE_logV6DeprecationWarnings)(future, router.future);
    }, [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $fIwXP.createElement($fIwXP.Fragment, null, /*#__PURE__*/ $fIwXP.createElement((0, $dAaLE.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $fIwXP.createElement((0, $dAaLE.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $fIwXP.createElement($76a326218c469af1$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $fIwXP.createElement($76a326218c469af1$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $fIwXP.createElement((0, $dAaLE.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $fIwXP.createElement($76a326218c469af1$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
var $76a326218c469af1$var$MemoizedDataRoutes = /*#__PURE__*/ $fIwXP.memo($76a326218c469af1$var$DataRoutes);
function $76a326218c469af1$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, $dAaLE.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $76a326218c469af1$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $fIwXP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $iU7ml.createBrowserHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $fIwXP.useCallback(function(newState) {
        v7_startTransition && $76a326218c469af1$var$startTransitionImpl ? $76a326218c469af1$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $fIwXP.useEffect(function() {
        return (0, $dAaLE.UNSAFE_logV6DeprecationWarnings)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $fIwXP.createElement((0, $dAaLE.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $76a326218c469af1$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $fIwXP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $iU7ml.createHashHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $fIwXP.useCallback(function(newState) {
        v7_startTransition && $76a326218c469af1$var$startTransitionImpl ? $76a326218c469af1$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $fIwXP.useEffect(function() {
        return (0, $dAaLE.UNSAFE_logV6DeprecationWarnings)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $fIwXP.createElement((0, $dAaLE.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $76a326218c469af1$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $fIwXP.useCallback(function(newState) {
        v7_startTransition && $76a326218c469af1$var$startTransitionImpl ? $76a326218c469af1$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $fIwXP.useEffect(function() {
        return (0, $dAaLE.UNSAFE_logV6DeprecationWarnings)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $fIwXP.createElement((0, $dAaLE.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
var $76a326218c469af1$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $76a326218c469af1$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $76a326218c469af1$export$a6c7ac8248d6e38a = /*#__PURE__*/ $fIwXP.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, viewTransition = _ref7.viewTransition, rest = $76a326218c469af1$var$_objectWithoutPropertiesLoose(_ref7, $76a326218c469af1$var$_excluded);
    var basename = $fIwXP.useContext((0, $dAaLE.UNSAFE_NavigationContext)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $76a326218c469af1$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($76a326218c469af1$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $iU7ml.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $dAaLE.useHref)(to, {
        relative: relative
    });
    var internalOnClick = $76a326218c469af1$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $fIwXP.createElement("a", $76a326218c469af1$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $76a326218c469af1$export$b0d92dbee9b5b60d = /*#__PURE__*/ $fIwXP.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, viewTransition = _ref8.viewTransition, children = _ref8.children, rest = $76a326218c469af1$var$_objectWithoutPropertiesLoose(_ref8, $76a326218c469af1$var$_excluded2);
    var path = (0, $dAaLE.useResolvedPath)(to, {
        relative: rest.relative
    });
    var location = (0, $dAaLE.useLocation)();
    var routerState = $fIwXP.useContext((0, $dAaLE.UNSAFE_DataRouterStateContext));
    var _React_useContext = $fIwXP.useContext((0, $dAaLE.UNSAFE_NavigationContext)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $76a326218c469af1$export$e262bd1977bea848(path) && viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $iU7ml.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $fIwXP.createElement($76a326218c469af1$export$a6c7ac8248d6e38a, $76a326218c469af1$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $76a326218c469af1$export$a7fed597f4b8afd8 = /*#__PURE__*/ $fIwXP.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $76a326218c469af1$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, viewTransition = _ref9.viewTransition, props = $76a326218c469af1$var$_objectWithoutPropertiesLoose(_ref9, $76a326218c469af1$var$_excluded3);
    var submit = $76a326218c469af1$export$47c85c6e3a081d3();
    var formAction = $76a326218c469af1$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $fIwXP.createElement("form", $76a326218c469af1$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $76a326218c469af1$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $76a326218c469af1$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $76a326218c469af1$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($76a326218c469af1$var$DataRouterHook || ($76a326218c469af1$var$DataRouterHook = {}));
var $76a326218c469af1$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($76a326218c469af1$var$DataRouterStateHook || ($76a326218c469af1$var$DataRouterStateHook = {}));
// Internal hooks
function $76a326218c469af1$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $76a326218c469af1$var$useDataRouterContext(hookName) {
    var ctx = $fIwXP.useContext((0, $dAaLE.UNSAFE_DataRouterContext));
    !ctx && (0, $iU7ml.UNSAFE_invariant)(false);
    return ctx;
}
function $76a326218c469af1$var$useDataRouterState(hookName) {
    var state = $fIwXP.useContext((0, $dAaLE.UNSAFE_DataRouterStateContext));
    !state && (0, $iU7ml.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $76a326218c469af1$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, viewTransition = _ref.viewTransition;
    var navigate = (0, $dAaLE.useNavigate)();
    var location = (0, $dAaLE.useLocation)();
    var path = (0, $dAaLE.useResolvedPath)(to, {
        relative: relative
    });
    return $fIwXP.useCallback(function(event) {
        if ($76a326218c469af1$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $iU7ml.createPath)(location) === (0, $iU7ml.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $76a326218c469af1$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $fIwXP.useRef($76a326218c469af1$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $fIwXP.useRef(false);
    var location = (0, $dAaLE.useLocation)();
    var searchParams = $fIwXP.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $76a326218c469af1$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $dAaLE.useNavigate)();
    var setSearchParams = $fIwXP.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $76a326218c469af1$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $76a326218c469af1$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $76a326218c469af1$var$fetcherId = 0;
var $76a326218c469af1$var$getUniqueFetcherId = function() {
    return "__" + String(++$76a326218c469af1$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $76a326218c469af1$export$47c85c6e3a081d3() {
    var router = $76a326218c469af1$var$useDataRouterContext($76a326218c469af1$var$DataRouterHook.UseSubmit).router;
    var basename = $fIwXP.useContext((0, $dAaLE.UNSAFE_NavigationContext)).basename;
    var currentRouteId = (0, $dAaLE.UNSAFE_useRouteId)();
    return $fIwXP.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $76a326218c469af1$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $76a326218c469af1$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $76a326218c469af1$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $76a326218c469af1$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $fIwXP.useContext((0, $dAaLE.UNSAFE_NavigationContext)).basename;
    var routeContext = $fIwXP.useContext((0, $dAaLE.UNSAFE_RouteContext));
    !routeContext && (0, $iU7ml.UNSAFE_invariant)(false);
    var _routeContext_matches_slice = (0, $kB67t._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $76a326218c469af1$var$_extends({}, (0, $dAaLE.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $dAaLE.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        var indexValues = params.getAll("index");
        var hasNakedIndexParam = indexValues.some(function(v) {
            return v === "";
        });
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $iU7ml.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $iU7ml.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $76a326218c469af1$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $76a326218c469af1$var$useDataRouterContext($76a326218c469af1$var$DataRouterHook.UseFetcher).router;
    var state = $76a326218c469af1$var$useDataRouterState($76a326218c469af1$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $fIwXP.useContext($76a326218c469af1$export$148fd98d095596d4);
    var route = $fIwXP.useContext((0, $dAaLE.UNSAFE_RouteContext));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $iU7ml.UNSAFE_invariant)(false);
    !route && (0, $iU7ml.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $iU7ml.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = $76a326218c469af1$var$useIdImpl ? $76a326218c469af1$var$useIdImpl() : "";
    var _React_useState = (0, $kB67t._)($fIwXP.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($76a326218c469af1$var$getUniqueFetcherId());
    // Registration/cleanup
    $fIwXP.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $fIwXP.useCallback(function(href, opts) {
        !routeId && (0, $iU7ml.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $76a326218c469af1$export$47c85c6e3a081d3();
    var submit = $fIwXP.useCallback(function(target, opts) {
        submitImpl(target, $76a326218c469af1$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $fIwXP.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $fIwXP.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $fIwXP.createElement($76a326218c469af1$export$a7fed597f4b8afd8, $76a326218c469af1$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $iU7ml.IDLE_FETCHER);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $fIwXP.useMemo(function() {
        return $76a326218c469af1$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $76a326218c469af1$export$fa996778a3a31087() {
    var state = $76a326218c469af1$var$useDataRouterState($76a326218c469af1$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $kB67t._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $76a326218c469af1$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $76a326218c469af1$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $76a326218c469af1$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $76a326218c469af1$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $76a326218c469af1$var$useDataRouterContext($76a326218c469af1$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $76a326218c469af1$var$useDataRouterState($76a326218c469af1$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $fIwXP.useContext((0, $dAaLE.UNSAFE_NavigationContext)).basename;
    var location = (0, $dAaLE.useLocation)();
    var matches = (0, $dAaLE.useMatches)();
    var navigation = (0, $dAaLE.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $fIwXP.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $76a326218c469af1$var$usePageHide($fIwXP.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $76a326218c469af1$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $76a326218c469af1$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($76a326218c469af1$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $fIwXP.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $76a326218c469af1$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $76a326218c469af1$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $fIwXP.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($76a326218c469af1$var$_extends({}, location, {
                    pathname: (0, $iU7ml.stripBasename)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($76a326218c469af1$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $fIwXP.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $76a326218c469af1$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $fIwXP.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $76a326218c469af1$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $fIwXP.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $76a326218c469af1$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $dAaLE.useBlocker)(when);
    $fIwXP.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $fIwXP.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $76a326218c469af1$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $fIwXP.useContext($76a326218c469af1$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $iU7ml.UNSAFE_invariant)(false);
    var basename = $76a326218c469af1$var$useDataRouterContext($76a326218c469af1$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $dAaLE.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $iU7ml.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $iU7ml.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $iU7ml.matchPath)(path.pathname, nextPath) != null || (0, $iU7ml.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("7k5I8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $554ed4b40b13e16f$export$71511d61b312f219; });
function $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $554ed4b40b13e16f$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("bB0zn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8713978b2328d32b$export$71511d61b312f219; });
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("kB67t", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $efec029548ccee7f$export$71511d61b312f219; });

var $Q9cvz = parcelRequire("Q9cvz");

var $c4AWK = parcelRequire("c4AWK");

var $dNApw = parcelRequire("dNApw");

var $ihB7G = parcelRequire("ihB7G");
function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $Q9cvz._)(arr) || (0, $c4AWK._)(arr, i) || (0, $ihB7G._)(arr, i) || (0, $dNApw._)();
}

});
parcelRegister("Q9cvz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09cbfe85151ea6c6$export$71511d61b312f219; });
function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("c4AWK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8ca2848f896a6803$export$71511d61b312f219; });
function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("dNApw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a0bc1859061deae1$export$71511d61b312f219; });
function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("lFlDF", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $fc5e3658b603cf39$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $fc5e3658b603cf39$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $YtE9h = parcelRequire("YtE9h");
var $fc5e3658b603cf39$var$extendStatics = function extendStatics1(d, b) {
    $fc5e3658b603cf39$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $fc5e3658b603cf39$var$extendStatics(d, b);
};
function $fc5e3658b603cf39$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $fc5e3658b603cf39$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fc5e3658b603cf39$export$18ce0697a983be9b = function __assign1() {
    $fc5e3658b603cf39$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc5e3658b603cf39$export$18ce0697a983be9b.apply(this, arguments);
};
function $fc5e3658b603cf39$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fc5e3658b603cf39$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $YtE9h._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $fc5e3658b603cf39$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $fc5e3658b603cf39$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $YtE9h._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $fc5e3658b603cf39$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $fc5e3658b603cf39$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $YtE9h._)(x)) === "symbol" ? x : "".concat(x);
}
function $fc5e3658b603cf39$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $YtE9h._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $fc5e3658b603cf39$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $YtE9h._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $fc5e3658b603cf39$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fc5e3658b603cf39$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $fc5e3658b603cf39$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $fc5e3658b603cf39$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $fc5e3658b603cf39$export$45d3717a4c69092e(o, m, p);
}
function $fc5e3658b603cf39$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $fc5e3658b603cf39$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $fc5e3658b603cf39$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fc5e3658b603cf39$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $fc5e3658b603cf39$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $fc5e3658b603cf39$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $fc5e3658b603cf39$export$10c90e4f7922046c(v) {
    return this instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? (this.v = v, this) : new $fc5e3658b603cf39$export$10c90e4f7922046c(v);
}
function $fc5e3658b603cf39$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $fc5e3658b603cf39$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fc5e3658b603cf39$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $fc5e3658b603cf39$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $fc5e3658b603cf39$export$19a8beecd37a4c45 === "function" ? $fc5e3658b603cf39$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $fc5e3658b603cf39$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $fc5e3658b603cf39$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $fc5e3658b603cf39$var$ownKeys = function ownKeys1(o) {
    $fc5e3658b603cf39$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $fc5e3658b603cf39$var$ownKeys(o);
};
function $fc5e3658b603cf39$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $fc5e3658b603cf39$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $fc5e3658b603cf39$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $fc5e3658b603cf39$var$__setModuleDefault(result, mod);
    return result;
}
function $fc5e3658b603cf39$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $fc5e3658b603cf39$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $fc5e3658b603cf39$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $fc5e3658b603cf39$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $YtE9h._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $fc5e3658b603cf39$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $fc5e3658b603cf39$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $fc5e3658b603cf39$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $fc5e3658b603cf39$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $fc5e3658b603cf39$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $fc5e3658b603cf39$export$2e2bcd8739ae039 = {
    __extends: $fc5e3658b603cf39$export$a8ba968b8961cb8a,
    __assign: $fc5e3658b603cf39$export$18ce0697a983be9b,
    __rest: $fc5e3658b603cf39$export$3c9a16f847548506,
    __decorate: $fc5e3658b603cf39$export$29e00dfd3077644b,
    __param: $fc5e3658b603cf39$export$d5ad3fd78186038f,
    __esDecorate: $fc5e3658b603cf39$export$3a84e1ae4e97e9b0,
    __runInitializers: $fc5e3658b603cf39$export$d831c04e792af3d,
    __propKey: $fc5e3658b603cf39$export$6a2a36740a146cb8,
    __setFunctionName: $fc5e3658b603cf39$export$d1a06452d3489bc7,
    __metadata: $fc5e3658b603cf39$export$f1db080c865becb9,
    __awaiter: $fc5e3658b603cf39$export$1050f835b63b671e,
    __generator: $fc5e3658b603cf39$export$67ebef60e6f28a6,
    __createBinding: $fc5e3658b603cf39$export$45d3717a4c69092e,
    __exportStar: $fc5e3658b603cf39$export$f33643c0debef087,
    __values: $fc5e3658b603cf39$export$19a8beecd37a4c45,
    __read: $fc5e3658b603cf39$export$8d051b38c9118094,
    __spread: $fc5e3658b603cf39$export$afc72e2116322959,
    __spreadArrays: $fc5e3658b603cf39$export$6388937ca91ccae8,
    __spreadArray: $fc5e3658b603cf39$export$1216008129fb82ed,
    __await: $fc5e3658b603cf39$export$10c90e4f7922046c,
    __asyncGenerator: $fc5e3658b603cf39$export$e427f37a30a4de9b,
    __asyncDelegator: $fc5e3658b603cf39$export$bbd80228419bb833,
    __asyncValues: $fc5e3658b603cf39$export$e3b29a3d6162315f,
    __makeTemplateObject: $fc5e3658b603cf39$export$4fb47efe1390b86f,
    __importStar: $fc5e3658b603cf39$export$c21735bcef00d192,
    __importDefault: $fc5e3658b603cf39$export$da59b14a69baef04,
    __classPrivateFieldGet: $fc5e3658b603cf39$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $fc5e3658b603cf39$export$d40a35129aaff81f,
    __classPrivateFieldIn: $fc5e3658b603cf39$export$81fdc39f203e4e04,
    __addDisposableResource: $fc5e3658b603cf39$export$88ac25d8e944e405,
    __disposeResources: $fc5e3658b603cf39$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $fc5e3658b603cf39$export$889dfb5d17574b0b
};

});

parcelRegister("iU7ml", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return Action; });
$parcel$export(module.exports, "createMemoryHistory", function () { return createMemoryHistory; });
$parcel$export(module.exports, "createPath", function () { return createPath; });
$parcel$export(module.exports, "parsePath", function () { return parsePath; });
$parcel$export(module.exports, "createBrowserHistory", function () { return createBrowserHistory; });
$parcel$export(module.exports, "createHashHistory", function () { return createHashHistory; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return invariant; });
$parcel$export(module.exports, "matchRoutes", function () { return matchRoutes; });
$parcel$export(module.exports, "stripBasename", function () { return stripBasename; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return decodePath; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return convertRouteMatchToUiMatch; });
$parcel$export(module.exports, "joinPaths", function () { return joinPaths; });
$parcel$export(module.exports, "matchPath", function () { return matchPath; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return getResolveToMatches; });
$parcel$export(module.exports, "resolveTo", function () { return resolveTo; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return AbortedDeferredError; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return ErrorResponseImpl; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return isRouteErrorResponse; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return IDLE_FETCHER; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return IDLE_BLOCKER; });
$parcel$export(module.exports, "createRouter", function () { return createRouter; });
/**
 * @remix-run/router v1.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7k5I8 = parcelRequire("7k5I8");

var $3Gvhd = parcelRequire("3Gvhd");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $hD5pT = parcelRequire("hD5pT");

var $5dLwP = parcelRequire("5dLwP");

var $kB67t = parcelRequire("kB67t");

var $bQ8GJ = parcelRequire("bQ8GJ");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $fPaN7 = parcelRequire("fPaN7");

var $lFlDF = parcelRequire("lFlDF");

var $lFlDF = parcelRequire("lFlDF");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
var PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = Action.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = Action.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = Action.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = Action.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = parsePath(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = Action.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
var immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $2Xzd1._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            var indexRoute = _extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    var pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        var decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $bQ8GJ._)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $2Xzd1._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $2Xzd1._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function(s) {
    return s === "*";
};
function computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter(function(s) {
        return !isSplat(s);
    }).reduce(function(score, segment) {
        return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
    }, initialScore);
}
function compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $kB67t._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            invariant(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $kB67t._)(compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        warning(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? parsePath(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    var pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ var joinPaths = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var normalizePathname = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ var json = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers: headers
    }));
};
var DataWithResponseInit = function DataWithResponseInit(data, init) {
    "use strict";
    (0, $bB0zn._)(this, DataWithResponseInit);
    this.type = "DataWithResponseInit";
    this.data = data;
    this.init = init || null;
};
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
var AbortedDeferredError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $5dLwP._)(AbortedDeferredError, Error1);
    function AbortedDeferredError() {
        (0, $bB0zn._)(this, AbortedDeferredError);
        return (0, $3Gvhd._)(this, AbortedDeferredError, arguments);
    }
    return AbortedDeferredError;
}((0, $fPaN7._)(Error));
var DeferredData = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $bB0zn._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && (typeof data === "undefined" ? "undefined" : (0, $YtE9h._)(data)) === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new AbortedDeferredError("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $kB67t._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $hD5pT._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $6QEWP._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $7k5I8._)(function() {
                    var aborted, onAbort;
                    return (0, $lFlDF.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $kB67t._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $hD5pT._)({}, key, unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ var defer = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirectDocument = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var replace = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var ErrorResponseImpl = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $bB0zn._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "get"
].concat((0, $2Xzd1._)(validMutationMethodsArr));
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    var dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    var patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    var future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    var initialMatchesIsFOW = false;
    var initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $hD5pT._)({}, route.id, error);
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        var fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    var initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            var fogOfWar1 = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar1.active && fogOfWar1.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar1.matches;
            }
        }
    } else if (initialMatches.some(function(m) {
        return m.route.lazy;
    })) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some(function(m) {
        return m.route.loader;
    })) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            var idx = initialMatches.findIndex(function(m) {
                return errors[m.route.id] !== undefined;
            });
            initialized = initialMatches.slice(0, idx + 1).every(function(m) {
                return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
            });
        } else initialized = initialMatches.every(function(m) {
            return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
        });
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                var nextHistoryUpdatePromise = new Promise(function(resolve) {
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(function() {
                            return init.history.go(delta);
                        });
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach(function(key) {
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, $2Xzd1._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers.delete(key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach(function(key) {
            return deletedFetchers.delete(key);
        });
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, IDLE_BLOCKER);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $7k5I8._)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = Action.Push;
                        if (userReplace === true) historyAction = Action.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = Action.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, IDLE_BLOCKER);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $7k5I8._)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, request, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
                        state.matches : matchRoutes(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $hD5pT._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial hydration will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingActionResult = [
                            findNearestBoundary(matches).route.id,
                            {
                                type: ResultType.error,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        // If we received a 404 from handleAction, it's because we couldn't lazily
                        // discover the destination route so we don't want to call loaders
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, $kB67t._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, $hD5pT._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // No need to do fog of war matching again on loader execution
                        fogOfWar.active = false;
                        // Create a GET request for the loaders
                        request = createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, _extends({
                            matches: updatedMatches || matches
                        }, getActionDataForCommit(pendingActionResult), {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $7k5I8._)(function(request, location, submission, matches, isFogOfWar, opts) {
            var navigation, discoverResult, boundaryId, _handleNavigational404, notFoundMatches, error, route, result, actionMatch, results, replace, _$location, boundaryMatch;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    pendingActionResult: [
                                        boundaryId,
                                        {
                                            type: ResultType.error,
                                            error: discoverResult.error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational404.notFoundMatches, error = _handleNavigational404.error, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route.id,
                                        {
                                            type: ResultType.error,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: ResultType.error,
                            error: getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            callDataStrategy("action", state, request, [
                                actionMatch
                            ], matches, null)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else {
                            // If the user didn't explicity indicate replace behavior, replace if
                            // we redirected to the exact same location we're currently at to avoid
                            // double back-buttons
                            _$location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                            replace = _$location === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, true, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if (isDeferredResult(result)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        if (isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions to the current location are REPLACE
                            // navigations, but if the action threw an error that'll be rendered in
                            // an errorElement, we fall back to PUSH so that the user can use the
                            // back button to get back to the pre-submission form location to try
                            // again
                            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $7k5I8._)(function(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, boundaryId, _handleNavigational404, error, notFoundMatches, route, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since it's not a "navigation"
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState(_extends({
                                navigation: loadingNavigation
                            }, actionData !== undefined ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    loaderData: {},
                                    errors: (0, $hD5pT._)({}, boundaryId, discoverResult.error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, $hD5pT._)({}, route.id, error)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $kB67t._)(getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, _extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $hD5pT._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                // Only update navigation/actionNData if we didn't already do it above
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== undefined) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = findRedirect(loaderResults);
                        if (!redirect) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        redirect = findRedirect(fetcherResults);
                        if (!redirect) return [
                            3,
                            7
                        ];
                        // If this redirect came from a fetcher make sure we mark it in
                        // fetchRedirectIds so it doesn't get revalidated on the next set of
                        // loader executions
                        fetchRedirectIds.add(redirect.key);
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        // Preserve SSR errors during partial hydration
                        if (future.v7_partialHydration && initialHydration && state.errors) errors = _extends({}, state.errors, errors);
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            _extends({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return (0, $hD5pT._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = state.fetchers.get(rf.key);
            var revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        var flushSync = (opts && opts.flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = matchRoutes(routesToUse, normalizedPath, basename);
        var fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = getTargetMatch(matches, path);
        var preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $7k5I8._)(function(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, actionResults, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, doneFetcher;
            function detectAndHandle405Error(m) {
                if (!m.route.action && !m.route.lazy) {
                    var error = getInternalRouterError(405, {
                        method: submission.formMethod,
                        pathname: path,
                        routeId: routeId
                    });
                    setFetcherError(key, routeId, error, {
                        flushSync: flushSync
                    });
                    return true;
                }
                return false;
            }
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!isFogOfWar && detectAndHandle405Error(match)) return [
                            2
                        ];
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            requestMatches = discoverResult.matches;
                            match = getTargetMatch(requestMatches, path);
                            if (detectAndHandle405Error(match)) return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        // Call the action for the fetcher
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("action", state, fetchRequest, [
                                match
                            ], requestMatches, key)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[match.route.id];
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                                updateFetcherState(key, getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if (isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, false, {
                                            fetcherSubmission: submission,
                                            preventScrollReset: preventScrollReset
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if (isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
                        invariant(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $kB67t._)(getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
                            match.route.id,
                            actionResult
                        ]), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = findRedirect(loaderResults);
                        if (redirect) return [
                            2,
                            startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                        redirect = findRedirect(fetcherResults);
                        if (redirect) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetchRedirectIds.add(redirect.key);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            invariant(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $7k5I8._)(function(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, results, result;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            matches = discoverResult.matches;
                            match = getTargetMatch(matches, path);
                        }
                        _state.label = 2;
                    case 2:
                        // Call the loader for this fetcher route match
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("loader", state, fetchRequest, [
                                match
                            ], matches, key)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[match.route.id];
                        if (!isDeferredResult(result)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 4:
                        result = _state.sent() || result;
                        _state.label = 5;
                    case 5:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!isRedirectResult(result)) return [
                            3,
                            8
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            6
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 6:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2
                        ];
                    case 8:
                        // Process any non-redirect errors thrown
                        if (isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $7k5I8._)(function(request, redirect, isNavigation, _temp2) {
            var _ref, submission, fetcherSubmission, preventScrollReset, replace, location, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, preventScrollReset = _ref.preventScrollReset, replace = _ref.replace;
                        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect.response.headers.get("Location");
                        invariant(location, "Expected a Location header on the redirect Response");
                        location = normalizeRedirectLocation(location, new URL(request.url), basename);
                        redirectLocation = createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if (ABSOLUTE_URL_REGEX.test(location)) {
                                url = init.history.createURL(location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                stripBasename(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!(redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: _extends({}, activeSubmission, {
                                    formAction: location
                                }),
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy client-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $7k5I8._)(function(type, state, request, matchesToLoad, matches, fetcherKey) {
            var results, dataResults, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, routeId, result, response, err;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataResults = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties)
                        ];
                    case 2:
                        results = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        // If the outer dataStrategy method throws, just return the error for all
                        // matches - and it'll naturally bubble to the root
                        matchesToLoad.forEach(function(m) {
                            dataResults[m.route.id] = {
                                type: ResultType.error,
                                error: e
                            };
                        });
                        return [
                            2,
                            dataResults
                        ];
                    case 4:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            11,
                            12,
                            13
                        ]);
                        _iterator = Object.entries(results)[Symbol.iterator]();
                        _state.label = 6;
                    case 6:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            10
                        ];
                        _step_value = (0, $kB67t._)(_step.value, 2), routeId = _step_value[0], result = _step_value[1];
                        if (!isRedirectDataStrategyResultResult(result)) return [
                            3,
                            7
                        ];
                        response = result.result;
                        dataResults[routeId] = {
                            type: ResultType.redirect,
                            response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
                        };
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            convertDataStrategyResultToDataResult(result)
                        ];
                    case 8:
                        dataResults[routeId] = _state.sent();
                        _state.label = 9;
                    case 9:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            3,
                            13
                        ];
                    case 11:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 12:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $7k5I8._)(function(state, matches, matchesToLoad, fetchersToLoad, request) {
            var currentMatches, loaderResultsPromise, fetcherResultsPromise, loaderResults, fetcherResults;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentMatches = state.matches;
                        // Kick off loaders and fetchers in parallel
                        loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
                        fetcherResultsPromise = Promise.all(fetchersToLoad.map(/*#__PURE__*/ function() {
                            var _ref = (0, $7k5I8._)(function(f) {
                                var results, result;
                                return (0, $lFlDF.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(f.matches && f.match && f.controller)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                                                    f.match
                                                ], f.matches, f.key)
                                            ];
                                        case 1:
                                            results = _state.sent();
                                            result = results[f.match.route.id];
                                            // Fetcher results are keyed by fetcher key from here on out, not routeId
                                            return [
                                                2,
                                                (0, $hD5pT._)({}, f.key, result)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                Promise.resolve((0, $hD5pT._)({}, f.key, {
                                                    type: ResultType.error,
                                                    error: getInternalRouterError(404, {
                                                        pathname: f.path
                                                    })
                                                }))
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(f) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                        return [
                            4,
                            loaderResultsPromise
                        ];
                    case 1:
                        loaderResults = _state.sent();
                        return [
                            4,
                            fetcherResultsPromise
                        ];
                    case 2:
                        fetcherResults = _state.sent().reduce(function(acc, r) {
                            return Object.assign(acc, r);
                        }, {});
                        return [
                            4,
                            Promise.all([
                                resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
                                resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
                            ])
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $2Xzd1._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $hD5pT._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        var count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                invariant(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    invariant(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $kB67t._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var _getShortCircuitMatches = getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return convertRouteMatchToUiMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                var fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                var partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal) {
        return _discoverRoutes.apply(this, arguments);
    }
    function _discoverRoutes() {
        _discoverRoutes = (0, $7k5I8._)(function(matches, pathname, signal) {
            var _loop, partialMatches, _ret;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function() {
                            var isNonHMR, routesToUse, localManifest, e, newMatches, newPartialMatches;
                            return (0, $lFlDF.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        isNonHMR = inFlightDataRoutes == null;
                                        routesToUse = inFlightDataRoutes || dataRoutes;
                                        localManifest = manifest;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            4,
                                            5
                                        ]);
                                        return [
                                            4,
                                            patchRoutesOnNavigationImpl({
                                                signal: signal,
                                                path: pathname,
                                                matches: partialMatches,
                                                patch: function(routeId, children) {
                                                    if (signal.aborted) return;
                                                    patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                                                }
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                v: {
                                                    type: "error",
                                                    error: e,
                                                    partialMatches: partialMatches
                                                }
                                            }
                                        ];
                                    case 4:
                                        // If we are not in the middle of an HMR revalidation and we changed the
                                        // routes, provide a new identity so when we `updateState` at the end of
                                        // this navigation/fetch `router.routes` will be a new identity and
                                        // trigger a re-run of memoized `router.routes` dependencies.
                                        // HMR will already update the identity and reflow when it lands
                                        // `inFlightDataRoutes` in `completeNavigation`
                                        if (isNonHMR && !signal.aborted) dataRoutes = (0, $2Xzd1._)(dataRoutes);
                                        return [
                                            7
                                        ];
                                    case 5:
                                        if (signal.aborted) return [
                                            2,
                                            {
                                                v: {
                                                    type: "aborted"
                                                }
                                            }
                                        ];
                                        newMatches = matchRoutes(routesToUse, pathname, basename);
                                        if (newMatches) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: newMatches
                                                }
                                            }
                                        ];
                                        newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                                        // Avoid loops if the second pass results in the same partial matches
                                        if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every(function(m, i) {
                                            return m.route.id === newPartialMatches[i].route.id;
                                        })) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: null
                                                }
                                            }
                                        ];
                                        partialMatches = newPartialMatches;
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        if (!patchRoutesOnNavigationImpl) return [
                            2,
                            {
                                type: "success",
                                matches: matches
                            }
                        ];
                        partialMatches = matches;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            3
                        ];
                        return [
                            5,
                            (0, $lFlDF.__values)(_loop())
                        ];
                    case 2:
                        _ret = _state.sent();
                        if ((0, $YtE9h._)(_ret) === "object") return [
                            2,
                            _ret.v
                        ];
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _discoverRoutes.apply(this, arguments);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        var isNonHMR = inFlightDataRoutes == null;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = (0, $2Xzd1._)(dataRoutes);
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    var future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp3) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ (0, $7k5I8._)(function(request, _temp3) {
            var _ref, requestContext, skipLoaderErrorBubbling, dataStrategy, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, requestContext = _ref.requestContext, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD") {
                            error = getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $hD5pT._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $hD5pT._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            _extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp4) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ (0, $7k5I8._)(function(request, _temp4) {
            var _ref, routeId, requestContext, dataStrategy, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : getTargetMatch(matches, location);
                        if (routeId && !match) throw getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $7k5I8._)(function(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
            var result, result1, e;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            isResponse(result1) ? result1 : _extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction for a
                        // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
                        // and then return or throw the raw Response here accordingly
                        if (isDataStrategyResult(e) && isResponse(e.result)) {
                            if (e.type === ResultType.error) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if (isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $7k5I8._)(function(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
            var result, error, results, error1, loaderRequest, boundaryMatch, context, context1;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        _state.label = 3;
                    case 3:
                        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if (isDeferredResult(result)) {
                            error1 = getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if (isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $hD5pT._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                                boundaryMatch.route.id,
                                result
                            ])
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            _extends({}, context, {
                                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: _extends({}, result.headers ? (0, $hD5pT._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            _extends({}, context1, {
                                actionData: (0, $hD5pT._)({}, actionMatch.route.id, result.data)
                            }, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionHeaders: result.headers ? (0, $hD5pT._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $7k5I8._)(function(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
            var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $hD5pT._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $hD5pT._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            _extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy server-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $7k5I8._)(function(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
            var results, dataResults;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext)
                        ];
                    case 1:
                        results = _state.sent();
                        dataResults = {};
                        return [
                            4,
                            Promise.all(matches.map(/*#__PURE__*/ function() {
                                var _ref = (0, $7k5I8._)(function(match) {
                                    var result, response, _;
                                    return (0, $lFlDF.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(match.route.id in results)) return [
                                                    2
                                                ];
                                                result = results[match.route.id];
                                                if (isRedirectDataStrategyResultResult(result)) {
                                                    response = result.result;
                                                    // Throw redirects and let the server handle them with an HTTP redirect
                                                    throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
                                                }
                                                if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
                                                // directly without unwrapping
                                                throw result;
                                                _ = match.route.id;
                                                return [
                                                    4,
                                                    convertDataStrategyResultToDataResult(result)
                                                ];
                                            case 1:
                                                dataResults[_] = _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(match) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    var newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: (0, $hD5pT._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        var nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            var params = new URLSearchParams(path.search);
            var indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path: path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, $kB67t._)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    var index = matches.findIndex(function(m) {
        return m.route.id === boundaryId;
    });
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    var actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    var shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    var hasData = loaderData != null && loaderData[route.id] !== undefined;
    var hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    var _childrenToPatch1;
    var childrenToPatch;
    if (routeId) {
        var route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    var uniqueChildren = children.filter(function(newRoute) {
        return !childrenToPatch.some(function(existingRoute) {
            return isSameRoute(newRoute, existingRoute);
        });
    });
    var newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch1 = childrenToPatch) == null ? void 0 : _childrenToPatch1.length) || "0")
    ], manifest);
    (_childrenToPatch = childrenToPatch).push.apply(_childrenToPatch, (0, $2Xzd1._)(newRoutes));
}
function isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every(function(aChild, i) {
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some(function(bChild) {
            return isSameRoute(aChild, bChild);
        });
    });
}
function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return _loadLazyRouteModule.apply(this, arguments);
}
function _loadLazyRouteModule() {
    _loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $7k5I8._)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    invariant(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        warning(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
                        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return _loadLazyRouteModule.apply(this, arguments);
}
function defaultDataStrategy(_ref4) {
    return _defaultDataStrategy.apply(this, arguments);
}
function _defaultDataStrategy() {
    _defaultDataStrategy = // Default implementation of `dataStrategy` which fetches all loaders in parallel
    (0, $7k5I8._)(function(_ref4) {
        var matches, matchesToLoad, results;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matches = _ref4.matches;
                    matchesToLoad = matches.filter(function(m) {
                        return m.shouldLoad;
                    });
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve();
                        }))
                    ];
                case 1:
                    results = _state.sent();
                    return [
                        2,
                        results.reduce(function(acc, result, i) {
                            return Object.assign(acc, (0, $hD5pT._)({}, matchesToLoad[i].route.id, result));
                        }, {})
                    ];
            }
        });
    });
    return _defaultDataStrategy.apply(this, arguments);
}
function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    return _callDataStrategyImpl.apply(this, arguments);
}
function _callDataStrategyImpl() {
    _callDataStrategyImpl = (0, $7k5I8._)(function(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
        var loadRouteDefinitionsPromises, dsMatches, results, e;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loadRouteDefinitionsPromises = matches.map(function(m) {
                        return m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined;
                    });
                    dsMatches = matches.map(function(match, i) {
                        var loadRoutePromise = loadRouteDefinitionsPromises[i];
                        var shouldLoad = matchesToLoad.some(function(m) {
                            return m.route.id === match.route.id;
                        });
                        // `resolve` encapsulates route.lazy(), executing the loader/action,
                        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
                        // can pass a callback to take fine-grained control over the execution
                        // of the loader/action
                        var resolve = /*#__PURE__*/ function() {
                            var _ref = (0, $7k5I8._)(function(handlerOverride) {
                                return (0, $lFlDF.__generator)(this, function(_state) {
                                    if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
                                    return [
                                        2,
                                        shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                                            type: ResultType.data,
                                            result: undefined
                                        })
                                    ];
                                });
                            });
                            return function resolve(handlerOverride) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        return _extends({}, match, {
                            shouldLoad: shouldLoad,
                            resolve: resolve
                        });
                    });
                    return [
                        4,
                        dataStrategyImpl({
                            matches: dsMatches,
                            request: request,
                            params: matches[0].params,
                            fetcherKey: fetcherKey,
                            context: requestContext
                        })
                    ];
                case 1:
                    results = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        Promise.all(loadRouteDefinitionsPromises)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2,
                        results
                    ];
            }
        });
    });
    return _callDataStrategyImpl.apply(this, arguments);
}
function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    return _callLoaderOrAction.apply(this, arguments);
}
function _callLoaderOrAction() {
    _callLoaderOrAction = // Default logic for calling a loader/action is the user has no specified a dataStrategy
    (0, $7k5I8._)(function(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
        var result, onReject, runHandler, handler, handlerError, _ref, value, url, pathname, url1, pathname1, e;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
                        // satisfy the function return value
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    params: match.params,
                                    context: staticContext
                                }
                            ].concat((0, $2Xzd1._)(ctx !== undefined ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise = (0, $7k5I8._)(function() {
                            var val, e;
                            return (0, $lFlDF.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            handlerOverride ? handlerOverride(function(ctx) {
                                                return actualHandler(ctx);
                                            }) : actualHandler()
                                        ];
                                    case 1:
                                        val = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "data",
                                                result: val
                                            }
                                        ];
                                    case 2:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "error",
                                                result: e
                                            }
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!loadRoutePromise) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            loadRoutePromise
                        ])
                    ];
                case 2:
                    _ref = (0, $kB67t._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== undefined) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        loadRoutePromise
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still runs even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: ResultType.data,
                            result: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    // We should already be catching and converting normal handler executions to
                    // DataStrategyResults and returning them, so anything that throws here is an
                    // unexpected error we still need to wrap
                    return [
                        2,
                        {
                            type: ResultType.error,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _callLoaderOrAction.apply(this, arguments);
}
function convertDataStrategyResultToDataResult(dataStrategyResult) {
    return _convertDataStrategyResultToDataResult.apply(this, arguments);
}
function _convertDataStrategyResultToDataResult() {
    _convertDataStrategyResultToDataResult = (0, $7k5I8._)(function(dataStrategyResult) {
        var result, type, data, contentType, e, _result$init3, _result$init4, _result$init, _result$init2, _result$init5, _result$init6, _result$init7, _result$init8;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = dataStrategyResult.result, type = dataStrategyResult.type;
                    if (!isResponse(result)) return [
                        3,
                        10
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        5
                    ];
                    if (!(result.body == null)) return [
                        3,
                        2
                    ];
                    data = null;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        result.json()
                    ];
                case 3:
                    data = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        result.text()
                    ];
                case 6:
                    data = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: ResultType.error,
                            error: e
                        }
                    ];
                case 9:
                    if (type === ResultType.error) return [
                        2,
                        {
                            type: ResultType.error,
                            error: new ErrorResponseImpl(result.status, result.statusText, data),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 10:
                    if (type === ResultType.error) {
                        if (isDataWithResponseInit(result)) {
                            ;
                            if (result.data instanceof Error) {
                                ;
                                return [
                                    2,
                                    {
                                        type: ResultType.error,
                                        error: result.data,
                                        statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                        headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                                    }
                                ];
                            }
                            // Convert thrown data() to ErrorResponse instances
                            return [
                                2,
                                {
                                    type: ResultType.error,
                                    error: new ErrorResponseImpl(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                                    statusCode: isRouteErrorResponse(result) ? result.status : undefined,
                                    headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: result,
                                statusCode: isRouteErrorResponse(result) ? result.status : undefined
                            }
                        ];
                    }
                    if (isDeferredData(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
                                headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    if (isDataWithResponseInit(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.data,
                                statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
                                headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return _convertDataStrategyResultToDataResult.apply(this, arguments);
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    var location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        var normalizedLocation = location;
        var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        var isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL(stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach(function(match) {
        if (!(match.route.id in results)) return;
        var id = match.route.id;
        var result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                var boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = (0, $hD5pT._)({}, pendingActionResult[0], pendingError);
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    ), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach(function(rf) {
        var key = rf.key, match = rf.match, controller = rf.controller;
        var result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            var boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, (0, $hD5pT._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = _extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, $hD5pT._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $2Xzd1._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    var entries = Object.entries(results);
    for(var i = entries.length - 1; i >= 0; i--){
        var _entries_i = (0, $kB67t._)(entries[i], 2), key = _entries_i[0], result = _entries_i[1];
        if (isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDataStrategyResult(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $YtE9h._)(result)) === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    var deferred = value;
    return deferred && (typeof deferred === "undefined" ? "undefined" : (0, $YtE9h._)(deferred)) === "object" && (0, $YtE9h._)(deferred.data) === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && (0, $YtE9h._)(value.headers) === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    return _resolveNavigationDeferredResults.apply(this, arguments);
}
function _resolveNavigationDeferredResults() {
    _resolveNavigationDeferredResults = (0, $7k5I8._)(function(matches, results, signal, currentMatches, currentLoaderData) {
        var _loop, entries, index;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var _entries_index, routeId, result, match, currentMatch, isRevalidatingLoader;
                        return (0, $lFlDF.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _entries_index = (0, $kB67t._)(entries[index], 2), routeId = _entries_index[0], result = _entries_index[1];
                                    match = matches.find(function(m) {
                                        return (m == null ? void 0 : m.route.id) === routeId;
                                    });
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!(isDeferredResult(result) && isRevalidatingLoader)) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    return [
                                        4,
                                        resolveDeferredData(result, signal, false).then(function(result) {
                                            if (result) results[routeId] = result;
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    entries = Object.entries(results);
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < entries.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $lFlDF.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _resolveNavigationDeferredResults.apply(this, arguments);
}
function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    return _resolveFetcherDeferredResults.apply(this, arguments);
}
function _resolveFetcherDeferredResults() {
    _resolveFetcherDeferredResults = (0, $7k5I8._)(function(matches, results, revalidatingFetchers) {
        var _loop, index;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var _revalidatingFetchers_index, key, routeId, controller, result, match;
                        return (0, $lFlDF.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, routeId = _revalidatingFetchers_index.routeId, controller = _revalidatingFetchers_index.controller;
                                    result = results[key];
                                    match = matches.find(function(m) {
                                        return (m == null ? void 0 : m.route.id) === routeId;
                                    });
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    if (!isDeferredResult(result)) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        resolveDeferredData(result, controller.signal, true).then(function(result) {
                                            if (result) results[key] = result;
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < revalidatingFetchers.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $lFlDF.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _resolveFetcherDeferredResults.apply(this, arguments);
}
function resolveDeferredData(result, signal, unwrap) {
    return _resolveDeferredData.apply(this, arguments);
}
function _resolveDeferredData() {
    _resolveDeferredData = (0, $7k5I8._)(function(result, signal, unwrap) {
        var aborted;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return _resolveDeferredData.apply(this, arguments);
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function getTargetMatch(matches, location) {
    var search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $kB67t._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $kB67t._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $2Xzd1._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});
parcelRegister("3Gvhd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2aed8e3a8a2d58d2$export$71511d61b312f219; });

var $ZhYhU = parcelRequire("ZhYhU");

var $bFohN = parcelRequire("bFohN");

var $oIOMH = parcelRequire("oIOMH");
function $2aed8e3a8a2d58d2$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $ZhYhU._)(derived);
    return (0, $oIOMH._)(_this, (0, $bFohN._)() ? Reflect.construct(derived, args || [], (0, $ZhYhU._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("ZhYhU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0b83a35ce2cd1792$export$71511d61b312f219; });
function $0b83a35ce2cd1792$export$71511d61b312f219(o) {
    $0b83a35ce2cd1792$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0b83a35ce2cd1792$export$71511d61b312f219(o);
}

});

parcelRegister("bFohN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $87e65cc21f1ac8a6$export$71511d61b312f219; });
function $87e65cc21f1ac8a6$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($87e65cc21f1ac8a6$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("oIOMH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $04a501f287790d91$export$71511d61b312f219; });

var $fWfWu = parcelRequire("fWfWu");

var $YtE9h = parcelRequire("YtE9h");
function $04a501f287790d91$export$71511d61b312f219(self, call) {
    if (call && ((0, $YtE9h._)(call) === "object" || typeof call === "function")) return call;
    return (0, $fWfWu._)(self);
}

});
parcelRegister("fWfWu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $02fe9748b9e38ccb$export$71511d61b312f219; });
function $02fe9748b9e38ccb$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("6QEWP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4fc75ccb937ab1df$export$71511d61b312f219; });
function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("hD5pT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cd5a47cf8ef6d766$export$71511d61b312f219; });
function $cd5a47cf8ef6d766$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("5dLwP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3cd308d6b98edc5a$export$71511d61b312f219; });

var $eZsRM = parcelRequire("eZsRM");
function $3cd308d6b98edc5a$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $eZsRM._)(subClass, superClass);
}

});
parcelRegister("eZsRM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ae9d277b5847b878$export$71511d61b312f219; });
function $ae9d277b5847b878$export$71511d61b312f219(o, p) {
    $ae9d277b5847b878$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ae9d277b5847b878$export$71511d61b312f219(o, p);
}

});


parcelRegister("bQ8GJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $89eb4a55c543f071$export$71511d61b312f219; });

var $Q9cvz = parcelRequire("Q9cvz");

var $Q6yVl = parcelRequire("Q6yVl");

var $dNApw = parcelRequire("dNApw");

var $ihB7G = parcelRequire("ihB7G");
function $89eb4a55c543f071$export$71511d61b312f219(arr) {
    return (0, $Q9cvz._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $dNApw._)();
}

});
parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});


parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fPaN7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b853fd5b3c362aee$export$71511d61b312f219; });

var $f5KHm = parcelRequire("f5KHm");

var $ZhYhU = parcelRequire("ZhYhU");

var $cHvTP = parcelRequire("cHvTP");

var $eZsRM = parcelRequire("eZsRM");
function $b853fd5b3c362aee$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $b853fd5b3c362aee$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $cHvTP._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $f5KHm._)(Class, arguments, (0, $ZhYhU._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $eZsRM._)(Wrapper, Class);
    };
    return $b853fd5b3c362aee$export$71511d61b312f219(Class);
}

});
parcelRegister("f5KHm", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $afcb8bf546bf0e4a$export$71511d61b312f219; });

var $bFohN = parcelRequire("bFohN");

var $eZsRM = parcelRequire("eZsRM");
function $afcb8bf546bf0e4a$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $bFohN._)()) $afcb8bf546bf0e4a$export$71511d61b312f219 = Reflect.construct;
    else $afcb8bf546bf0e4a$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $eZsRM._)(instance, Class.prototype);
        return instance;
    };
    return $afcb8bf546bf0e4a$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("cHvTP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $93f23ebd967272a8$export$71511d61b312f219; });
function $93f23ebd967272a8$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});



parcelRegister("dAaLE", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $9e36fd5982483bee$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $9e36fd5982483bee$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $9e36fd5982483bee$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $9e36fd5982483bee$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $9e36fd5982483bee$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $9e36fd5982483bee$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $9e36fd5982483bee$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $9e36fd5982483bee$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $9e36fd5982483bee$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $9e36fd5982483bee$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "useRouteError", function () { return $9e36fd5982483bee$export$ed527bf60f6e05f2; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $9e36fd5982483bee$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $9e36fd5982483bee$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $9e36fd5982483bee$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $9e36fd5982483bee$export$b273b3273281a049; });
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", function () { return $9e36fd5982483bee$export$db5148ec97d6af7a; });
$parcel$export(module.exports, "Router", function () { return $9e36fd5982483bee$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Outlet", function () { return $9e36fd5982483bee$export$910ae8079b2c2852; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $9e36fd5982483bee$export$52b333d321859367; });
/**
 * React Router v6.29.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $3Gvhd = parcelRequire("3Gvhd");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $5dLwP = parcelRequire("5dLwP");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $fIwXP = parcelRequire("fIwXP");

var $iU7ml = parcelRequire("iU7ml");
function $9e36fd5982483bee$var$_extends() {
    $9e36fd5982483bee$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9e36fd5982483bee$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $9e36fd5982483bee$export$3add0d5dce533e2e = /*#__PURE__*/ $fIwXP.createContext(null);
var $9e36fd5982483bee$export$145dfa71566a64dc = /*#__PURE__*/ $fIwXP.createContext(null);
var $9e36fd5982483bee$var$AwaitContext = /*#__PURE__*/ $fIwXP.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $9e36fd5982483bee$export$26749e8557646306 = /*#__PURE__*/ $fIwXP.createContext(null);
var $9e36fd5982483bee$export$c7914228fb69b0f5 = /*#__PURE__*/ $fIwXP.createContext(null);
var $9e36fd5982483bee$export$9072aa6dd1f93057 = /*#__PURE__*/ $fIwXP.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $9e36fd5982483bee$var$RouteErrorContext = /*#__PURE__*/ $fIwXP.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $9e36fd5982483bee$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $iU7ml.UNSAFE_invariant)(false);
    var _React_useContext = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $9e36fd5982483bee$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $iU7ml.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $9e36fd5982483bee$export$9c954a9d03d32f4a() {
    return $fIwXP.useContext($9e36fd5982483bee$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $9e36fd5982483bee$export$45d76561a5302f2b() {
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $iU7ml.UNSAFE_invariant)(false);
    return $fIwXP.useContext($9e36fd5982483bee$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $9e36fd5982483bee$export$1b3f31771c5d07c() {
    return $fIwXP.useContext($9e36fd5982483bee$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $9e36fd5982483bee$export$6c330e8992e8a295(pattern) {
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $iU7ml.UNSAFE_invariant)(false);
    var pathname = $9e36fd5982483bee$export$45d76561a5302f2b().pathname;
    return $fIwXP.useMemo(function() {
        return (0, $iU7ml.matchPath)(pattern, (0, $iU7ml.UNSAFE_decodePath)(pathname));
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $9e36fd5982483bee$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $9e36fd5982483bee$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fIwXP.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $9e36fd5982483bee$export$9770f232ac06a008() {
    var isDataRoute = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $9e36fd5982483bee$var$useNavigateStable() : $9e36fd5982483bee$var$useNavigateUnstable();
}
function $9e36fd5982483bee$var$useNavigateUnstable() {
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $iU7ml.UNSAFE_invariant)(false);
    var dataRouterContext = $fIwXP.useContext($9e36fd5982483bee$export$3add0d5dce533e2e);
    var _React_useContext = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).matches;
    var _useLocation = $9e36fd5982483bee$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $iU7ml.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    var activeRef = $fIwXP.useRef(false);
    $9e36fd5982483bee$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $fIwXP.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $iU7ml.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $iU7ml.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $9e36fd5982483bee$var$OutletContext = /*#__PURE__*/ $fIwXP.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $9e36fd5982483bee$export$4138103a3ae699cc() {
    return $fIwXP.useContext($9e36fd5982483bee$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $9e36fd5982483bee$export$a3be3530d8e40d0b(context) {
    var outlet = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $9e36fd5982483bee$export$99eaa27ddbbb95ef() {
    var matches = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $9e36fd5982483bee$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306).future;
    var matches = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).matches;
    var _useLocation = $9e36fd5982483bee$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $iU7ml.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $fIwXP.useMemo(function() {
        return (0, $iU7ml.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $9e36fd5982483bee$export$5d3fca4a98652595(routes, locationArg) {
    return $9e36fd5982483bee$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $9e36fd5982483bee$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $iU7ml.UNSAFE_invariant)(false);
    var _React_useContext = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306), navigator = _React_useContext.navigator, isStatic = _React_useContext.static;
    var _React_useContext1 = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057), parentMatches = _React_useContext1.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $9e36fd5982483bee$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $iU7ml.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $iU7ml.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $iU7ml.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $9e36fd5982483bee$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $iU7ml.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $iU7ml.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $9e36fd5982483bee$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $iU7ml.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $9e36fd5982483bee$var$DefaultErrorComponent() {
    var error = $9e36fd5982483bee$export$ed527bf60f6e05f2();
    var message = (0, $iU7ml.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $fIwXP.createElement($fIwXP.Fragment, null, /*#__PURE__*/ $fIwXP.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $fIwXP.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $fIwXP.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $9e36fd5982483bee$var$defaultErrorElement = /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$DefaultErrorComponent, null);
var $9e36fd5982483bee$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $5dLwP._)(RenderErrorBoundary, _React_Component);
    function RenderErrorBoundary(props) {
        (0, $bB0zn._)(this, RenderErrorBoundary);
        var _this;
        _this = (0, $3Gvhd._)(this, RenderErrorBoundary, [
            props
        ]);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $6QEWP._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($fIwXP.Component);
function $9e36fd5982483bee$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $fIwXP.useContext($9e36fd5982483bee$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $9e36fd5982483bee$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined;
        });
        !(errorIndex >= 0) && (0, $iU7ml.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $9e36fd5982483bee$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $9e36fd5982483bee$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $fIwXP.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $9e36fd5982483bee$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($9e36fd5982483bee$var$DataRouterHook || {});
var $9e36fd5982483bee$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($9e36fd5982483bee$var$DataRouterStateHook || {});
function $9e36fd5982483bee$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $9e36fd5982483bee$var$useDataRouterContext(hookName) {
    var ctx = $fIwXP.useContext($9e36fd5982483bee$export$3add0d5dce533e2e);
    !ctx && (0, $iU7ml.UNSAFE_invariant)(false);
    return ctx;
}
function $9e36fd5982483bee$var$useDataRouterState(hookName) {
    var state = $fIwXP.useContext($9e36fd5982483bee$export$145dfa71566a64dc);
    !state && (0, $iU7ml.UNSAFE_invariant)(false);
    return state;
}
function $9e36fd5982483bee$var$useRouteContext(hookName) {
    var route = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057);
    !route && (0, $iU7ml.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $9e36fd5982483bee$var$useCurrentRouteId(hookName) {
    var route = $9e36fd5982483bee$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $iU7ml.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $9e36fd5982483bee$export$5fc8298006ad9e58() {
    return $9e36fd5982483bee$var$useCurrentRouteId($9e36fd5982483bee$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $9e36fd5982483bee$export$d0fd4b7106de2769() {
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $9e36fd5982483bee$export$600dc272ed516c15() {
    var dataRouterContext = $9e36fd5982483bee$var$useDataRouterContext($9e36fd5982483bee$var$DataRouterHook.UseRevalidator);
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseRevalidator);
    return $fIwXP.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $9e36fd5982483bee$export$2378eb7f5ff86053() {
    var _useDataRouterState = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $fIwXP.useMemo(function() {
        return matches.map(function(m) {
            return (0, $iU7ml.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $9e36fd5982483bee$export$1448a5050d252c4d() {
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseLoaderData);
    var routeId = $9e36fd5982483bee$var$useCurrentRouteId($9e36fd5982483bee$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $9e36fd5982483bee$export$fd5d37484eab868d(routeId) {
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $9e36fd5982483bee$export$fdc00f3f26066d5e() {
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseActionData);
    var routeId = $9e36fd5982483bee$var$useCurrentRouteId($9e36fd5982483bee$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $9e36fd5982483bee$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $fIwXP.useContext($9e36fd5982483bee$var$RouteErrorContext);
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseRouteError);
    var routeId = $9e36fd5982483bee$var$useCurrentRouteId($9e36fd5982483bee$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $9e36fd5982483bee$export$78a72ddb39bdd145() {
    var value = $fIwXP.useContext($9e36fd5982483bee$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $9e36fd5982483bee$export$17f53340677d5831() {
    var value = $fIwXP.useContext($9e36fd5982483bee$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $9e36fd5982483bee$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $9e36fd5982483bee$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $9e36fd5982483bee$var$useDataRouterContext($9e36fd5982483bee$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $kB67t._)($fIwXP.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $fIwXP.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $9e36fd5982483bee$var$_extends({}, currentLocation, {
                pathname: (0, $iU7ml.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $9e36fd5982483bee$var$_extends({}, nextLocation, {
                pathname: (0, $iU7ml.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $fIwXP.useEffect(function() {
        var key = String(++$9e36fd5982483bee$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $fIwXP.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $iU7ml.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $9e36fd5982483bee$var$useNavigateStable() {
    var router = $9e36fd5982483bee$var$useDataRouterContext($9e36fd5982483bee$var$DataRouterHook.UseNavigateStable).router;
    var id = $9e36fd5982483bee$var$useCurrentRouteId($9e36fd5982483bee$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $fIwXP.useRef(false);
    $9e36fd5982483bee$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $fIwXP.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $9e36fd5982483bee$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $9e36fd5982483bee$var$alreadyWarned$1 = {};
function $9e36fd5982483bee$var$warningOnce(key, cond, message) {
    if (!cond && !$9e36fd5982483bee$var$alreadyWarned$1[key]) $9e36fd5982483bee$var$alreadyWarned$1[key] = true;
}
var $9e36fd5982483bee$var$alreadyWarned = {};
function $9e36fd5982483bee$var$warnOnce(key, message) {}
var $9e36fd5982483bee$var$logDeprecation = function(flag, msg, link) {
    return $9e36fd5982483bee$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
};
function $9e36fd5982483bee$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $9e36fd5982483bee$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $9e36fd5982483bee$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $9e36fd5982483bee$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $9e36fd5982483bee$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $9e36fd5982483bee$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $9e36fd5982483bee$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $9e36fd5982483bee$var$START_TRANSITION = "startTransition";
var $9e36fd5982483bee$var$startTransitionImpl = $fIwXP[$9e36fd5982483bee$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $9e36fd5982483bee$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $kB67t._)($fIwXP.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $fIwXP.useCallback(function(newState) {
        if (v7_startTransition && $9e36fd5982483bee$var$startTransitionImpl) $9e36fd5982483bee$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $fIwXP.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $fIwXP.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $fIwXP.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $fIwXP.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    $fIwXP.useEffect(function() {
        return $9e36fd5982483bee$export$db5148ec97d6af7a(future, router.future);
    }, [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $fIwXP.createElement($fIwXP.Fragment, null, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $9e36fd5982483bee$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return $9e36fd5982483bee$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $9e36fd5982483bee$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $fIwXP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $iU7ml.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $fIwXP.useCallback(function(newState) {
        v7_startTransition && $9e36fd5982483bee$var$startTransitionImpl ? $9e36fd5982483bee$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    $fIwXP.useEffect(function() {
        return $9e36fd5982483bee$export$db5148ec97d6af7a(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $9e36fd5982483bee$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $iU7ml.UNSAFE_invariant)(false);
    var _React_useContext = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306), future = _React_useContext.future, isStatic = _React_useContext.static;
    var matches = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).matches;
    var _useLocation = $9e36fd5982483bee$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $9e36fd5982483bee$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $iU7ml.resolveTo)(to, (0, $iU7ml.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $fIwXP.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $9e36fd5982483bee$export$910ae8079b2c2852(props) {
    return $9e36fd5982483bee$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $9e36fd5982483bee$export$e7b0ac011bb776c6(_props) {
    (0, $iU7ml.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $9e36fd5982483bee$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $iU7ml.Action).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $iU7ml.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $fIwXP.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $9e36fd5982483bee$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $iU7ml.parsePath)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $fIwXP.useMemo(function() {
        var trailingPathname = (0, $iU7ml.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $9e36fd5982483bee$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $9e36fd5982483bee$export$5d3fca4a98652595($9e36fd5982483bee$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $9e36fd5982483bee$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$ResolveAwait, null, children));
}
var $9e36fd5982483bee$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($9e36fd5982483bee$var$AwaitRenderStatus || {});
var $9e36fd5982483bee$var$neverSettledPromise = new Promise(function() {});
var $9e36fd5982483bee$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $5dLwP._)(AwaitErrorBoundary, _React_Component);
    function AwaitErrorBoundary(props) {
        (0, $bB0zn._)(this, AwaitErrorBoundary);
        var _this;
        _this = (0, $3Gvhd._)(this, AwaitErrorBoundary, [
            props
        ]);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $6QEWP._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $9e36fd5982483bee$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $9e36fd5982483bee$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $9e36fd5982483bee$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = "_error" in promise ? $9e36fd5982483bee$var$AwaitRenderStatus.error : "_data" in promise ? $9e36fd5982483bee$var$AwaitRenderStatus.success : $9e36fd5982483bee$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $9e36fd5982483bee$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $9e36fd5982483bee$var$AwaitRenderStatus.error && promise._error instanceof (0, $iU7ml.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
                throw $9e36fd5982483bee$var$neverSettledPromise;
                if (status === $9e36fd5982483bee$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $9e36fd5982483bee$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $9e36fd5982483bee$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($fIwXP.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $9e36fd5982483bee$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $9e36fd5982483bee$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $fIwXP.createElement($fIwXP.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $9e36fd5982483bee$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $fIwXP.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $fIwXP.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $2Xzd1._)(parentPath).concat([
            index
        ]);
        if (element.type === $fIwXP.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $9e36fd5982483bee$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $9e36fd5982483bee$export$e7b0ac011bb776c6) && (0, $iU7ml.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $iU7ml.UNSAFE_invariant)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $9e36fd5982483bee$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $9e36fd5982483bee$export$daf73786167a7f72(matches) {
    return $9e36fd5982483bee$var$_renderMatches(matches);
}
function $9e36fd5982483bee$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $fIwXP.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $fIwXP.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $fIwXP.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $9e36fd5982483bee$export$f30f7e456d254e83(routes, opts) {
    return (0, $iU7ml.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $9e36fd5982483bee$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $iU7ml.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $9e36fd5982483bee$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("eRslx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ad1c00e896d27009$export$71511d61b312f219; });

var $hD5pT = parcelRequire("hD5pT");
function $ad1c00e896d27009$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $hD5pT._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("jYM0A", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $e8b8dc64a4f17ad2$export$bf730a2d8bf68b42; }, function (v) { return $e8b8dc64a4f17ad2$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e8b8dc64a4f17ad2$export$bf730a2d8bf68b42;
"use strict";

var $fIwXP = parcelRequire("fIwXP");
function $e8b8dc64a4f17ad2$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $e8b8dc64a4f17ad2$var$objectIs = "function" === typeof Object.is ? Object.is : $e8b8dc64a4f17ad2$var$is, $e8b8dc64a4f17ad2$var$useSyncExternalStore = $fIwXP.useSyncExternalStore, $e8b8dc64a4f17ad2$var$useRef = $fIwXP.useRef, $e8b8dc64a4f17ad2$var$useEffect = $fIwXP.useEffect, $e8b8dc64a4f17ad2$var$useMemo = $fIwXP.useMemo, $e8b8dc64a4f17ad2$var$useDebugValue = $fIwXP.useDebugValue;
$e8b8dc64a4f17ad2$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $e8b8dc64a4f17ad2$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $e8b8dc64a4f17ad2$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($e8b8dc64a4f17ad2$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $e8b8dc64a4f17ad2$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $e8b8dc64a4f17ad2$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $e8b8dc64a4f17ad2$var$useDebugValue(value);
    return value;
};

});

parcelRegister("iVsXN", function(module, exports) {

$parcel$export(module.exports, "IMG_URL", function () { return $dc74046c776679c5$export$1d6744690e556718; });
$parcel$export(module.exports, "MENUS_IMG_URL", function () { return $dc74046c776679c5$export$82bbd7ef838ace61; });
$parcel$export(module.exports, "MART_PRODUCT_IMG", function () { return $dc74046c776679c5$export$124cb2b3b77d7ea; });
$parcel$export(module.exports, "RESTAURANT_URL", function () { return $dc74046c776679c5$export$9c3231652f8fee3e; });
$parcel$export(module.exports, "RESTAURANT_MENU", function () { return $dc74046c776679c5$export$d28dc33571f365ee; });
$parcel$export(module.exports, "instantMartJson", function () { return $dc74046c776679c5$export$bd6dade3c32c157d; });
$parcel$export(module.exports, "restaurantJson", function () { return $dc74046c776679c5$export$1bedaa6526a9305d; });
var $dc74046c776679c5$export$1d6744690e556718 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
var $dc74046c776679c5$export$82bbd7ef838ace61 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_300,h_300,c_fit/";
var $dc74046c776679c5$export$124cb2b3b77d7ea = "https://instamart-media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_304/";
var $dc74046c776679c5$export$9c3231652f8fee3e = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9715987&lng=77.5945627&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";
var $dc74046c776679c5$export$d28dc33571f365ee = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9715987&lng=77.5945627&restaurantId=";
var $dc74046c776679c5$export$bd6dade3c32c157d = {
    "data": {
        "storeId": "1313712",
        "slaString": "19 Mins",
        "serviceability": "SERVICEABLE",
        "serviceabilityMessage": "",
        "serviceabilityIcon": "",
        "nextAvailableSlot": "",
        "serviceabilityType": "FAST_SERVICEABLE",
        "storeDetails": {
            "id": "1313712",
            "name": "Instamart",
            "address": "Ground Floor, Zam Zam Complex property No.26 Infantry Road,Shivaji Nagar Bengaluru,BBMP Ward No. 110- Sampangiramnagar Bengaluru-560001",
            "description": "Instamart-Shivaji Nagar",
            "active": true,
            "priority": 2,
            "locality": "Shivaji Nagar",
            "categories": [
                {
                    "id": 52,
                    "name": "Instamart"
                }
            ],
            "tags": [],
            "sources": [
                {
                    "source": {
                        "id": 6,
                        "name": "Offline Sourced"
                    },
                    "id_in_source": "MUSTHAVE_400976"
                }
            ],
            "badges": [],
            "maxAllowedItemsInCart": 200,
            "maxAllowedCartWeightInGrams": 40000,
            "maxAllowedCartVolumeInCc": 80000,
            "minimumOrderValueInRs": 0,
            "subCategoryTypeMaxAllowedWeights": {},
            "discountInfo": {
                "couponLessDiscounts": [
                    {
                        "description": "Use FREEONION | On orders above \u20B9599",
                        "short_description": "1 Kg Onions free!",
                        "discount_type": "FREEBIE",
                        "logo_id": "e0cf25488aee88d25b9df510a56809f2",
                        "title": "Get 1 Kg Onions free!",
                        "sub_title": "Use code FREEONION and get 1 Kg Onions free on orders above \u20B9599",
                        "tnc": [
                            "Offer valid till stocks last",
                            "Offer valid for a limited period only",
                            "Other TnCs may apply",
                            "Offer valid till Dec 30, 2025"
                        ],
                        "coupon_code": "",
                        "super_offer": false,
                        "discount_cap": 0,
                        "valid_till": "2025-12-30T18:30:00.000+0000",
                        "offer_id": "17425f0f-739d-41d6-b7b6-2f3065f8184a",
                        "minimum_order_value": 999,
                        "discount_value": 0,
                        "nudge": {
                            "message": "",
                            "logoId": "",
                            "threshold": 0,
                            "frequency": 35,
                            "timeout": 10000,
                            "cta": {
                                "text": "View Items",
                                "link": ""
                            }
                        },
                        "success_dialog": {
                            "title": "",
                            "message": "",
                            "header": ""
                        },
                        "prev_mov_text": "",
                        "post_mov_text": "",
                        "groups_info": {
                            "exclusionGroupsInfo": {},
                            "message": ""
                        },
                        "pre_display_threshold_text": "",
                        "discount_on_type": "CART"
                    },
                    {
                        "description": "Use FREEONION | On orders above \u20B9599",
                        "short_description": "1 Kg Onions free!",
                        "discount_type": "FREEBIE",
                        "logo_id": "e0cf25488aee88d25b9df510a56809f2",
                        "title": "Get 1 Kg Onions free!",
                        "sub_title": "Use code FREEONION and get 1 Kg Onions free on orders above \u20B9599",
                        "tnc": [
                            "Offer valid till stocks last",
                            "Offer valid for a limited period only",
                            "Other TnCs may apply",
                            "Offer valid till Dec 30, 2025"
                        ],
                        "coupon_code": "",
                        "super_offer": false,
                        "discount_cap": 0,
                        "valid_till": "2025-12-30T18:30:00.000+0000",
                        "offer_id": "0cf6ae9f-5c63-42c7-a38e-b4a5e1215418",
                        "minimum_order_value": 1,
                        "discount_value": 0,
                        "nudge": {
                            "message": "Add \u20B9<remainingMov> more to get a freebie with <couponCode>",
                            "logoId": "",
                            "threshold": 50,
                            "frequency": 35,
                            "timeout": 10000,
                            "cta": {
                                "text": "View Items",
                                "link": ""
                            }
                        },
                        "success_dialog": {
                            "title": "You saved \u20B9{0}!",
                            "message": "You got extra \u20B9{0} off on your bill by adding Zydus items worth \u20B91",
                            "header": ""
                        },
                        "prev_mov_text": "Add \u20B9<remainingMov> more to get a freebie with <couponCode>",
                        "post_mov_text": "You got extra \u20B9{0} off on your bill by adding Zydus items worth \u20B91",
                        "groups_info": {
                            "exclusionGroupsInfo": {},
                            "message": ""
                        },
                        "pre_display_threshold_text": "",
                        "discount_on_type": "CART"
                    }
                ],
                "superOffer": false,
                "discounts": [
                    {
                        "description": "Get free delivery on orders above \u20B9499",
                        "short_description": "Free Delivery above \u20B9499",
                        "discount_type": "PERCENT",
                        "logo_id": "w03c3dtgopc4qvtqgntr",
                        "title": "Free Delivery on orders above \u20B9499",
                        "sub_title": "Get free delivery on orders above \u20B9499",
                        "tnc": [
                            "Other T&Cs may apply",
                            "Offer valid till Dec 30, 2025 23:59 PM"
                        ],
                        "coupon_code": "",
                        "super_offer": false,
                        "minimum_order_value": 49900,
                        "prev_mov_text": "Add items worth \u20B9{differenceFromMov} more and get <b>FREE DELIVERY</b>",
                        "post_mov_text": "Yay! You have unlocked <b>FREE DELIVERY!</b>",
                        "groups_info": {
                            "exclusionGroupsInfo": {},
                            "message": ""
                        },
                        "pre_display_threshold_text": "You have <b>FREE DELIVERY</b> on order above \u20B9499!",
                        "discount_on_type": "DELIVERY"
                    },
                    {
                        "description": "Use PHARMA10| On orders above \u20B9499",
                        "short_description": "10% off upto \u20B9200",
                        "discount_type": "PERCENT",
                        "logo_id": "InstamartAssets/Swiggy%20New%20(400%20x%20400)%20Logo.png",
                        "title": "10% off upto \u20B9200",
                        "sub_title": "Use code PHARMA10 & get 10% off upto \u20B9200 on orders above \u20B9499",
                        "tnc": [
                            "Limited period offer",
                            "Valid only on Instamart orders 5 times per user",
                            "Valid only on Pharma items",
                            "Other T&Cs may apply.",
                            "Offer valid till Feb 27, 2025"
                        ],
                        "coupon_code": "PHARMA10",
                        "super_offer": false,
                        "minimum_order_value": 49900,
                        "prev_mov_text": "Add items worth \u20B9{differenceFromMov} to get atleast \u20B950 off | PHARMA10",
                        "post_mov_text": "PHARMA10 coupon unlocked! Use it to get atleast \u20B950 off",
                        "groups_info": {
                            "exclusionGroupsInfo": {
                                "LRIG": {
                                    "message": "Certain items are excluded as per regulatory and manufacturer policies"
                                }
                            },
                            "message": "Certain items are excluded as per regulatory and manufacturer policies"
                        },
                        "pre_display_threshold_text": "",
                        "discount_on_type": "CART"
                    }
                ]
            },
            "metadata": {
                "unstructured_enabled": false,
                "user_verification_required": false,
                "guaranteed_delivery": false
            },
            "lastOrderTimestamp": 0,
            "inStockItems": 0,
            "deliverySlots": [],
            "invoiceDetails": {
                "invoice_entity_name": ""
            },
            "bulkCartConstraints": {
                "minWeightInGrams": 15000,
                "minItemCount": 200
            },
            "hasPharmacy": false,
            "pharmacyEnabled": false,
            "slottedDeliveryAvailable": false,
            "sellerName": "",
            "sellerFssaiAuthorisedAddress": "GF, Zam Zam Complex property No.26 Infantry Road,Shivaji Nagar, Sampangiramnagar Bengaluru-560001",
            "sellerFssaiNumber": "11222333000873",
            "partner": true,
            "unstructuredEnabled": false,
            "lat_long": "12.981516,77.601807",
            "phone_numbers": "9513800331",
            "is_verified": true,
            "is_partner": true,
            "image_id": "",
            "product_categories": [],
            "store_chain": {
                "id": 229,
                "name": "Instamart"
            },
            "store_document": {
                "fssai_license_no": "11222333000873",
                "drug_license_no": "KA-B11-230876, KA-B11-230877",
                "gstin_number": "29AAJCG5616Q1ZU",
                "liquor_license_no": "",
                "fssai_reference_no": "",
                "fssai_registered_business_entity_name": "GROWGREENHERBS MODERN RETAILS PRIVATE LIMITED",
                "fssai_authorised_premises_address": "GF, Zam Zam Complex property No.26 Infantry Road,Shivaji Nagar, Sampangiramnagar Bengaluru-560001"
            },
            "popular_category": {
                "id": 52,
                "name": "Instamart"
            }
        },
        "superData": {
            "userStatus": "INVALID_SUPER"
        },
        "available": true,
        "widgets": [
            {
                "collectionId": 1,
                "layoutId": 2671,
                "id": 94198,
                "active": 1,
                "widgetInfo": {
                    "widgetType": "NxM_BANNER",
                    "title": "Instamart",
                    "fallbackTitle": "",
                    "affordance": false,
                    "autoScrollTime": -1,
                    "description": "",
                    "analytics": {
                        "objectValue": null,
                        "context": "{}",
                        "impressionObjectName": "impression-menu-widget",
                        "clickObjectName": "click-cta",
                        "extraFields": {
                            "widgetId": "94198"
                        }
                    },
                    "row": 1,
                    "column": 1,
                    "aspectRatio": {
                        "width": "360",
                        "height": "380"
                    },
                    "carouselWidgetType": "INSTAMART_FAST_SERVICEABLE_MASTHEAD",
                    "minimumBanner": 1,
                    "fullGrid": true,
                    "orientation": "VERTICAL",
                    "fullMonetized": false,
                    "clickable": false,
                    "fitToWidth": false,
                    "dataProvider": "CAROUSEL",
                    "isMasthead": true
                },
                "data": [
                    {
                        "bannerId": 766353,
                        "creativeId": "rng/md/carousel/production/d261ea9bd68db7895e2508e8866e7f12",
                        "entityType": "static",
                        "entityId": "N/A",
                        "page": "STORES_MENU",
                        "cappingEnabled": false,
                        "widgetData": {
                            "widgetType": "INSTAMART_FAST_SERVICEABLE_MASTHEAD",
                            "backgroundColor": "#FFF6FB",
                            "dividerColor": "#FFFFFF",
                            "theme": "light",
                            "altText": "Fast Serviceable",
                            "altTextCTA": "Fast Serviceable"
                        },
                        "metadata": {
                            "offerText": null
                        },
                        "creativeType": "IMAGE",
                        "analytics": {
                            "objectValue": null,
                            "context": "{}",
                            "impressionObjectName": "impression-banner",
                            "clickObjectName": "click-banner",
                            "extraFields": {
                                "bannerId": "766353"
                            }
                        },
                        "score": 0
                    }
                ],
                "type": "NxM_BANNER",
                "priority": 1,
                "widgetTimeSlotInfo": {
                    "alwaysActive": true,
                    "widgetSlotDayListMap": null
                },
                "segments": []
            },
            {
                "collectionId": 1,
                "layoutId": 2671,
                "id": 142740,
                "active": 1,
                "widgetInfo": {
                    "widgetType": "CLUSTER",
                    "header": null,
                    "title": "Valentines Day Main RU",
                    "fallbackTitle": "",
                    "affordance": false,
                    "autoScrollTime": -1,
                    "description": "",
                    "platformVersionInfoList": [],
                    "widgetStyles": null,
                    "cities": [],
                    "widgetIdentifier": null,
                    "analytics": {
                        "objectValue": null,
                        "context": "{}",
                        "impressionObjectName": "impression-menu-widget",
                        "clickObjectName": "click-cta",
                        "extraFields": {
                            "widgetId": "142740"
                        }
                    },
                    "backgroundColor": "",
                    "textColor": "",
                    "productBgColor": "",
                    "showCollapsible": false,
                    "minimumWidgets": 1,
                    "maximizeText": null,
                    "minimizeText": null,
                    "layoutId": 9455,
                    "subtitle": null,
                    "withPadding": true,
                    "backgroundImageCreativeId": null,
                    "backgroundCarouselWidgetType": "IM_VALENTINE25_MAIN_BG",
                    "backgroundCarouselBanner": {
                        "bannerId": 4420853,
                        "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/6/57a87b2d-50f8-4c8e-8889-be8eb1af1754_360x2503.png",
                        "entityType": "static",
                        "entityId": "N/A",
                        "carouselTitle": "NA",
                        "page": "STORES_MENU",
                        "cappingEnabled": false,
                        "widgetData": {
                            "widgetType": "IM_VALENTINE25_MAIN_BG"
                        },
                        "creativeType": "IMAGE",
                        "score": 0
                    },
                    "minimumBanner": 1,
                    "maximumBanner": 1,
                    "fitToWidth": false
                },
                "data": null,
                "nestedWidgets": [
                    {
                        "collectionId": 1,
                        "layoutId": 9455,
                        "id": 142208,
                        "active": 1,
                        "widgetInfo": {
                            "widgetType": "NxM_BANNER",
                            "title": "",
                            "fallbackTitle": "",
                            "affordance": false,
                            "autoScrollTime": -1,
                            "description": "",
                            "subType": "NXM_FULLWIDTH",
                            "platformVersionInfoList": [],
                            "widgetStyles": {
                                "padding": {
                                    "top": "0",
                                    "right": "0",
                                    "bottom": "0",
                                    "left": "0"
                                }
                            },
                            "cities": [],
                            "analytics": {
                                "objectValue": null,
                                "context": "{\"clusterId\":\"142740\"}",
                                "impressionObjectName": "impression-menu-widget",
                                "clickObjectName": "click-cta",
                                "extraFields": {
                                    "widgetId": "142208"
                                }
                            },
                            "row": 1,
                            "column": 1,
                            "aspectRatio": {
                                "width": "360",
                                "height": "50"
                            },
                            "carouselWidgetType": "IM_VALENTINE25_MAIN_TOP",
                            "minimumBanner": 1,
                            "fullGrid": true,
                            "orientation": "VERTICAL",
                            "fullMonetized": false,
                            "clickable": false,
                            "fitToWidth": false,
                            "dataProvider": "CAROUSEL",
                            "isMasthead": true
                        },
                        "data": [
                            {
                                "bannerId": 4412549,
                                "creativeId": "https://media-assets.swiggy.com/MERCHANDISING_BANNERS/LOTTIES/MERCH/2025/2/7/a337013c-5bd1-4898-9907-05cfca0d031a_VdayHeaderTextOptimised.json",
                                "entityType": "deeplink",
                                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9023&customerPage=STORES_MxN_40",
                                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9023&customerPage=STORES_MxN_40",
                                "carouselTitle": "NA",
                                "page": "STORES_MENU",
                                "cappingEnabled": false,
                                "widgetData": {
                                    "widgetType": "IM_VALENTINE25_MAIN_TOP",
                                    "mediaType": "LOTTIE"
                                },
                                "metadata": {
                                    "offerText": null
                                },
                                "creativeType": "IMAGE",
                                "analytics": {
                                    "objectValue": null,
                                    "context": "{\"clusterId\":\"142740\"}",
                                    "impressionObjectName": "impression-banner",
                                    "clickObjectName": "click-banner",
                                    "extraFields": {
                                        "bannerId": "4412549"
                                    }
                                },
                                "score": 0
                            }
                        ],
                        "type": "NxM_BANNER",
                        "priority": 1,
                        "widgetTimeSlotInfo": {
                            "alwaysActive": true,
                            "widgetSlotDayListMap": null
                        },
                        "segments": []
                    },
                    {
                        "collectionId": 1,
                        "layoutId": 9455,
                        "id": 142209,
                        "active": 1,
                        "widgetInfo": {
                            "widgetType": "NxM_BANNER",
                            "title": "",
                            "fallbackTitle": "",
                            "affordance": false,
                            "autoScrollTime": -1,
                            "description": "",
                            "platformVersionInfoList": [],
                            "widgetStyles": {
                                "padding": {
                                    "top": "0",
                                    "right": "16",
                                    "bottom": "20",
                                    "left": "16"
                                }
                            },
                            "cities": [],
                            "analytics": {
                                "objectValue": null,
                                "context": "{\"clusterId\":\"142740\"}",
                                "impressionObjectName": "impression-menu-widget",
                                "clickObjectName": "click-cta",
                                "extraFields": {
                                    "widgetId": "142209"
                                }
                            },
                            "row": 1,
                            "column": 2,
                            "aspectRatio": {
                                "width": "166",
                                "height": "85"
                            },
                            "carouselWidgetType": "IM_VALENTINE25_MAIN_CH",
                            "minimumBanner": 1,
                            "fullGrid": true,
                            "orientation": "VERTICAL",
                            "fullMonetized": false,
                            "clickable": false,
                            "fitToWidth": true,
                            "dataProvider": "CAROUSEL",
                            "isMasthead": false
                        },
                        "data": [
                            {
                                "bannerId": 4412555,
                                "creativeId": "https://media-assets.swiggy.com/MERCHANDISING_BANNERS/LOTTIES/MERCH/2025/2/8/135c4f20-65f1-4601-807d-2c509481889e_giftsforher.json",
                                "entityType": "deeplink",
                                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9287&customerPage=STORES_MxN_42",
                                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9287&customerPage=STORES_MxN_42",
                                "carouselTitle": "NA",
                                "page": "STORES_MENU",
                                "cappingEnabled": false,
                                "widgetData": {
                                    "widgetType": "IM_VALENTINE25_MAIN_CH",
                                    "mediaType": "LOTTIE"
                                },
                                "metadata": {
                                    "offerText": null
                                },
                                "creativeType": "IMAGE",
                                "analytics": {
                                    "objectValue": null,
                                    "context": "{\"clusterId\":\"142740\"}",
                                    "impressionObjectName": "impression-banner",
                                    "clickObjectName": "click-banner",
                                    "extraFields": {
                                        "bannerId": "4412555"
                                    }
                                },
                                "score": 0
                            },
                            {
                                "bannerId": 4412552,
                                "creativeId": "https://media-assets.swiggy.com/MERCHANDISING_BANNERS/LOTTIES/MERCH/2025/2/8/4732550a-ef68-40d1-9bd5-f3388228e5db_giftsforhim.json",
                                "entityType": "deeplink",
                                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9380&customerPage=STORES_MxN_44",
                                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9380&customerPage=STORES_MxN_44",
                                "carouselTitle": "NA",
                                "page": "STORES_MENU",
                                "cappingEnabled": false,
                                "widgetData": {
                                    "widgetType": "IM_VALENTINE25_MAIN_CH",
                                    "mediaType": "LOTTIE"
                                },
                                "metadata": {
                                    "offerText": null
                                },
                                "creativeType": "IMAGE",
                                "analytics": {
                                    "objectValue": null,
                                    "context": "{\"clusterId\":\"142740\"}",
                                    "impressionObjectName": "impression-banner",
                                    "clickObjectName": "click-banner",
                                    "extraFields": {
                                        "bannerId": "4412552"
                                    }
                                },
                                "score": 0
                            }
                        ],
                        "type": "NxM_BANNER",
                        "priority": 2,
                        "widgetTimeSlotInfo": {
                            "alwaysActive": true,
                            "widgetSlotDayListMap": null
                        },
                        "segments": []
                    },
                    {
                        "collectionId": 1,
                        "layoutId": 9455,
                        "id": 142709,
                        "active": 1,
                        "widgetInfo": {
                            "widgetType": "NxM_BANNER",
                            "title": "",
                            "fallbackTitle": "",
                            "affordance": false,
                            "autoScrollTime": -1,
                            "description": "",
                            "platformVersionInfoList": [],
                            "widgetStyles": {
                                "padding": {
                                    "top": "0",
                                    "right": "16",
                                    "bottom": "5",
                                    "left": "16"
                                }
                            },
                            "cities": [],
                            "analytics": {
                                "objectValue": null,
                                "context": "{\"clusterId\":\"142740\"}",
                                "impressionObjectName": "impression-menu-widget",
                                "clickObjectName": "click-cta",
                                "extraFields": {
                                    "widgetId": "142709"
                                }
                            },
                            "row": 1,
                            "column": 7,
                            "aspectRatio": {
                                "width": "101",
                                "height": "126"
                            },
                            "carouselWidgetType": "IM_VALENTINE25_MAIN_CH1",
                            "minimumBanner": 1,
                            "fullGrid": true,
                            "orientation": "VERTICAL",
                            "fullMonetized": false,
                            "clickable": false,
                            "fitToWidth": false,
                            "dataProvider": "CAROUSEL",
                            "isMasthead": false
                        },
                        "data": [
                            {
                                "bannerId": 4462865,
                                "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/10/e8994656-8da6-4d92-b0f9-674bf51697ba_PromiseDayspecials101x152.png",
                                "entityType": "deeplink",
                                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9382&customerPage=STORES_MxN_41",
                                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9382&customerPage=STORES_MxN_41",
                                "carouselTitle": "NA",
                                "page": "STORES_MENU",
                                "cappingEnabled": false,
                                "widgetData": {
                                    "widgetType": "IM_VALENTINE25_MAIN_CH1"
                                },
                                "metadata": {
                                    "offerText": null
                                },
                                "creativeType": "IMAGE",
                                "analytics": {
                                    "objectValue": null,
                                    "context": "{\"clusterId\":\"142740\"}",
                                    "impressionObjectName": "impression-banner",
                                    "clickObjectName": "click-banner",
                                    "extraFields": {
                                        "bannerId": "4462865"
                                    }
                                },
                                "score": 0
                            },
                            {
                                "bannerId": 4432923,
                                "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/7/a64e6f18-1571-4e0f-8b3b-95f9c69a5e99_Chocolatesflowers101x1261.png",
                                "entityType": "deeplink",
                                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9378&customerPage=STORES_MxN_43",
                                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9378&customerPage=STORES_MxN_43",
                                "carouselTitle": "NA",
                                "page": "STORES_MENU",
                                "cappingEnabled": false,
                                "widgetData": {
                                    "widgetType": "IM_VALENTINE25_MAIN_CH1"
                                },
                                "metadata": {
                                    "offerText": null
                                },
                                "creativeType": "IMAGE",
                                "analytics": {
                                    "objectValue": null,
                                    "context": "{\"clusterId\":\"142740\"}",
                                    "impressionObjectName": "impression-banner",
                                    "clickObjectName": "click-banner",
                                    "extraFields": {
                                        "bannerId": "4432923"
                                    }
                                },
                                "score": 0
                            },
                            {
                                "bannerId": 4420725,
                                "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/6/07f61d4e-7e50-489b-bd79-e1bf9e30ad3f_Feeltheintimacy101x126.png",
                                "entityType": "deeplink",
                                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9406&customerPage=STORES_MxN_47",
                                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9406&customerPage=STORES_MxN_47",
                                "carouselTitle": "NA",
                                "page": "STORES_MENU",
                                "cappingEnabled": false,
                                "widgetData": {
                                    "widgetType": "IM_VALENTINE25_MAIN_CH1"
                                },
                                "metadata": {
                                    "offerText": null
                                },
                                "creativeType": "IMAGE",
                                "analytics": {
                                    "objectValue": null,
                                    "context": "{\"clusterId\":\"142740\"}",
                                    "impressionObjectName": "impression-banner",
                                    "clickObjectName": "click-banner",
                                    "extraFields": {
                                        "bannerId": "4420725"
                                    }
                                },
                                "score": 0
                            },
                            {
                                "bannerId": 4420719,
                                "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/6/2f387401-80da-4e66-80c6-31df275b5fee_Dateideas101x126.png",
                                "entityType": "deeplink",
                                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9463&customerPage=STORES_MxN_45",
                                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9463&customerPage=STORES_MxN_45",
                                "carouselTitle": "NA",
                                "page": "STORES_MENU",
                                "cappingEnabled": false,
                                "widgetData": {
                                    "widgetType": "IM_VALENTINE25_MAIN_CH1"
                                },
                                "metadata": {
                                    "offerText": null
                                },
                                "creativeType": "IMAGE",
                                "analytics": {
                                    "objectValue": null,
                                    "context": "{\"clusterId\":\"142740\"}",
                                    "impressionObjectName": "impression-banner",
                                    "clickObjectName": "click-banner",
                                    "extraFields": {
                                        "bannerId": "4420719"
                                    }
                                },
                                "score": 0
                            },
                            {
                                "bannerId": 4420728,
                                "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/6/97505477-18f1-4246-8c71-56ec1e744762_Getdateready101x126.png",
                                "entityType": "deeplink",
                                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9446&customerPage=STORES_MxN_48",
                                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9446&customerPage=STORES_MxN_48",
                                "carouselTitle": "NA",
                                "page": "STORES_MENU",
                                "cappingEnabled": false,
                                "widgetData": {
                                    "widgetType": "IM_VALENTINE25_MAIN_CH1"
                                },
                                "metadata": {
                                    "offerText": null
                                },
                                "creativeType": "IMAGE",
                                "analytics": {
                                    "objectValue": null,
                                    "context": "{\"clusterId\":\"142740\"}",
                                    "impressionObjectName": "impression-banner",
                                    "clickObjectName": "click-banner",
                                    "extraFields": {
                                        "bannerId": "4420728"
                                    }
                                },
                                "score": 0
                            },
                            {
                                "bannerId": 4420722,
                                "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/6/6bcbdc96-654b-437e-9032-4ff0fdb43870_Decorhosting101x126.png",
                                "entityType": "deeplink",
                                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9412&customerPage=STORES_MxN_46",
                                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9412&customerPage=STORES_MxN_46",
                                "carouselTitle": "NA",
                                "page": "STORES_MENU",
                                "cappingEnabled": false,
                                "widgetData": {
                                    "widgetType": "IM_VALENTINE25_MAIN_CH1"
                                },
                                "metadata": {
                                    "offerText": null
                                },
                                "creativeType": "IMAGE",
                                "analytics": {
                                    "objectValue": null,
                                    "context": "{\"clusterId\":\"142740\"}",
                                    "impressionObjectName": "impression-banner",
                                    "clickObjectName": "click-banner",
                                    "extraFields": {
                                        "bannerId": "4420722"
                                    }
                                },
                                "score": 0
                            },
                            {
                                "bannerId": 4445202,
                                "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/6/35838683-a547-4f7f-b643-84f4ce5986ca_Valentinesgiftingguide101x126.png",
                                "entityType": "deeplink",
                                "entityId": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9482&customerPage=STORES_MxN_49",
                                "entityDeepLink": "/instamart/campaign-collection/mxn?custom_back=true&layoutId=9482&customerPage=STORES_MxN_49",
                                "carouselTitle": "NA",
                                "page": "STORES_MENU",
                                "cappingEnabled": false,
                                "widgetData": {
                                    "widgetType": "IM_VALENTINE25_MAIN_CH1"
                                },
                                "metadata": {
                                    "offerText": null
                                },
                                "creativeType": "IMAGE",
                                "analytics": {
                                    "objectValue": null,
                                    "context": "{\"clusterId\":\"142740\"}",
                                    "impressionObjectName": "impression-banner",
                                    "clickObjectName": "click-banner",
                                    "extraFields": {
                                        "bannerId": "4445202"
                                    }
                                },
                                "score": 0
                            }
                        ],
                        "type": "NxM_BANNER",
                        "priority": 3,
                        "widgetTimeSlotInfo": {
                            "alwaysActive": true,
                            "widgetSlotDayListMap": null
                        },
                        "segments": []
                    }
                ],
                "type": "CLUSTER",
                "priority": 3,
                "widgetTimeSlotInfo": {
                    "alwaysActive": true,
                    "widgetSlotDayListMap": null
                },
                "segments": []
            },
            {
                "collectionId": 1,
                "layoutId": 2671,
                "id": 143158,
                "active": 1,
                "widgetInfo": {
                    "widgetType": "NxM_BANNER",
                    "title": "",
                    "fallbackTitle": "",
                    "affordance": false,
                    "autoScrollTime": -1,
                    "description": "",
                    "platformVersionInfoList": [],
                    "widgetStyles": {
                        "padding": {
                            "top": "0",
                            "right": "0",
                            "bottom": "5",
                            "left": "0"
                        }
                    },
                    "cities": [],
                    "analytics": {
                        "objectValue": null,
                        "context": "{}",
                        "impressionObjectName": "impression-menu-widget",
                        "clickObjectName": "click-cta",
                        "extraFields": {
                            "widgetId": "143158"
                        }
                    },
                    "row": 1,
                    "column": 1,
                    "aspectRatio": {
                        "width": "360",
                        "height": "70"
                    },
                    "carouselWidgetType": "IM_VALENTINE_FLASH",
                    "minimumBanner": 1,
                    "fullGrid": true,
                    "orientation": "VERTICAL",
                    "fullMonetized": false,
                    "clickable": false,
                    "fitToWidth": false,
                    "dataProvider": "CAROUSEL",
                    "isMasthead": false
                },
                "data": [
                    {
                        "bannerId": 4429967,
                        "creativeId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/11/a69f0109-a6a9-4373-b0d0-6f55209e056d_Promiseday730newdeals360x70.png",
                        "entityType": "storeitemcollectionv2",
                        "entityId": "162708",
                        "entityDeepLink": "swiggy://stores/instamart/collection-listing?storeId=1313712&collectionId=162708",
                        "carouselTitle": "NA",
                        "page": "STORES_MENU",
                        "cappingEnabled": false,
                        "widgetData": {
                            "widgetType": "IM_VALENTINE_FLASH"
                        },
                        "metadata": {
                            "offerText": null
                        },
                        "creativeType": "IMAGE",
                        "analytics": {
                            "objectValue": null,
                            "context": "{}",
                            "impressionObjectName": "impression-banner",
                            "clickObjectName": "click-banner",
                            "extraFields": {
                                "bannerId": "4429967"
                            }
                        },
                        "score": 0
                    }
                ],
                "type": "NxM_BANNER",
                "priority": 5,
                "widgetTimeSlotInfo": {
                    "alwaysActive": true,
                    "widgetSlotDayListMap": null
                },
                "segments": []
            },
            {
                "collectionId": 162708,
                "layoutId": 2671,
                "id": 143159,
                "active": 1,
                "widgetInfo": {
                    "widgetType": "PRODUCT_WITH_BACKGROUND",
                    "header": null,
                    "title": "",
                    "fallbackTitle": "",
                    "affordance": false,
                    "autoScrollTime": -1,
                    "description": "",
                    "platformVersionInfoList": [],
                    "widgetStyles": null,
                    "cities": [],
                    "widgetIdentifier": null,
                    "analytics": {
                        "objectValue": null,
                        "context": "{}",
                        "impressionObjectName": "impression-menu-widget",
                        "clickObjectName": "click-cta",
                        "extraFields": {
                            "widgetId": "143159",
                            "collectionId": "162708"
                        }
                    },
                    "backgroundColor": "#000000",
                    "textColor": "#000000",
                    "productBgColor": "#000000",
                    "subtitle": "",
                    "ctaText": null,
                    "creativeImage": null,
                    "backgroundImage": null,
                    "analyticsData": null,
                    "itemCount": 0
                },
                "data": [
                    {
                        "display_name": "Hershey's Cookies 'N' Creme Chocolate",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Hershey's",
                        "brand_id": "5e2972575e2e085b2f55db64cc4f6d81c3f0d7ab",
                        "variations": [
                            {
                                "id": "LNWGY1NRB1",
                                "display_name": "Hershey's Cookies 'N' Creme Chocolate",
                                "listing_variant": true,
                                "spin": "WLDIULB4FN",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2025/1/2/af68380c-cd4b-4018-8d58-7cb0a4ebc5e6_2764_1.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/2/3c65fc45-04bd-4e55-91c9-b4c8cc147c62_2764_2.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/2/7d0faa4c-296c-468d-89be-fa69d560cb40_2764_3.png",
                                    "NI_CATALOG/IMAGES/CIW/2024/4/25/dc9c09f8-a803-4c65-843e-aac8a13dbb5e_chocolate_WLDIULB4FN_AL3.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 65,
                                    "store_price": 65,
                                    "offer_price": 53,
                                    "offer_applied": {
                                        "offer_id": "3e4af866-e38e-46a3-8463-535b35a7c2ed",
                                        "listing_description": "18% OFF",
                                        "product_description": "18% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "132.5/100 g",
                                    "loyalty_pricing": {
                                        "super_offer_price": 53,
                                        "non_super_offer_price": 53
                                    },
                                    "discount_value": 12
                                },
                                "quantity": "40",
                                "sku_quantity_with_combo": "40 g",
                                "unit_of_measure": "g",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 1,
                                "cart_allowed_quantity": {
                                    "total": 1,
                                    "message": "Only 1 unit(s) of this item can be added per order."
                                },
                                "weight_in_grams": 40,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "Chocolate Bar",
                                "dimensions": {
                                    "length_in_cm": 14,
                                    "width_in_cm": 6,
                                    "height_in_cm": 1,
                                    "volume_in_cc": 84
                                },
                                "brand": "Hershey's",
                                "brand_id": "5e2972575e2e085b2f55db64cc4f6d81c3f0d7ab",
                                "category": "Milk Chocolates",
                                "last_ordered_at": 0,
                                "category_id": "f1e8e052-d7d9-493e-814c-2cbeb1174507",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": true,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Cookies 'N' Creme Chocolate",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Chocolates",
                                "sub_category_l3": "Chocolate Bars",
                                "sub_category_l4": "Semi Premium",
                                "sub_category_l5": "Small",
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"LNWGY1NRB1\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "ZGBEWMDNJ1",
                        "product_name_without_brand": "Cookies 'N' Creme Chocolate"
                    },
                    {
                        "display_name": "Raffaello Pack",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Raffaello",
                        "brand_id": "68a7089a9c322527631ee430100943ffc61df3b2",
                        "variations": [
                            {
                                "id": "18LJVS7UZA",
                                "display_name": "Raffaello Pack",
                                "listing_variant": true,
                                "spin": "VM719O6IOP",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2024/7/2/aebdd051-6e7e-4954-b31d-37bbe38f43de_chocolate_VM719O6IOP_MN.png",
                                    "NI_CATALOG/IMAGES/CIW/2024/7/2/298d3827-ddc7-462a-944a-ba08d1d4bd03_chocolate_VM719O6IOP_AL1.png",
                                    "NI_CATALOG/IMAGES/CIW/2024/7/2/7693b820-977d-4323-87f8-f5429a95f234_chocolate_NKDG2LDLLJ_AL2.png",
                                    "NI_CATALOG/IMAGES/CIW/2024/7/2/214c9184-ca7a-4163-ae2f-02b4b7a7d188_chocolate_VM719O6IOP_AL3.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 99,
                                    "store_price": 99,
                                    "offer_price": 79,
                                    "offer_applied": {
                                        "offer_id": "6cdaa64a-44a9-43d2-871f-a108ac252063",
                                        "listing_description": "20% OFF",
                                        "product_description": "20% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 79,
                                        "non_super_offer_price": 79
                                    },
                                    "discount_value": 20
                                },
                                "quantity": "30",
                                "sku_quantity_with_combo": "30 g",
                                "unit_of_measure": "g",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 1,
                                "cart_allowed_quantity": {
                                    "total": 1,
                                    "message": "Only 1 unit(s) of this item can be added per order."
                                },
                                "weight_in_grams": 0,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "Confectionery",
                                "dimensions": {
                                    "length_in_cm": 0,
                                    "width_in_cm": 1,
                                    "height_in_cm": 1,
                                    "volume_in_cc": 0
                                },
                                "brand": "Raffaello",
                                "brand_id": "68a7089a9c322527631ee430100943ffc61df3b2",
                                "category": "Chocolate Boxes and Gifts",
                                "last_ordered_at": 0,
                                "category_id": "f1e8e052-d7d9-493e-814c-2cbeb1174507",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Pack",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Chocolates",
                                "sub_category_l3": "Pralines",
                                "sub_category_l4": "Luxury",
                                "sub_category_l5": "Large",
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"18LJVS7UZA\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "VE3IHQ1HBI",
                        "product_name_without_brand": "Pack"
                    },
                    {
                        "display_name": "Oye Happy Strawberry Bliss Jar Candle",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Oye Happy",
                        "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                        "variations": [
                            {
                                "id": "2F4BMCU3IX",
                                "display_name": "Oye Happy Strawberry Bliss Jar Candle",
                                "listing_variant": true,
                                "spin": "S7Q51MPD4J",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2025/1/22/bab4b2ab-19fa-4c6a-938a-5a54aa9e6e7e_994358_1.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/22/f2330ba7-2329-4cb8-9270-84d35ccdf615_994358_2.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/22/0784bb9d-7900-492f-9c05-063f787add4c_994358_3.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 499,
                                    "store_price": 499,
                                    "offer_price": 174,
                                    "offer_applied": {
                                        "offer_id": "941b4865-d563-46c7-80df-bcbbc51da2ee",
                                        "listing_description": "65% OFF",
                                        "product_description": "65% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 174,
                                        "non_super_offer_price": 174
                                    },
                                    "discount_value": 325
                                },
                                "quantity": "1",
                                "sku_quantity_with_combo": "1 Piece",
                                "unit_of_measure": "Piece",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 6,
                                "cart_allowed_quantity": {
                                    "total": 2,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 300,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "Candle",
                                "dimensions": {
                                    "length_in_cm": 19,
                                    "width_in_cm": 14,
                                    "height_in_cm": 4,
                                    "volume_in_cc": 1064
                                },
                                "brand": "Oye Happy",
                                "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                                "category": "Home Decor",
                                "last_ordered_at": 0,
                                "category_id": "f894178f-8ad8-4e8b-b7b6-f52577ea1b07",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Strawberry Bliss Jar Candle",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Home",
                                "sub_category_l3": "Candles",
                                "sub_category_l4": null,
                                "sub_category_l5": null,
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"2F4BMCU3IX\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "PKTK5GLUR3",
                        "product_name_without_brand": "Strawberry Bliss Jar Candle"
                    },
                    {
                        "display_name": "Oye Happy Couple Acrylic Cake Topper",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Oye Happy",
                        "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                        "variations": [
                            {
                                "id": "S6HFVC1OHF",
                                "display_name": "Oye Happy Couple Acrylic Cake Topper",
                                "listing_variant": true,
                                "spin": "V4JWZISM7V",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2025/2/1/1739113a-9172-451c-aff6-ee1bc1ccd18f_414301_1.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/1/183c9c8a-eda8-4b24-8e7d-75b3985bc45c_414301_2.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/1/4412ef2a-7d65-4b14-b175-6c67a9c54ebc_414301_3.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/1/1c129653-237b-49b9-8c99-ac609308360a_414301_4.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 199,
                                    "store_price": 199,
                                    "offer_price": 69,
                                    "offer_applied": {
                                        "offer_id": "5a394fad-80d2-40f6-a8c0-a2d7be56c5d1",
                                        "listing_description": "65% OFF",
                                        "product_description": "65% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 69,
                                        "non_super_offer_price": 69
                                    },
                                    "discount_value": 130
                                },
                                "quantity": "1",
                                "sku_quantity_with_combo": "1 Piece",
                                "unit_of_measure": "Piece",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 6,
                                "cart_allowed_quantity": {
                                    "total": 2,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 300,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "",
                                "dimensions": {
                                    "length_in_cm": 19,
                                    "width_in_cm": 14,
                                    "height_in_cm": 4,
                                    "volume_in_cc": 1064
                                },
                                "brand": "Oye Happy",
                                "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                                "category": "Cake Decor",
                                "last_ordered_at": 0,
                                "category_id": "030dca44-a5db-459c-a5e6-6351548447e1",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Couple Acrylic Cake Topper",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Party Planning",
                                "sub_category_l3": "Cake Toppers",
                                "sub_category_l4": null,
                                "sub_category_l5": null,
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"S6HFVC1OHF\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "KT86XJAYXD",
                        "product_name_without_brand": "Couple Acrylic Cake Topper"
                    },
                    {
                        "display_name": "Snickers Shareable Bites Peanut Filled Chocolate Pack",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Snickers",
                        "brand_id": "8d29e0790cb0b418a53ad277030c04950500cb31",
                        "variations": [
                            {
                                "id": "AR2F3G0TJF",
                                "display_name": "Snickers Shareable Bites Peanut Filled Chocolate Pack",
                                "listing_variant": true,
                                "spin": "3OLUR7APBO",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2025/1/31/9cae84e1-8e2e-411a-b937-5ce17b554ba9_25706_1.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/31/310a9a78-4e2e-4974-bb42-cb1fbb128936_25706_2.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/31/22f2cfa3-fa59-42c5-bacc-abfdc93d23db_25706_3.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/31/cabd56b8-668c-46a0-96e9-c3aedaa3af0c_25706_4.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/31/452ce252-858c-40fa-85e1-7bba2cc97f45_25706_5.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/31/dd034268-8451-466f-8f7c-1eff81fbb49d_25706_6.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 159,
                                    "store_price": 159,
                                    "offer_price": 96,
                                    "offer_applied": {
                                        "offer_id": "daae71f1-667c-4359-aad9-50f1bc3ce0ec",
                                        "listing_description": "39% OFF",
                                        "product_description": "39% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "80/100 g",
                                    "loyalty_pricing": {
                                        "super_offer_price": 96,
                                        "non_super_offer_price": 96
                                    },
                                    "discount_value": 63
                                },
                                "quantity": "120",
                                "sku_quantity_with_combo": "120 g",
                                "unit_of_measure": "g",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 20,
                                "cart_allowed_quantity": {
                                    "total": 2,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 120,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "Chocolate Bar",
                                "dimensions": {
                                    "length_in_cm": 19,
                                    "width_in_cm": 16,
                                    "height_in_cm": 6,
                                    "volume_in_cc": 1824
                                },
                                "brand": "Snickers",
                                "brand_id": "8d29e0790cb0b418a53ad277030c04950500cb31",
                                "category": "Chocolate Boxes and Gifts",
                                "last_ordered_at": 0,
                                "category_id": "f1e8e052-d7d9-493e-814c-2cbeb1174507",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": true,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Shareable Bites Peanut Filled Chocolate Pack",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Chocolates",
                                "sub_category_l3": "Filled Chocolate",
                                "sub_category_l4": "Premium",
                                "sub_category_l5": "Medium",
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"AR2F3G0TJF\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "VKJPU6CTZM",
                        "product_name_without_brand": "Shareable Bites Peanut Filled Chocolate Pack"
                    },
                    {
                        "display_name": "Hershey's Creamy Milk Chocolate",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Hershey's",
                        "brand_id": "5e2972575e2e085b2f55db64cc4f6d81c3f0d7ab",
                        "variations": [
                            {
                                "id": "A8HIPY8CIG",
                                "display_name": "Hershey's Creamy Milk Chocolate",
                                "listing_variant": true,
                                "spin": "TWSXDAXHZP",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2025/1/11/2f534a74-f426-48d0-b95f-22ede5c795d4_2766_1.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/11/caa777cd-1195-4dcf-805b-4f85c0ebf65f_2766_2.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/11/49b558d7-649d-4eac-8b29-66e0b4a13f62_2766_3.png",
                                    "21c7b6f0d159d0f0cc7a95695a242022"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 140,
                                    "store_price": 140,
                                    "offer_price": 96,
                                    "offer_applied": {
                                        "offer_id": "f435248c-ae97-4e74-bb29-e83936c93a33",
                                        "listing_description": "31% OFF",
                                        "product_description": "31% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 96,
                                        "non_super_offer_price": 96
                                    },
                                    "discount_value": 44
                                },
                                "quantity": "100",
                                "sku_quantity_with_combo": "100 g",
                                "unit_of_measure": "g",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 30,
                                "cart_allowed_quantity": {
                                    "total": 3,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 100,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "Chocolate Bar",
                                "dimensions": {
                                    "length_in_cm": 18,
                                    "width_in_cm": 8,
                                    "height_in_cm": 1,
                                    "volume_in_cc": 144
                                },
                                "brand": "Hershey's",
                                "brand_id": "5e2972575e2e085b2f55db64cc4f6d81c3f0d7ab",
                                "category": "Milk Chocolates",
                                "last_ordered_at": 0,
                                "category_id": "f1e8e052-d7d9-493e-814c-2cbeb1174507",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Creamy Milk Chocolate",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Chocolates",
                                "sub_category_l3": "Chocolate Bars",
                                "sub_category_l4": "Semi Premium",
                                "sub_category_l5": "Medium",
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"A8HIPY8CIG\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "CVYWMCMP9U",
                        "product_name_without_brand": "Creamy Milk Chocolate"
                    },
                    {
                        "display_name": "Party Propz Pack of 16 Foil Balloons With Balloon Stand Combo (Party, Multicolour)",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Party Propz",
                        "brand_id": "66402f121bf164c1f92692a5e24e06f900553fc5",
                        "variations": [
                            {
                                "id": "YR072S85MA",
                                "display_name": "Party Propz Pack of 16 Foil Balloons With Balloon Stand Combo (Party, Multicolour)",
                                "listing_variant": true,
                                "spin": "GIVQDCRILQ",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2025/1/2/8f09343d-d710-481c-af44-8f066c4aa6b7_142695_1.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/2/d171e5e7-026e-4522-a6b2-618a4bccc74c_142695_2.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/2/83242836-d534-4888-baba-e05e1765971b_142695_3.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/2/98de2546-0e76-45a5-9804-1d7d12e9b6b1_142695_4.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 1299,
                                    "store_price": 1299,
                                    "offer_price": 399,
                                    "offer_applied": {
                                        "offer_id": "fcf81d32-1c1e-465d-870b-c9b027a489ec",
                                        "listing_description": "69% OFF",
                                        "product_description": "69% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 399,
                                        "non_super_offer_price": 399
                                    },
                                    "discount_value": 900
                                },
                                "quantity": "16",
                                "sku_quantity_with_combo": "16 pieces",
                                "unit_of_measure": "pieces",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 6,
                                "cart_allowed_quantity": {
                                    "total": 1,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 700,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "",
                                "dimensions": {
                                    "length_in_cm": 70,
                                    "width_in_cm": 33,
                                    "height_in_cm": 5,
                                    "volume_in_cc": 11550
                                },
                                "brand": "Party Propz",
                                "brand_id": "66402f121bf164c1f92692a5e24e06f900553fc5",
                                "category": "Party Decor",
                                "last_ordered_at": 0,
                                "category_id": "030dca44-a5db-459c-a5e6-6351548447e1",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Pack of 16 Foil Balloons With Balloon Stand Combo (Party, Multicolour)",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Party Planning",
                                "sub_category_l3": "Balloons",
                                "sub_category_l4": "Foil Balloons",
                                "sub_category_l5": null,
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"YR072S85MA\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "DPP2H4ENJ3",
                        "product_name_without_brand": "Pack of 16 Foil Balloons With Balloon Stand Combo (Party, Multicolour)"
                    },
                    {
                        "display_name": "Oye Happy LOVE Cake Topper",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Oye Happy",
                        "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                        "variations": [
                            {
                                "id": "1WR8H3I4X5",
                                "display_name": "Oye Happy LOVE Cake Topper",
                                "listing_variant": true,
                                "spin": "T1SXAFJ9DO",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2025/2/1/e7e3b9f9-2c46-4f23-92bd-ed2892bcb0eb_726271_1.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/1/b66f6f85-1971-4828-8cef-6c0012a7f044_726271_2.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/1/54039e95-1f3e-4fce-9659-720df1a80253_726271_3.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/1/e26e1697-5ad2-4c0f-af8e-2322fc231ce6_726271_4.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 199,
                                    "store_price": 199,
                                    "offer_price": 69,
                                    "offer_applied": {
                                        "offer_id": "068b9aa8-d31c-4a8a-9077-8083ab3337e3",
                                        "listing_description": "65% OFF",
                                        "product_description": "65% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 69,
                                        "non_super_offer_price": 69
                                    },
                                    "discount_value": 130
                                },
                                "quantity": "1",
                                "sku_quantity_with_combo": "1 Piece",
                                "unit_of_measure": "Piece",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 6,
                                "cart_allowed_quantity": {
                                    "total": 2,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 300,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "",
                                "dimensions": {
                                    "length_in_cm": 19,
                                    "width_in_cm": 14,
                                    "height_in_cm": 4,
                                    "volume_in_cc": 1064
                                },
                                "brand": "Oye Happy",
                                "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                                "category": "Cake Decor",
                                "last_ordered_at": 0,
                                "category_id": "030dca44-a5db-459c-a5e6-6351548447e1",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "LOVE Cake Topper",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Party Planning",
                                "sub_category_l3": "Cake Toppers",
                                "sub_category_l4": null,
                                "sub_category_l5": null,
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"1WR8H3I4X5\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "KRJ4Y00JAR",
                        "product_name_without_brand": "LOVE Cake Topper"
                    },
                    {
                        "display_name": "Nestasia 6 Pieces Crystal Red Wine Glass - Blue",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Nestasia",
                        "brand_id": "3f9aa8fe69fc5866531f9eb8c4f8dd1991776ec0",
                        "variations": [
                            {
                                "id": "9CD5Z705AQ",
                                "display_name": "Nestasia 6 Pieces Crystal Red Wine Glass - Blue",
                                "listing_variant": true,
                                "spin": "N1KUFGRMA1",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2024/4/30/5b29a18d-5f50-4001-95c1-37421184834e_HomeandKitchenNeeds_N1KUFGRMA1_MN.png",
                                    "NI_CATALOG/IMAGES/CIW/2024/4/30/d3b48870-efe9-4eee-a8b3-761621fc8e4c_HomeandKitchenNeeds_N1KUFGRMA1_AL1.png",
                                    "NI_CATALOG/IMAGES/CIW/2024/4/30/51eedbbb-5d5a-4eba-a0ee-b6a473bcfe9a_HomeandKitchenNeeds_N1KUFGRMA1_AL2.png",
                                    "NI_CATALOG/IMAGES/CIW/2024/4/30/a1c257c2-3119-429b-a7ac-ceed547c3c11_HomeandKitchenNeeds_N1KUFGRMA1_AL3.png",
                                    "NI_CATALOG/IMAGES/CIW/2024/4/30/9905a3c0-3c54-431f-a006-4eca4e210cbe_HomeandKitchenNeeds_N1KUFGRMA1_AL4.png",
                                    "NI_CATALOG/IMAGES/CIW/2024/4/30/5ae61c54-91d0-4bb1-bd44-375d152fab0f_HomeandKitchenNeeds_N1KUFGRMA1_AL5.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 2500,
                                    "store_price": 2500,
                                    "offer_price": 1226,
                                    "offer_applied": {
                                        "offer_id": "edad99b1-d26c-40e0-9521-cec92aa02f7f",
                                        "listing_description": "50% OFF",
                                        "product_description": "50% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 1226,
                                        "non_super_offer_price": 1226
                                    },
                                    "discount_value": 1274
                                },
                                "quantity": "1",
                                "sku_quantity_with_combo": "1 pack",
                                "unit_of_measure": "pack",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 6,
                                "cart_allowed_quantity": {
                                    "total": 2,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 1,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "Glasses",
                                "dimensions": {
                                    "length_in_cm": 2,
                                    "width_in_cm": 1,
                                    "height_in_cm": 1,
                                    "volume_in_cc": 2
                                },
                                "brand": "Nestasia",
                                "brand_id": "3f9aa8fe69fc5866531f9eb8c4f8dd1991776ec0",
                                "category": "Glasses",
                                "last_ordered_at": 0,
                                "category_id": "f894178f-8ad8-4e8b-b7b6-f52577ea1b07",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "6 Pieces Crystal Red Wine Glass - Blue",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Kitchen and Dining",
                                "sub_category_l3": "Red Wine Glass",
                                "sub_category_l4": null,
                                "sub_category_l5": "Set of 6",
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"9CD5Z705AQ\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "Q0H1FQ4MEW",
                        "product_name_without_brand": "6 Pieces Crystal Red Wine Glass - Blue"
                    },
                    {
                        "display_name": "SOLARA Elixir 40oz Hot and Cold Insulated Tumbler with Lid & Straw (1.2L, Stainless Steel, Matte, Solid, Double-Wall, Mint Green)",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "SOLARA",
                        "brand_id": "d5f27929e9ca6f4d4e643d4d2bd33976427d581e",
                        "variations": [
                            {
                                "id": "9R5DIT6RG6",
                                "display_name": "SOLARA Elixir 40oz Hot and Cold Insulated Tumbler with Lid & Straw (1.2L, Stainless Steel, Matte, Solid, Double-Wall, Mint Green)",
                                "listing_variant": true,
                                "spin": "3W1LKXMDJS",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2024/8/23/c194f6dd-c4ec-42c5-9d4b-4e6baf1869a5_225020_1.png",
                                    "NI_CATALOG/IMAGES/CIW/2024/8/23/c7416d18-1c83-4431-b344-5244a6c2235f_225020_2.png",
                                    "NI_CATALOG/IMAGES/CIW/2024/8/23/dd19393c-53b5-49b5-88cd-3e406bbb1e81_225020_3.png",
                                    "NI_CATALOG/IMAGES/CIW/2024/8/23/4e742529-876f-4c01-9872-e081bbd7459d_225020_4.png",
                                    "NI_CATALOG/IMAGES/CIW/2024/8/23/27100302-f799-4ce6-af4c-a7865f47792a_225020_5.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 3499,
                                    "store_price": 3499,
                                    "offer_price": 1549,
                                    "offer_applied": {
                                        "offer_id": "c33347c7-538e-4d15-b54f-b12895f6c7e0",
                                        "listing_description": "55% OFF",
                                        "product_description": "55% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 1549,
                                        "non_super_offer_price": 1549
                                    },
                                    "discount_value": 1950
                                },
                                "quantity": "1",
                                "sku_quantity_with_combo": "1 Piece",
                                "unit_of_measure": "Piece",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 6,
                                "cart_allowed_quantity": {
                                    "total": 2,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 630,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "Travel Coffee Mugs",
                                "dimensions": {
                                    "length_in_cm": 1260,
                                    "width_in_cm": 1,
                                    "height_in_cm": 1,
                                    "volume_in_cc": 1260
                                },
                                "brand": "SOLARA",
                                "brand_id": "d5f27929e9ca6f4d4e643d4d2bd33976427d581e",
                                "category": "Coffee Mugs",
                                "last_ordered_at": 0,
                                "category_id": "f894178f-8ad8-4e8b-b7b6-f52577ea1b07",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Elixir 40oz Hot and Cold Insulated Tumbler with Lid & Straw (1.2L, Stainless Steel, Matte, Solid, Double-Wall, Mint Green)",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Kitchen and Dining",
                                "sub_category_l3": "Travel Coffee Mugs",
                                "sub_category_l4": null,
                                "sub_category_l5": null,
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"9R5DIT6RG6\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "FWG283TQZQ",
                        "product_name_without_brand": "Elixir 40oz Hot and Cold Insulated Tumbler with Lid & Straw (1.2L, Stainless Steel, Matte, Solid, Double-Wall, Mint Green)"
                    },
                    {
                        "display_name": "Hammer Ace 3.0 Smart Watch, 1.85 Inches IPS Display, 5 Days Battery Life, Water Resistant, Bluetooth Calling (Black)",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Hammer",
                        "brand_id": "f4c2feb0dde1e511e39c6cfa540368a97c2b443e",
                        "variations": [
                            {
                                "id": "2ZT851HB40",
                                "display_name": "Hammer Ace 3.0 Smart Watch, 1.85 Inches IPS Display, 5 Days Battery Life, Water Resistant, Bluetooth Calling (Black)",
                                "listing_variant": true,
                                "spin": "L7NCF7NIVP",
                                "super_saver": false,
                                "images": [
                                    "3ee2b7fc80369030908b62cffc296ab9",
                                    "5af5727ec52f00eaf7d34fccc0229ff1",
                                    "1a6ce8ba2bf01292694279518029bdbd",
                                    "3b7549729193fa8516d9deb9cef5de9b",
                                    "b86a7be5bafb39ab71cfd2e64744f68d",
                                    "ad46596b8b5faf5112f72ec436d3495b",
                                    "NI_CATALOG/IMAGES/CIW/2024/7/17/6c7f9607-0d07-45e3-93a5-2d7668a0a8a7_ElectronicsandWearables_AV0XII1J0V_AL6.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 4999,
                                    "store_price": 4999,
                                    "offer_price": 849,
                                    "offer_applied": {
                                        "offer_id": "f031ee94-2198-44e4-87ef-03fbc426e8a9",
                                        "listing_description": "83% OFF",
                                        "product_description": "83% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 849,
                                        "non_super_offer_price": 849
                                    },
                                    "discount_value": 4150
                                },
                                "quantity": "1",
                                "sku_quantity_with_combo": "1 unit",
                                "unit_of_measure": "unit",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 4,
                                "cart_allowed_quantity": {
                                    "total": 4,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 1,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "",
                                "dimensions": {
                                    "length_in_cm": 21,
                                    "width_in_cm": 8,
                                    "height_in_cm": 2,
                                    "volume_in_cc": 336
                                },
                                "brand": "Hammer",
                                "brand_id": "f4c2feb0dde1e511e39c6cfa540368a97c2b443e",
                                "category": "Smart Wearables",
                                "last_ordered_at": 0,
                                "category_id": "4c3295d5-852c-4b17-b7e5-5f1b4223f82d",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Ace 3.0 Smart Watch, 1.85 Inches IPS Display, 5 Days Battery Life, Water Resistant, Bluetooth Calling (Black)",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Electronics and Appliances",
                                "sub_category_l3": "Smart Watches",
                                "sub_category_l4": "Rectangular",
                                "sub_category_l5": null,
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"2ZT851HB40\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "K8W2RY4WZB",
                        "product_name_without_brand": "Ace 3.0 Smart Watch, 1.85 Inches IPS Display, 5 Days Battery Life, Water Resistant, Bluetooth Calling (Black)"
                    },
                    {
                        "display_name": "Voylla Special Seven Day Series Valentine Hamper",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Voylla",
                        "brand_id": "bcf09d85555bcdf71ebb5f6d10a0eaa5f5a95b7f",
                        "variations": [
                            {
                                "id": "C8GQJ9I806",
                                "display_name": "Voylla Special Seven Day Series Valentine Hamper",
                                "listing_variant": true,
                                "spin": "Q57PE93FEI",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/53ac6ef1-5a28-42fc-8209-4224f65be549_460973_1.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/2ec37830-f422-446d-b607-83ef5440ca87_460973_2.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/b508c0cd-4bb0-403a-90a3-c8ed1e959b96_460973_3.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/7ffe1a7b-8ad1-4e4f-9804-9ae99afb41dc_460973_4.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/7bf8b140-5beb-473c-bb7b-5c86f4b4f7d8_460973_5.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/5295991d-85d5-4f3d-be18-4b998f19d1fd_460973_6.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/8f22a7b0-9689-4685-a841-d52e31da112e_460973_7.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/8bc330b9-863e-48f0-b0d4-939e1ad349b6_460973_8.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/372fd935-7876-403c-8428-c463b6b058e5_460973_9.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/b9b72613-7f2a-41f0-8b75-e416d16da0e5_460973_10.jpeg"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 2399,
                                    "store_price": 2399,
                                    "offer_price": 1159,
                                    "offer_applied": {
                                        "offer_id": "04513693-8ccc-47b2-a0cf-a9393753d8c0",
                                        "listing_description": "51% OFF",
                                        "product_description": "51% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 1159,
                                        "non_super_offer_price": 1159
                                    },
                                    "discount_value": 1240
                                },
                                "quantity": "1",
                                "sku_quantity_with_combo": "1 pack",
                                "unit_of_measure": "pack",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 6,
                                "cart_allowed_quantity": {
                                    "total": 2,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 200,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "",
                                "dimensions": {
                                    "length_in_cm": 400,
                                    "width_in_cm": 1,
                                    "height_in_cm": 1,
                                    "volume_in_cc": 400
                                },
                                "brand": "Voylla",
                                "brand_id": "bcf09d85555bcdf71ebb5f6d10a0eaa5f5a95b7f",
                                "category": "Gift Box",
                                "last_ordered_at": 0,
                                "category_id": "f7af01b8-c84c-4bb5-a69c-2a871e39cfb4",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Special Seven Day Series Valentine Hamper",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Jewelry and Hair Accessories",
                                "sub_category_l3": "Multipack",
                                "sub_category_l4": "women",
                                "sub_category_l5": "Medium",
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"C8GQJ9I806\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "CECVPLQR5N",
                        "product_name_without_brand": "Special Seven Day Series Valentine Hamper"
                    },
                    {
                        "display_name": "Voylla Valentine's Day Forever In Love Pendant Set",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Voylla",
                        "brand_id": "bcf09d85555bcdf71ebb5f6d10a0eaa5f5a95b7f",
                        "variations": [
                            {
                                "id": "UIF957HXP1",
                                "display_name": "Voylla Valentine's Day Forever In Love Pendant Set",
                                "listing_variant": true,
                                "spin": "TC7GD1HRD0",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/e02ad384-5c70-4331-a66a-de412fee57d8_551942_1.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/6ad9331a-e46f-4f97-87ce-d62f928dc363_551942_2.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/552609fd-00ff-47b1-9bbf-a6cd80b909d4_551942_3.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/361f30c3-58de-4c77-9a78-c4b475bcc5d7_551942_4.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/947e58d9-0919-44f1-95f8-99715dcdd6db_551942_5.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/35ac1c13-9d54-4e87-bd7a-b7b7f32b3b08_551942_6.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/5a36956c-f936-4649-b6f7-2c995f4a0b5c_551942_7.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/16/68c64998-dce1-46b0-a8ee-1b93060b23b4_551942_8.jpg"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 899,
                                    "store_price": 899,
                                    "offer_price": 409,
                                    "offer_applied": {
                                        "offer_id": "8c8ee081-fa45-4f7a-af80-d1c912b1eb0b",
                                        "listing_description": "54% OFF",
                                        "product_description": "54% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 409,
                                        "non_super_offer_price": 409
                                    },
                                    "discount_value": 490
                                },
                                "quantity": "1",
                                "sku_quantity_with_combo": "1 pack",
                                "unit_of_measure": "pack",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 6,
                                "cart_allowed_quantity": {
                                    "total": 1,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 0,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "",
                                "dimensions": {
                                    "length_in_cm": 0,
                                    "width_in_cm": 1,
                                    "height_in_cm": 1,
                                    "volume_in_cc": 0
                                },
                                "brand": "Voylla",
                                "brand_id": "bcf09d85555bcdf71ebb5f6d10a0eaa5f5a95b7f",
                                "category": "Jewelry Sets",
                                "last_ordered_at": 0,
                                "category_id": "f7af01b8-c84c-4bb5-a69c-2a871e39cfb4",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Valentine's Day Forever In Love Pendant Set",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Jewelry and Hair Accessories",
                                "sub_category_l3": null,
                                "sub_category_l4": null,
                                "sub_category_l5": null,
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"UIF957HXP1\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "OL8UT7SQ06",
                        "product_name_without_brand": "Valentine's Day Forever In Love Pendant Set"
                    },
                    {
                        "display_name": "Everstylish Giora Warm Hugs - Casual Silver Adjustable Ring for Couple",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Everstylish",
                        "brand_id": "ace6bbe4fd51d7f55038693f0f6637ec82e8247f",
                        "variations": [
                            {
                                "id": "HXULR9TSKI",
                                "display_name": "Everstylish Giora Warm Hugs - Casual Silver Adjustable Ring for Couple",
                                "listing_variant": true,
                                "spin": "63V6ONGU0G",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2025/2/8/b76de418-45cf-41c4-ab61-e6aa6a4265d9_532245_1.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/8/c6e4c89f-501d-4698-aecc-d1c0b53bb86e_532245_2.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/8/c1424850-6cf5-4056-9734-cfe90bcd3d1d_532245_3.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/8/8b7ba242-8f2a-4506-b26f-bcf9d5a26320_532245_4.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/8/1658519a-1829-4766-83ce-6f95dce2055d_532245_5.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/8/c5986f07-550c-4ebb-bc1c-5571eed8e8f2_532245_6.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/8/441522f8-18ac-4633-8451-e42387a4ccfe_532245_7.jpg"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 1750,
                                    "store_price": 1750,
                                    "offer_price": 461,
                                    "offer_applied": {
                                        "offer_id": "2d76403f-3a65-424e-828d-54c46e66723f",
                                        "listing_description": "73% OFF",
                                        "product_description": "73% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 461,
                                        "non_super_offer_price": 461
                                    },
                                    "discount_value": 1289
                                },
                                "quantity": "1",
                                "sku_quantity_with_combo": "1 Pair",
                                "unit_of_measure": "Pair",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 6,
                                "cart_allowed_quantity": {
                                    "total": 2,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 2,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "",
                                "dimensions": {
                                    "length_in_cm": 2,
                                    "width_in_cm": 1,
                                    "height_in_cm": 2,
                                    "volume_in_cc": 4
                                },
                                "brand": "Everstylish",
                                "brand_id": "ace6bbe4fd51d7f55038693f0f6637ec82e8247f",
                                "category": "Rings",
                                "last_ordered_at": 0,
                                "category_id": "f7af01b8-c84c-4bb5-a69c-2a871e39cfb4",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Giora Warm Hugs - Casual Silver Adjustable Ring for Couple",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Jewelry and Hair Accessories",
                                "sub_category_l3": null,
                                "sub_category_l4": "women",
                                "sub_category_l5": "Medium",
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"HXULR9TSKI\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "K7P1MYWC4Q",
                        "product_name_without_brand": "Giora Warm Hugs - Casual Silver Adjustable Ring for Couple"
                    },
                    {
                        "display_name": "Red Rose",
                        "ad_tracking_context": null,
                        "badges": [
                            {
                                "badge_type": "SOURCE",
                                "badge_text": "Export Quality",
                                "badge_color": "#60b24626",
                                "text_color": "#60B246"
                            }
                        ],
                        "badge_info": {
                            "badge_type": "SOURCE",
                            "badge_text": "Export Quality",
                            "badge_color": "#60b24626",
                            "text_color": "#60B246"
                        },
                        "item_card_view": "V2",
                        "brand": "",
                        "brand_id": "f945332e63fffc189578bb45dc242aa10d897d68",
                        "variations": [
                            {
                                "id": "WMHJAIH01X",
                                "display_name": "Red Roses",
                                "listing_variant": false,
                                "spin": "W4SH2DPGY0",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2025/2/6/c9a7cbc1-ea09-4f8d-9730-c67ae5a3646b_27005_1.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/6/ae304424-f949-490a-979a-7a225f47c658_9540_2.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/6/043b97dc-657c-434a-a14f-ba3480b1cf6e_9540_3.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/6/2aec9754-5215-445d-97b5-0ccc2c57e0db_9540_4.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/6/19a5be0e-91ca-4bdf-bf02-d72ff4d47691_9540_5.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 200,
                                    "store_price": 200,
                                    "offer_price": 68,
                                    "offer_applied": {
                                        "offer_id": "9870b432-14ed-4693-bb08-2a91e99617af",
                                        "listing_description": "66% OFF",
                                        "product_description": "66% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 68,
                                        "non_super_offer_price": 68
                                    },
                                    "discount_value": 132
                                },
                                "quantity": "2",
                                "sku_quantity_with_combo": "1 flower x 2",
                                "unit_of_measure": "pieces",
                                "meta": {
                                    "short_description": "Quality so good that it doesn't require adjectives",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 6,
                                "cart_allowed_quantity": {
                                    "total": 6,
                                    "message": "Only 6 unit(s) of this item can be added per order."
                                },
                                "weight_in_grams": 2,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "Loose",
                                "dimensions": {
                                    "length_in_cm": 7,
                                    "width_in_cm": 7,
                                    "height_in_cm": 7,
                                    "volume_in_cc": 343
                                },
                                "brand": "",
                                "brand_id": "f945332e63fffc189578bb45dc242aa10d897d68",
                                "category": "Flowers",
                                "last_ordered_at": 0,
                                "category_id": "36b4932d-b688-4b75-b871-1bf06e14e5d9",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Red Roses",
                                "sourcing_time": "",
                                "sourced_from": "Export Quality",
                                "super_category": "Fruits and Vegetables",
                                "sub_category_l3": "Rose",
                                "sub_category_l4": "Pink Rose",
                                "sub_category_l5": "Combo",
                                "scm_item_type": "VIRTUAL_COMBO",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            },
                            {
                                "id": "Z96DQ55CNM",
                                "display_name": "Red Rose",
                                "listing_variant": true,
                                "spin": "UIR5F9WXXO",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2025/2/6/c271dfd7-452d-4b1e-b95c-0cd675439407_9540_1.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/6/ae304424-f949-490a-979a-7a225f47c658_9540_2.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/6/043b97dc-657c-434a-a14f-ba3480b1cf6e_9540_3.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/6/2aec9754-5215-445d-97b5-0ccc2c57e0db_9540_4.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/6/19a5be0e-91ca-4bdf-bf02-d72ff4d47691_9540_5.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 100,
                                    "store_price": 100,
                                    "offer_price": 39,
                                    "offer_applied": {
                                        "offer_id": "9870b432-14ed-4693-bb08-2a91e99617af",
                                        "listing_description": "61% OFF",
                                        "product_description": "61% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 39,
                                        "non_super_offer_price": 39
                                    },
                                    "discount_value": 61
                                },
                                "quantity": "1",
                                "sku_quantity_with_combo": "1 flower",
                                "unit_of_measure": "flower",
                                "meta": {
                                    "short_description": "Quality so good that it doesn't require adjectives",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 20,
                                "cart_allowed_quantity": {
                                    "total": 20,
                                    "message": "Only 20 unit(s) of this item can be added per order."
                                },
                                "weight_in_grams": 1,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "Loose",
                                "dimensions": {
                                    "length_in_cm": 15,
                                    "width_in_cm": 15,
                                    "height_in_cm": 15,
                                    "volume_in_cc": 3375
                                },
                                "brand": "",
                                "brand_id": "f945332e63fffc189578bb45dc242aa10d897d68",
                                "category": "Flowers",
                                "last_ordered_at": 0,
                                "category_id": "36b4932d-b688-4b75-b871-1bf06e14e5d9",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": true,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Red Rose",
                                "sourcing_time": "",
                                "sourced_from": "Export Quality",
                                "super_category": "Fruits and Vegetables",
                                "sub_category_l3": "Rose",
                                "sub_category_l4": "Pink Rose",
                                "sub_category_l5": "Normal",
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"Z96DQ55CNM\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "NQ60LH4MQV",
                        "product_name_without_brand": "Red Rose"
                    },
                    {
                        "display_name": "Oye Happy Cute Pink Party Popper",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Oye Happy",
                        "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                        "variations": [
                            {
                                "id": "7LG3HF5HDP",
                                "display_name": "Oye Happy Cute Pink Party Popper",
                                "listing_variant": true,
                                "spin": "M2ISKAJW5P",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2025/2/1/915be3f6-8206-4ad6-807f-d2d41f558b02_164896_1.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/1/23e49c41-840f-4e25-b749-a4f9a6b32a84_164896_2.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/1/d58376c1-a546-4082-9a75-109deb9b6091_164896_3.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/1/6a8f0e24-763b-4694-b543-a2e44d3f8981_164896_4.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/2/1/563b3cfd-35c2-4b76-9c5c-9ea52d5a2dc5_164896_5.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 249,
                                    "store_price": 249,
                                    "offer_price": 75,
                                    "offer_applied": {
                                        "offer_id": "dfbcb7af-4ca4-47fa-824b-8b787140ee16",
                                        "listing_description": "69% OFF",
                                        "product_description": "69% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 75,
                                        "non_super_offer_price": 75
                                    },
                                    "discount_value": 174
                                },
                                "quantity": "1",
                                "sku_quantity_with_combo": "1 Piece",
                                "unit_of_measure": "Piece",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 6,
                                "cart_allowed_quantity": {
                                    "total": 2,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 300,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "",
                                "dimensions": {
                                    "length_in_cm": 19,
                                    "width_in_cm": 14,
                                    "height_in_cm": 4,
                                    "volume_in_cc": 1064
                                },
                                "brand": "Oye Happy",
                                "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                                "category": "Party Accessories",
                                "last_ordered_at": 0,
                                "category_id": "030dca44-a5db-459c-a5e6-6351548447e1",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Cute Pink Party Popper",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Party Planning",
                                "sub_category_l3": "Party Poppers",
                                "sub_category_l4": null,
                                "sub_category_l5": null,
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"7LG3HF5HDP\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "VTBQEYVGJT",
                        "product_name_without_brand": "Cute Pink Party Popper"
                    },
                    {
                        "display_name": "Oye Happy Dreamy Lavendar Candle Jar",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Oye Happy",
                        "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                        "variations": [
                            {
                                "id": "N8WO4AUTM4",
                                "display_name": "Oye Happy Dreamy Lavendar Candle Jar",
                                "listing_variant": true,
                                "spin": "ACUFSPPP1U",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2025/1/22/ae31a622-cc6f-490e-9acb-b06d653c2f8b_939608_1.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/22/c64661bf-f976-4ae9-927b-e2152d920e1f_939608_2.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/22/163ab1bc-8383-42c2-b23e-82544a10447b_939608_3.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 499,
                                    "store_price": 499,
                                    "offer_price": 174,
                                    "offer_applied": {
                                        "offer_id": "6b9ca5dd-d041-4183-be41-f90498af2ddf",
                                        "listing_description": "65% OFF",
                                        "product_description": "65% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 174,
                                        "non_super_offer_price": 174
                                    },
                                    "discount_value": 325
                                },
                                "quantity": "1",
                                "sku_quantity_with_combo": "1 Piece",
                                "unit_of_measure": "Piece",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 6,
                                "cart_allowed_quantity": {
                                    "total": 2,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 300,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "",
                                "dimensions": {
                                    "length_in_cm": 19,
                                    "width_in_cm": 14,
                                    "height_in_cm": 4,
                                    "volume_in_cc": 1064
                                },
                                "brand": "Oye Happy",
                                "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                                "category": "Home Decor",
                                "last_ordered_at": 0,
                                "category_id": "f894178f-8ad8-4e8b-b7b6-f52577ea1b07",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Dreamy Lavendar Candle Jar",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Home",
                                "sub_category_l3": "Candles",
                                "sub_category_l4": null,
                                "sub_category_l5": null,
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"N8WO4AUTM4\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "1U0IEKP5JH",
                        "product_name_without_brand": "Dreamy Lavendar Candle Jar"
                    },
                    {
                        "display_name": "Oye Happy Red Scented Pillar Candle",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Oye Happy",
                        "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                        "variations": [
                            {
                                "id": "R4UU162PL4",
                                "display_name": "Oye Happy Red Scented Pillar Candle",
                                "listing_variant": true,
                                "spin": "44JYVGFYOM",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2025/1/23/29e1dde0-a784-4013-a2b3-dfbe1b07bdab_804583_1.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/23/d12adb29-c283-4605-8951-125751e9b465_804583_2.png",
                                    "NI_CATALOG/IMAGES/CIW/2025/1/23/04cb5e33-1cca-4571-a73e-8c96c29772c9_804583_3.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 799,
                                    "store_price": 799,
                                    "offer_price": 279,
                                    "offer_applied": {
                                        "offer_id": "c388ce8e-12b4-45c5-8d5d-39893fed48f2",
                                        "listing_description": "65% OFF",
                                        "product_description": "65% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 279,
                                        "non_super_offer_price": 279
                                    },
                                    "discount_value": 520
                                },
                                "quantity": "1",
                                "sku_quantity_with_combo": "1 Piece",
                                "unit_of_measure": "Piece",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 6,
                                "cart_allowed_quantity": {
                                    "total": 2,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 300,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "",
                                "dimensions": {
                                    "length_in_cm": 19,
                                    "width_in_cm": 14,
                                    "height_in_cm": 4,
                                    "volume_in_cc": 1064
                                },
                                "brand": "Oye Happy",
                                "brand_id": "9a9d6da7b33e704481a1cc941b0b00a5047b3800",
                                "category": "Home Decor",
                                "last_ordered_at": 0,
                                "category_id": "f894178f-8ad8-4e8b-b7b6-f52577ea1b07",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "Red Scented Pillar Candle",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Home",
                                "sub_category_l3": "Candles",
                                "sub_category_l4": null,
                                "sub_category_l5": null,
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"R4UU162PL4\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "VHJMIKW98F",
                        "product_name_without_brand": "Red Scented Pillar Candle"
                    },
                    {
                        "display_name": "SUGAR Cosmetics Bestsellers Makeup Kit - Classics",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "SUGAR Cosmetics",
                        "brand_id": "c28146ca101f4860b31021a05b2d09970d46fdee",
                        "variations": [
                            {
                                "id": "QDGQVRJD6O",
                                "display_name": "SUGAR Cosmetics Bestsellers Makeup Kit - Classics",
                                "listing_variant": true,
                                "spin": "A9LCFNMIT9",
                                "super_saver": false,
                                "images": [
                                    "NI_CATALOG/IMAGES/CIW/2024/12/18/3c95df2a-b814-4d1c-904d-e7db4b7cbcbc_813338_2.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2024/12/18/0c339359-a01d-414f-8213-ccac041fcabc_813338_1.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2024/12/18/0834087f-1cd0-4f1a-8f35-8173c673061f_813338_3.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2024/12/18/0b4a33d3-ab96-49ee-a5a2-8d1efb731ec9_813338_4.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2024/12/18/42e99f01-395c-4b5a-9a50-2671be0d4bc2_813338_5.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2024/12/18/bb4cb106-d033-41da-aab9-8bca158e82e3_813338_6.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2024/12/18/4e65ab25-eba2-41bf-9fc1-5d8e01cfd07b_813338_7.jpg",
                                    "NI_CATALOG/IMAGES/CIW/2024/12/18/29e7af99-246d-46ee-9a31-28a6383bed39_813338_8.jpg"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 1446,
                                    "store_price": 1446,
                                    "offer_price": 868,
                                    "offer_applied": {
                                        "offer_id": "b34f5501-7c68-41b9-a83f-ea32f9bd8565",
                                        "listing_description": "39% OFF",
                                        "product_description": "39% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 868,
                                        "non_super_offer_price": 868
                                    },
                                    "discount_value": 578
                                },
                                "quantity": "1",
                                "sku_quantity_with_combo": "1 g",
                                "unit_of_measure": "g",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 6,
                                "cart_allowed_quantity": {
                                    "total": 2,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 20,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "Others",
                                "dimensions": {
                                    "length_in_cm": 40,
                                    "width_in_cm": 1,
                                    "height_in_cm": 1,
                                    "volume_in_cc": 40
                                },
                                "brand": "SUGAR Cosmetics",
                                "brand_id": "c28146ca101f4860b31021a05b2d09970d46fdee",
                                "category": "Gift Packs",
                                "last_ordered_at": 0,
                                "category_id": "787f1b32-2a2b-4200-8116-8bce8bee77cc",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": [
                                        1739847765390
                                    ]
                                },
                                "default": false,
                                "product_name_without_brand": "Bestsellers Makeup Kit - Classics",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Makeup",
                                "sub_category_l3": "Makeup Kits",
                                "sub_category_l4": "Mixed",
                                "sub_category_l5": "Multipack",
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"QDGQVRJD6O\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "I6HPOF92NX",
                        "product_name_without_brand": "Bestsellers Makeup Kit - Classics"
                    },
                    {
                        "display_name": "Havells HD3151 Foldable Hair Dryer 1200W with 3 Heat Settings for Versatile Styling (Turquoise)",
                        "ad_tracking_context": null,
                        "badges": [],
                        "badge_info": null,
                        "item_card_view": "V2",
                        "brand": "Havells",
                        "brand_id": "a9716a602965c55896c0214a5e98bc3923c0779a",
                        "variations": [
                            {
                                "id": "815N1S2864",
                                "display_name": "Havells HD3151 Foldable Hair Dryer 1200W with 3 Heat Settings for Versatile Styling (Turquoise)",
                                "listing_variant": true,
                                "spin": "CPWY6RPCUN",
                                "super_saver": false,
                                "images": [
                                    "d097599dd235d764a4eeca8d09ab8876",
                                    "f5b9fc2b9a8f265e42ebc995366cdf37",
                                    "ba373dc673a55f854d5711518b48c0f3",
                                    "98b8c14feda7fc8649812962f42d4d86",
                                    "80eeb16f14a560ceb5f0a912d337db0c",
                                    "7d8cf37076e231488860f691dfb74258",
                                    "NI_CATALOG/IMAGES/CIW/2024/7/19/2f6a96ce-4ca9-4410-8a2f-b37659e20fa5_HomeElectricalAppliances_PJR728G62S_AL6.png"
                                ],
                                "images_v2": [],
                                "price": {
                                    "mrp": 1695,
                                    "store_price": 1695,
                                    "offer_price": 912,
                                    "offer_applied": {
                                        "offer_id": "559f47c1-50cf-4248-8bcc-841b440ef2ea",
                                        "listing_description": "46% OFF",
                                        "product_description": "46% OFF",
                                        "super_offer": false
                                    },
                                    "unit_level_price": "",
                                    "loyalty_pricing": {
                                        "super_offer_price": 912,
                                        "non_super_offer_price": 912
                                    },
                                    "discount_value": 783
                                },
                                "quantity": "1",
                                "sku_quantity_with_combo": "1 unit",
                                "unit_of_measure": "unit",
                                "meta": {
                                    "short_description": "",
                                    "groups": [],
                                    "coupon_less_offers": [],
                                    "sticker": "",
                                    "handpicked": false
                                },
                                "tags": null,
                                "inventory": {
                                    "in_stock": true,
                                    "total": 0,
                                    "remaining": 0,
                                    "message": null
                                },
                                "max_allowed_quantity": 4,
                                "cart_allowed_quantity": {
                                    "total": 3,
                                    "message": "That\u2019s all we have in stock at the moment!"
                                },
                                "weight_in_grams": 1,
                                "volumetric_weight": 0,
                                "alcohol_content_percentage": 0,
                                "container_type": "",
                                "sub_category_type": "",
                                "dimensions": {
                                    "length_in_cm": 2,
                                    "width_in_cm": 1,
                                    "height_in_cm": 1,
                                    "volume_in_cc": 2
                                },
                                "brand": "Havells",
                                "brand_id": "a9716a602965c55896c0214a5e98bc3923c0779a",
                                "category": "Personal Care Appliances",
                                "last_ordered_at": 0,
                                "category_id": "01b621e3-7126-496b-8abc-dce0e414d24d",
                                "sku_secondary_quantity": "",
                                "store_id": "1313712",
                                "display_variant": false,
                                "sku_slot_info": {
                                    "message": null,
                                    "avail": true,
                                    "is_avail": true,
                                    "next_change_time": []
                                },
                                "default": false,
                                "product_name_without_brand": "HD3151 Foldable Hair Dryer 1200W with 3 Heat Settings for Versatile Styling (Turquoise)",
                                "sourcing_time": "",
                                "sourced_from": "",
                                "super_category": "Electronics and Appliances",
                                "sub_category_l3": "Hair Dryers",
                                "sub_category_l4": "Dryers",
                                "sub_category_l5": null,
                                "scm_item_type": "NORMAL",
                                "filters_tag": null,
                                "external_pharmacy_item": false,
                                "rx_required": false,
                                "variation_tags": null
                            }
                        ],
                        "inline_message": null,
                        "analytics": {
                            "objectValue": null,
                            "context": "{\"itemId\":\"815N1S2864\",\"slotAvailability\":true}",
                            "impressionObjectName": "item-impression",
                            "clickObjectName": "click-item",
                            "extraFields": {}
                        },
                        "sos_ads_position_data": null,
                        "avail": true,
                        "ad_item": false,
                        "in_stock": true,
                        "is_avail": true,
                        "product_id": "OMXHFEZCZ7",
                        "product_name_without_brand": "HD3151 Foldable Hair Dryer 1200W with 3 Heat Settings for Versatile Styling (Turquoise)"
                    }
                ],
                "type": "PRODUCT_WITH_BACKGROUND",
                "priority": 6,
                "widgetTimeSlotInfo": {
                    "alwaysActive": false,
                    "widgetSlotDayListMap": {
                        "TUESDAY": [
                            {
                                "startTime": "17:30",
                                "endTime": "19:30"
                            }
                        ]
                    }
                },
                "segments": []
            }
        ],
        "headerMessageType": "NON_GUARANTEED_DELIVERY",
        "hasMoreWidgets": true,
        "layoutId": 2671,
        "serviceLine": "INSTAMART",
        "requestId": "38149f0e-9adb-41a7-96b2-0da7f1e929b2",
        "storesDetails": [
            {
                "id": "1313712",
                "name": "Instamart",
                "storeConstraints": {
                    "maxAllowedItemsInCart": 200,
                    "maxAllowedCartWeightInGrams": 40000,
                    "maxAllowedCartVolumeInCc": 80000,
                    "bulkCartConstraints": {
                        "minWeightInGrams": 15000,
                        "minItemCount": 200
                    }
                },
                "discountInfo": {
                    "couponLessDiscounts": [
                        {
                            "description": "Use FREEONION | On orders above \u20B9599",
                            "short_description": "1 Kg Onions free!",
                            "discount_type": "FREEBIE",
                            "logo_id": "e0cf25488aee88d25b9df510a56809f2",
                            "title": "Get 1 Kg Onions free!",
                            "sub_title": "Use code FREEONION and get 1 Kg Onions free on orders above \u20B9599",
                            "tnc": [
                                "Offer valid till stocks last",
                                "Offer valid for a limited period only",
                                "Other TnCs may apply",
                                "Offer valid till Dec 30, 2025"
                            ],
                            "coupon_code": "",
                            "super_offer": false,
                            "discount_cap": 0,
                            "valid_till": "2025-12-30T18:30:00.000+0000",
                            "offer_id": "17425f0f-739d-41d6-b7b6-2f3065f8184a",
                            "minimum_order_value": 999,
                            "discount_value": 0,
                            "nudge": {
                                "message": "",
                                "logoId": "",
                                "threshold": 0,
                                "frequency": 35,
                                "timeout": 10000,
                                "cta": {
                                    "text": "View Items",
                                    "link": ""
                                }
                            },
                            "success_dialog": {
                                "title": "",
                                "message": "",
                                "header": ""
                            },
                            "prev_mov_text": "",
                            "post_mov_text": "",
                            "groups_info": {
                                "exclusionGroupsInfo": {},
                                "message": ""
                            },
                            "pre_display_threshold_text": "",
                            "discount_on_type": "CART"
                        },
                        {
                            "description": "Use FREEONION | On orders above \u20B9599",
                            "short_description": "1 Kg Onions free!",
                            "discount_type": "FREEBIE",
                            "logo_id": "e0cf25488aee88d25b9df510a56809f2",
                            "title": "Get 1 Kg Onions free!",
                            "sub_title": "Use code FREEONION and get 1 Kg Onions free on orders above \u20B9599",
                            "tnc": [
                                "Offer valid till stocks last",
                                "Offer valid for a limited period only",
                                "Other TnCs may apply",
                                "Offer valid till Dec 30, 2025"
                            ],
                            "coupon_code": "",
                            "super_offer": false,
                            "discount_cap": 0,
                            "valid_till": "2025-12-30T18:30:00.000+0000",
                            "offer_id": "0cf6ae9f-5c63-42c7-a38e-b4a5e1215418",
                            "minimum_order_value": 1,
                            "discount_value": 0,
                            "nudge": {
                                "message": "Add \u20B9<remainingMov> more to get a freebie with <couponCode>",
                                "logoId": "",
                                "threshold": 50,
                                "frequency": 35,
                                "timeout": 10000,
                                "cta": {
                                    "text": "View Items",
                                    "link": ""
                                }
                            },
                            "success_dialog": {
                                "title": "You saved \u20B9{0}!",
                                "message": "You got extra \u20B9{0} off on your bill by adding Zydus items worth \u20B91",
                                "header": ""
                            },
                            "prev_mov_text": "Add \u20B9<remainingMov> more to get a freebie with <couponCode>",
                            "post_mov_text": "You got extra \u20B9{0} off on your bill by adding Zydus items worth \u20B91",
                            "groups_info": {
                                "exclusionGroupsInfo": {},
                                "message": ""
                            },
                            "pre_display_threshold_text": "",
                            "discount_on_type": "CART"
                        }
                    ],
                    "superOffer": false,
                    "discounts": [
                        {
                            "description": "Get free delivery on orders above \u20B9499",
                            "short_description": "Free Delivery above \u20B9499",
                            "discount_type": "PERCENT",
                            "logo_id": "w03c3dtgopc4qvtqgntr",
                            "title": "Free Delivery on orders above \u20B9499",
                            "sub_title": "Get free delivery on orders above \u20B9499",
                            "tnc": [
                                "Other T&Cs may apply",
                                "Offer valid till Dec 30, 2025 23:59 PM"
                            ],
                            "coupon_code": "",
                            "super_offer": false,
                            "minimum_order_value": 49900,
                            "prev_mov_text": "Add items worth \u20B9{differenceFromMov} more and get <b>FREE DELIVERY</b>",
                            "post_mov_text": "Yay! You have unlocked <b>FREE DELIVERY!</b>",
                            "groups_info": {
                                "exclusionGroupsInfo": {},
                                "message": ""
                            },
                            "pre_display_threshold_text": "You have <b>FREE DELIVERY</b> on order above \u20B9499!",
                            "discount_on_type": "DELIVERY"
                        },
                        {
                            "description": "Use PHARMA10| On orders above \u20B9499",
                            "short_description": "10% off upto \u20B9200",
                            "discount_type": "PERCENT",
                            "logo_id": "InstamartAssets/Swiggy%20New%20(400%20x%20400)%20Logo.png",
                            "title": "10% off upto \u20B9200",
                            "sub_title": "Use code PHARMA10 & get 10% off upto \u20B9200 on orders above \u20B9499",
                            "tnc": [
                                "Limited period offer",
                                "Valid only on Instamart orders 5 times per user",
                                "Valid only on Pharma items",
                                "Other T&Cs may apply.",
                                "Offer valid till Feb 27, 2025"
                            ],
                            "coupon_code": "PHARMA10",
                            "super_offer": false,
                            "minimum_order_value": 49900,
                            "prev_mov_text": "Add items worth \u20B9{differenceFromMov} to get atleast \u20B950 off | PHARMA10",
                            "post_mov_text": "PHARMA10 coupon unlocked! Use it to get atleast \u20B950 off",
                            "groups_info": {
                                "exclusionGroupsInfo": {
                                    "LRIG": {
                                        "message": "Certain items are excluded as per regulatory and manufacturer policies"
                                    }
                                },
                                "message": "Certain items are excluded as per regulatory and manufacturer policies"
                            },
                            "pre_display_threshold_text": "",
                            "discount_on_type": "CART"
                        }
                    ]
                },
                "priority": "PRIORITY_PRIMARY",
                "orderabilityDetails": {
                    "sla": {
                        "value": "19",
                        "unit": "mins",
                        "backgroundColor": "#B6B6B6",
                        "textColor": "text_color_low_emphasis"
                    },
                    "serviceabilityStatus": "SERVICEABLE",
                    "serviceabilityType": "FAST_SERVICEABLE",
                    "available": true
                }
            },
            {
                "id": "911032",
                "name": "Instamart",
                "storeConstraints": {
                    "maxAllowedItemsInCart": 200,
                    "maxAllowedCartWeightInGrams": 38000,
                    "maxAllowedCartVolumeInCc": 80000,
                    "bulkCartConstraints": {
                        "minWeightInGrams": 15000,
                        "minItemCount": 200
                    }
                },
                "discountInfo": {
                    "couponLessDiscounts": [
                        {
                            "description": "Use FREEONION | On orders above \u20B9599",
                            "short_description": "1 Kg Onions free!",
                            "discount_type": "FREEBIE",
                            "logo_id": "e0cf25488aee88d25b9df510a56809f2",
                            "title": "Get 1 Kg Onions free!",
                            "sub_title": "Use code FREEONION and get 1 Kg Onions free on orders above \u20B9599",
                            "tnc": [
                                "Offer valid till stocks last",
                                "Offer valid for a limited period only",
                                "Other TnCs may apply",
                                "Offer valid till Dec 30, 2025"
                            ],
                            "coupon_code": "",
                            "super_offer": false,
                            "discount_cap": 0,
                            "valid_till": "2025-12-30T18:30:00.000+0000",
                            "offer_id": "17425f0f-739d-41d6-b7b6-2f3065f8184a",
                            "minimum_order_value": 999,
                            "discount_value": 0,
                            "nudge": {
                                "message": "",
                                "logoId": "",
                                "threshold": 0,
                                "frequency": 35,
                                "timeout": 10000,
                                "cta": {
                                    "text": "View Items",
                                    "link": ""
                                }
                            },
                            "success_dialog": {
                                "title": "",
                                "message": "",
                                "header": ""
                            },
                            "prev_mov_text": "",
                            "post_mov_text": "",
                            "groups_info": {
                                "exclusionGroupsInfo": {},
                                "message": ""
                            },
                            "pre_display_threshold_text": "",
                            "discount_on_type": "CART"
                        },
                        {
                            "description": "Use FREEONION | On orders above \u20B9599",
                            "short_description": "1 Kg Onions free!",
                            "discount_type": "FREEBIE",
                            "logo_id": "e0cf25488aee88d25b9df510a56809f2",
                            "title": "Get 1 Kg Onions free!",
                            "sub_title": "Use code FREEONION and get 1 Kg Onions free on orders above \u20B9599",
                            "tnc": [
                                "Offer valid till stocks last",
                                "Offer valid for a limited period only",
                                "Other TnCs may apply",
                                "Offer valid till Dec 30, 2025"
                            ],
                            "coupon_code": "",
                            "super_offer": false,
                            "discount_cap": 0,
                            "valid_till": "2025-12-30T18:30:00.000+0000",
                            "offer_id": "0cf6ae9f-5c63-42c7-a38e-b4a5e1215418",
                            "minimum_order_value": 1,
                            "discount_value": 0,
                            "nudge": {
                                "message": "Add \u20B9<remainingMov> more to get a freebie with <couponCode>",
                                "logoId": "",
                                "threshold": 50,
                                "frequency": 35,
                                "timeout": 10000,
                                "cta": {
                                    "text": "View Items",
                                    "link": ""
                                }
                            },
                            "success_dialog": {
                                "title": "You saved \u20B9{0}!",
                                "message": "You got extra \u20B9{0} off on your bill by adding Zydus items worth \u20B91",
                                "header": ""
                            },
                            "prev_mov_text": "Add \u20B9<remainingMov> more to get a freebie with <couponCode>",
                            "post_mov_text": "You got extra \u20B9{0} off on your bill by adding Zydus items worth \u20B91",
                            "groups_info": {
                                "exclusionGroupsInfo": {},
                                "message": ""
                            },
                            "pre_display_threshold_text": "",
                            "discount_on_type": "CART"
                        }
                    ],
                    "superOffer": false,
                    "discounts": [
                        {
                            "description": "Get free delivery on orders above \u20B9499",
                            "short_description": "Free Delivery above \u20B9499",
                            "discount_type": "PERCENT",
                            "logo_id": "w03c3dtgopc4qvtqgntr",
                            "title": "Free Delivery on orders above \u20B9499",
                            "sub_title": "Get free delivery on orders above \u20B9499",
                            "tnc": [
                                "Other T&Cs may apply",
                                "Offer valid till Dec 30, 2025 23:59 PM"
                            ],
                            "coupon_code": "",
                            "super_offer": false,
                            "minimum_order_value": 49900,
                            "prev_mov_text": "Add items worth \u20B9{differenceFromMov} more and get <b>FREE DELIVERY</b>",
                            "post_mov_text": "Yay! You have unlocked <b>FREE DELIVERY!</b>",
                            "groups_info": {
                                "exclusionGroupsInfo": {},
                                "message": ""
                            },
                            "pre_display_threshold_text": "You have <b>FREE DELIVERY</b> on order above \u20B9499!",
                            "discount_on_type": "DELIVERY"
                        },
                        {
                            "description": "Use PHARMA10| On orders above \u20B9499",
                            "short_description": "10% off upto \u20B9200",
                            "discount_type": "PERCENT",
                            "logo_id": "InstamartAssets/Swiggy%20New%20(400%20x%20400)%20Logo.png",
                            "title": "10% off upto \u20B9200",
                            "sub_title": "Use code PHARMA10 & get 10% off upto \u20B9200 on orders above \u20B9499",
                            "tnc": [
                                "Limited period offer",
                                "Valid only on Instamart orders 5 times per user",
                                "Valid only on Pharma items",
                                "Other T&Cs may apply.",
                                "Offer valid till Feb 27, 2025"
                            ],
                            "coupon_code": "PHARMA10",
                            "super_offer": false,
                            "minimum_order_value": 49900,
                            "prev_mov_text": "Add items worth \u20B9{differenceFromMov} to get atleast \u20B950 off | PHARMA10",
                            "post_mov_text": "PHARMA10 coupon unlocked! Use it to get atleast \u20B950 off",
                            "groups_info": {
                                "exclusionGroupsInfo": {
                                    "LRIG": {
                                        "message": "Certain items are excluded as per regulatory and manufacturer policies"
                                    }
                                },
                                "message": "Certain items are excluded as per regulatory and manufacturer policies"
                            },
                            "pre_display_threshold_text": "",
                            "discount_on_type": "CART"
                        }
                    ]
                },
                "priority": "PRIORITY_SECONDARY",
                "orderabilityDetails": {
                    "sla": {
                        "value": "35",
                        "unit": "mins",
                        "backgroundColor": "#B6B6B6",
                        "textColor": "text_color_low_emphasis"
                    },
                    "serviceabilityStatus": "SERVICEABLE",
                    "serviceabilityType": "REGULAR_SERVICEABLE",
                    "available": true
                }
            }
        ],
        "pageConfigs": {
            "showImLauncherDialog": false
        },
        "splitCartEnabled": true
    },
    "statusCode": 0
};
var $dc74046c776679c5$export$1bedaa6526a9305d = {
    "statusCode": 0,
    "data": {
        "statusMessage": "done successfully",
        "pageOffset": {
            "nextOffset": "CJhlELQ4KIDQusb87tyOXjCnEzgD",
            "widgetOffset": {
                "NewListingView_category_bar_chicletranking_TwoRows": "",
                "NewListingView_category_bar_chicletranking_TwoRows_Rendition": "",
                "Restaurant_Group_WebView_PB_Theme": "",
                "Restaurant_Group_WebView_SEO_PB_Theme": "",
                "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo": "9",
                "inlineFacetFilter": "",
                "restaurantCountWidget": ""
            }
        },
        "cards": [
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        "header": {
                            "title": "What's on your mind?",
                            "headerStyling": {
                                "padding": {
                                    "left": 16,
                                    "top": 16,
                                    "bottom": 4
                                }
                            }
                        },
                        "layout": {
                            "rows": 1,
                            "columns": 10,
                            "horizontalScrollEnabled": true,
                            "itemSpacing": 24,
                            "widgetPadding": {},
                            "containerStyle": {
                                "containerPadding": {
                                    "left": 8,
                                    "top": 8,
                                    "right": 12,
                                    "bottom": 4
                                }
                            },
                            "scrollBar": {},
                            "widgetTheme": {
                                "defaultMode": {
                                    "backgroundColour": "#FFFFFF",
                                    "theme": "THEME_TYPE_LIGHT"
                                },
                                "darkMode": {
                                    "theme": "THEME_TYPE_DARK"
                                }
                            }
                        },
                        "imageGridCards": {
                            "info": [
                                {
                                    "id": "4561996",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/13/f3f47efa-ba21-4a97-896c-e4ec35ff2c55_PCTileCakesDesserts.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/164261?+Desserts=&collection_id=164261&header_title=Cakes+&tags=layout_NY25_Page1&type=rcv2",
                                        "text": "Valentines day",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for valentines day",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=164261&tags=layout_NY25_Page1&header_title=Cakes%20&%20Desserts",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "750591",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Biryani.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                                        "text": "Biryani",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for biryani",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83639&tags=layout_CCS_Biryani&search_context=biryani",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "750579",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Pizzas.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                                        "text": "Pizzas",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for pizza",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83631&tags=layout_CCS_Pizza&search_context=pizza",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "750589",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_burger.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                                        "text": "Burgers",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for burger",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "749868",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_cake.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
                                        "text": "Cakes",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for cake",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83655&tags=layout_CCS_Cake",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "750222",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/17/58760e8e-324f-479e-88fa-31800120ea38_Rolls1.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
                                        "text": "Rolls",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for roll",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83669&tags=layout_CCS_Rolls",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "749768",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Momos.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
                                        "text": "Momos",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for momos",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=80461&tags=layout_CCS_Momos",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "750587",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/1/24/897bc750-6b57-4e7d-9365-87c1ab2c6d7e_Chinese2.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83636?collection_id=83636&tags=layout_CCS_Chinese&type=rcv2",
                                        "text": "Chinese",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for chinese",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83636&tags=layout_CCS_Chinese",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "750585",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Salad-1.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83634?collection_id=83634&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                                        "text": "South Indian",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for south indian",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83634&tags=layout_CCS_SouthIndian&search_context=southindian",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "750228",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/f1263395-5d4a-4775-95dc-80ab6f3bbd89_samosa.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80396?collection_id=80396&tags=layout_BAU_Contextual%2Csamosa&type=rcv2",
                                        "text": "Samosa",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for samosa",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "80396",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "750248",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/f1263395-5d4a-4775-95dc-80ab6f3bbd89_shawarma.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80402?collection_id=80402&tags=layout_Shawarma_Contextual&type=rcv2",
                                        "text": "Shawarma",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for shawarma",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=80402&tags=layout_Shawarma_Contextual",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "745861",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Shake.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/83673?collection_id=83673&tags=layout_CCS_Shakes&type=rcv2",
                                        "text": "Shake",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for shakes",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=83673&tags=layout_CCS_Shakes",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "750206",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/f1263395-5d4a-4775-95dc-80ab6f3bbd89_pasta.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80479?collection_id=80479&search_context=pasta&tags=layout_CCS_Pasta&type=rcv2",
                                        "text": "Pasta",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for pasta",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=80479&tags=layout_CCS_Pasta&search_context=pasta",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "750131",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Dosa.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
                                        "text": "Dosa",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for dosa",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=80424&tags=layout_CCS_Dosa",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "750216",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Pav Bhaji.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80362?collection_id=80362&tags=layout_PavBhaji_Contextual&type=rcv2",
                                        "text": "Pav Bhaji",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for pav bhaji",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=80362&tags=layout_PavBhaji_Contextual",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "750079",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_cutlet.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80414?collection_id=80414&tags=layout_BAU_Contextual%2Ccutlet&type=rcv2",
                                        "text": "Cutlet",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for cutlet",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "80414",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "749772",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Noodles.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80463?collection_id=80463&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2",
                                        "text": "Noodles",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for noodles",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "80463",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "750571",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Pure Veg.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80435?collection_id=80435&tags=layout_CCS_PureVeg&type=rcv2",
                                        "text": "Pure Veg",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurants curated for veg",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=80435&tags=layout_CCS_PureVeg",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "750225",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/1/24/186ebf5c-d9ad-4d2b-a2b0-77795e19241f_Salad2.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80394?collection_id=80394&tags=layout_CCS_Salad&type=rcv2",
                                        "text": "Salad",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for salad",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "swiggy://collectionV2?collection_id=80394&tags=layout_CCS_Salad",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                },
                                {
                                    "id": "750204",
                                    "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Parotta.png",
                                    "action": {
                                        "link": "https://www.swiggy.com/collections/80477?collection_id=80477&tags=layout_BAU_Contextual%2Cparotta&type=rcv2",
                                        "text": "Parotta",
                                        "type": "WEBLINK"
                                    },
                                    "entityType": "BANNER",
                                    "accessibility": {
                                        "altText": "restaurant curated for parotta",
                                        "altTextCta": "open"
                                    },
                                    "entityId": "80477",
                                    "frequencyCapping": {},
                                    "externalMarketing": {}
                                }
                            ],
                            "style": {
                                "width": {
                                    "type": "TYPE_RELATIVE",
                                    "value": 0.2941,
                                    "reference": "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                                },
                                "height": {
                                    "type": "TYPE_RELATIVE",
                                    "value": 1.2444,
                                    "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                                }
                            }
                        },
                        "id": "whats_on_your_mind",
                        "gridElements": {
                            "infoWithStyle": {
                                "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.ImageInfoLayoutCard",
                                "info": [
                                    {
                                        "id": "4561996",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/2/13/f3f47efa-ba21-4a97-896c-e4ec35ff2c55_PCTileCakesDesserts.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/164261?+Desserts=&collection_id=164261&header_title=Cakes+&tags=layout_NY25_Page1&type=rcv2",
                                            "text": "Valentines day",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for valentines day",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=164261&tags=layout_NY25_Page1&header_title=Cakes%20&%20Desserts",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "750591",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Biryani.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                                            "text": "Biryani",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for biryani",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83639&tags=layout_CCS_Biryani&search_context=biryani",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "750579",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Pizzas.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                                            "text": "Pizzas",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for pizza",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83631&tags=layout_CCS_Pizza&search_context=pizza",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "750589",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_burger.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                                            "text": "Burgers",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for burger",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "749868",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_cake.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
                                            "text": "Cakes",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for cake",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83655&tags=layout_CCS_Cake",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "750222",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/17/58760e8e-324f-479e-88fa-31800120ea38_Rolls1.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
                                            "text": "Rolls",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for roll",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83669&tags=layout_CCS_Rolls",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "749768",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Momos.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
                                            "text": "Momos",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for momos",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=80461&tags=layout_CCS_Momos",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "750587",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/1/24/897bc750-6b57-4e7d-9365-87c1ab2c6d7e_Chinese2.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83636?collection_id=83636&tags=layout_CCS_Chinese&type=rcv2",
                                            "text": "Chinese",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for chinese",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83636&tags=layout_CCS_Chinese",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "750585",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Salad-1.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83634?collection_id=83634&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                                            "text": "South Indian",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for south indian",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83634&tags=layout_CCS_SouthIndian&search_context=southindian",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "750228",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/f1263395-5d4a-4775-95dc-80ab6f3bbd89_samosa.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80396?collection_id=80396&tags=layout_BAU_Contextual%2Csamosa&type=rcv2",
                                            "text": "Samosa",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for samosa",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "80396",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "750248",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/f1263395-5d4a-4775-95dc-80ab6f3bbd89_shawarma.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80402?collection_id=80402&tags=layout_Shawarma_Contextual&type=rcv2",
                                            "text": "Shawarma",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for shawarma",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=80402&tags=layout_Shawarma_Contextual",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "745861",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Shake.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/83673?collection_id=83673&tags=layout_CCS_Shakes&type=rcv2",
                                            "text": "Shake",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for shakes",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=83673&tags=layout_CCS_Shakes",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "750206",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/f1263395-5d4a-4775-95dc-80ab6f3bbd89_pasta.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80479?collection_id=80479&search_context=pasta&tags=layout_CCS_Pasta&type=rcv2",
                                            "text": "Pasta",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for pasta",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=80479&tags=layout_CCS_Pasta&search_context=pasta",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "750131",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Dosa.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
                                            "text": "Dosa",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for dosa",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=80424&tags=layout_CCS_Dosa",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "750216",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Pav Bhaji.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80362?collection_id=80362&tags=layout_PavBhaji_Contextual&type=rcv2",
                                            "text": "Pav Bhaji",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for pav bhaji",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=80362&tags=layout_PavBhaji_Contextual",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "750079",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_cutlet.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80414?collection_id=80414&tags=layout_BAU_Contextual%2Ccutlet&type=rcv2",
                                            "text": "Cutlet",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for cutlet",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "80414",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "749772",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/6ef07bda-b707-48ea-9b14-2594071593d1_Noodles.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80463?collection_id=80463&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2",
                                            "text": "Noodles",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for noodles",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "80463",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "750571",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Pure Veg.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80435?collection_id=80435&tags=layout_CCS_PureVeg&type=rcv2",
                                            "text": "Pure Veg",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurants curated for veg",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=80435&tags=layout_CCS_PureVeg",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "750225",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2025/1/24/186ebf5c-d9ad-4d2b-a2b0-77795e19241f_Salad2.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80394?collection_id=80394&tags=layout_CCS_Salad&type=rcv2",
                                            "text": "Salad",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for salad",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "swiggy://collectionV2?collection_id=80394&tags=layout_CCS_Salad",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    },
                                    {
                                        "id": "750204",
                                        "imageId": "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/7/2/8f508de7-e0ac-4ba8-b54d-def9db98959e_Parotta.png",
                                        "action": {
                                            "link": "https://www.swiggy.com/collections/80477?collection_id=80477&tags=layout_BAU_Contextual%2Cparotta&type=rcv2",
                                            "text": "Parotta",
                                            "type": "WEBLINK"
                                        },
                                        "entityType": "BANNER",
                                        "accessibility": {
                                            "altText": "restaurant curated for parotta",
                                            "altTextCta": "open"
                                        },
                                        "entityId": "80477",
                                        "frequencyCapping": {},
                                        "externalMarketing": {}
                                    }
                                ],
                                "style": {
                                    "width": {
                                        "type": "TYPE_RELATIVE",
                                        "value": 0.2941,
                                        "reference": "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                                    },
                                    "height": {
                                        "type": "TYPE_RELATIVE",
                                        "value": 1.2444,
                                        "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                                    }
                                }
                            }
                        }
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        "header": {
                            "title": "Top restaurant chains in Bangalore",
                            "action": {},
                            "headerStyling": {
                                "padding": {
                                    "left": 16,
                                    "top": 28,
                                    "bottom": 18
                                }
                            }
                        },
                        "layout": {
                            "rows": 1,
                            "columns": 20,
                            "horizontalScrollEnabled": true,
                            "itemSpacing": 32,
                            "widgetPadding": {},
                            "containerStyle": {
                                "containerPadding": {
                                    "left": 16,
                                    "right": 12,
                                    "bottom": 12
                                }
                            },
                            "scrollBar": {
                                "scrollThumbColor": "#E46D47",
                                "scrollTrackColor": "#02060C",
                                "width": 54,
                                "height": 4,
                                "scrollStyling": {
                                    "padding": {
                                        "top": 6,
                                        "bottom": 24
                                    }
                                }
                            },
                            "widgetTheme": {
                                "defaultMode": {
                                    "backgroundColour": "#1B3028",
                                    "theme": "THEME_TYPE_DARK"
                                },
                                "darkMode": {
                                    "backgroundColour": "#1B3028",
                                    "theme": "THEME_TYPE_DARK"
                                }
                            }
                        },
                        "id": "top_brands_for_you",
                        "gridElements": {
                            "infoWithStyle": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                                "restaurants": [
                                    {
                                        "info": {
                                            "id": "10575",
                                            "name": "Pizza Hut",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/7/16/5b9c53df-e0cb-48fc-ac31-f02735592edc_10575.jpg",
                                            "locality": "Richmond Town",
                                            "areaName": "Central Bangalore",
                                            "costForTwo": "\u20B9600 for two",
                                            "cuisines": [
                                                "Pizzas"
                                            ],
                                            "avgRating": 4.3,
                                            "parentId": "721",
                                            "avgRatingString": "4.3",
                                            "totalRatingsString": "10K+",
                                            "sla": {
                                                "deliveryTime": 35,
                                                "lastMileTravel": 2.7,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "2.7 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-15 03:00:00",
                                                "opened": true
                                            },
                                            "badges": {},
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "50% OFF",
                                                "subHeader": "UPTO \u20B9100"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.1",
                                                    "ratingCount": "1.8K+"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/pizza-hut-richmond-town-central-bangalore-rest10575",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "5938",
                                            "name": "Burger King",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/11/7f76a072-c1bc-4d74-ac56-33e0eea20c1e_5938.JPG",
                                            "locality": "Tasker Town",
                                            "areaName": "Shivaji Nagar",
                                            "costForTwo": "\u20B9350 for two",
                                            "cuisines": [
                                                "Burgers",
                                                "American"
                                            ],
                                            "avgRating": 4.4,
                                            "parentId": "166",
                                            "avgRatingString": "4.4",
                                            "totalRatingsString": "38K+",
                                            "sla": {
                                                "deliveryTime": 37,
                                                "lastMileTravel": 2.7,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "35-40 mins",
                                                "lastMileTravelString": "2.7 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-15 03:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Burger.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Burger.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "60% OFF",
                                                "subHeader": "UPTO \u20B9120"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "--"
                                                }
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/burger-king-tasker-town-shivaji-nagar-rest5938",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "69274",
                                            "name": "Chai Point",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/22/5ee468dd-aeb5-4779-84e8-be4f9fcdb5db_69274.jpg",
                                            "locality": "Ashok Nagar",
                                            "areaName": "Ashok Nagar",
                                            "costForTwo": "\u20B9150 for two",
                                            "cuisines": [
                                                "Bakery",
                                                "Beverages",
                                                "Maharashtrian",
                                                "Snacks",
                                                "Street Food",
                                                "South Indian",
                                                "Punjabi",
                                                "Chaat",
                                                "Indian",
                                                "American"
                                            ],
                                            "avgRating": 4.5,
                                            "parentId": "1607",
                                            "avgRatingString": "4.5",
                                            "totalRatingsString": "9.7K+",
                                            "sla": {
                                                "deliveryTime": 39,
                                                "lastMileTravel": 1.8,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "35-40 mins",
                                                "lastMileTravelString": "1.8 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 23:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Cafe%20&%20Chai.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Cafe%20&%20Chai.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "50% OFF",
                                                "subHeader": "UPTO \u20B9100"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.1",
                                                    "ratingCount": "1.5K+"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/chai-point-ashok-nagar-rest69274",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "396750",
                                            "name": "The Biryani Life",
                                            "cloudinaryImageId": "wvjsuvqrd6ahqqyhmnrt",
                                            "locality": "Residency Road",
                                            "areaName": "Central Bangalore",
                                            "costForTwo": "\u20B9250 for two",
                                            "cuisines": [
                                                "Biryani",
                                                "Mughlai",
                                                "Lucknowi",
                                                "Hyderabadi",
                                                "Kebabs",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            "avgRating": 3.9,
                                            "parentId": "8496",
                                            "avgRatingString": "3.9",
                                            "totalRatingsString": "416",
                                            "sla": {
                                                "deliveryTime": 38,
                                                "lastMileTravel": 2.2,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "35-40 mins",
                                                "lastMileTravelString": "2.2 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 23:59:00",
                                                "opened": true
                                            },
                                            "badges": {},
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "ITEMS",
                                                "subHeader": "AT \u20B949"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "--"
                                                }
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/the-biryani-life-residency-road-central-bangalore-rest396750",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "29673",
                                            "name": "Natural Ice Cream",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/8/ebea52ad-d68c-4387-9548-550081bba290_29673.JPG",
                                            "locality": "St. Marks Road",
                                            "areaName": "Central Bangalore",
                                            "costForTwo": "\u20B9150 for two",
                                            "cuisines": [
                                                "Ice Cream",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.7,
                                            "parentId": "2093",
                                            "avgRatingString": "4.7",
                                            "totalRatingsString": "11K+",
                                            "sla": {
                                                "deliveryTime": 30,
                                                "lastMileTravel": 0.8,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "0.8 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-15 00:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Ice-creams.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Ice-creams.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "20% OFF",
                                                "subHeader": "UPTO \u20B950"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.4",
                                                    "ratingCount": "1.1K+"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/natural-ice-cream-st-marks-road-central-bangalore-rest29673",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "566497",
                                            "name": "Faasos' Signature Wraps & Rolls",
                                            "cloudinaryImageId": "c583ca6ce40b426797a78ae2ac91f2ec",
                                            "locality": "Residency Road",
                                            "areaName": "Central Bangalore",
                                            "costForTwo": "\u20B9350 for two",
                                            "cuisines": [
                                                "Fast Food",
                                                "Snacks",
                                                "North Indian",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            "avgRating": 4.1,
                                            "parentId": "340366",
                                            "avgRatingString": "4.1",
                                            "totalRatingsString": "51",
                                            "sla": {
                                                "deliveryTime": 45,
                                                "lastMileTravel": 2.2,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "45-50 mins",
                                                "lastMileTravelString": "2.2 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 23:59:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "guiltfree/GF_Logo_android_3x",
                                                        "shortDescription": "options available",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                                                    "shortDescription": "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "ITEMS",
                                                "subHeader": "AT \u20B963",
                                                "discountCalloutInfo": {
                                                    "message": "Free Delivery",
                                                    "logoCtx": {
                                                        "logo": "v1655895371/free_delivery_logo_hqipbo.png"
                                                    }
                                                }
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "--"
                                                }
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/faasos-signature-wraps-and-rolls-residency-road-central-bangalore-rest566497",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "43836",
                                            "name": "McDonald's",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/9/18/5e7991d9-6a0d-4034-82a9-59bd2bbdc0b3_43836.jpg",
                                            "locality": "MG Road",
                                            "areaName": "Ashok Nagar",
                                            "costForTwo": "\u20B9400 for two",
                                            "cuisines": [
                                                "Burgers",
                                                "Beverages",
                                                "Cafe",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.4,
                                            "parentId": "630",
                                            "avgRatingString": "4.4",
                                            "totalRatingsString": "25K+",
                                            "sla": {
                                                "deliveryTime": 32,
                                                "lastMileTravel": 1.3,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "1.3 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-15 02:45:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Burger.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Burger.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "20% OFF",
                                                "subHeader": "UPTO \u20B950"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "--"
                                                }
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/mcdonalds-mg-road-ashok-nagar-rest43836",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "588619",
                                            "name": "KFC",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/12/9/4398bfb2-6948-484a-9613-2d7628a2457a_588619.JPG",
                                            "locality": "Brigade Road",
                                            "areaName": "Central Bangalore",
                                            "costForTwo": "\u20B9400 for two",
                                            "cuisines": [
                                                "Burgers",
                                                "Fast Food",
                                                "Rolls & Wraps"
                                            ],
                                            "avgRating": 4.5,
                                            "parentId": "547",
                                            "avgRatingString": "4.5",
                                            "totalRatingsString": "2.3K+",
                                            "sla": {
                                                "deliveryTime": 40,
                                                "lastMileTravel": 2.4,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "40-45 mins",
                                                "lastMileTravelString": "2.4 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 23:00:00",
                                                "opened": true
                                            },
                                            "badges": {},
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "ITEMS",
                                                "subHeader": "AT \u20B959"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.0",
                                                    "ratingCount": "353"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/kfc-brigade-road-central-bangalore-rest588619",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "23847",
                                            "name": "Domino's Pizza",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/7/c4e84cd7-081c-4ead-acfb-1794a932b80d_23847.JPG",
                                            "locality": "MG Road",
                                            "areaName": "Brigade Road",
                                            "costForTwo": "\u20B9400 for two",
                                            "cuisines": [
                                                "Pizzas",
                                                "Italian",
                                                "Pastas",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.4,
                                            "parentId": "2456",
                                            "avgRatingString": "4.4",
                                            "totalRatingsString": "5.9K+",
                                            "sla": {
                                                "deliveryTime": 25,
                                                "lastMileTravel": 2.4,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "20-25 mins",
                                                "lastMileTravelString": "2.4 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 22:59:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Pizza.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Pizza.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "ITEMS",
                                                "subHeader": "AT \u20B989"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.0",
                                                    "ratingCount": "4.9K+"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/dominos-pizza-mg-road-brigade-road-rest23847",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "69876",
                                            "name": "Subway",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/21/636cfd42-9fe5-4ce9-8501-d811377da198_69876.JPG",
                                            "locality": "UB City",
                                            "areaName": "Vittal Mallya Road",
                                            "costForTwo": "\u20B9350 for two",
                                            "cuisines": [
                                                "sandwich",
                                                "Salads",
                                                "wrap",
                                                "Healthy Food"
                                            ],
                                            "avgRating": 4.3,
                                            "parentId": "2",
                                            "avgRatingString": "4.3",
                                            "totalRatingsString": "3.7K+",
                                            "sla": {
                                                "deliveryTime": 38,
                                                "lastMileTravel": 0.4,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "35-40 mins",
                                                "lastMileTravelString": "0.4 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 23:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Sandwiches.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Sandwiches.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "ITEMS",
                                                "subHeader": "AT \u20B9119"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "3.8",
                                                    "ratingCount": "282"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/subway-ub-city-vittal-mallya-road-rest69876",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "570511",
                                            "name": "Bakingo",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/6/cc788590-0b0c-4422-afb2-104986968047_570511.jpg",
                                            "locality": "Puhlong X-road",
                                            "areaName": "Vasanth Nagar",
                                            "costForTwo": "\u20B9299 for two",
                                            "cuisines": [
                                                "Bakery",
                                                "Desserts",
                                                "Beverages",
                                                "Snacks"
                                            ],
                                            "avgRating": 4.6,
                                            "parentId": "3818",
                                            "avgRatingString": "4.6",
                                            "totalRatingsString": "4.0K+",
                                            "sla": {
                                                "deliveryTime": 34,
                                                "lastMileTravel": 3.6,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "3.6 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-15 01:00:00",
                                                "opened": true
                                            },
                                            "badges": {},
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "ITEMS",
                                                "subHeader": "AT \u20B989"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "--"
                                                }
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/bakingo-puhlong-x-road-vasanth-nagar-rest570511",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "312660",
                                            "name": "Samosa Party",
                                            "cloudinaryImageId": "ixgxvfu6ggvw1w1awgr1",
                                            "locality": "Brigade Road",
                                            "areaName": "Central Bangalore",
                                            "costForTwo": "\u20B9150 for two",
                                            "cuisines": [
                                                "Fast Food",
                                                "Snacks",
                                                "Beverages",
                                                "Chaat",
                                                "North Indian",
                                                "Street Food",
                                                "Sweets",
                                                "Desserts",
                                                "Punjabi",
                                                "Bakery"
                                            ],
                                            "avgRating": 4.6,
                                            "parentId": "6364",
                                            "avgRatingString": "4.6",
                                            "totalRatingsString": "4.6K+",
                                            "sla": {
                                                "deliveryTime": 31,
                                                "lastMileTravel": 2.3,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "2.3 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 22:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "guiltfree/GF_Logo_android_3x",
                                                        "shortDescription": "options available",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                                                    "shortDescription": "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "60% OFF",
                                                "subHeader": "UPTO \u20B9120"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.2",
                                                    "ratingCount": "31"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/samosa-party-brigade-road-central-bangalore-rest312660",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "435405",
                                            "name": "Chaayos Chai+Snacks=Relax",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/17/dfbcecfc-b380-4648-930a-b9b56b21e781_435405.JPG",
                                            "locality": "Cunningham Road",
                                            "areaName": "Central Bangalore",
                                            "costForTwo": "\u20B9250 for two",
                                            "cuisines": [
                                                "Beverages",
                                                "Chaat",
                                                "Snacks",
                                                "Bakery",
                                                "Street Food",
                                                "healthy",
                                                "Home Food",
                                                "Maharashtrian",
                                                "Italian",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.6,
                                            "parentId": "281782",
                                            "avgRatingString": "4.6",
                                            "totalRatingsString": "2.0K+",
                                            "sla": {
                                                "deliveryTime": 36,
                                                "lastMileTravel": 3,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "35-40 mins",
                                                "lastMileTravelString": "3.0 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-15 00:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Cafe%20&%20Chai.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Cafe%20&%20Chai.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "ITEMS",
                                                "subHeader": "AT \u20B9199"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.1",
                                                    "ratingCount": "376"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/chaayos-chai-snacks-relax-cunningham-road-central-bangalore-rest435405",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "342643",
                                            "name": "The Pizza Bakery - Wood Fired Sourdough",
                                            "cloudinaryImageId": "0335dd45be555d0a4187255e57d2ca88",
                                            "locality": "Church Street",
                                            "areaName": "Central Bangalore",
                                            "costForTwo": "\u20B9700 for two",
                                            "cuisines": [
                                                "Pizzas",
                                                "Pastas",
                                                "Italian",
                                                "Desserts",
                                                "Continental"
                                            ],
                                            "avgRating": 4.6,
                                            "parentId": "522292",
                                            "avgRatingString": "4.6",
                                            "totalRatingsString": "6.0K+",
                                            "sla": {
                                                "deliveryTime": 36,
                                                "lastMileTravel": 1.7,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "35-40 mins",
                                                "lastMileTravelString": "1.7 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 23:30:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Pizza.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Pizza.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "40% OFF",
                                                "subHeader": "UPTO \u20B980"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.3",
                                                    "ratingCount": "2.2K+"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/the-pizza-bakery-wood-fired-sourdough-church-street-central-bangalore-rest342643",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "667962",
                                            "name": "Paris Panini - Gourmet Sandwiches & Wraps",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/10/db53f58f-bbcc-4aab-a16b-8c7c5d0b84a1_667962.jpg",
                                            "locality": "Church Street",
                                            "areaName": "Central Bangalore",
                                            "costForTwo": "\u20B9500 for two",
                                            "cuisines": [
                                                "Continental",
                                                "Pastas",
                                                "Salads",
                                                "Snacks",
                                                "Desserts",
                                                "Fast Food",
                                                "French"
                                            ],
                                            "avgRating": 4.7,
                                            "parentId": "21019",
                                            "avgRatingString": "4.7",
                                            "totalRatingsString": "3.6K+",
                                            "sla": {
                                                "deliveryTime": 36,
                                                "lastMileTravel": 1.5,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "35-40 mins",
                                                "lastMileTravelString": "1.5 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 23:30:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Sandwiches.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Sandwiches.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "40% OFF",
                                                "subHeader": "UPTO \u20B980"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.2",
                                                    "ratingCount": "807"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/paris-panini-gourmet-sandwiches-and-wraps-church-street-central-bangalore-rest667962",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "51835",
                                            "name": "Aubree",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/8/2c329e01-b5b9-4909-ba47-87e146df02da_51835.jpg",
                                            "locality": "Shivaji Nagar",
                                            "areaName": "Shivaji Nagar",
                                            "costForTwo": "\u20B9700 for two",
                                            "cuisines": [
                                                "Desserts",
                                                "Bakery"
                                            ],
                                            "avgRating": 4.7,
                                            "parentId": "3807",
                                            "avgRatingString": "4.7",
                                            "totalRatingsString": "2.0K+",
                                            "sla": {
                                                "deliveryTime": 42,
                                                "lastMileTravel": 2.8,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "40-45 mins",
                                                "lastMileTravelString": "2.8 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 21:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "newg.png",
                                                        "description": "Gourmet"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "D",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Gourmet",
                                                                    "imageId": "newg.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "50% OFF",
                                                "subHeader": "UPTO \u20B9100"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.7",
                                                    "ratingCount": "838"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/aubree-shivaji-nagar-rest51835",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "426730",
                                            "name": "Theobroma",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/12/b07377e8-096b-4310-84af-976838c5973f_426730.jpg",
                                            "locality": "Lavelle Road",
                                            "areaName": "Ashok Nagar",
                                            "costForTwo": "\u20B9400 for two",
                                            "cuisines": [
                                                "Desserts",
                                                "Bakery",
                                                "Beverages"
                                            ],
                                            "avgRating": 4.7,
                                            "parentId": "1040",
                                            "avgRatingString": "4.7",
                                            "totalRatingsString": "5.3K+",
                                            "sla": {
                                                "deliveryTime": 26,
                                                "lastMileTravel": 0.3,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "25-30 mins",
                                                "lastMileTravelString": "0.3 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 23:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Desserts.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Desserts.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "ITEMS",
                                                "subHeader": "AT \u20B939"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.1",
                                                    "ratingCount": "427"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/theobroma-lavelle-road-ashok-nagar-rest426730",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "17376",
                                            "name": "Glen's Bakehouse",
                                            "cloudinaryImageId": "m6jahioyu7zrodei5pcq",
                                            "locality": "Lavelle Road",
                                            "areaName": "Ashok Nagar",
                                            "costForTwo": "\u20B9500 for two",
                                            "cuisines": [
                                                "Desserts",
                                                "Bakery",
                                                "Beverages",
                                                "Continental",
                                                "Italian"
                                            ],
                                            "avgRating": 4.7,
                                            "parentId": "3220",
                                            "avgRatingString": "4.7",
                                            "totalRatingsString": "25K+",
                                            "sla": {
                                                "deliveryTime": 32,
                                                "lastMileTravel": 0.4,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "0.4 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 23:59:00",
                                                "opened": true
                                            },
                                            "badges": {},
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "20% OFF",
                                                "subHeader": "UPTO \u20B950"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.4",
                                                    "ratingCount": "10K+"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/glens-bakehouse-lavelle-road-ashok-nagar-rest17376",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "737841",
                                            "name": "Amadora Gourmet Ice Cream",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/18/a0d99957-9f36-43ce-bf8e-01721cbd97af_737841.jpg",
                                            "locality": "u b city",
                                            "areaName": "Vittal Mallaya",
                                            "costForTwo": "\u20B9300 for two",
                                            "cuisines": [
                                                "Ice Cream",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.7,
                                            "parentId": "30800",
                                            "avgRatingString": "4.7",
                                            "totalRatingsString": "608",
                                            "sla": {
                                                "deliveryTime": 30,
                                                "lastMileTravel": 0.4,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "0.4 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-15 01:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "newg.png",
                                                        "description": "Gourmet"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Gourmet",
                                                                    "imageId": "newg.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "20% OFF",
                                                "subHeader": "UPTO \u20B950"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "--"
                                                }
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/amadora-gourmet-ice-cream-u-b-city-vittal-mallaya-rest737841",
                                            "type": "WEBLINK"
                                        }
                                    },
                                    {
                                        "info": {
                                            "id": "622202",
                                            "name": "MOJO Pizza - 2X Toppings",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/12/12/e7ccd786-be92-4743-8e0c-f3d3a577d48f_622202.jpg",
                                            "locality": "Langford Road",
                                            "areaName": "Central Bangalore",
                                            "costForTwo": "\u20B9250 for two",
                                            "cuisines": [
                                                "Pizzas",
                                                "Italian",
                                                "Fast Food",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.6,
                                            "parentId": "11329",
                                            "avgRatingString": "4.6",
                                            "totalRatingsString": "634",
                                            "sla": {
                                                "deliveryTime": 25,
                                                "lastMileTravel": 2.6,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "20-30 mins",
                                                "lastMileTravelString": "2.6 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-15 02:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "guiltfree/GF_Logo_android_3x",
                                                        "shortDescription": "options available",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                                                    "shortDescription": "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "ITEMS",
                                                "subHeader": "AT \u20B9159"
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "--"
                                                }
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/mojo-pizza-2x-toppings-langford-road-central-bangalore-rest622202",
                                            "type": "WEBLINK"
                                        }
                                    }
                                ],
                                "theme": "Restaurant_Group_WebView_SEO_PB_Theme",
                                "widgetType": "WIDGET_TYPE_POPULAR_BRANDS",
                                "style": {
                                    "width": {
                                        "type": "TYPE_RELATIVE",
                                        "value": 0.41111112,
                                        "reference": "RELATIVE_DIMENSION_REFERENCE_DEVICE_WIDTH"
                                    },
                                    "height": {
                                        "type": "TYPE_RELATIVE",
                                        "value": 0.7027027,
                                        "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                                    },
                                    "layoutAlignment": "LAYOUT_ALIGNMENT_LEFT"
                                },
                                "collectionId": "84124"
                            }
                        }
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BasicContent",
                        "title": "Restaurants with online food delivery in Bangalore",
                        "id": "popular_restaurants_title"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.InlineViewFilterSortWidget",
                        "sortConfigs": [
                            {
                                "key": "relevance",
                                "title": "Relevance (Default)",
                                "selected": true,
                                "defaultSelection": true
                            },
                            {
                                "key": "deliveryTimeAsc",
                                "title": "Delivery Time"
                            },
                            {
                                "key": "modelBasedRatingDesc",
                                "title": "Rating"
                            },
                            {
                                "key": "costForTwoAsc",
                                "title": "Cost: Low to High"
                            },
                            {
                                "key": "costForTwoDesc",
                                "title": "Cost: High to Low"
                            }
                        ],
                        "restaurantCount": 1897,
                        "facetList": [
                            {
                                "label": "Delivery Time",
                                "id": "deliveryTime",
                                "selection": "SELECT_TYPE_MULTISELECT",
                                "facetInfo": [
                                    {
                                        "label": "Fast Delivery",
                                        "id": "deliveryTimefacetquery1",
                                        "analytics": {},
                                        "openFilter": true
                                    }
                                ],
                                "viewType": "VIEW_TYPE_HALF_CARD",
                                "subLabel": "Filterby"
                            },
                            {
                                "label": "Cuisines",
                                "id": "catalog_cuisines",
                                "selection": "SELECT_TYPE_MULTISELECT",
                                "facetInfo": [
                                    {
                                        "label": "Afghani",
                                        "id": "query_afghani",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "American",
                                        "id": "query_american",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Andhra",
                                        "id": "query_andhra",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Arabian",
                                        "id": "query_arabian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Asian",
                                        "id": "query_asian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Assamese",
                                        "id": "query_assamese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Awadhi",
                                        "id": "query_awadhi",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Bakery",
                                        "id": "query_bakery",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Barbecue",
                                        "id": "query_barbecue",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Bengali",
                                        "id": "query_bengali",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Beverages",
                                        "id": "query_beverages",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Bihari",
                                        "id": "query_bihari",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Biryani",
                                        "id": "query_biryani",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "British",
                                        "id": "query_british",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Bubble Tea",
                                        "id": "query_bubble_tea",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Buffalo meat",
                                        "id": "query_buffalo_meat",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Burger",
                                        "id": "query_burger",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Burgers",
                                        "id": "query_burgers",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Burmese",
                                        "id": "query_burmese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Cafe",
                                        "id": "query_cafe",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Cakes",
                                        "id": "query_cakes",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Cakes & Pastries",
                                        "id": "query_cakes_&_pastries",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Cakes and Pastries",
                                        "id": "query_cakes_and_pastries",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Chaat",
                                        "id": "query_chaat",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Chettinad",
                                        "id": "query_chettinad",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Chinese",
                                        "id": "query_chinese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Coastal",
                                        "id": "query_coastal",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Coffee",
                                        "id": "query_coffee",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Combo",
                                        "id": "query_combo",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Combos",
                                        "id": "query_combos",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Continental",
                                        "id": "query_continental",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Dessert",
                                        "id": "query_dessert",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Desserts",
                                        "id": "query_desserts",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "European",
                                        "id": "query_european",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Fast Food",
                                        "id": "query_fast_food",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "French",
                                        "id": "query_french",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Goan",
                                        "id": "query_goan",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Greek",
                                        "id": "query_greek",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Grill",
                                        "id": "query_grill",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Gujarati",
                                        "id": "query_gujarati",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Haleem",
                                        "id": "query_haleem",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Healthy",
                                        "id": "query_healthy",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Healthy Food",
                                        "id": "query_healthy_food",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Home Food",
                                        "id": "query_home_food",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Hyderabadi",
                                        "id": "query_hyderabadi",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Ice Cream",
                                        "id": "query_ice_cream",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Ice Cream Cakes",
                                        "id": "query_ice_cream_cakes",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Indian",
                                        "id": "query_indian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Indonesian",
                                        "id": "query_indonesian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Italian",
                                        "id": "query_italian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Italian-American",
                                        "id": "query_italian-american",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Jain",
                                        "id": "query_jain",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Japanese",
                                        "id": "query_japanese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Juice and shake",
                                        "id": "query_juice_and_shake",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Juices",
                                        "id": "query_juices",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Kashmiri",
                                        "id": "query_kashmiri",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Kebabs",
                                        "id": "query_kebabs",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Kerala",
                                        "id": "query_kerala",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Keto",
                                        "id": "query_keto",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Korean",
                                        "id": "query_korean",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Lebanese",
                                        "id": "query_lebanese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Lucknowi",
                                        "id": "query_lucknowi",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Maharashtrian",
                                        "id": "query_maharashtrian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Malaysian",
                                        "id": "query_malaysian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Mangalorean",
                                        "id": "query_mangalorean",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Meat",
                                        "id": "query_meat",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Mediterranean",
                                        "id": "query_mediterranean",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Mexican",
                                        "id": "query_mexican",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Middle Eastern",
                                        "id": "query_middle_eastern",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Momos",
                                        "id": "query_momos",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Mughlai",
                                        "id": "query_mughlai",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Naga",
                                        "id": "query_naga",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Navratri Special",
                                        "id": "query_navratri_special",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Nepalese",
                                        "id": "query_nepalese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "North Eastern",
                                        "id": "query_north_eastern",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "North Indian",
                                        "id": "query_north_indian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Oriental",
                                        "id": "query_oriental",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Paan",
                                        "id": "query_paan",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Pan-Asian",
                                        "id": "query_pan-asian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Parsi",
                                        "id": "query_parsi",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Pastas",
                                        "id": "query_pastas",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Persian",
                                        "id": "query_persian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Pizzas",
                                        "id": "query_pizzas",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Portuguese",
                                        "id": "query_portuguese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Punjabi",
                                        "id": "query_punjabi",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Rajasthani",
                                        "id": "query_rajasthani",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Rolls",
                                        "id": "query_rolls",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Rolls & Wraps",
                                        "id": "query_rolls_&_wraps",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Salads",
                                        "id": "query_salads",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Seafood",
                                        "id": "query_seafood",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Shawarma",
                                        "id": "query_shawarma",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Sindhi",
                                        "id": "query_sindhi",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Singaporean",
                                        "id": "query_singaporean",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Snacks",
                                        "id": "query_snacks",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "South American",
                                        "id": "query_south_american",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "South Indian",
                                        "id": "query_south_indian",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Sri Lankan",
                                        "id": "query_sri_lankan",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Steakhouse",
                                        "id": "query_steakhouse",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Street Food",
                                        "id": "query_street_food",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Sushi",
                                        "id": "query_sushi",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Sweets",
                                        "id": "query_sweets",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Tandoor",
                                        "id": "query_tandoor",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Tandoori",
                                        "id": "query_tandoori",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Tea",
                                        "id": "query_tea",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Tex-Mex",
                                        "id": "query_tex-mex",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Thai",
                                        "id": "query_thai",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Thali",
                                        "id": "query_thali",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Thalis",
                                        "id": "query_thalis",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Tibetan",
                                        "id": "query_tibetan",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Tribal",
                                        "id": "query_tribal",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Turkish",
                                        "id": "query_turkish",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Vietnamese",
                                        "id": "query_vietnamese",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Waffle",
                                        "id": "query_waffle",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "briyani",
                                        "id": "query_briyani",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "dessert",
                                        "id": "query_dessert",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "fastfood",
                                        "id": "query_fastfood",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "healthy",
                                        "id": "query_healthy",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "jar cakes",
                                        "id": "query_jar_cakes",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "juice",
                                        "id": "query_juice",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "pav bhaji",
                                        "id": "query_pav_bhaji",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "pizza",
                                        "id": "query_pizza",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "pure veg",
                                        "id": "query_pure_veg",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "rolls",
                                        "id": "query_rolls",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "sandwich",
                                        "id": "query_sandwich",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "shawarma",
                                        "id": "query_shawarma",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "snack",
                                        "id": "query_snack",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "veg restaurant",
                                        "id": "query_veg_restaurant",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "wrap",
                                        "id": "query_wrap",
                                        "analytics": {},
                                        "openFilter": true
                                    }
                                ],
                                "viewType": "VIEW_TYPE_HALF_CARD",
                                "canSearch": true,
                                "subLabel": "Filterbycuisine",
                                "openFilter": true
                            },
                            {
                                "label": "Explore",
                                "id": "explore",
                                "selection": "SELECT_TYPE_MULTISELECT",
                                "facetInfo": [
                                    {
                                        "label": "New on Swiggy",
                                        "id": "newfacetquery1",
                                        "analytics": {},
                                        "openFilter": true
                                    }
                                ],
                                "viewType": "VIEW_TYPE_HALF_CARD"
                            },
                            {
                                "label": "Ratings",
                                "id": "rating",
                                "selection": "SELECT_TYPE_MULTISELECT",
                                "facetInfo": [
                                    {
                                        "label": "Ratings 4.5+",
                                        "id": "ratingfacetquery3",
                                        "analytics": {}
                                    },
                                    {
                                        "label": "Ratings 4.0+",
                                        "id": "ratingfacetquery4",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Ratings 3.5+",
                                        "id": "ratingfacetquery5",
                                        "analytics": {}
                                    }
                                ],
                                "viewType": "VIEW_TYPE_HALF_CARD",
                                "subLabel": "Filterby"
                            },
                            {
                                "label": "Veg/Non-Veg",
                                "id": "isVeg",
                                "selection": "SELECT_TYPE_SINGLESELECT",
                                "facetInfo": [
                                    {
                                        "label": "Pure Veg",
                                        "id": "isVegfacetquery2",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Non Veg",
                                        "id": "isVegfacetquery3",
                                        "analytics": {}
                                    }
                                ],
                                "viewType": "VIEW_TYPE_FLATTENED",
                                "subLabel": "Filterby"
                            },
                            {
                                "label": "Offers",
                                "id": "restaurantOfferMultiTd",
                                "selection": "SELECT_TYPE_SINGLESELECT",
                                "facetInfo": [
                                    {
                                        "label": "Offers",
                                        "id": "restaurantOfferMultiTdfacetquery3",
                                        "analytics": {},
                                        "openFilter": true
                                    }
                                ],
                                "viewType": "VIEW_TYPE_FLATTENED",
                                "subLabel": "Restaurantswith"
                            },
                            {
                                "label": "Cost for two",
                                "id": "costForTwo",
                                "selection": "SELECT_TYPE_MULTISELECT",
                                "facetInfo": [
                                    {
                                        "label": "Rs. 300-Rs. 600",
                                        "id": "costForTwofacetquery3",
                                        "analytics": {},
                                        "openFilter": true
                                    },
                                    {
                                        "label": "Greater than Rs. 600",
                                        "id": "costForTwofacetquery4",
                                        "analytics": {}
                                    },
                                    {
                                        "label": "Less than Rs. 300",
                                        "id": "costForTwofacetquery5",
                                        "analytics": {},
                                        "openFilter": true
                                    }
                                ],
                                "viewType": "VIEW_TYPE_HALF_CARD",
                                "subLabel": "Filterby"
                            }
                        ]
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
                        "layout": {
                            "columns": 4
                        },
                        "id": "restaurant_grid_listing",
                        "gridElements": {
                            "infoWithStyle": {
                                "@type": "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                                "restaurants": [
                                    {
                                        "info": {
                                            "id": "10575",
                                            "name": "Pizza Hut",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/7/16/5b9c53df-e0cb-48fc-ac31-f02735592edc_10575.jpg",
                                            "locality": "Richmond Town",
                                            "areaName": "Central Bangalore",
                                            "costForTwo": "\u20B9600 for two",
                                            "cuisines": [
                                                "Pizzas"
                                            ],
                                            "avgRating": 4.3,
                                            "parentId": "721",
                                            "avgRatingString": "4.3",
                                            "totalRatingsString": "10K+",
                                            "sla": {
                                                "deliveryTime": 35,
                                                "lastMileTravel": 2.7,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "2.7 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-15 03:00:00",
                                                "opened": true
                                            },
                                            "badges": {},
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "50% OFF",
                                                "subHeader": "UPTO \u20B9100"
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.1",
                                                    "ratingCount": "1.8K+"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/pizza-hut-richmond-town-central-bangalore-rest10575",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        "info": {
                                            "id": "405798",
                                            "name": "Chinese Wok",
                                            "cloudinaryImageId": "e0839ff574213e6f35b3899ebf1fc597",
                                            "locality": "Malleshwaram",
                                            "areaName": "Malleshwaram",
                                            "costForTwo": "\u20B9250 for two",
                                            "cuisines": [
                                                "Chinese",
                                                "Asian",
                                                "Tibetan",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.4,
                                            "parentId": "61955",
                                            "avgRatingString": "4.4",
                                            "totalRatingsString": "1.2K+",
                                            "sla": {
                                                "deliveryTime": 57,
                                                "lastMileTravel": 5,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "55-60 mins",
                                                "lastMileTravelString": "5.0 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 22:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Green%20Dot%20Awards/Best%20In%20Veg%20Noodles.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Green%20Dot%20Awards/Best%20In%20Veg%20Noodles.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "ITEMS",
                                                "subHeader": "AT \u20B9129"
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "3.4",
                                                    "ratingCount": "58"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/chinese-wok-malleshwaram-rest405798",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        "info": {
                                            "id": "5938",
                                            "name": "Burger King",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/11/7f76a072-c1bc-4d74-ac56-33e0eea20c1e_5938.JPG",
                                            "locality": "Tasker Town",
                                            "areaName": "Shivaji Nagar",
                                            "costForTwo": "\u20B9350 for two",
                                            "cuisines": [
                                                "Burgers",
                                                "American"
                                            ],
                                            "avgRating": 4.4,
                                            "parentId": "166",
                                            "avgRatingString": "4.4",
                                            "totalRatingsString": "38K+",
                                            "sla": {
                                                "deliveryTime": 37,
                                                "lastMileTravel": 2.7,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "35-40 mins",
                                                "lastMileTravelString": "2.7 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-15 03:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Burger.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Burger.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "60% OFF",
                                                "subHeader": "UPTO \u20B9120"
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "--"
                                                }
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/burger-king-tasker-town-shivaji-nagar-rest5938",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        "info": {
                                            "id": "30034",
                                            "name": "Mani's Dum Biryani",
                                            "cloudinaryImageId": "y0fjz8h4ad8nfzkmbznu",
                                            "locality": "Haudin Road",
                                            "areaName": "Ulsoor",
                                            "costForTwo": "\u20B9499 for two",
                                            "cuisines": [
                                                "Andhra",
                                                "Biryani",
                                                "North Indian"
                                            ],
                                            "avgRating": 4.5,
                                            "parentId": "623",
                                            "avgRatingString": "4.5",
                                            "totalRatingsString": "23K+",
                                            "sla": {
                                                "deliveryTime": 38,
                                                "lastMileTravel": 3.6,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "35-40 mins",
                                                "lastMileTravelString": "3.6 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 23:30:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "guiltfree/GF_Logo_android_3x",
                                                        "shortDescription": "options available",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "aggregatedDiscountInfoV2": {},
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                                                    "shortDescription": "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.2",
                                                    "ratingCount": "1.6K+"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/manis-dum-biryani-haudin-road-ulsoor-rest30034",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        "info": {
                                            "id": "69274",
                                            "name": "Chai Point",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/1/22/5ee468dd-aeb5-4779-84e8-be4f9fcdb5db_69274.jpg",
                                            "locality": "Ashok Nagar",
                                            "areaName": "Ashok Nagar",
                                            "costForTwo": "\u20B9150 for two",
                                            "cuisines": [
                                                "Bakery",
                                                "Beverages",
                                                "Maharashtrian",
                                                "Snacks",
                                                "Street Food",
                                                "South Indian",
                                                "Punjabi",
                                                "Chaat",
                                                "Indian",
                                                "American"
                                            ],
                                            "avgRating": 4.5,
                                            "parentId": "1607",
                                            "avgRatingString": "4.5",
                                            "totalRatingsString": "9.7K+",
                                            "sla": {
                                                "deliveryTime": 39,
                                                "lastMileTravel": 1.8,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "35-40 mins",
                                                "lastMileTravelString": "1.8 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 23:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Cafe%20&%20Chai.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Cafe%20&%20Chai.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "50% OFF",
                                                "subHeader": "UPTO \u20B9100"
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.1",
                                                    "ratingCount": "1.5K+"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/chai-point-ashok-nagar-rest69274",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        "info": {
                                            "id": "396750",
                                            "name": "The Biryani Life",
                                            "cloudinaryImageId": "wvjsuvqrd6ahqqyhmnrt",
                                            "locality": "Residency Road",
                                            "areaName": "Central Bangalore",
                                            "costForTwo": "\u20B9250 for two",
                                            "cuisines": [
                                                "Biryani",
                                                "Mughlai",
                                                "Lucknowi",
                                                "Hyderabadi",
                                                "Kebabs",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            "avgRating": 3.9,
                                            "parentId": "8496",
                                            "avgRatingString": "3.9",
                                            "totalRatingsString": "416",
                                            "sla": {
                                                "deliveryTime": 38,
                                                "lastMileTravel": 2.2,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "35-40 mins",
                                                "lastMileTravelString": "2.2 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 23:59:00",
                                                "opened": true
                                            },
                                            "badges": {},
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "ITEMS",
                                                "subHeader": "AT \u20B949"
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "--"
                                                }
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/the-biryani-life-residency-road-central-bangalore-rest396750",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        "info": {
                                            "id": "29673",
                                            "name": "Natural Ice Cream",
                                            "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/8/ebea52ad-d68c-4387-9548-550081bba290_29673.JPG",
                                            "locality": "St. Marks Road",
                                            "areaName": "Central Bangalore",
                                            "costForTwo": "\u20B9150 for two",
                                            "cuisines": [
                                                "Ice Cream",
                                                "Desserts"
                                            ],
                                            "avgRating": 4.7,
                                            "parentId": "2093",
                                            "avgRatingString": "4.7",
                                            "totalRatingsString": "11K+",
                                            "sla": {
                                                "deliveryTime": 30,
                                                "lastMileTravel": 0.8,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "30-35 mins",
                                                "lastMileTravelString": "0.8 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-15 00:00:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "imageBadges": [
                                                    {
                                                        "imageId": "Rxawards/_CATEGORY-Ice-creams.png",
                                                        "description": "Delivery!"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "Delivery!",
                                                                    "imageId": "Rxawards/_CATEGORY-Ice-creams.png"
                                                                }
                                                            }
                                                        ]
                                                    },
                                                    "textBased": {},
                                                    "textExtendedBadges": {}
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "20% OFF",
                                                "subHeader": "UPTO \u20B950"
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "4.4",
                                                    "ratingCount": "1.1K+"
                                                },
                                                "source": "GOOGLE",
                                                "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/natural-ice-cream-st-marks-road-central-bangalore-rest29673",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    },
                                    {
                                        "info": {
                                            "id": "566497",
                                            "name": "Faasos' Signature Wraps & Rolls",
                                            "cloudinaryImageId": "c583ca6ce40b426797a78ae2ac91f2ec",
                                            "locality": "Residency Road",
                                            "areaName": "Central Bangalore",
                                            "costForTwo": "\u20B9350 for two",
                                            "cuisines": [
                                                "Fast Food",
                                                "Snacks",
                                                "North Indian",
                                                "Desserts",
                                                "Beverages"
                                            ],
                                            "avgRating": 4.1,
                                            "parentId": "340366",
                                            "avgRatingString": "4.1",
                                            "totalRatingsString": "51",
                                            "sla": {
                                                "deliveryTime": 45,
                                                "lastMileTravel": 2.2,
                                                "serviceability": "SERVICEABLE",
                                                "slaString": "45-50 mins",
                                                "lastMileTravelString": "2.2 km",
                                                "iconType": "ICON_TYPE_EMPTY"
                                            },
                                            "availability": {
                                                "nextCloseTime": "2025-02-14 23:59:00",
                                                "opened": true
                                            },
                                            "badges": {
                                                "textExtendedBadges": [
                                                    {
                                                        "iconId": "guiltfree/GF_Logo_android_3x",
                                                        "shortDescription": "options available",
                                                        "fontColor": "#7E808C"
                                                    }
                                                ]
                                            },
                                            "isOpen": true,
                                            "type": "F",
                                            "badgesV2": {
                                                "entityBadges": {
                                                    "imageBased": {},
                                                    "textBased": {},
                                                    "textExtendedBadges": {
                                                        "badgeObject": [
                                                            {
                                                                "attributes": {
                                                                    "description": "",
                                                                    "fontColor": "#7E808C",
                                                                    "iconId": "guiltfree/GF_Logo_android_3x",
                                                                    "shortDescription": "options available"
                                                                }
                                                            }
                                                        ]
                                                    }
                                                }
                                            },
                                            "aggregatedDiscountInfoV3": {
                                                "header": "ITEMS",
                                                "subHeader": "AT \u20B963",
                                                "discountCalloutInfo": {
                                                    "message": "Free Delivery",
                                                    "logoCtx": {
                                                        "logo": "v1655895371/free_delivery_logo_hqipbo.png"
                                                    }
                                                }
                                            },
                                            "orderabilityCommunication": {
                                                "title": {},
                                                "subTitle": {},
                                                "message": {},
                                                "customIcon": {}
                                            },
                                            "differentiatedUi": {
                                                "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                                                "differentiatedUiMediaDetails": {
                                                    "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                                                    "lottie": {},
                                                    "video": {}
                                                }
                                            },
                                            "reviewsSummary": {},
                                            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                                            "restaurantOfferPresentationInfo": {},
                                            "externalRatings": {
                                                "aggregatedRating": {
                                                    "rating": "--"
                                                }
                                            },
                                            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
                                        },
                                        "analytics": {
                                            "context": "seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9"
                                        },
                                        "cta": {
                                            "link": "https://www.swiggy.com/city/bangalore/faasos-signature-wraps-and-rolls-residency-road-central-bangalore-rest566497",
                                            "text": "RESTAURANT_MENU",
                                            "type": "WEBLINK"
                                        },
                                        "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                                    }
                                ],
                                "theme": "SeoRestaurantListingGridWidget"
                            }
                        }
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.ShowMoreButton",
                        "message": "Show More",
                        "id": "show_more_button"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
                        "title": "Best Places to Eat Across Cities",
                        "brands": [
                            {
                                "text": "Best Restaurants in Bangalore",
                                "link": "https://www.swiggy.com/city/bangalore/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Pune",
                                "link": "https://www.swiggy.com/city/pune/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Mumbai",
                                "link": "https://www.swiggy.com/city/mumbai/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Delhi",
                                "link": "https://www.swiggy.com/city/delhi/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Hyderabad",
                                "link": "https://www.swiggy.com/city/hyderabad/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Kolkata",
                                "link": "https://www.swiggy.com/city/kolkata/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Chennai",
                                "link": "https://www.swiggy.com/city/chennai/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Chandigarh",
                                "link": "https://www.swiggy.com/city/chandigarh/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Ahmedabad",
                                "link": "https://www.swiggy.com/city/ahmedabad/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Jaipur",
                                "link": "https://www.swiggy.com/city/jaipur/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Nagpur",
                                "link": "https://www.swiggy.com/city/nagpur/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Bhubaneswar",
                                "link": "https://www.swiggy.com/city/bhubaneswar/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Kochi",
                                "link": "https://www.swiggy.com/city/kochi/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Surat",
                                "link": "https://www.swiggy.com/city/surat/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Dehradun",
                                "link": "https://www.swiggy.com/city/dehradun/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Ludhiana",
                                "link": "https://www.swiggy.com/city/ludhiana/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Patna",
                                "link": "https://www.swiggy.com/city/patna/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Mangaluru",
                                "link": "https://www.swiggy.com/city/mangaluru/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Bhopal",
                                "link": "https://www.swiggy.com/city/bhopal/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Gurgaon",
                                "link": "https://www.swiggy.com/city/gurgaon/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Coimbatore",
                                "link": "https://www.swiggy.com/city/coimbatore/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Agra",
                                "link": "https://www.swiggy.com/city/agra/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Noida",
                                "link": "https://www.swiggy.com/city/noida/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Vijayawada",
                                "link": "https://www.swiggy.com/city/vijayawada/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Guwahati",
                                "link": "https://www.swiggy.com/city/guwahati/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Mysore",
                                "link": "https://www.swiggy.com/city/mysore/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Pondicherry",
                                "link": "https://www.swiggy.com/city/pondicherry/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Thiruvananthapuram",
                                "link": "https://www.swiggy.com/city/thiruvananthapuram/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Ranchi",
                                "link": "https://www.swiggy.com/city/ranchi/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Vizag",
                                "link": "https://www.swiggy.com/city/vizag/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Udaipur",
                                "link": "https://www.swiggy.com/city/udaipur/best-restaurants"
                            },
                            {
                                "text": "Best Restaurants in Vadodara",
                                "link": "https://www.swiggy.com/city/vadodara/best-restaurants"
                            }
                        ],
                        "id": "restaurant_near_me_links"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
                        "title": "Best Cuisines Near Me",
                        "brands": [
                            {
                                "text": "Chinese Restaurant Near Me",
                                "link": "https://www.swiggy.com/chinese-restaurants-near-me"
                            },
                            {
                                "text": "South Indian Restaurant Near Me",
                                "link": "https://www.swiggy.com/south-indian-restaurants-near-me"
                            },
                            {
                                "text": "Indian Restaurant Near Me",
                                "link": "https://www.swiggy.com/indian-restaurants-near-me"
                            },
                            {
                                "text": "Kerala Restaurant Near Me",
                                "link": "https://www.swiggy.com/kerala-restaurants-near-me"
                            },
                            {
                                "text": "Korean Restaurant Near Me",
                                "link": "https://www.swiggy.com/korean-restaurants-near-me"
                            },
                            {
                                "text": "North Indian Restaurant Near Me",
                                "link": "https://www.swiggy.com/north-indian-restaurants-near-me"
                            },
                            {
                                "text": "Seafood Restaurant Near Me",
                                "link": "https://www.swiggy.com/seafood-restaurants-near-me"
                            },
                            {
                                "text": "Bengali Restaurant Near Me",
                                "link": "https://www.swiggy.com/bengali-restaurants-near-me"
                            },
                            {
                                "text": "Punjabi Restaurant Near Me",
                                "link": "https://www.swiggy.com/punjabi-restaurants-near-me"
                            },
                            {
                                "text": "Italian Restaurant Near Me",
                                "link": "https://www.swiggy.com/italian-restaurants-near-me"
                            },
                            {
                                "text": "Andhra Restaurant Near Me",
                                "link": "https://www.swiggy.com/andhra-restaurants-near-me"
                            },
                            {
                                "text": "Biryani Restaurant Near Me",
                                "link": "https://www.swiggy.com/biryani-restaurants-near-me"
                            },
                            {
                                "text": "Japanese Restaurant Near Me",
                                "link": "https://www.swiggy.com/japanese-restaurants-near-me"
                            },
                            {
                                "text": "Arabian Restaurant Near Me",
                                "link": "https://www.swiggy.com/arabian-restaurants-near-me"
                            },
                            {
                                "text": "Fast Food Restaurant Near Me",
                                "link": "https://www.swiggy.com/fast-food-restaurants-near-me"
                            },
                            {
                                "text": "Jain Restaurant Near Me",
                                "link": "https://www.swiggy.com/jain-restaurants-near-me"
                            },
                            {
                                "text": "Gujarati Restaurant Near Me",
                                "link": "https://www.swiggy.com/gujarati-restaurants-near-me"
                            },
                            {
                                "text": "Thai Restaurant Near Me",
                                "link": "https://www.swiggy.com/thai-restaurants-near-me"
                            },
                            {
                                "text": "Pizzas Restaurant Near Me",
                                "link": "https://www.swiggy.com/pizzas-restaurants-near-me"
                            },
                            {
                                "text": "Asian Restaurant Near Me",
                                "link": "https://www.swiggy.com/asian-restaurants-near-me"
                            },
                            {
                                "text": "Cafe Restaurant Near Me",
                                "link": "https://www.swiggy.com/cafe-restaurants-near-me"
                            },
                            {
                                "text": "Continental Restaurant Near Me",
                                "link": "https://www.swiggy.com/continental-restaurants-near-me"
                            },
                            {
                                "text": "Mexican Restaurant Near Me",
                                "link": "https://www.swiggy.com/mexican-restaurants-near-me"
                            },
                            {
                                "text": "Mughlai Restaurant Near Me",
                                "link": "https://www.swiggy.com/mughlai-restaurants-near-me"
                            },
                            {
                                "text": "Sushi Restaurant Near Me",
                                "link": "https://www.swiggy.com/sushi-restaurants-near-me"
                            },
                            {
                                "text": "Mangalorean Restaurant Near Me",
                                "link": "https://www.swiggy.com/mangalorean-restaurants-near-me"
                            },
                            {
                                "text": "Tibetan Restaurant Near Me",
                                "link": "https://www.swiggy.com/tibetan-restaurants-near-me"
                            },
                            {
                                "text": "Barbecue Restaurant Near Me",
                                "link": "https://www.swiggy.com/barbecue-restaurants-near-me"
                            },
                            {
                                "text": "Maharashtrian Restaurant Near Me",
                                "link": "https://www.swiggy.com/maharashtrian-restaurants-near-me"
                            },
                            {
                                "text": "Nepalese Restaurant Near Me",
                                "link": "https://www.swiggy.com/nepalese-restaurants-near-me"
                            },
                            {
                                "text": "Rajasthani Restaurant Near Me",
                                "link": "https://www.swiggy.com/rajasthani-restaurants-near-me"
                            },
                            {
                                "text": "Turkish Restaurant Near Me",
                                "link": "https://www.swiggy.com/turkish-restaurants-near-me"
                            }
                        ],
                        "id": "restaurant_near_me_links"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
                        "title": "Explore Every Restaurants Near Me",
                        "brands": [
                            {
                                "text": "Explore Restaurants Near Me",
                                "link": "https://www.swiggy.com/restaurants-near-me"
                            },
                            {
                                "text": "Explore Top Rated Restaurants Near Me",
                                "link": "https://www.swiggy.com/best-restaurants-near-me"
                            }
                        ],
                        "id": "restaurant_near_me_links"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.AppInstallLinks",
                        "title": "For better experience,download the Swiggy app now",
                        "androidAppImage": "portal/m/play_store.png",
                        "androidAppLink": "https://play.google.com/store/apps/details?id=in.swiggy.android&referrer=utm_source%3Dswiggy%26utm_medium%3Dheader",
                        "iosAppImage": "portal/m/app_store.png",
                        "iosAppLink": "https://itunes.apple.com/in/app/id989540920?referrer=utm_source%3Dswiggy%26utm_medium%3Dhomepage",
                        "id": "app_install_links"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.FooterContent",
                        "cities": [
                            {
                                "text": "Bangalore",
                                "link": "https://www.swiggy.com/city/bangalore"
                            },
                            {
                                "text": "Gurgaon",
                                "link": "https://www.swiggy.com/city/gurgaon"
                            },
                            {
                                "text": "Hyderabad",
                                "link": "https://www.swiggy.com/city/hyderabad"
                            },
                            {
                                "text": "Delhi",
                                "link": "https://www.swiggy.com/city/delhi"
                            },
                            {
                                "text": "Mumbai",
                                "link": "https://www.swiggy.com/city/mumbai"
                            },
                            {
                                "text": "Pune",
                                "link": "https://www.swiggy.com/city/pune"
                            },
                            {
                                "text": "Kolkata",
                                "link": "https://www.swiggy.com/city/kolkata"
                            },
                            {
                                "text": "Chennai",
                                "link": "https://www.swiggy.com/city/chennai"
                            },
                            {
                                "text": "Ahmedabad",
                                "link": "https://www.swiggy.com/city/ahmedabad"
                            },
                            {
                                "text": "Chandigarh",
                                "link": "https://www.swiggy.com/city/chandigarh"
                            },
                            {
                                "text": "Jaipur",
                                "link": "https://www.swiggy.com/city/jaipur"
                            },
                            {
                                "text": "Kochi",
                                "link": "https://www.swiggy.com/city/kochi"
                            },
                            {
                                "text": "Coimbatore",
                                "link": "https://www.swiggy.com/city/coimbatore"
                            },
                            {
                                "text": "Lucknow",
                                "link": "https://www.swiggy.com/city/lucknow"
                            },
                            {
                                "text": "Nagpur",
                                "link": "https://www.swiggy.com/city/nagpur"
                            },
                            {
                                "text": "Vadodara",
                                "link": "https://www.swiggy.com/city/vadodara"
                            },
                            {
                                "text": "Indore",
                                "link": "https://www.swiggy.com/city/indore"
                            },
                            {
                                "text": "Guwahati",
                                "link": "https://www.swiggy.com/city/guwahati"
                            },
                            {
                                "text": "Vizag",
                                "link": "https://www.swiggy.com/city/vizag"
                            },
                            {
                                "text": "Surat",
                                "link": "https://www.swiggy.com/city/surat"
                            },
                            {
                                "text": "Dehradun",
                                "link": "https://www.swiggy.com/city/dehradun"
                            },
                            {
                                "text": "Noida",
                                "link": "https://www.swiggy.com/city/noida"
                            },
                            {
                                "text": "Ludhiana",
                                "link": "https://www.swiggy.com/city/ludhiana"
                            },
                            {
                                "text": "Trichy",
                                "link": "https://www.swiggy.com/city/trichy"
                            },
                            {
                                "text": "Vijayawada",
                                "link": "https://www.swiggy.com/city/vijayawada"
                            },
                            {
                                "text": "Kanpur",
                                "link": "https://www.swiggy.com/city/kanpur"
                            },
                            {
                                "text": "Mysore",
                                "link": "https://www.swiggy.com/city/mysore"
                            },
                            {
                                "text": "Nashik",
                                "link": "https://www.swiggy.com/city/nashik"
                            },
                            {
                                "text": "Udaipur",
                                "link": "https://www.swiggy.com/city/udaipur"
                            },
                            {
                                "text": "Pondicherry",
                                "link": "https://www.swiggy.com/city/pondicherry"
                            },
                            {
                                "text": "Agra",
                                "link": "https://www.swiggy.com/city/agra"
                            },
                            {
                                "text": "Aurangabad",
                                "link": "https://www.swiggy.com/city/aurangabad"
                            },
                            {
                                "text": "Jalandhar",
                                "link": "https://www.swiggy.com/city/jalandhar"
                            },
                            {
                                "text": "Kota",
                                "link": "https://www.swiggy.com/city/kota"
                            },
                            {
                                "text": "Madurai",
                                "link": "https://www.swiggy.com/city/madurai"
                            },
                            {
                                "text": "Allahabad",
                                "link": "https://www.swiggy.com/city/allahabad"
                            },
                            {
                                "text": "Manipal",
                                "link": "https://www.swiggy.com/city/manipal"
                            },
                            {
                                "text": "Amritsar",
                                "link": "https://www.swiggy.com/city/amritsar"
                            },
                            {
                                "text": "Bareilly",
                                "link": "https://www.swiggy.com/city/bareilly"
                            },
                            {
                                "text": "Meerut",
                                "link": "https://www.swiggy.com/city/meerut"
                            },
                            {
                                "text": "Bhopal",
                                "link": "https://www.swiggy.com/city/bhopal"
                            },
                            {
                                "text": "Ooty",
                                "link": "https://www.swiggy.com/city/ooty"
                            },
                            {
                                "text": "Bhubaneswar",
                                "link": "https://www.swiggy.com/city/bhubaneswar"
                            },
                            {
                                "text": "Raipur",
                                "link": "https://www.swiggy.com/city/raipur"
                            },
                            {
                                "text": "Bikaner",
                                "link": "https://www.swiggy.com/city/bikaner"
                            },
                            {
                                "text": "Rajkot",
                                "link": "https://www.swiggy.com/city/rajkot"
                            },
                            {
                                "text": "Kozhikode",
                                "link": "https://www.swiggy.com/city/kozhikode"
                            },
                            {
                                "text": "Central Goa",
                                "link": "https://www.swiggy.com/city/central-goa"
                            },
                            {
                                "text": "Sirsa",
                                "link": "https://www.swiggy.com/city/sirsa"
                            },
                            {
                                "text": "Gwalior",
                                "link": "https://www.swiggy.com/city/gwalior"
                            },
                            {
                                "text": "Thrissur",
                                "link": "https://www.swiggy.com/city/thrissur"
                            },
                            {
                                "text": "Kharagpur",
                                "link": "https://www.swiggy.com/city/kharagpur"
                            },
                            {
                                "text": "Tirupati",
                                "link": "https://www.swiggy.com/city/tirupati"
                            },
                            {
                                "text": "Tirupur",
                                "link": "https://www.swiggy.com/city/tirupur"
                            },
                            {
                                "text": "Vellore",
                                "link": "https://www.swiggy.com/city/vellore"
                            },
                            {
                                "text": "Thiruvananthapuram",
                                "link": "https://www.swiggy.com/city/thiruvananthapuram"
                            },
                            {
                                "text": "Warangal",
                                "link": "https://www.swiggy.com/city/warangal"
                            },
                            {
                                "text": "Varanasi",
                                "link": "https://www.swiggy.com/city/varanasi"
                            },
                            {
                                "text": "Mangaluru",
                                "link": "https://www.swiggy.com/city/mangaluru"
                            },
                            {
                                "text": "Patna",
                                "link": "https://www.swiggy.com/city/patna"
                            },
                            {
                                "text": "Ranchi",
                                "link": "https://www.swiggy.com/city/ranchi"
                            },
                            {
                                "text": "Faridabad",
                                "link": "https://www.swiggy.com/city/faridabad"
                            },
                            {
                                "text": "Guntur",
                                "link": "https://www.swiggy.com/city/guntur"
                            },
                            {
                                "text": "Ujjain",
                                "link": "https://www.swiggy.com/city/ujjain"
                            },
                            {
                                "text": "Patiala",
                                "link": "https://www.swiggy.com/city/patiala"
                            },
                            {
                                "text": "Karnal",
                                "link": "https://www.swiggy.com/city/karnal"
                            },
                            {
                                "text": "Kakinada",
                                "link": "https://www.swiggy.com/city/kakinada"
                            },
                            {
                                "text": "Rajahmundry",
                                "link": "https://www.swiggy.com/city/rajahmundry"
                            },
                            {
                                "text": "Bilaspur",
                                "link": "https://www.swiggy.com/city/bilaspur"
                            },
                            {
                                "text": "Bhilai",
                                "link": "https://www.swiggy.com/city/bhilai"
                            },
                            {
                                "text": "Anand",
                                "link": "https://www.swiggy.com/city/anand"
                            },
                            {
                                "text": "Bhavnagar",
                                "link": "https://www.swiggy.com/city/bhavnagar"
                            },
                            {
                                "text": "Jammu",
                                "link": "https://www.swiggy.com/city/jammu"
                            },
                            {
                                "text": "Muktsar",
                                "link": "https://www.swiggy.com/city/muktsar"
                            },
                            {
                                "text": "Panipat",
                                "link": "https://www.swiggy.com/city/panipat"
                            },
                            {
                                "text": "Jamshedpur",
                                "link": "https://www.swiggy.com/city/jamshedpur"
                            },
                            {
                                "text": "Dhanbad",
                                "link": "https://www.swiggy.com/city/dhanbad"
                            },
                            {
                                "text": "Bokaro",
                                "link": "https://www.swiggy.com/city/bokaro"
                            },
                            {
                                "text": "Hubli",
                                "link": "https://www.swiggy.com/city/hubli"
                            },
                            {
                                "text": "Belgaum",
                                "link": "https://www.swiggy.com/city/belgaum"
                            },
                            {
                                "text": "Jabalpur",
                                "link": "https://www.swiggy.com/city/jabalpur"
                            },
                            {
                                "text": "Kolhapur",
                                "link": "https://www.swiggy.com/city/kolhapur"
                            },
                            {
                                "text": "Solapur",
                                "link": "https://www.swiggy.com/city/solapur"
                            },
                            {
                                "text": "Shillong",
                                "link": "https://www.swiggy.com/city/shillong"
                            },
                            {
                                "text": "Cuttack",
                                "link": "https://www.swiggy.com/city/cuttack"
                            },
                            {
                                "text": "Aligarh",
                                "link": "https://www.swiggy.com/city/aligarh"
                            },
                            {
                                "text": "Salem",
                                "link": "https://www.swiggy.com/city/salem"
                            },
                            {
                                "text": "Agartala",
                                "link": "https://www.swiggy.com/city/agartala"
                            },
                            {
                                "text": "Jodhpur",
                                "link": "https://www.swiggy.com/city/jodhpur"
                            },
                            {
                                "text": "Ajmer",
                                "link": "https://www.swiggy.com/city/ajmer"
                            },
                            {
                                "text": "Jhansi",
                                "link": "https://www.swiggy.com/city/jhansi"
                            },
                            {
                                "text": "Gorakhpur",
                                "link": "https://www.swiggy.com/city/gorakhpur"
                            },
                            {
                                "text": "Thanjavur",
                                "link": "https://www.swiggy.com/city/thanjavur"
                            },
                            {
                                "text": "Erode",
                                "link": "https://www.swiggy.com/city/erode"
                            },
                            {
                                "text": "Nellore",
                                "link": "https://www.swiggy.com/city/nellore"
                            },
                            {
                                "text": "Rourkela",
                                "link": "https://www.swiggy.com/city/rourkela"
                            },
                            {
                                "text": "Anantapur",
                                "link": "https://www.swiggy.com/city/anantapur"
                            },
                            {
                                "text": "Kurnool",
                                "link": "https://www.swiggy.com/city/kurnool"
                            },
                            {
                                "text": "Ahmednagar",
                                "link": "https://www.swiggy.com/city/ahmednagar"
                            },
                            {
                                "text": "Phagwara",
                                "link": "https://www.swiggy.com/city/phagwara"
                            },
                            {
                                "text": "Ambala",
                                "link": "https://www.swiggy.com/city/ambala"
                            },
                            {
                                "text": "Ballari",
                                "link": "https://www.swiggy.com/city/ballari"
                            },
                            {
                                "text": "Saharanpur",
                                "link": "https://www.swiggy.com/city/saharanpur"
                            },
                            {
                                "text": "Tirunelveli",
                                "link": "https://www.swiggy.com/city/tirunelveli"
                            },
                            {
                                "text": "Bathinda",
                                "link": "https://www.swiggy.com/city/bathinda"
                            },
                            {
                                "text": "Mathura",
                                "link": "https://www.swiggy.com/city/mathura"
                            },
                            {
                                "text": "Haridwar",
                                "link": "https://www.swiggy.com/city/haridwar"
                            },
                            {
                                "text": "Ratnagiri",
                                "link": "https://www.swiggy.com/city/ratnagiri"
                            },
                            {
                                "text": "Sangli",
                                "link": "https://www.swiggy.com/city/sangli"
                            },
                            {
                                "text": "Amravati",
                                "link": "https://www.swiggy.com/city/amravati"
                            },
                            {
                                "text": "Rishikesh",
                                "link": "https://www.swiggy.com/city/rishikesh"
                            },
                            {
                                "text": "Nagercoil",
                                "link": "https://www.swiggy.com/city/nagercoil"
                            },
                            {
                                "text": "KanyaKumari",
                                "link": "https://www.swiggy.com/city/kanyakumari"
                            },
                            {
                                "text": "Kadapa",
                                "link": "https://www.swiggy.com/city/kadapa"
                            },
                            {
                                "text": "Nizamabad",
                                "link": "https://www.swiggy.com/city/nizamabad"
                            },
                            {
                                "text": "Shivamogga",
                                "link": "https://www.swiggy.com/city/shivamogga"
                            },
                            {
                                "text": "Davanagere",
                                "link": "https://www.swiggy.com/city/davanagere"
                            },
                            {
                                "text": "Roorkee",
                                "link": "https://www.swiggy.com/city/roorkee"
                            },
                            {
                                "text": "Nanded",
                                "link": "https://www.swiggy.com/city/nanded"
                            },
                            {
                                "text": "Rewa",
                                "link": "https://www.swiggy.com/city/rewa"
                            },
                            {
                                "text": "Satna",
                                "link": "https://www.swiggy.com/city/satna"
                            },
                            {
                                "text": "Shimla",
                                "link": "https://www.swiggy.com/city/shimla"
                            },
                            {
                                "text": "Muzaffarpur",
                                "link": "https://www.swiggy.com/city/muzaffarpur"
                            },
                            {
                                "text": "Valsad",
                                "link": "https://www.swiggy.com/city/valsad"
                            },
                            {
                                "text": "Vapi",
                                "link": "https://www.swiggy.com/city/vapi"
                            },
                            {
                                "text": "Chhapra",
                                "link": "https://www.swiggy.com/city/chhapra"
                            },
                            {
                                "text": "Dharamshala",
                                "link": "https://www.swiggy.com/city/dharamshala"
                            },
                            {
                                "text": "Kollam",
                                "link": "https://www.swiggy.com/city/kollam"
                            },
                            {
                                "text": "Silchar",
                                "link": "https://www.swiggy.com/city/silchar"
                            },
                            {
                                "text": "Alappuzha",
                                "link": "https://www.swiggy.com/city/alappuzha"
                            },
                            {
                                "text": "Sonipat",
                                "link": "https://www.swiggy.com/city/sonipat"
                            },
                            {
                                "text": "Rohtak",
                                "link": "https://www.swiggy.com/city/rohtak"
                            },
                            {
                                "text": "Mehsana",
                                "link": "https://www.swiggy.com/city/mehsana"
                            },
                            {
                                "text": "Kullu",
                                "link": "https://www.swiggy.com/city/kullu"
                            },
                            {
                                "text": "Dhule",
                                "link": "https://www.swiggy.com/city/dhule"
                            },
                            {
                                "text": "Dharwad",
                                "link": "https://www.swiggy.com/city/dharwad"
                            },
                            {
                                "text": "Latur",
                                "link": "https://www.swiggy.com/city/latur"
                            },
                            {
                                "text": "Vizianagaram",
                                "link": "https://www.swiggy.com/city/vizianagaram"
                            },
                            {
                                "text": "Khammam",
                                "link": "https://www.swiggy.com/city/khammam"
                            },
                            {
                                "text": "Hampi",
                                "link": "https://www.swiggy.com/city/hampi"
                            },
                            {
                                "text": "Nainital",
                                "link": "https://www.swiggy.com/city/nainital"
                            },
                            {
                                "text": "Akola",
                                "link": "https://www.swiggy.com/city/akola"
                            },
                            {
                                "text": "Kalaburagi",
                                "link": "https://www.swiggy.com/city/kalaburagi"
                            },
                            {
                                "text": "Gaya",
                                "link": "https://www.swiggy.com/city/gaya"
                            },
                            {
                                "text": "Muzaffarnagar",
                                "link": "https://www.swiggy.com/city/muzaffarnagar"
                            },
                            {
                                "text": "Dewas",
                                "link": "https://www.swiggy.com/city/dewas"
                            },
                            {
                                "text": "Korba",
                                "link": "https://www.swiggy.com/city/korba"
                            },
                            {
                                "text": "Mussoorie",
                                "link": "https://www.swiggy.com/city/mussoorie"
                            },
                            {
                                "text": "Jalgaon",
                                "link": "https://www.swiggy.com/city/jalgaon"
                            },
                            {
                                "text": "Yamuna Nagar",
                                "link": "https://www.swiggy.com/city/yamuna-nagar"
                            },
                            {
                                "text": "Bhagalpur",
                                "link": "https://www.swiggy.com/city/bhagalpur"
                            },
                            {
                                "text": "Hapur",
                                "link": "https://www.swiggy.com/city/hapur"
                            },
                            {
                                "text": "Morena",
                                "link": "https://www.swiggy.com/city/morena"
                            },
                            {
                                "text": "Hassan",
                                "link": "https://www.swiggy.com/city/hassan"
                            },
                            {
                                "text": "Hisar",
                                "link": "https://www.swiggy.com/city/hisar"
                            },
                            {
                                "text": "Godhra",
                                "link": "https://www.swiggy.com/city/godhra"
                            },
                            {
                                "text": "Kolar ",
                                "link": "https://www.swiggy.com/city/kolar"
                            },
                            {
                                "text": "Rampur",
                                "link": "https://www.swiggy.com/city/rampur"
                            },
                            {
                                "text": "Sitapur",
                                "link": "https://www.swiggy.com/city/sitapur"
                            },
                            {
                                "text": "Etawah",
                                "link": "https://www.swiggy.com/city/etawah"
                            },
                            {
                                "text": "Porbandar",
                                "link": "https://www.swiggy.com/city/porbandar"
                            },
                            {
                                "text": "Nadiad",
                                "link": "https://www.swiggy.com/city/nadiad"
                            },
                            {
                                "text": "Sagar",
                                "link": "https://www.swiggy.com/city/sagar"
                            },
                            {
                                "text": "Morbi",
                                "link": "https://www.swiggy.com/city/morbi"
                            },
                            {
                                "text": "Chhindwara",
                                "link": "https://www.swiggy.com/city/chhindwara"
                            },
                            {
                                "text": "Tumakuru",
                                "link": "https://www.swiggy.com/city/tumakuru"
                            },
                            {
                                "text": "Singrauli",
                                "link": "https://www.swiggy.com/city/singrauli"
                            },
                            {
                                "text": "Thoothukudi",
                                "link": "https://www.swiggy.com/city/thoothukudi"
                            },
                            {
                                "text": "Katni",
                                "link": "https://www.swiggy.com/city/katni"
                            },
                            {
                                "text": "Khandwa",
                                "link": "https://www.swiggy.com/city/khandwa"
                            },
                            {
                                "text": "Eluru",
                                "link": "https://www.swiggy.com/city/eluru"
                            },
                            {
                                "text": "Malappuram",
                                "link": "https://www.swiggy.com/city/malappuram"
                            },
                            {
                                "text": "Dibrugarh",
                                "link": "https://www.swiggy.com/city/dibrugarh"
                            },
                            {
                                "text": "Deoghar",
                                "link": "https://www.swiggy.com/city/deoghar"
                            },
                            {
                                "text": "Khanna",
                                "link": "https://www.swiggy.com/city/khanna"
                            },
                            {
                                "text": "Bidar",
                                "link": "https://www.swiggy.com/city/bidar"
                            },
                            {
                                "text": "Anantnag",
                                "link": "https://www.swiggy.com/city/anantnag"
                            },
                            {
                                "text": "Madikeri",
                                "link": "https://www.swiggy.com/city/madikeri"
                            },
                            {
                                "text": "Haldwani",
                                "link": "https://www.swiggy.com/city/haldwani"
                            },
                            {
                                "text": "Panchkula",
                                "link": "https://www.swiggy.com/city/panchkula"
                            },
                            {
                                "text": "Farrukhabad",
                                "link": "https://www.swiggy.com/city/farrukhabad"
                            },
                            {
                                "text": "Malegaon",
                                "link": "https://www.swiggy.com/city/malegaon"
                            },
                            {
                                "text": "Dindigul",
                                "link": "https://www.swiggy.com/city/dindigul"
                            },
                            {
                                "text": "Shahjahanpur",
                                "link": "https://www.swiggy.com/city/shahjahanpur"
                            },
                            {
                                "text": "Beed",
                                "link": "https://www.swiggy.com/city/beed"
                            },
                            {
                                "text": "Junagadh",
                                "link": "https://www.swiggy.com/city/junagadh"
                            },
                            {
                                "text": "Asansol",
                                "link": "https://www.swiggy.com/city/asansol"
                            },
                            {
                                "text": "Beawar",
                                "link": "https://www.swiggy.com/city/beawar"
                            },
                            {
                                "text": "Kishangarh",
                                "link": "https://www.swiggy.com/city/kishangarh"
                            },
                            {
                                "text": "Budhwal",
                                "link": "https://www.swiggy.com/city/budhwal"
                            },
                            {
                                "text": "Parbhani",
                                "link": "https://www.swiggy.com/city/parbhani"
                            },
                            {
                                "text": "Gondia",
                                "link": "https://www.swiggy.com/city/gondia"
                            },
                            {
                                "text": "Ichalkaranji",
                                "link": "https://www.swiggy.com/city/ichalkaranji"
                            },
                            {
                                "text": "Jalna",
                                "link": "https://www.swiggy.com/city/jalna"
                            },
                            {
                                "text": "Yavatmal",
                                "link": "https://www.swiggy.com/city/yavatmal"
                            },
                            {
                                "text": "Shivpuri",
                                "link": "https://www.swiggy.com/city/shivpuri"
                            },
                            {
                                "text": "Moga",
                                "link": "https://www.swiggy.com/city/moga"
                            },
                            {
                                "text": "Abohar",
                                "link": "https://www.swiggy.com/city/abohar"
                            },
                            {
                                "text": "Adoni",
                                "link": "https://www.swiggy.com/city/adoni"
                            },
                            {
                                "text": "Madanapalle",
                                "link": "https://www.swiggy.com/city/madanapalle"
                            },
                            {
                                "text": "Tiruvannamalai",
                                "link": "https://www.swiggy.com/city/tiruvannamalai"
                            },
                            {
                                "text": "Satara",
                                "link": "https://www.swiggy.com/city/satara"
                            },
                            {
                                "text": "Ambur",
                                "link": "https://www.swiggy.com/city/ambur"
                            },
                            {
                                "text": "Karimnagar",
                                "link": "https://www.swiggy.com/city/karimnagar"
                            },
                            {
                                "text": "Ratlam",
                                "link": "https://www.swiggy.com/city/ratlam"
                            },
                            {
                                "text": "Moradabad",
                                "link": "https://www.swiggy.com/city/moradabad"
                            },
                            {
                                "text": "Machilipatnam",
                                "link": "https://www.swiggy.com/city/machilipatnam"
                            },
                            {
                                "text": "Ongole",
                                "link": "https://www.swiggy.com/city/ongole"
                            },
                            {
                                "text": "Kottayam",
                                "link": "https://www.swiggy.com/city/kottayam"
                            },
                            {
                                "text": "Darbhanga",
                                "link": "https://www.swiggy.com/city/darbhanga"
                            },
                            {
                                "text": "Kurukshetra",
                                "link": "https://www.swiggy.com/city/kurukshetra"
                            },
                            {
                                "text": "Unnao",
                                "link": "https://www.swiggy.com/city/unnao"
                            },
                            {
                                "text": "Bulandshahr",
                                "link": "https://www.swiggy.com/city/bulandshahr"
                            },
                            {
                                "text": "Durgapur",
                                "link": "https://www.swiggy.com/city/durgapur"
                            },
                            {
                                "text": "Siliguri",
                                "link": "https://www.swiggy.com/city/siliguri"
                            },
                            {
                                "text": "Pali",
                                "link": "https://www.swiggy.com/city/pali"
                            },
                            {
                                "text": "Tadepalligudem",
                                "link": "https://www.swiggy.com/city/tadepalligudem"
                            },
                            {
                                "text": "Ramagundam",
                                "link": "https://www.swiggy.com/city/ramagundam"
                            },
                            {
                                "text": "Mahbubnagar",
                                "link": "https://www.swiggy.com/city/mahbubnagar"
                            },
                            {
                                "text": "Bhiwani",
                                "link": "https://www.swiggy.com/city/bhiwani"
                            },
                            {
                                "text": "Cuddalore",
                                "link": "https://www.swiggy.com/city/cuddalore"
                            },
                            {
                                "text": "Kaithal",
                                "link": "https://www.swiggy.com/city/kaithal"
                            },
                            {
                                "text": "Jagtial",
                                "link": "https://www.swiggy.com/city/jagtial"
                            },
                            {
                                "text": "Palakkad",
                                "link": "https://www.swiggy.com/city/palakkad"
                            },
                            {
                                "text": "Guna",
                                "link": "https://www.swiggy.com/city/guna"
                            },
                            {
                                "text": "Kumbakonam",
                                "link": "https://www.swiggy.com/city/kumbakonam"
                            },
                            {
                                "text": "Maunath Bhanjan",
                                "link": "https://www.swiggy.com/city/maunath-bhanjan"
                            },
                            {
                                "text": "Baripada",
                                "link": "https://www.swiggy.com/city/baripada"
                            },
                            {
                                "text": "Orai",
                                "link": "https://www.swiggy.com/city/orai"
                            },
                            {
                                "text": "Bhadrak",
                                "link": "https://www.swiggy.com/city/bhadrak"
                            },
                            {
                                "text": "Batala",
                                "link": "https://www.swiggy.com/city/batala"
                            },
                            {
                                "text": "Firozpur",
                                "link": "https://www.swiggy.com/city/firozpur"
                            },
                            {
                                "text": "Barnala",
                                "link": "https://www.swiggy.com/city/barnala"
                            },
                            {
                                "text": "Raigarh",
                                "link": "https://www.swiggy.com/city/raigarh"
                            },
                            {
                                "text": "Nagaon",
                                "link": "https://www.swiggy.com/city/nagaon"
                            },
                            {
                                "text": "Mainpuri",
                                "link": "https://www.swiggy.com/city/mainpuri"
                            },
                            {
                                "text": "Balurghat",
                                "link": "https://www.swiggy.com/city/balurghat"
                            },
                            {
                                "text": "Giridih",
                                "link": "https://www.swiggy.com/city/giridih"
                            },
                            {
                                "text": "Ghazipur",
                                "link": "https://www.swiggy.com/city/ghazipur"
                            },
                            {
                                "text": "Jagdalpur",
                                "link": "https://www.swiggy.com/city/jagdalpur"
                            },
                            {
                                "text": "Vidisha",
                                "link": "https://www.swiggy.com/city/vidisha"
                            },
                            {
                                "text": "Dimapur",
                                "link": "https://www.swiggy.com/city/dimapur"
                            },
                            {
                                "text": "Shikohabad",
                                "link": "https://www.swiggy.com/city/shikohabad"
                            },
                            {
                                "text": "Imphal",
                                "link": "https://www.swiggy.com/city/imphal"
                            },
                            {
                                "text": "Lakhimpur",
                                "link": "https://www.swiggy.com/city/lakhimpur"
                            },
                            {
                                "text": "Rudrapur",
                                "link": "https://www.swiggy.com/city/rudrapur"
                            },
                            {
                                "text": "Ambikapur",
                                "link": "https://www.swiggy.com/city/ambikapur"
                            },
                            {
                                "text": "Damoh",
                                "link": "https://www.swiggy.com/city/damoh"
                            },
                            {
                                "text": "Rae Bareli",
                                "link": "https://www.swiggy.com/city/rae-bareli"
                            },
                            {
                                "text": "Tinsukia",
                                "link": "https://www.swiggy.com/city/tinsukia"
                            },
                            {
                                "text": "Rajapalayam",
                                "link": "https://www.swiggy.com/city/rajapalayam"
                            },
                            {
                                "text": "Rajnandgaon",
                                "link": "https://www.swiggy.com/city/rajnandgaon"
                            },
                            {
                                "text": "Kashipur",
                                "link": "https://www.swiggy.com/city/kashipur"
                            },
                            {
                                "text": "Ranibennur",
                                "link": "https://www.swiggy.com/city/ranibennur"
                            },
                            {
                                "text": "Burhanpur",
                                "link": "https://www.swiggy.com/city/burhanpur"
                            },
                            {
                                "text": "Bhadravati",
                                "link": "https://www.swiggy.com/city/bhadravati"
                            },
                            {
                                "text": "Chittoor",
                                "link": "https://www.swiggy.com/city/chittoor"
                            },
                            {
                                "text": "Pudukkottai",
                                "link": "https://www.swiggy.com/city/pudukkottai"
                            },
                            {
                                "text": "Hardoi",
                                "link": "https://www.swiggy.com/city/hardoi"
                            },
                            {
                                "text": "Basti",
                                "link": "https://www.swiggy.com/city/basti"
                            },
                            {
                                "text": "Karaikkudi",
                                "link": "https://www.swiggy.com/city/karaikkudi"
                            },
                            {
                                "text": "Lalitpur",
                                "link": "https://www.swiggy.com/city/lalitpur"
                            },
                            {
                                "text": "Hospet",
                                "link": "https://www.swiggy.com/city/hospet"
                            },
                            {
                                "text": "Budaun",
                                "link": "https://www.swiggy.com/city/budaun"
                            },
                            {
                                "text": "Neemuch",
                                "link": "https://www.swiggy.com/city/neemuch"
                            },
                            {
                                "text": "Pilibhit",
                                "link": "https://www.swiggy.com/city/pilibhit"
                            },
                            {
                                "text": "Amroha",
                                "link": "https://www.swiggy.com/city/amroha"
                            },
                            {
                                "text": "Barshi",
                                "link": "https://www.swiggy.com/city/barshi"
                            },
                            {
                                "text": "Sri Ganganagar",
                                "link": "https://www.swiggy.com/city/sri-ganganagar"
                            },
                            {
                                "text": "Wardha",
                                "link": "https://www.swiggy.com/city/wardha"
                            },
                            {
                                "text": "Sehore",
                                "link": "https://www.swiggy.com/city/sehore"
                            },
                            {
                                "text": "Bhimavaram",
                                "link": "https://www.swiggy.com/city/bhimavaram"
                            },
                            {
                                "text": "Hanumangarh",
                                "link": "https://www.swiggy.com/city/hanumangarh"
                            },
                            {
                                "text": "Pathankot",
                                "link": "https://www.swiggy.com/city/pathankot"
                            },
                            {
                                "text": "Puri",
                                "link": "https://www.swiggy.com/city/puri"
                            },
                            {
                                "text": "Fatehpur",
                                "link": "https://www.swiggy.com/city/fatehpur"
                            },
                            {
                                "text": "Surendranagar Dudhrej",
                                "link": "https://www.swiggy.com/city/surendranagar-dudhrej"
                            },
                            {
                                "text": "Jamnagar",
                                "link": "https://www.swiggy.com/city/jamnagar"
                            },
                            {
                                "text": "Bhuj",
                                "link": "https://www.swiggy.com/city/bhuj"
                            },
                            {
                                "text": "Gandhidham",
                                "link": "https://www.swiggy.com/city/gandhidham"
                            },
                            {
                                "text": "Bharuch",
                                "link": "https://www.swiggy.com/city/bharuch"
                            },
                            {
                                "text": "Navsari",
                                "link": "https://www.swiggy.com/city/navsari"
                            },
                            {
                                "text": "Amreli",
                                "link": "https://www.swiggy.com/city/amreli"
                            },
                            {
                                "text": "Palanpur",
                                "link": "https://www.swiggy.com/city/palanpur"
                            },
                            {
                                "text": "Bhilwara",
                                "link": "https://www.swiggy.com/city/bhilwara"
                            },
                            {
                                "text": "Suratgarh",
                                "link": "https://www.swiggy.com/city/suratgarh"
                            },
                            {
                                "text": "Sikar",
                                "link": "https://www.swiggy.com/city/sikar"
                            },
                            {
                                "text": "Churu",
                                "link": "https://www.swiggy.com/city/churu"
                            },
                            {
                                "text": "Alwar",
                                "link": "https://www.swiggy.com/city/alwar"
                            },
                            {
                                "text": "Bhiwadi",
                                "link": "https://www.swiggy.com/city/bhiwadi"
                            },
                            {
                                "text": "Bharatpur",
                                "link": "https://www.swiggy.com/city/bharatpur"
                            },
                            {
                                "text": "Mount Abu",
                                "link": "https://www.swiggy.com/city/mount-abu"
                            },
                            {
                                "text": "Bundi",
                                "link": "https://www.swiggy.com/city/bundi"
                            },
                            {
                                "text": "Sawai Madhopur",
                                "link": "https://www.swiggy.com/city/sawai-madhopur"
                            },
                            {
                                "text": "Purulia",
                                "link": "https://www.swiggy.com/city/purulia"
                            },
                            {
                                "text": "Bardhaman",
                                "link": "https://www.swiggy.com/city/bardhaman"
                            },
                            {
                                "text": "Raniganj",
                                "link": "https://www.swiggy.com/city/raniganj"
                            },
                            {
                                "text": "Darjeeling",
                                "link": "https://www.swiggy.com/city/darjeeling"
                            },
                            {
                                "text": "Jalpaiguri",
                                "link": "https://www.swiggy.com/city/jalpaiguri"
                            },
                            {
                                "text": "Chittorgarh",
                                "link": "https://www.swiggy.com/city/chittorgarh"
                            },
                            {
                                "text": "Dholpur",
                                "link": "https://www.swiggy.com/city/dholpur"
                            },
                            {
                                "text": "Uluberia",
                                "link": "https://www.swiggy.com/city/uluberia"
                            },
                            {
                                "text": "Nabadwip",
                                "link": "https://www.swiggy.com/city/nabadwip"
                            },
                            {
                                "text": "Bongaon",
                                "link": "https://www.swiggy.com/city/bongaon"
                            },
                            {
                                "text": "Kanchrapara",
                                "link": "https://www.swiggy.com/city/kanchrapara"
                            },
                            {
                                "text": "Bankura",
                                "link": "https://www.swiggy.com/city/bankura"
                            },
                            {
                                "text": "Habra",
                                "link": "https://www.swiggy.com/city/habra"
                            },
                            {
                                "text": "Firozabad",
                                "link": "https://www.swiggy.com/city/firozabad"
                            },
                            {
                                "text": "Nalgonda",
                                "link": "https://www.swiggy.com/city/nalgonda"
                            },
                            {
                                "text": "Chandrapur",
                                "link": "https://www.swiggy.com/city/chandrapur"
                            },
                            {
                                "text": "Bijapur",
                                "link": "https://www.swiggy.com/city/bijapur"
                            },
                            {
                                "text": "Bhusawal",
                                "link": "https://www.swiggy.com/city/bhusawal"
                            },
                            {
                                "text": "Raichur",
                                "link": "https://www.swiggy.com/city/raichur"
                            },
                            {
                                "text": "Bahraich",
                                "link": "https://www.swiggy.com/city/bahraich"
                            },
                            {
                                "text": "Azamgarh",
                                "link": "https://www.swiggy.com/city/azamgarh"
                            },
                            {
                                "text": "Bahadurgarh",
                                "link": "https://www.swiggy.com/city/bahadurgarh"
                            },
                            {
                                "text": "Jind",
                                "link": "https://www.swiggy.com/city/jind"
                            },
                            {
                                "text": "Rewari",
                                "link": "https://www.swiggy.com/city/rewari"
                            },
                            {
                                "text": "Palwal",
                                "link": "https://www.swiggy.com/city/palwal"
                            },
                            {
                                "text": "Hathras",
                                "link": "https://www.swiggy.com/city/hathras"
                            },
                            {
                                "text": "Sambalpur",
                                "link": "https://www.swiggy.com/city/sambalpur"
                            },
                            {
                                "text": "Banda",
                                "link": "https://www.swiggy.com/city/banda"
                            },
                            {
                                "text": "Hoshiarpur",
                                "link": "https://www.swiggy.com/city/hoshiarpur"
                            },
                            {
                                "text": "Faridkot",
                                "link": "https://www.swiggy.com/city/faridkot"
                            },
                            {
                                "text": "Mandsaur",
                                "link": "https://www.swiggy.com/city/mandsaur"
                            },
                            {
                                "text": "Suryapet",
                                "link": "https://www.swiggy.com/city/suryapet"
                            },
                            {
                                "text": "Adilabad",
                                "link": "https://www.swiggy.com/city/adilabad"
                            },
                            {
                                "text": "Narasaraopet",
                                "link": "https://www.swiggy.com/city/narasaraopet"
                            },
                            {
                                "text": "Faizabad",
                                "link": "https://www.swiggy.com/city/faizabad"
                            },
                            {
                                "text": "Tadpatri",
                                "link": "https://www.swiggy.com/city/tadpatri"
                            },
                            {
                                "text": "Gonda",
                                "link": "https://www.swiggy.com/city/gonda"
                            },
                            {
                                "text": "Mughalsarai",
                                "link": "https://www.swiggy.com/city/mughalsarai"
                            },
                            {
                                "text": "Medinipur",
                                "link": "https://www.swiggy.com/city/medinipur"
                            },
                            {
                                "text": "Nagda",
                                "link": "https://www.swiggy.com/city/nagda"
                            },
                            {
                                "text": "Chilakaluripet",
                                "link": "https://www.swiggy.com/city/chilakaluripet"
                            },
                            {
                                "text": "Hindupur",
                                "link": "https://www.swiggy.com/city/hindupur"
                            },
                            {
                                "text": "Kasganj",
                                "link": "https://www.swiggy.com/city/kasganj"
                            },
                            {
                                "text": "Raiganj",
                                "link": "https://www.swiggy.com/city/raiganj"
                            },
                            {
                                "text": "Deoria City",
                                "link": "https://www.swiggy.com/city/deoria-city"
                            },
                            {
                                "text": "Sultanpur",
                                "link": "https://www.swiggy.com/city/sultanpur"
                            },
                            {
                                "text": "Shamli",
                                "link": "https://www.swiggy.com/city/shamli"
                            },
                            {
                                "text": "Krishnanagar",
                                "link": "https://www.swiggy.com/city/krishnanagar"
                            },
                            {
                                "text": "Ballia",
                                "link": "https://www.swiggy.com/city/ballia"
                            },
                            {
                                "text": "Guntakal",
                                "link": "https://www.swiggy.com/city/guntakal"
                            },
                            {
                                "text": "Miryalaguda",
                                "link": "https://www.swiggy.com/city/miryalaguda"
                            },
                            {
                                "text": "Etah",
                                "link": "https://www.swiggy.com/city/etah"
                            },
                            {
                                "text": "Berhampore",
                                "link": "https://www.swiggy.com/city/berhampore"
                            },
                            {
                                "text": "Gudivada",
                                "link": "https://www.swiggy.com/city/gudivada"
                            },
                            {
                                "text": "Haldia",
                                "link": "https://www.swiggy.com/city/haldia"
                            },
                            {
                                "text": "Santipur",
                                "link": "https://www.swiggy.com/city/santipur"
                            },
                            {
                                "text": "Basirhat",
                                "link": "https://www.swiggy.com/city/basirhat"
                            },
                            {
                                "text": "Seoni",
                                "link": "https://www.swiggy.com/city/seoni"
                            },
                            {
                                "text": "Udgir",
                                "link": "https://www.swiggy.com/city/udgir"
                            },
                            {
                                "text": "Proddatur",
                                "link": "https://www.swiggy.com/city/proddatur"
                            },
                            {
                                "text": "Nagapattinam",
                                "link": "https://www.swiggy.com/city/nagapattinam"
                            },
                            {
                                "text": "Chikmagalur",
                                "link": "https://www.swiggy.com/city/chikmagalur"
                            },
                            {
                                "text": "Chandausi",
                                "link": "https://www.swiggy.com/city/chandausi"
                            },
                            {
                                "text": "Bhind",
                                "link": "https://www.swiggy.com/city/bhind"
                            },
                            {
                                "text": "Mandya",
                                "link": "https://www.swiggy.com/city/mandya"
                            },
                            {
                                "text": "Bagalkot",
                                "link": "https://www.swiggy.com/city/bagalkot"
                            },
                            {
                                "text": "Nandurbar",
                                "link": "https://www.swiggy.com/city/nandurbar"
                            },
                            {
                                "text": "Chitradurga",
                                "link": "https://www.swiggy.com/city/chitradurga"
                            },
                            {
                                "text": "Osmanabad",
                                "link": "https://www.swiggy.com/city/osmanabad"
                            },
                            {
                                "text": "Modinagar",
                                "link": "https://www.swiggy.com/city/modinagar"
                            },
                            {
                                "text": "Gadag-Betigeri",
                                "link": "https://www.swiggy.com/city/gadag-betigeri"
                            },
                            {
                                "text": "Hoshangabad",
                                "link": "https://www.swiggy.com/city/hoshangabad"
                            },
                            {
                                "text": "Jaunpur",
                                "link": "https://www.swiggy.com/city/jaunpur"
                            },
                            {
                                "text": "Khurja",
                                "link": "https://www.swiggy.com/city/khurja"
                            },
                            {
                                "text": "Port Blair",
                                "link": "https://www.swiggy.com/city/port-blair"
                            },
                            {
                                "text": "Jorhat",
                                "link": "https://www.swiggy.com/city/jorhat"
                            },
                            {
                                "text": "Nandyal",
                                "link": "https://www.swiggy.com/city/nandyal"
                            },
                            {
                                "text": "Biharsharif",
                                "link": "https://www.swiggy.com/city/biharsharif"
                            },
                            {
                                "text": "Buxar",
                                "link": "https://www.swiggy.com/city/buxar"
                            },
                            {
                                "text": "Siwan",
                                "link": "https://www.swiggy.com/city/siwan"
                            },
                            {
                                "text": "Dehri",
                                "link": "https://www.swiggy.com/city/dehri"
                            },
                            {
                                "text": "Bettiah",
                                "link": "https://www.swiggy.com/city/bettiah"
                            },
                            {
                                "text": "Kishanganj",
                                "link": "https://www.swiggy.com/city/kishanganj"
                            },
                            {
                                "text": "Saharsa",
                                "link": "https://www.swiggy.com/city/saharsa"
                            },
                            {
                                "text": "Hajipur",
                                "link": "https://www.swiggy.com/city/hajipur"
                            },
                            {
                                "text": "Motihari",
                                "link": "https://www.swiggy.com/city/motihari"
                            },
                            {
                                "text": "Sasaram",
                                "link": "https://www.swiggy.com/city/sasaram"
                            },
                            {
                                "text": "Munger",
                                "link": "https://www.swiggy.com/city/munger"
                            },
                            {
                                "text": "Katihar",
                                "link": "https://www.swiggy.com/city/katihar"
                            },
                            {
                                "text": "Arrah",
                                "link": "https://www.swiggy.com/city/arrah"
                            },
                            {
                                "text": "Srikakulam",
                                "link": "https://www.swiggy.com/city/srikakulam"
                            },
                            {
                                "text": "Begusarai",
                                "link": "https://www.swiggy.com/city/begusarai"
                            },
                            {
                                "text": "Neyveli",
                                "link": "https://www.swiggy.com/city/neyveli"
                            },
                            {
                                "text": "Waidhan",
                                "link": "https://www.swiggy.com/city/waidhan"
                            },
                            {
                                "text": "Markapur",
                                "link": "https://www.swiggy.com/city/markapur"
                            },
                            {
                                "text": "Chikkaballapur",
                                "link": "https://www.swiggy.com/city/chikkaballapur"
                            },
                            {
                                "text": "Bhatkal",
                                "link": "https://www.swiggy.com/city/bhatkal"
                            },
                            {
                                "text": "Gokak",
                                "link": "https://www.swiggy.com/city/gokak"
                            },
                            {
                                "text": "Itarsi",
                                "link": "https://www.swiggy.com/city/itarsi"
                            },
                            {
                                "text": "Dabra",
                                "link": "https://www.swiggy.com/city/dabra"
                            },
                            {
                                "text": "Dhar",
                                "link": "https://www.swiggy.com/city/dhar"
                            },
                            {
                                "text": "Chalisgaon",
                                "link": "https://www.swiggy.com/city/chalisgaon"
                            },
                            {
                                "text": "Thiruvallur",
                                "link": "https://www.swiggy.com/city/thiruvallur"
                            },
                            {
                                "text": "Namakkal",
                                "link": "https://www.swiggy.com/city/namakkal"
                            },
                            {
                                "text": "Dharmapuri",
                                "link": "https://www.swiggy.com/city/dharmapuri"
                            },
                            {
                                "text": "Bhandara",
                                "link": "https://www.swiggy.com/city/bhandara"
                            },
                            {
                                "text": "Virudhunagar",
                                "link": "https://www.swiggy.com/city/virudhunagar"
                            },
                            {
                                "text": "Siddipet",
                                "link": "https://www.swiggy.com/city/siddipet"
                            },
                            {
                                "text": "Gadwal",
                                "link": "https://www.swiggy.com/city/gadwal"
                            },
                            {
                                "text": "Bodhan-Rural",
                                "link": "https://www.swiggy.com/city/bodhan-rural"
                            },
                            {
                                "text": "Kamareddy",
                                "link": "https://www.swiggy.com/city/kamareddy"
                            },
                            {
                                "text": "Jhunjhunu",
                                "link": "https://www.swiggy.com/city/jhunjhunu"
                            },
                            {
                                "text": "Kapurthala",
                                "link": "https://www.swiggy.com/city/kapurthala"
                            },
                            {
                                "text": "Sangrur",
                                "link": "https://www.swiggy.com/city/sangrur"
                            },
                            {
                                "text": "Gurdaspur",
                                "link": "https://www.swiggy.com/city/gurdaspur"
                            },
                            {
                                "text": "Ramgarh",
                                "link": "https://www.swiggy.com/city/ramgarh"
                            },
                            {
                                "text": "Bantwal",
                                "link": "https://www.swiggy.com/city/bantwal"
                            },
                            {
                                "text": "Doddaballapura",
                                "link": "https://www.swiggy.com/city/doddaballapura"
                            },
                            {
                                "text": "Buldana",
                                "link": "https://www.swiggy.com/city/buldana"
                            },
                            {
                                "text": "Karad",
                                "link": "https://www.swiggy.com/city/karad"
                            },
                            {
                                "text": "Krishnagiri",
                                "link": "https://www.swiggy.com/city/krishnagiri"
                            },
                            {
                                "text": "Tiptur",
                                "link": "https://www.swiggy.com/city/tiptur"
                            },
                            {
                                "text": "Bhadrachalam",
                                "link": "https://www.swiggy.com/city/bhadrachalam"
                            },
                            {
                                "text": "Mancherial",
                                "link": "https://www.swiggy.com/city/mancherial"
                            },
                            {
                                "text": "Balrampur",
                                "link": "https://www.swiggy.com/city/balrampur"
                            },
                            {
                                "text": "Bharabanki",
                                "link": "https://www.swiggy.com/city/bharabanki"
                            },
                            {
                                "text": "Malout",
                                "link": "https://www.swiggy.com/city/malout"
                            },
                            {
                                "text": "Fatehgarh Sahib",
                                "link": "https://www.swiggy.com/city/fatehgarh-sahib"
                            },
                            {
                                "text": "Ropar",
                                "link": "https://www.swiggy.com/city/ropar"
                            },
                            {
                                "text": "Nangal",
                                "link": "https://www.swiggy.com/city/nangal"
                            },
                            {
                                "text": "Narnaul",
                                "link": "https://www.swiggy.com/city/narnaul"
                            },
                            {
                                "text": "Naraingarh",
                                "link": "https://www.swiggy.com/city/naraingarh"
                            },
                            {
                                "text": "Himmatnagar",
                                "link": "https://www.swiggy.com/city/himmatnagar"
                            },
                            {
                                "text": "Dausa",
                                "link": "https://www.swiggy.com/city/dausa"
                            },
                            {
                                "text": "Jahanabad",
                                "link": "https://www.swiggy.com/city/jahanabad"
                            },
                            {
                                "text": "Samastipur",
                                "link": "https://www.swiggy.com/city/samastipur"
                            },
                            {
                                "text": "Purnea",
                                "link": "https://www.swiggy.com/city/purnea"
                            },
                            {
                                "text": "Berhampur",
                                "link": "https://www.swiggy.com/city/berhampur"
                            },
                            {
                                "text": "Malda",
                                "link": "https://www.swiggy.com/city/malda"
                            },
                            {
                                "text": "Tuni",
                                "link": "https://www.swiggy.com/city/tuni"
                            },
                            {
                                "text": "Puttur",
                                "link": "https://www.swiggy.com/city/puttur"
                            },
                            {
                                "text": "Rayachoty",
                                "link": "https://www.swiggy.com/city/rayachoty"
                            },
                            {
                                "text": "Medak",
                                "link": "https://www.swiggy.com/city/medak"
                            },
                            {
                                "text": "Nirmal",
                                "link": "https://www.swiggy.com/city/nirmal"
                            },
                            {
                                "text": "Mirzapur",
                                "link": "https://www.swiggy.com/city/mirzapur"
                            },
                            {
                                "text": "Tanuku",
                                "link": "https://www.swiggy.com/city/tanuku"
                            },
                            {
                                "text": "Dahod",
                                "link": "https://www.swiggy.com/city/dahod"
                            },
                            {
                                "text": "Barmer",
                                "link": "https://www.swiggy.com/city/barmer"
                            },
                            {
                                "text": "Gangapur City",
                                "link": "https://www.swiggy.com/city/gangapur-city"
                            },
                            {
                                "text": "Mandi Gobindgarh",
                                "link": "https://www.swiggy.com/city/mandi-gobindgarh"
                            },
                            {
                                "text": "Tarn Taran Sahib",
                                "link": "https://www.swiggy.com/city/tarn-taran-sahib"
                            },
                            {
                                "text": "Nakodar",
                                "link": "https://www.swiggy.com/city/nakodar"
                            },
                            {
                                "text": "Ankleshwar",
                                "link": "https://www.swiggy.com/city/ankleshwar"
                            },
                            {
                                "text": "Vyara",
                                "link": "https://www.swiggy.com/city/vyara"
                            },
                            {
                                "text": "Bardoli",
                                "link": "https://www.swiggy.com/city/bardoli"
                            },
                            {
                                "text": "Halol",
                                "link": "https://www.swiggy.com/city/halol"
                            },
                            {
                                "text": "Bijnor",
                                "link": "https://www.swiggy.com/city/bijnor"
                            },
                            {
                                "text": "Sawantwadi",
                                "link": "https://www.swiggy.com/city/sawantwadi"
                            },
                            {
                                "text": "Shrirampur",
                                "link": "https://www.swiggy.com/city/shrirampur"
                            },
                            {
                                "text": "Sangamner",
                                "link": "https://www.swiggy.com/city/sangamner"
                            },
                            {
                                "text": "Baramati",
                                "link": "https://www.swiggy.com/city/baramati"
                            },
                            {
                                "text": "Betul",
                                "link": "https://www.swiggy.com/city/betul"
                            },
                            {
                                "text": "Chhatarpur",
                                "link": "https://www.swiggy.com/city/chhatarpur"
                            },
                            {
                                "text": "Datia",
                                "link": "https://www.swiggy.com/city/datia"
                            },
                            {
                                "text": "Balaghat",
                                "link": "https://www.swiggy.com/city/balaghat"
                            },
                            {
                                "text": "Sivakasi",
                                "link": "https://www.swiggy.com/city/sivakasi"
                            },
                            {
                                "text": "Viluppuram",
                                "link": "https://www.swiggy.com/city/viluppuram"
                            },
                            {
                                "text": "Ramanathapuram",
                                "link": "https://www.swiggy.com/city/ramanathapuram"
                            },
                            {
                                "text": "Sirsi",
                                "link": "https://www.swiggy.com/city/sirsi"
                            },
                            {
                                "text": "Kodaikanal",
                                "link": "https://www.swiggy.com/city/kodaikanal"
                            },
                            {
                                "text": "Theni",
                                "link": "https://www.swiggy.com/city/theni"
                            },
                            {
                                "text": "Karur",
                                "link": "https://www.swiggy.com/city/karur"
                            },
                            {
                                "text": "Karwar",
                                "link": "https://www.swiggy.com/city/karwar"
                            },
                            {
                                "text": "Sindhanur",
                                "link": "https://www.swiggy.com/city/sindhanur"
                            },
                            {
                                "text": "Kannur",
                                "link": "https://www.swiggy.com/city/kannur"
                            },
                            {
                                "text": "Noida 1",
                                "link": "https://www.swiggy.com/city/noida-1"
                            },
                            {
                                "text": "Karunagappaly",
                                "link": "https://www.swiggy.com/city/karunagappaly"
                            },
                            {
                                "text": "Thiruvalla",
                                "link": "https://www.swiggy.com/city/thiruvalla"
                            },
                            {
                                "text": "Thodupuzha",
                                "link": "https://www.swiggy.com/city/thodupuzha"
                            },
                            {
                                "text": "Kadiri",
                                "link": "https://www.swiggy.com/city/kadiri"
                            },
                            {
                                "text": "Kavali",
                                "link": "https://www.swiggy.com/city/kavali"
                            },
                            {
                                "text": "Tezpur",
                                "link": "https://www.swiggy.com/city/tezpur"
                            },
                            {
                                "text": "Kayamkulam",
                                "link": "https://www.swiggy.com/city/kayamkulam"
                            },
                            {
                                "text": "Kottarakkara",
                                "link": "https://www.swiggy.com/city/kottarakkara"
                            },
                            {
                                "text": "Mandi Dabwali",
                                "link": "https://www.swiggy.com/city/mandi-dabwali"
                            },
                            {
                                "text": "Fatehabad",
                                "link": "https://www.swiggy.com/city/fatehabad"
                            },
                            {
                                "text": "Jagraon",
                                "link": "https://www.swiggy.com/city/jagraon"
                            },
                            {
                                "text": "Mansa",
                                "link": "https://www.swiggy.com/city/mansa"
                            },
                            {
                                "text": "Pinjore City",
                                "link": "https://www.swiggy.com/city/pinjore-city"
                            },
                            {
                                "text": "Fazilka",
                                "link": "https://www.swiggy.com/city/fazilka"
                            },
                            {
                                "text": "Baddi",
                                "link": "https://www.swiggy.com/city/baddi"
                            },
                            {
                                "text": "Solan",
                                "link": "https://www.swiggy.com/city/solan"
                            },
                            {
                                "text": "Daltonganj",
                                "link": "https://www.swiggy.com/city/daltonganj"
                            },
                            {
                                "text": "Balangir",
                                "link": "https://www.swiggy.com/city/balangir"
                            },
                            {
                                "text": "Paonta Sahib",
                                "link": "https://www.swiggy.com/city/paonta-sahib"
                            },
                            {
                                "text": "Kothagudem",
                                "link": "https://www.swiggy.com/city/kothagudem"
                            },
                            {
                                "text": "Hansi",
                                "link": "https://www.swiggy.com/city/hansi"
                            },
                            {
                                "text": "Aurangabad_Bihar",
                                "link": "https://www.swiggy.com/city/aurangabadbihar"
                            },
                            {
                                "text": "Charkhi Dadri",
                                "link": "https://www.swiggy.com/city/charkhi-dadri"
                            },
                            {
                                "text": "Gopalganj",
                                "link": "https://www.swiggy.com/city/gopalganj"
                            },
                            {
                                "text": "Jharsuguda",
                                "link": "https://www.swiggy.com/city/jharsuguda"
                            },
                            {
                                "text": "Tohana",
                                "link": "https://www.swiggy.com/city/tohana"
                            },
                            {
                                "text": "Jhalawar",
                                "link": "https://www.swiggy.com/city/jhalawar"
                            },
                            {
                                "text": "Sivasagar",
                                "link": "https://www.swiggy.com/city/sivasagar"
                            },
                            {
                                "text": "Bagdogra",
                                "link": "https://www.swiggy.com/city/bagdogra"
                            },
                            {
                                "text": "Angul",
                                "link": "https://www.swiggy.com/city/angul"
                            },
                            {
                                "text": "Kendrapada",
                                "link": "https://www.swiggy.com/city/kendrapada"
                            },
                            {
                                "text": "Mallapuram (Do not Use)",
                                "link": "https://www.swiggy.com/city/mallapuram-do-not-use"
                            },
                            {
                                "text": "Veraval",
                                "link": "https://www.swiggy.com/city/veraval"
                            },
                            {
                                "text": "Daman",
                                "link": "https://www.swiggy.com/city/daman"
                            },
                            {
                                "text": "Chiplun",
                                "link": "https://www.swiggy.com/city/chiplun"
                            },
                            {
                                "text": "Silvassa",
                                "link": "https://www.swiggy.com/city/silvassa"
                            },
                            {
                                "text": "Bapatla&Chirala",
                                "link": "https://www.swiggy.com/city/bapatla-and-chirala"
                            },
                            {
                                "text": "Lonavla",
                                "link": "https://www.swiggy.com/city/lonavla"
                            },
                            {
                                "text": "Bongaigaon",
                                "link": "https://www.swiggy.com/city/bongaigaon"
                            },
                            {
                                "text": "Golaghat",
                                "link": "https://www.swiggy.com/city/golaghat"
                            },
                            {
                                "text": "Duliajan",
                                "link": "https://www.swiggy.com/city/duliajan"
                            },
                            {
                                "text": "Ramnagar",
                                "link": "https://www.swiggy.com/city/ramnagar"
                            },
                            {
                                "text": "Bolpur",
                                "link": "https://www.swiggy.com/city/bolpur"
                            },
                            {
                                "text": "Madhubani",
                                "link": "https://www.swiggy.com/city/madhubani"
                            },
                            {
                                "text": "Balasore",
                                "link": "https://www.swiggy.com/city/balasore"
                            },
                            {
                                "text": "Palampur",
                                "link": "https://www.swiggy.com/city/palampur"
                            },
                            {
                                "text": "Kotdwar",
                                "link": "https://www.swiggy.com/city/kotdwar"
                            },
                            {
                                "text": "Koppal",
                                "link": "https://www.swiggy.com/city/koppal"
                            },
                            {
                                "text": "Chikhli",
                                "link": "https://www.swiggy.com/city/chikhli"
                            },
                            {
                                "text": "Dahanu",
                                "link": "https://www.swiggy.com/city/dahanu"
                            },
                            {
                                "text": "Itanagar",
                                "link": "https://www.swiggy.com/city/itanagar"
                            },
                            {
                                "text": "Rangpo",
                                "link": "https://www.swiggy.com/city/rangpo"
                            },
                            {
                                "text": "Aizawl",
                                "link": "https://www.swiggy.com/city/aizawl"
                            },
                            {
                                "text": "Gangtok",
                                "link": "https://www.swiggy.com/city/gangtok"
                            },
                            {
                                "text": "Mayiladuthurai",
                                "link": "https://www.swiggy.com/city/mayiladuthurai"
                            },
                            {
                                "text": "Kannauj",
                                "link": "https://www.swiggy.com/city/kannauj"
                            },
                            {
                                "text": "Cooch Behar",
                                "link": "https://www.swiggy.com/city/cooch-behar"
                            },
                            {
                                "text": "Jaigaon",
                                "link": "https://www.swiggy.com/city/jaigaon"
                            },
                            {
                                "text": "Palani",
                                "link": "https://www.swiggy.com/city/palani"
                            },
                            {
                                "text": "Bilimora",
                                "link": "https://www.swiggy.com/city/bilimora"
                            },
                            {
                                "text": "Udhampur",
                                "link": "https://www.swiggy.com/city/udhampur"
                            },
                            {
                                "text": "Boisar",
                                "link": "https://www.swiggy.com/city/boisar"
                            },
                            {
                                "text": "Kohima",
                                "link": "https://www.swiggy.com/city/kohima"
                            },
                            {
                                "text": "Naharlagun",
                                "link": "https://www.swiggy.com/city/naharlagun"
                            },
                            {
                                "text": "Dumka",
                                "link": "https://www.swiggy.com/city/dumka"
                            },
                            {
                                "text": "Rajsamand",
                                "link": "https://www.swiggy.com/city/rajsamand"
                            },
                            {
                                "text": "Gauriganj",
                                "link": "https://www.swiggy.com/city/gauriganj"
                            },
                            {
                                "text": "Bodinayakanur",
                                "link": "https://www.swiggy.com/city/bodinayakanur"
                            },
                            {
                                "text": "Bhawanipatna",
                                "link": "https://www.swiggy.com/city/bhawanipatna"
                            },
                            {
                                "text": "Baran",
                                "link": "https://www.swiggy.com/city/baran"
                            },
                            {
                                "text": "Narsinghpur",
                                "link": "https://www.swiggy.com/city/narsinghpur"
                            },
                            {
                                "text": "Uran Islampur",
                                "link": "https://www.swiggy.com/city/uran-islampur"
                            },
                            {
                                "text": "Kovilpatti",
                                "link": "https://www.swiggy.com/city/kovilpatti"
                            },
                            {
                                "text": "Kasaragod",
                                "link": "https://www.swiggy.com/city/kasaragod"
                            },
                            {
                                "text": "Pusad",
                                "link": "https://www.swiggy.com/city/pusad"
                            },
                            {
                                "text": "Kendujhar",
                                "link": "https://www.swiggy.com/city/kendujhar"
                            },
                            {
                                "text": "Manali",
                                "link": "https://www.swiggy.com/city/manali"
                            },
                            {
                                "text": "Diu",
                                "link": "https://www.swiggy.com/city/diu"
                            },
                            {
                                "text": "Khamgaon",
                                "link": "https://www.swiggy.com/city/khamgaon"
                            },
                            {
                                "text": "Ramanagara",
                                "link": "https://www.swiggy.com/city/ramanagara"
                            },
                            {
                                "text": "Alipurduar",
                                "link": "https://www.swiggy.com/city/alipurduar"
                            },
                            {
                                "text": "Almora",
                                "link": "https://www.swiggy.com/city/almora"
                            },
                            {
                                "text": "Jhargram",
                                "link": "https://www.swiggy.com/city/jhargram"
                            },
                            {
                                "text": "Arambagh",
                                "link": "https://www.swiggy.com/city/arambagh"
                            },
                            {
                                "text": "Bhadohi",
                                "link": "https://www.swiggy.com/city/bhadohi"
                            },
                            {
                                "text": "Tenkasi",
                                "link": "https://www.swiggy.com/city/tenkasi"
                            },
                            {
                                "text": "Srivilliputhur",
                                "link": "https://www.swiggy.com/city/srivilliputhur"
                            },
                            {
                                "text": "Chidambaram",
                                "link": "https://www.swiggy.com/city/chidambaram"
                            },
                            {
                                "text": "Rajgarh",
                                "link": "https://www.swiggy.com/city/rajgarh"
                            },
                            {
                                "text": "Pratapgarh",
                                "link": "https://www.swiggy.com/city/pratapgarh"
                            },
                            {
                                "text": "Washim",
                                "link": "https://www.swiggy.com/city/washim"
                            },
                            {
                                "text": "Mandi HP",
                                "link": "https://www.swiggy.com/city/mandi-hp"
                            },
                            {
                                "text": "Ranaghat",
                                "link": "https://www.swiggy.com/city/ranaghat"
                            },
                            {
                                "text": "Raghunathpur",
                                "link": "https://www.swiggy.com/city/raghunathpur"
                            },
                            {
                                "text": "Suri",
                                "link": "https://www.swiggy.com/city/suri"
                            },
                            {
                                "text": "Kadayanallur",
                                "link": "https://www.swiggy.com/city/kadayanallur"
                            },
                            {
                                "text": "Thiruvarur",
                                "link": "https://www.swiggy.com/city/thiruvarur"
                            },
                            {
                                "text": "Ranaghat-WB",
                                "link": "https://www.swiggy.com/city/ranaghat-wb"
                            },
                            {
                                "text": "Idukki",
                                "link": "https://www.swiggy.com/city/idukki"
                            },
                            {
                                "text": "Wayanad",
                                "link": "https://www.swiggy.com/city/wayanad"
                            },
                            {
                                "text": "Perambalur",
                                "link": "https://www.swiggy.com/city/perambalur"
                            },
                            {
                                "text": "Paramakudi",
                                "link": "https://www.swiggy.com/city/paramakudi"
                            },
                            {
                                "text": "Khopoli",
                                "link": "https://www.swiggy.com/city/khopoli"
                            },
                            {
                                "text": "Bela Pratapgarh",
                                "link": "https://www.swiggy.com/city/bela-pratapgarh"
                            },
                            {
                                "text": "Mahoba",
                                "link": "https://www.swiggy.com/city/mahoba"
                            },
                            {
                                "text": "Sitamarhi",
                                "link": "https://www.swiggy.com/city/sitamarhi"
                            },
                            {
                                "text": "Chakdaha",
                                "link": "https://www.swiggy.com/city/chakdaha"
                            },
                            {
                                "text": "Khalilabad",
                                "link": "https://www.swiggy.com/city/khalilabad"
                            },
                            {
                                "text": "Pattukkottai",
                                "link": "https://www.swiggy.com/city/pattukkottai"
                            },
                            {
                                "text": "Tindivanam",
                                "link": "https://www.swiggy.com/city/tindivanam"
                            },
                            {
                                "text": "Tiruttani",
                                "link": "https://www.swiggy.com/city/tiruttani"
                            },
                            {
                                "text": "Gangarampur",
                                "link": "https://www.swiggy.com/city/gangarampur"
                            },
                            {
                                "text": "Dharapuram",
                                "link": "https://www.swiggy.com/city/dharapuram"
                            },
                            {
                                "text": "Arakkonam",
                                "link": "https://www.swiggy.com/city/arakkonam"
                            },
                            {
                                "text": "Sirkali",
                                "link": "https://www.swiggy.com/city/sirkali"
                            },
                            {
                                "text": "Aruppukottai",
                                "link": "https://www.swiggy.com/city/aruppukottai"
                            },
                            {
                                "text": "Mettupalayam",
                                "link": "https://www.swiggy.com/city/mettupalayam"
                            },
                            {
                                "text": "Digboi",
                                "link": "https://www.swiggy.com/city/digboi"
                            },
                            {
                                "text": "Biswanath Chariali",
                                "link": "https://www.swiggy.com/city/biswanath-chariali"
                            },
                            {
                                "text": "Nalbari",
                                "link": "https://www.swiggy.com/city/nalbari"
                            },
                            {
                                "text": "Shirdi city",
                                "link": "https://www.swiggy.com/city/shirdi-city"
                            },
                            {
                                "text": "Mukerian",
                                "link": "https://www.swiggy.com/city/mukerian"
                            },
                            {
                                "text": "Hosur",
                                "link": "https://www.swiggy.com/city/hosur"
                            },
                            {
                                "text": "Palakollu",
                                "link": "https://www.swiggy.com/city/palakollu"
                            },
                            {
                                "text": "Amalapuram",
                                "link": "https://www.swiggy.com/city/amalapuram"
                            },
                            {
                                "text": "Ravulapalem",
                                "link": "https://www.swiggy.com/city/ravulapalem"
                            },
                            {
                                "text": "Narsipatnam",
                                "link": "https://www.swiggy.com/city/narsipatnam"
                            },
                            {
                                "text": "Barh",
                                "link": "https://www.swiggy.com/city/barh"
                            },
                            {
                                "text": "Palghar",
                                "link": "https://www.swiggy.com/city/palghar"
                            },
                            {
                                "text": "Shahdol",
                                "link": "https://www.swiggy.com/city/shahdol"
                            },
                            {
                                "text": "Kushalnagar",
                                "link": "https://www.swiggy.com/city/kushalnagar"
                            },
                            {
                                "text": "Dungarpur",
                                "link": "https://www.swiggy.com/city/dungarpur"
                            },
                            {
                                "text": "Chaibasa",
                                "link": "https://www.swiggy.com/city/chaibasa"
                            },
                            {
                                "text": "Haveri",
                                "link": "https://www.swiggy.com/city/haveri"
                            },
                            {
                                "text": "Karaikal",
                                "link": "https://www.swiggy.com/city/karaikal"
                            },
                            {
                                "text": "Jjajjar",
                                "link": "https://www.swiggy.com/city/jjajjar"
                            },
                            {
                                "text": "Kokrajhar",
                                "link": "https://www.swiggy.com/city/kokrajhar"
                            },
                            {
                                "text": "Rangia",
                                "link": "https://www.swiggy.com/city/rangia"
                            },
                            {
                                "text": "Hamirpur",
                                "link": "https://www.swiggy.com/city/hamirpur"
                            },
                            {
                                "text": "Una",
                                "link": "https://www.swiggy.com/city/una"
                            },
                            {
                                "text": "Sulthan Bathery",
                                "link": "https://www.swiggy.com/city/sulthan-bathery"
                            },
                            {
                                "text": "Rayagada",
                                "link": "https://www.swiggy.com/city/rayagada"
                            },
                            {
                                "text": "Paradeep",
                                "link": "https://www.swiggy.com/city/paradeep"
                            },
                            {
                                "text": "Mandapeta",
                                "link": "https://www.swiggy.com/city/mandapeta"
                            },
                            {
                                "text": "Jamui",
                                "link": "https://www.swiggy.com/city/jamui"
                            },
                            {
                                "text": "Pilkhuwa",
                                "link": "https://www.swiggy.com/city/pilkhuwa"
                            },
                            {
                                "text": "Parvathipuram",
                                "link": "https://www.swiggy.com/city/parvathipuram"
                            },
                            {
                                "text": "Ambajogai",
                                "link": "https://www.swiggy.com/city/ambajogai"
                            },
                            {
                                "text": "Araria",
                                "link": "https://www.swiggy.com/city/araria"
                            },
                            {
                                "text": "North Lakhimpur",
                                "link": "https://www.swiggy.com/city/north-lakhimpur"
                            },
                            {
                                "text": "Rajampet",
                                "link": "https://www.swiggy.com/city/rajampet"
                            },
                            {
                                "text": "Udumalaipettai",
                                "link": "https://www.swiggy.com/city/udumalaipettai"
                            },
                            {
                                "text": "Tirupattur",
                                "link": "https://www.swiggy.com/city/tirupattur"
                            },
                            {
                                "text": "Hojai",
                                "link": "https://www.swiggy.com/city/hojai"
                            },
                            {
                                "text": "Khagaria",
                                "link": "https://www.swiggy.com/city/khagaria"
                            },
                            {
                                "text": "Dasuya",
                                "link": "https://www.swiggy.com/city/dasuya"
                            },
                            {
                                "text": "Gudur",
                                "link": "https://www.swiggy.com/city/gudur"
                            },
                            {
                                "text": "Sullurpeta",
                                "link": "https://www.swiggy.com/city/sullurpeta"
                            },
                            {
                                "text": "Piler",
                                "link": "https://www.swiggy.com/city/piler"
                            },
                            {
                                "text": "SankaranKoil",
                                "link": "https://www.swiggy.com/city/sankarankoil"
                            },
                            {
                                "text": "Nabha",
                                "link": "https://www.swiggy.com/city/nabha"
                            },
                            {
                                "text": "LPU - Phagwara",
                                "link": "https://www.swiggy.com/city/lpu-phagwara"
                            },
                            {
                                "text": "Jangipur",
                                "link": "https://www.swiggy.com/city/jangipur"
                            },
                            {
                                "text": "Roha",
                                "link": "https://www.swiggy.com/city/roha"
                            },
                            {
                                "text": "Maharajganj",
                                "link": "https://www.swiggy.com/city/maharajganj"
                            },
                            {
                                "text": "Kallakurichi",
                                "link": "https://www.swiggy.com/city/kallakurichi"
                            },
                            {
                                "text": "Kalimpong",
                                "link": "https://www.swiggy.com/city/kalimpong"
                            },
                            {
                                "text": "Sundernagar",
                                "link": "https://www.swiggy.com/city/sundernagar"
                            },
                            {
                                "text": "Nawada",
                                "link": "https://www.swiggy.com/city/nawada"
                            },
                            {
                                "text": "Forbesganj",
                                "link": "https://www.swiggy.com/city/forbesganj"
                            },
                            {
                                "text": "Mokameh Khas",
                                "link": "https://www.swiggy.com/city/mokameh-khas"
                            },
                            {
                                "text": "Bazpur",
                                "link": "https://www.swiggy.com/city/bazpur"
                            },
                            {
                                "text": "Lakhisarai",
                                "link": "https://www.swiggy.com/city/lakhisarai"
                            },
                            {
                                "text": "Rameswaram",
                                "link": "https://www.swiggy.com/city/rameswaram"
                            },
                            {
                                "text": "Sahjanwa",
                                "link": "https://www.swiggy.com/city/sahjanwa"
                            },
                            {
                                "text": "Siddharthnagar",
                                "link": "https://www.swiggy.com/city/siddharthnagar"
                            },
                            {
                                "text": "Nanjangud",
                                "link": "https://www.swiggy.com/city/nanjangud"
                            },
                            {
                                "text": "Chamarajanagar",
                                "link": "https://www.swiggy.com/city/chamarajanagar"
                            },
                            {
                                "text": "Kurali",
                                "link": "https://www.swiggy.com/city/kurali"
                            },
                            {
                                "text": "Sundar Nagar",
                                "link": "https://www.swiggy.com/city/sundar-nagar"
                            },
                            {
                                "text": "Bobbili",
                                "link": "https://www.swiggy.com/city/bobbili"
                            },
                            {
                                "text": "Jangaon",
                                "link": "https://www.swiggy.com/city/jangaon"
                            },
                            {
                                "text": "Banswara",
                                "link": "https://www.swiggy.com/city/banswara"
                            },
                            {
                                "text": "Sundergarh",
                                "link": "https://www.swiggy.com/city/sundergarh"
                            },
                            {
                                "text": "Godda",
                                "link": "https://www.swiggy.com/city/godda"
                            },
                            {
                                "text": "Madhupur",
                                "link": "https://www.swiggy.com/city/madhupur"
                            },
                            {
                                "text": "Katwa",
                                "link": "https://www.swiggy.com/city/katwa"
                            },
                            {
                                "text": "Dhupguri",
                                "link": "https://www.swiggy.com/city/dhupguri"
                            },
                            {
                                "text": "Contai",
                                "link": "https://www.swiggy.com/city/contai"
                            },
                            {
                                "text": "Baramulla",
                                "link": "https://www.swiggy.com/city/baramulla"
                            },
                            {
                                "text": "Kangeyam",
                                "link": "https://www.swiggy.com/city/kangeyam"
                            },
                            {
                                "text": "Naugachia",
                                "link": "https://www.swiggy.com/city/naugachia"
                            },
                            {
                                "text": "Madhepura",
                                "link": "https://www.swiggy.com/city/madhepura"
                            },
                            {
                                "text": "Jamkhambhaliya",
                                "link": "https://www.swiggy.com/city/jamkhambhaliya"
                            },
                            {
                                "text": "Mundra",
                                "link": "https://www.swiggy.com/city/mundra"
                            },
                            {
                                "text": "Patan",
                                "link": "https://www.swiggy.com/city/patan"
                            },
                            {
                                "text": "Mahuva",
                                "link": "https://www.swiggy.com/city/mahuva"
                            },
                            {
                                "text": "Attur",
                                "link": "https://www.swiggy.com/city/attur"
                            },
                            {
                                "text": "Pen",
                                "link": "https://www.swiggy.com/city/pen"
                            },
                            {
                                "text": "Mandla",
                                "link": "https://www.swiggy.com/city/mandla"
                            },
                            {
                                "text": "Sidhi",
                                "link": "https://www.swiggy.com/city/sidhi"
                            },
                            {
                                "text": "Lakshadweep",
                                "link": "https://www.swiggy.com/city/lakshadweep"
                            },
                            {
                                "text": "Chitrakoot",
                                "link": "https://www.swiggy.com/city/chitrakoot"
                            },
                            {
                                "text": "Rajam",
                                "link": "https://www.swiggy.com/city/rajam"
                            },
                            {
                                "text": "Nippani",
                                "link": "https://www.swiggy.com/city/nippani"
                            },
                            {
                                "text": "Sankeshwar",
                                "link": "https://www.swiggy.com/city/sankeshwar"
                            },
                            {
                                "text": "Chikkodi",
                                "link": "https://www.swiggy.com/city/chikkodi"
                            },
                            {
                                "text": "Modasa",
                                "link": "https://www.swiggy.com/city/modasa"
                            },
                            {
                                "text": "Bavla",
                                "link": "https://www.swiggy.com/city/bavla"
                            },
                            {
                                "text": "Puttur_AP",
                                "link": "https://www.swiggy.com/city/puttur-ap"
                            },
                            {
                                "text": "Sinnar",
                                "link": "https://www.swiggy.com/city/sinnar"
                            },
                            {
                                "text": "singur",
                                "link": "https://www.swiggy.com/city/singur"
                            },
                            {
                                "text": "Nelamangala",
                                "link": "https://www.swiggy.com/city/nelamangala"
                            },
                            {
                                "text": "Srinagar Uttarakhand",
                                "link": "https://www.swiggy.com/city/srinagar-uttarakhand"
                            },
                            {
                                "text": "Dhampur",
                                "link": "https://www.swiggy.com/city/dhampur"
                            }
                        ],
                        "id": "footer_content"
                    }
                }
            },
            {
                "card": {
                    "card": {
                        "@type": "type.googleapis.com/swiggy.seo.widgets.v1.MetaContext",
                        "citySlug": "bangalore",
                        "lat": "12.9715987",
                        "lng": "77.5945627",
                        "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/132.0.0.0 Safari/537.36",
                        "gandalfRequest": "{\"sortAttribute\":\"relevance\",\"isFiltered\":false,\"queryId\":\"seo-data-e21ae234-d3ae-452a-a500-6f7399432cb9\",\"seoParams\":{\"apiName\":\"FoodHomePage\",\"brandId\":\"\",\"seoUrl\":\"www.swiggy.com\",\"pageType\":\"FOOD_HOME_PAGE\",\"businessLine\":\"FOOD\"}}",
                        "id": "meta_data",
                        "metaInfo": {
                            "pageType": "FOOD_HOME_PAGE",
                            "pageTitle": "Order Food Online from India's Best Food Delivery Service | Swiggy",
                            "pageMetaDescription": "Order food online from restaurants and get it delivered. Serving in Bangalore, Hyderabad, Delhi and more. Order Pizzas, Biryanis, from Swiggy.",
                            "pageKeywords": "Food delivery, Online food order, Online food dleivery"
                        },
                        "screenType": "filteredCollection",
                        "seoParams": {
                            "apiName": "FoodHomePage",
                            "seoUrl": "www.swiggy.com",
                            "pageType": "FOOD_HOME_PAGE",
                            "businessLine": "FOOD"
                        },
                        "pageContext": {
                            "citySlug": "bangalore",
                            "cityName": "Bangalore",
                            "pageType": "FOOD_HOME_PAGE"
                        }
                    }
                }
            }
        ],
        "firstOffsetRequest": true,
        "cacheExpiryTime": 240,
        "nextFetch": 1
    },
    "tid": "37681b11-b467-4716-b6f6-76be757cded1",
    "sid": "ixt97309-2fb8-4082-819f-d83e96eda66e",
    "deviceId": "6c90e7bc-4db3-e5ff-465a-f48094c0bdf0",
    "csrfToken": "qXXCBJP3Kevz-g-mmixFhlJjxcHGBgdojURgtMmo"
};
var $dc74046c776679c5$export$44307b49e5e0b24d = [
    {
        info: {
            id: "1015873",
            name: "Domino's Chicken Fiesta",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2024/12/26/0ce90b3b-4793-4031-9f0c-559bdc1d7df3_1015873.JPG",
            locality: "Mohan Park",
            areaName: "Modi Nagar",
            costForTwo: "\u20B9400 for two",
            cuisines: [
                "Pizzas",
                "Italian",
                "Pastas",
                "Desserts"
            ],
            parentId: "533739",
            avgRatingString: "--",
            sla: {
                deliveryTime: 30,
                lastMileTravel: 3.9,
                serviceability: "SERVICEABLE",
                slaString: "25-30 mins",
                lastMileTravelString: "3.9 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-02-08 01:59:00",
                opened: true
            },
            badges: {},
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "40% OFF",
                subHeader: "UPTO \u20B980"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55"
        },
        cta: {
            link: "https://www.swiggy.com/city/modinagar/dominos-chicken-fiesta-mohan-park-modi-nagar-rest1015873",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        info: {
            id: "85998",
            name: "Domino's Pizza",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2025/2/7/1ec07a06-6d25-41bb-b4e5-4f1a9acfbae9_85998.JPG",
            locality: "Mohan Park",
            areaName: "Modi Nagar",
            costForTwo: "\u20B9400 for two",
            cuisines: [
                "Pizzas",
                "Italian",
                "Pastas",
                "Desserts"
            ],
            avgRating: 4.2,
            parentId: "2456",
            avgRatingString: "4.2",
            totalRatingsString: "1.3K+",
            sla: {
                deliveryTime: 30,
                lastMileTravel: 3.9,
                serviceability: "SERVICEABLE",
                slaString: "25-30 mins",
                lastMileTravelString: "3.9 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextCloseTime: "2025-02-08 01:55:00",
                opened: true
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "Rxawards/_CATEGORY-Pizza.png",
                        description: "Delivery!"
                    }
                ]
            },
            isOpen: true,
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "Delivery!",
                                    imageId: "Rxawards/_CATEGORY-Pizza.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "ITEMS",
                subHeader: "AT \u20B989"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55"
        },
        cta: {
            link: "https://www.swiggy.com/city/modinagar/dominos-pizza-mohan-park-modi-nagar-rest85998",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        info: {
            id: "400539",
            name: "Samar's Punjabi Chaap Corner",
            cloudinaryImageId: "gmargk5diknxfrjlngtk",
            locality: "Bhagwat Niwas",
            areaName: "Dayapuri",
            costForTwo: "\u20B9200 for two",
            cuisines: [
                "North Indian",
                "Tandoor"
            ],
            avgRating: 4.4,
            veg: true,
            parentId: "254346",
            avgRatingString: "4.4",
            totalRatingsString: "360",
            sla: {
                deliveryTime: 23,
                lastMileTravel: 1.6,
                serviceability: "SERVICEABLE_WITH_BANNER",
                slaString: "20-25 mins",
                lastMileTravelString: "1.6 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextOpenTimeMessage: "Opens next at 5:25 pm, tomorrow"
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "bolt/Bolt%20Listing%20badge@3x.png",
                        description: "bolt!"
                    },
                    {
                        imageId: "v1695133679/badges/Pure_Veg111.png",
                        description: "pureveg"
                    }
                ]
            },
            aggregatedDiscountInfoV2: {},
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "bolt!",
                                    imageId: "bolt/Bolt%20Listing%20badge@3x.png"
                                }
                            },
                            {
                                attributes: {
                                    description: "pureveg",
                                    imageId: "v1695133679/badges/Pure_Veg111.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55"
        },
        cta: {
            link: "https://www.swiggy.com/city/modinagar/samars-punjabi-chaap-corner-bhagwat-niwas-dayapuri-rest400539",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        info: {
            id: "886659",
            name: "Baap Of Chaap",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2024/5/18/093c08a3-2720-44df-85e7-39a5caf64bc7_886659.jpg",
            locality: "Modinagar",
            areaName: "Dayapuri",
            costForTwo: "\u20B9250 for two",
            cuisines: [
                "North Indian"
            ],
            avgRating: 4.3,
            veg: true,
            parentId: "458771",
            avgRatingString: "4.3",
            totalRatingsString: "167",
            sla: {
                deliveryTime: 23,
                lastMileTravel: 1.6,
                serviceability: "SERVICEABLE_WITH_BANNER",
                slaString: "20-25 mins",
                lastMileTravelString: "1.6 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextOpenTimeMessage: "Opens next at 12:55 pm, tomorrow"
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "bolt/Bolt%20Listing%20badge@3x.png",
                        description: "bolt!"
                    },
                    {
                        imageId: "v1695133679/badges/Pure_Veg111.png",
                        description: "pureveg"
                    }
                ]
            },
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "bolt!",
                                    imageId: "bolt/Bolt%20Listing%20badge@3x.png"
                                }
                            },
                            {
                                attributes: {
                                    description: "pureveg",
                                    imageId: "v1695133679/badges/Pure_Veg111.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "\u20B940 OFF",
                subHeader: "ABOVE \u20B9499",
                discountTag: "FLAT DEAL"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55"
        },
        cta: {
            link: "https://www.swiggy.com/city/modinagar/baap-of-chaap-dayapuri-rest886659",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        info: {
            id: "186409",
            name: "Jain Chaat Bhandar",
            cloudinaryImageId: "tauamvpvfo73ol11g2wk",
            locality: "Meerut Road",
            areaName: "Dayapuri",
            costForTwo: "\u20B9100 for two",
            cuisines: [
                "Indian"
            ],
            avgRating: 4.4,
            veg: true,
            parentId: "108834",
            avgRatingString: "4.4",
            totalRatingsString: "511",
            sla: {
                deliveryTime: 24,
                lastMileTravel: 1.3,
                serviceability: "SERVICEABLE_WITH_BANNER",
                slaString: "20-25 mins",
                lastMileTravelString: "1.3 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextOpenTimeMessage: "Temporarily closed for delivery"
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "v1695133679/badges/Pure_Veg111.png",
                        description: "pureveg"
                    }
                ]
            },
            aggregatedDiscountInfoV2: {},
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "pureveg",
                                    imageId: "v1695133679/badges/Pure_Veg111.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55"
        },
        cta: {
            link: "https://www.swiggy.com/city/modinagar/jain-chaat-bhandar-meerut-road-dayapuri-rest186409",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        info: {
            id: "244833",
            name: "Narang Restaurant",
            cloudinaryImageId: "xgdriumtwhjk9eqnz1zo",
            locality: "Dayapuri",
            areaName: "Dayapuri",
            costForTwo: "\u20B9400 for two",
            cuisines: [
                "Afghani"
            ],
            avgRating: 4.3,
            parentId: "453559",
            avgRatingString: "4.3",
            totalRatingsString: "382",
            sla: {
                deliveryTime: 25,
                lastMileTravel: 1.1,
                serviceability: "SERVICEABLE_WITH_BANNER",
                slaString: "25-30 mins",
                lastMileTravelString: "1.1 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextOpenTimeMessage: "Opens next at 12 noon, tomorrow"
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "bolt/Bolt%20Listing%20badge@3x.png",
                        description: "bolt!"
                    }
                ],
                textExtendedBadges: [
                    {
                        iconId: "Akash/Listing%20badge.png",
                        shortDescription: "Price Match Promise",
                        fontColor: "#7E808C"
                    }
                ]
            },
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "bolt!",
                                    imageId: "bolt/Bolt%20Listing%20badge@3x.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "",
                                    fontColor: "#7E808C",
                                    iconId: "Akash/Listing%20badge.png",
                                    shortDescription: "Price Match Promise"
                                }
                            }
                        ]
                    }
                }
            },
            aggregatedDiscountInfoV3: {
                header: "\u20B950 OFF",
                subHeader: "ABOVE \u20B9249",
                discountTag: "FLAT DEAL"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55"
        },
        cta: {
            link: "https://www.swiggy.com/city/modinagar/narang-restaurant-dayapuri-rest244833",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        info: {
            id: "475418",
            name: "Sky Cafe",
            cloudinaryImageId: "eduj2rw1e3sbacxzpxk8",
            locality: "Impala Tower",
            areaName: "Modinagar Locality",
            costForTwo: "\u20B9400 for two",
            cuisines: [
                "North Indian",
                "Chinese"
            ],
            avgRating: 4.2,
            veg: true,
            parentId: "189290",
            avgRatingString: "4.2",
            totalRatingsString: "259",
            sla: {
                deliveryTime: 33,
                lastMileTravel: 1.2,
                serviceability: "SERVICEABLE_WITH_BANNER",
                slaString: "30-35 mins",
                lastMileTravelString: "1.2 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextOpenTimeMessage: "Opens next at 12 noon, tomorrow"
            },
            badges: {
                imageBadges: [
                    {
                        imageId: "v1695133679/badges/Pure_Veg111.png",
                        description: "pureveg"
                    }
                ]
            },
            aggregatedDiscountInfoV2: {},
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {
                        badgeObject: [
                            {
                                attributes: {
                                    description: "pureveg",
                                    imageId: "v1695133679/badges/Pure_Veg111.png"
                                }
                            }
                        ]
                    },
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55"
        },
        cta: {
            link: "https://www.swiggy.com/city/modinagar/sky-cafe-impala-tower-modinagar-locality-rest475418",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    },
    {
        info: {
            id: "938075",
            name: "Renu's Kitchen",
            cloudinaryImageId: "RX_THUMBNAIL/IMAGES/VENDOR/2024/8/7/b88486a7-1003-43d3-a5f2-c2c742edacb8_938075.JPG",
            locality: "Dayapuri",
            areaName: "Dayapuri",
            costForTwo: "\u20B9199 for two",
            cuisines: [
                "Chinese",
                "Punjabi",
                "Thalis",
                "Indian",
                "Beverages",
                "Waffle",
                "Fast Food"
            ],
            parentId: "253648",
            avgRatingString: "--",
            sla: {
                deliveryTime: 22,
                lastMileTravel: 0.8,
                serviceability: "SERVICEABLE_WITH_BANNER",
                slaString: "20-25 mins",
                lastMileTravelString: "0.8 km",
                iconType: "ICON_TYPE_EMPTY"
            },
            availability: {
                nextOpenTimeMessage: "Opens next at 9 am, tomorrow"
            },
            badges: {},
            type: "F",
            badgesV2: {
                entityBadges: {
                    imageBased: {},
                    textBased: {},
                    textExtendedBadges: {}
                }
            },
            aggregatedDiscountInfoV3: {
                header: "10% OFF",
                subHeader: "UPTO \u20B940"
            },
            orderabilityCommunication: {
                title: {},
                subTitle: {},
                message: {},
                customIcon: {}
            },
            differentiatedUi: {
                displayType: "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                differentiatedUiMediaDetails: {
                    mediaType: "ADS_MEDIA_ENUM_IMAGE",
                    lottie: {},
                    video: {}
                }
            },
            reviewsSummary: {},
            displayType: "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            restaurantOfferPresentationInfo: {},
            externalRatings: {
                aggregatedRating: {
                    rating: "--"
                }
            },
            ratingsDisplayPreference: "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
        },
        analytics: {
            context: "seo-data-d9db2e6e-47fe-45a6-9a26-ee0c01e51a55"
        },
        cta: {
            link: "https://www.swiggy.com/city/modinagar/renus-kitchen-dayapuri-rest938075",
            text: "RESTAURANT_MENU",
            type: "WEBLINK"
        },
        widgetId: "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
    }
];

});

parcelRegister("5icQr", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return isDraft; });
$parcel$export(module.exports, "isDraftable", function () { return isDraftable; });
$parcel$export(module.exports, "current", function () { return current; });
$parcel$export(module.exports, "produce", function () { return produce; });

var $3Gvhd = parcelRequire("3Gvhd");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $hD5pT = parcelRequire("hD5pT");

var $5dLwP = parcelRequire("5dLwP");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $fPaN7 = parcelRequire("fPaN7");
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    throw new Error("[Immer] minified error nr: ".concat(error, ". Full error at: https://bit.ly/3cXEKWf"));
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) !== "object") return false;
    var proto = getPrototypeOf(value);
    if (proto === null) return true;
    var Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach(function(key) {
        iter(key, obj[key], obj);
    });
    else obj.forEach(function(entry, index) {
        return iter(index, entry, obj);
    });
}
function getArchtype(thing) {
    var state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    var t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    var isPlain = isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        var descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[DRAFT_STATE];
        var keys = Reflect.ownKeys(descriptors);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create(getPrototypeOf(base), descriptors);
    } else {
        var proto = getPrototypeOf(base);
        if (proto !== null && isPlain) return __spreadValues({}, base);
        var obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function freeze(obj) {
    var deep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(function(param) {
        var _param = (0, $kB67t._)(param, 2), key = _param[0], value = _param[1];
        return freeze(value, true);
    });
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    var plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    var state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    var baseDraft = scope.drafts_[0];
    var isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    if (!state) {
        each(value, function(key, childValue) {
            return finalizeProperty(rootScope, state, value, key, childValue, path);
        });
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        var result = state.copy_;
        var resultEach = result;
        var isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, function(key, childValue) {
            return finalizeProperty(rootScope, state, result, key, childValue, path, isSet2);
        });
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        var path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        var res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && (typeof prop === "undefined" ? "undefined" : (0, $YtE9h._)(prop)) !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value) {
    var deep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    var isArray = Array.isArray(base);
    var state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    var target = state;
    var traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    var _Proxy_revocable = Proxy.revocable(target, traps), revoke = _Proxy_revocable.revoke, proxy = _Proxy_revocable.proxy;
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get: function(state, prop) {
        if (prop === DRAFT_STATE) return state;
        var source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        var value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has: function(state, prop) {
        return prop in latest(state);
    },
    ownKeys: function(state) {
        return Reflect.ownKeys(latest(state));
    },
    set: function(state, prop, value) {
        var desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            var current2 = peek(latest(state), prop);
            var currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty: function(state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor: function(state, prop) {
        var owner = latest(state);
        var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty: function() {
        die(11);
    },
    getPrototypeOf: function(state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf: function() {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, function(key, fn) {
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    var state = draft[DRAFT_STATE];
    var source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    var desc = getDescriptorFromProto(source, prop);
    return desc ? "value" in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    var proto = getPrototypeOf(source);
    while(proto){
        var desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = /*#__PURE__*/ function() {
    "use strict";
    function Immer2(config) {
        var _this = this;
        (0, $bB0zn._)(this, Immer2);
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = function(base, recipe, patchListener) {
            if (typeof base === "function" && typeof recipe !== "function") {
                var defaultBase = recipe;
                recipe = base;
                var self = _this;
                return function curriedProduce() {
                    var _this = this;
                    var base2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultBase;
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _recipe;
                    return self.produce(base2, function(draft) {
                        return (_recipe = recipe).call.apply(_recipe, [
                            _this,
                            draft
                        ].concat((0, $2Xzd1._)(args)));
                    });
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            var result;
            if (isDraftable(base)) {
                var scope = enterScope(_this);
                var proxy = createProxy(base, void 0);
                var hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || (typeof base === "undefined" ? "undefined" : (0, $YtE9h._)(base)) !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (_this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    var p = [];
                    var ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = function(base, recipe) {
            var _this1 = _this;
            if (typeof base === "function") return function(state) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return _this1.produceWithPatches(state, function(draft) {
                    return base.apply(void 0, [
                        draft
                    ].concat((0, $2Xzd1._)(args)));
                });
            };
            var patches, inversePatches;
            var result = _this.produce(base, recipe, function(p, ip) {
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    (0, $6QEWP._)(Immer2, [
        {
            key: "createDraft",
            value: function createDraft(base) {
                if (!isDraftable(base)) die(8);
                if (isDraft(base)) base = current(base);
                var scope = enterScope(this);
                var proxy = createProxy(base, void 0);
                proxy[DRAFT_STATE].isManual_ = true;
                leaveScope(scope);
                return proxy;
            }
        },
        {
            key: "finishDraft",
            value: function finishDraft(draft, patchListener) {
                var state = draft && draft[DRAFT_STATE];
                if (!state || !state.isManual_) die(9);
                var scope = state.scope_;
                usePatchesInScope(scope, patchListener);
                return processResult(void 0, scope);
            }
        },
        {
            /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ key: "setAutoFreeze",
            value: function setAutoFreeze(value) {
                this.autoFreeze_ = value;
            }
        },
        {
            /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ key: "setUseStrictShallowCopy",
            value: function setUseStrictShallowCopy(value) {
                this.useStrictShallowCopy_ = value;
            }
        },
        {
            key: "applyPatches",
            value: function applyPatches(base, patches) {
                var i;
                for(i = patches.length - 1; i >= 0; i--){
                    var patch = patches[i];
                    if (patch.path.length === 0 && patch.op === "replace") {
                        base = patch.value;
                        break;
                    }
                }
                if (i > -1) patches = patches.slice(i + 1);
                var applyPatchesImpl = getPlugin("Patches").applyPatches_;
                if (isDraft(base)) return applyPatchesImpl(base, patches);
                return this.produce(base, function(draft) {
                    return applyPatchesImpl(draft, patches);
                });
            }
        }
    ]);
    return Immer2;
}();
function createProxy(value, parent) {
    var draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    var scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    var copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, function(key, childValue) {
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    var errorOffset = 16;
    var REPLACE = "replace";
    var ADD = "add";
    var REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, assigned_ = state.assigned_;
        var copy_ = state.copy_;
        if (copy_.length < base_.length) {
            var ref;
            ref = [
                copy_,
                base_
            ], base_ = ref[0], copy_ = ref[1], ref;
            var ref1;
            ref1 = [
                inversePatches,
                patches
            ], patches = ref1[0], inversePatches = ref1[1], ref1;
        }
        for(var i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            var path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(var i1 = base_.length; i1 < copy_.length; i1++){
            var path1 = basePath.concat([
                i1
            ]);
            patches.push({
                op: ADD,
                path: path1,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i1])
            });
        }
        for(var i2 = copy_.length - 1; base_.length <= i2; --i2){
            var path2 = basePath.concat([
                i2
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path2
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        each(state.assigned_, function(key, assignedValue) {
            var origValue = get(base_, key);
            var value = get(copy_, key);
            var op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            var path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        var i = 0;
        base_.forEach(function(value) {
            if (!copy_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach(function(value) {
            if (!base_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach(function(patch) {
            var path = patch.path, op = patch.op;
            var base = draft;
            for(var i = 0; i < path.length - 1; i++){
                var parentType = getArchtype(base);
                var p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if ((typeof base === "undefined" ? "undefined" : (0, $YtE9h._)(base)) !== "object") die(errorOffset + 2, path.join("/"));
            }
            var type = getArchtype(base);
            var value = deepClonePatchValue(patch.value);
            var key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(function(param) {
            var _param = (0, $kB67t._)(param, 2), k = _param[0], v = _param[1];
            return [
                k,
                deepClonePatchValue(v)
            ];
        }));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        var cloned = Object.create(getPrototypeOf(obj));
        for(var key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    var DraftMap = /*#__PURE__*/ function(Map1) {
        "use strict";
        (0, $5dLwP._)(DraftMap, Map1);
        function DraftMap(target, parent) {
            (0, $bB0zn._)(this, DraftMap);
            var _this;
            _this = (0, $3Gvhd._)(this, DraftMap);
            _this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: _this,
                isManual_: false,
                revoked_: false
            };
            return _this;
        }
        (0, $6QEWP._)(DraftMap, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(key) {
                    return latest(this[DRAFT_STATE]).has(key);
                }
            },
            {
                key: "set",
                value: function set(key, value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!latest(state).has(key) || latest(state).get(key) !== value) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_.set(key, true);
                        state.copy_.set(key, value);
                        state.assigned_.set(key, true);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(key) {
                    if (!this.has(key)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareMapCopy(state);
                    markChanged(state);
                    if (state.base_.has(key)) state.assigned_.set(key, false);
                    else state.assigned_.delete(key);
                    state.copy_.delete(key);
                    return true;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_ = /* @__PURE__ */ new Map();
                        each(state.base_, function(key) {
                            state.assigned_.set(key, false);
                        });
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var _this = this;
                    var state = this[DRAFT_STATE];
                    latest(state).forEach(function(_value, key, _map) {
                        cb.call(thisArg, _this.get(key), key, _this);
                    });
                }
            },
            {
                key: "get",
                value: function get(key) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    var value = latest(state).get(key);
                    if (state.finalized_ || !isDraftable(value)) return value;
                    if (value !== state.base_.get(key)) return value;
                    var draft = createProxy(value, state);
                    prepareMapCopy(state);
                    state.copy_.set(key, draft);
                    return draft;
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return latest(this[DRAFT_STATE]).keys();
                }
            },
            {
                key: "values",
                value: function values() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $hD5pT._)(_obj, Symbol.iterator, function() {
                        return _this.values();
                    }), (0, $hD5pT._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: value
                        };
                    }), _obj;
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $hD5pT._)(_obj, Symbol.iterator, function() {
                        return _this.entries();
                    }), (0, $hD5pT._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: [
                                r.value,
                                value
                            ]
                        };
                    }), _obj;
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.entries();
                }
            }
        ]);
        return DraftMap;
    }((0, $fPaN7._)(Map));
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    var DraftSet = /*#__PURE__*/ function(Set1) {
        "use strict";
        (0, $5dLwP._)(DraftSet, Set1);
        function DraftSet(target, parent) {
            (0, $bB0zn._)(this, DraftSet);
            var _this;
            _this = (0, $3Gvhd._)(this, DraftSet);
            _this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: _this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
            return _this;
        }
        (0, $6QEWP._)(DraftSet, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!state.copy_) return state.base_.has(value);
                    if (state.copy_.has(value)) return true;
                    if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
                    return false;
                }
            },
            {
                key: "add",
                value: function add(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!this.has(value)) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.add(value);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(value) {
                    if (!this.has(value)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    markChanged(state);
                    return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "values",
                value: function values() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.values();
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.entries();
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return this.values();
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.values();
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var iterator = this.values();
                    var result = iterator.next();
                    while(!result.done){
                        cb.call(thisArg, result.value, result.value, this);
                        result = iterator.next();
                    }
                }
            }
        ]);
        return DraftSet;
    }((0, $fPaN7._)(Set));
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach(function(value) {
                if (isDraftable(value)) {
                    var draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

});

parcelRegister("gcxSh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcb80b1c3e9300e6$export$2e2bcd8739ae039; });

var $7k5I8 = parcelRequire("7k5I8");

var $kB67t = parcelRequire("kB67t");

var $lFlDF = parcelRequire("lFlDF");

var $fIwXP = parcelRequire("fIwXP");

var $iVsXN = parcelRequire("iVsXN");
var $bcb80b1c3e9300e6$var$UseGetInstantMart = function() {
    var getInstaMart = function getInstaMart() {
        return _getInstaMart.apply(this, arguments);
    };
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), instantMartProduct = _useState[0], setInstantMartProduct = _useState[1];
    (0, $fIwXP.useEffect)(function() {
        getInstaMart();
    }, []);
    function _getInstaMart() {
        _getInstaMart = (0, $7k5I8._)(function() {
            var _data_data_widgets_, _data_data, response, data, martProduct, _instantMartJson_data_widgets_, _instantMartJson_data;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("https://www.swiggy.com/api/instamart/home?clientId=INSTAMART-APP")
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        data = _state.sent();
                        martProduct = data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : (_data_data_widgets_ = _data_data.widgets[4]) === null || _data_data_widgets_ === void 0 ? void 0 : _data_data_widgets_.data;
                        if (martProduct === undefined) {
                            ;
                            setInstantMartProduct((0, $iVsXN.instantMartJson) === null || (0, $iVsXN.instantMartJson) === void 0 ? void 0 : (_instantMartJson_data = (0, $iVsXN.instantMartJson).data) === null || _instantMartJson_data === void 0 ? void 0 : (_instantMartJson_data_widgets_ = _instantMartJson_data.widgets[3]) === null || _instantMartJson_data_widgets_ === void 0 ? void 0 : _instantMartJson_data_widgets_.data);
                            console.log("fromJson");
                        } else {
                            setInstantMartProduct(martProduct);
                            console.log("fromApi");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _getInstaMart.apply(this, arguments);
    }
    return instantMartProduct;
// return data?.data?.widgets[3]?.data
};
var $bcb80b1c3e9300e6$export$2e2bcd8739ae039 = $bcb80b1c3e9300e6$var$UseGetInstantMart;

});

parcelRegister("dg0St", function(module, exports) {


module.exports = (parcelRequire("jrcmb"))((parcelRequire("451Sc")).resolve("fNg5n")).then(function() {
    return parcelRequire('4JZv2');
});

});
parcelRegister("jrcmb", function(module, exports) {
"use strict";

var $bnxiY = parcelRequire("bnxiY");
module.exports = $bnxiY(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("bnxiY", function(module, exports) {
"use strict";
var $848bad63e2eca00a$var$cachedBundles = {};
var $848bad63e2eca00a$var$cachedPreloads = {};
var $848bad63e2eca00a$var$cachedPrefetches = {};
function $848bad63e2eca00a$var$getCache(type) {
    switch(type){
        case 'preload':
            return $848bad63e2eca00a$var$cachedPreloads;
        case 'prefetch':
            return $848bad63e2eca00a$var$cachedPrefetches;
        default:
            return $848bad63e2eca00a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $848bad63e2eca00a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("gyRE9", function(module, exports) {


module.exports = (parcelRequire("jrcmb"))((parcelRequire("451Sc")).resolve("4kfD8")).then(function() {
    return parcelRequire('9lnrZ');
});

});

parcelRegister("djdP9", function(module, exports) {


module.exports = (parcelRequire("jrcmb"))((parcelRequire("451Sc")).resolve("kkub5")).then(function() {
    return parcelRequire('8fAyO');
});

});

var $e4b08997485452b1$exports = {};


(parcelRequire("451Sc")).register((parcelRequire("i1aqH")).getBundleURL('6MXXU'), JSON.parse("[\"6MXXU\",\"index.764cd458.js\",\"i47zn\",\"logo.ac088745.png\",\"fNg5n\",\"Body.38240f9e.js\",\"4kfD8\",\"InstantMart.a2980758.js\",\"kkub5\",\"About.80e920c9.js\"]"));


var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");
var $fb34d4b6d3b01836$exports = {};
'use strict';
function $fb34d4b6d3b01836$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($fb34d4b6d3b01836$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$fb34d4b6d3b01836$var$checkDCE();

$fb34d4b6d3b01836$exports = (parcelRequire("gd2PY"));



var $abvdI = parcelRequire("abvdI");
var $dAaLE = parcelRequire("dAaLE");

var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");

var $abvdI = parcelRequire("abvdI");

var $fIwXP = parcelRequire("fIwXP");
var $0cf10ba694782b3e$var$UserContext = /*#__PURE__*/ (0, $fIwXP.createContext)({
    user: {
        name: "Dummy Name",
        email: "dummyname@gmail.com"
    }
});
var $0cf10ba694782b3e$export$2e2bcd8739ae039 = $0cf10ba694782b3e$var$UserContext;



var $eRslx = parcelRequire("eRslx");
function $f17388ede13a49cc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f17388ede13a49cc$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $f17388ede13a49cc$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");
// ✅ Initial State
var $8a4be34b89c09502$var$initialState = {
    cart: JSON.parse(localStorage.getItem("cart")) || [],
    count: localStorage.getItem("count") || 0
};
// ✅ Reducer Function
var $8a4be34b89c09502$var$cartReducer = function(state, action) {
    switch(action.type){
        case "ADD_TO_CART":
            {
                var updateCart = (0, $2Xzd1._)(state.cart).concat([
                    action.payload
                ]);
                var updateCount = +state.count + 1;
                // localStorage.setItem("cart",JSON.stringify(updateCart))
                // localStorage.setItem("count",updateCount) 
                return (0, $f17388ede13a49cc$export$71511d61b312f219)((0, $eRslx._)({}, state), {
                    cart: updateCart,
                    // Item add hoga
                    count: updateCount // Count update hoga
                });
            }
        case "REMOVE_FROM_CART":
            {
                var removeCart = state.cart.filter(function(item) {
                    var _item_info;
                    return (item === null || item === void 0 ? void 0 : (_item_info = item.info) === null || _item_info === void 0 ? void 0 : _item_info.id) !== action.payload;
                });
                var removeCount = state.count > 0 ? state.count - 1 : 0;
                localStorage.setItem("cart", JSON.stringify(removeCart));
                localStorage.setItem("count", removeCount);
                return (0, $f17388ede13a49cc$export$71511d61b312f219)((0, $eRslx._)({}, state), {
                    cart: removeCart,
                    // Remove item
                    count: removeCount // Count decrement  
                });
            }
        default:
            return state;
    }
};
var $8a4be34b89c09502$export$5558332cef65f159 = /*#__PURE__*/ (0, $fIwXP.createContext)();
var $8a4be34b89c09502$export$9081b9c87ee4e12e = function(param) {
    var children = param.children;
    var _useReducer = (0, $kB67t._)((0, $fIwXP.useReducer)($8a4be34b89c09502$var$cartReducer, $8a4be34b89c09502$var$initialState), 2), state = _useReducer[0], dispatch = _useReducer[1];
    // 🟢 Ensure localStorage updates on state change
    (0, $fIwXP.useEffect)(function() {
        localStorage.setItem("cart", JSON.stringify(state.cart));
        localStorage.setItem("count", state.count);
    }, [
        state.cart,
        state.count
    ]);
    return /*#__PURE__*/ (0, $cc6u1.jsx)($8a4be34b89c09502$export$5558332cef65f159.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};



var $hD5pT = parcelRequire("hD5pT");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $fIwXP = parcelRequire("fIwXP");
var $6dda7e3f4bfdb607$exports = {};
'use strict';

$6dda7e3f4bfdb607$exports = (parcelRequire("jYM0A"));


var $c7b80bd183211e5d$var$__defProp = Object.defineProperty;
var $c7b80bd183211e5d$var$__defProps = Object.defineProperties;
var $c7b80bd183211e5d$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c7b80bd183211e5d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c7b80bd183211e5d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c7b80bd183211e5d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c7b80bd183211e5d$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $c7b80bd183211e5d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $c7b80bd183211e5d$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($c7b80bd183211e5d$var$__hasOwnProp.call(b, prop)) $c7b80bd183211e5d$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($c7b80bd183211e5d$var$__getOwnPropSymbols) try {
        for(var _iterator = $c7b80bd183211e5d$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($c7b80bd183211e5d$var$__propIsEnum.call(b, prop)) $c7b80bd183211e5d$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $c7b80bd183211e5d$var$__spreadProps = function(a, b) {
    return $c7b80bd183211e5d$var$__defProps(a, $c7b80bd183211e5d$var$__getOwnPropDescs(b));
};
var $c7b80bd183211e5d$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($c7b80bd183211e5d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $c7b80bd183211e5d$var$__getOwnPropSymbols) try {
        for(var _iterator = $c7b80bd183211e5d$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $c7b80bd183211e5d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
// src/utils/react-is.ts
var $c7b80bd183211e5d$var$IS_REACT_19 = /* @__PURE__ */ $fIwXP.version.startsWith("19");
var $c7b80bd183211e5d$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($c7b80bd183211e5d$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $c7b80bd183211e5d$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $c7b80bd183211e5d$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $c7b80bd183211e5d$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $c7b80bd183211e5d$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $c7b80bd183211e5d$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $c7b80bd183211e5d$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $c7b80bd183211e5d$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $c7b80bd183211e5d$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $c7b80bd183211e5d$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $c7b80bd183211e5d$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $c7b80bd183211e5d$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $c7b80bd183211e5d$var$ForwardRef = $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE;
var $c7b80bd183211e5d$var$Memo = $c7b80bd183211e5d$var$REACT_MEMO_TYPE;
function $c7b80bd183211e5d$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $c7b80bd183211e5d$var$REACT_FRAGMENT_TYPE || type === $c7b80bd183211e5d$var$REACT_PROFILER_TYPE || type === $c7b80bd183211e5d$var$REACT_STRICT_MODE_TYPE || type === $c7b80bd183211e5d$var$REACT_SUSPENSE_TYPE || type === $c7b80bd183211e5d$var$REACT_SUSPENSE_LIST_TYPE || type === $c7b80bd183211e5d$var$REACT_OFFSCREEN_TYPE || (typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type)) === "object" && type !== null && (type.$$typeof === $c7b80bd183211e5d$var$REACT_LAZY_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_MEMO_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_CONSUMER_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $c7b80bd183211e5d$var$typeOf(object) {
    if ((typeof object === "undefined" ? "undefined" : (0, $YtE9h._)(object)) === "object" && object !== null) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $c7b80bd183211e5d$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $c7b80bd183211e5d$var$REACT_FRAGMENT_TYPE:
                    case $c7b80bd183211e5d$var$REACT_PROFILER_TYPE:
                    case $c7b80bd183211e5d$var$REACT_STRICT_MODE_TYPE:
                    case $c7b80bd183211e5d$var$REACT_SUSPENSE_TYPE:
                    case $c7b80bd183211e5d$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE:
                            case $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE:
                            case $c7b80bd183211e5d$var$REACT_LAZY_TYPE:
                            case $c7b80bd183211e5d$var$REACT_MEMO_TYPE:
                                return object;
                            case $c7b80bd183211e5d$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $c7b80bd183211e5d$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $c7b80bd183211e5d$var$isContextConsumer(object) {
    return $c7b80bd183211e5d$var$IS_REACT_19 ? $c7b80bd183211e5d$var$typeOf(object) === $c7b80bd183211e5d$var$REACT_CONSUMER_TYPE : $c7b80bd183211e5d$var$typeOf(object) === $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE;
}
function $c7b80bd183211e5d$var$isMemo(object) {
    return $c7b80bd183211e5d$var$typeOf(object) === $c7b80bd183211e5d$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $c7b80bd183211e5d$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $c7b80bd183211e5d$var$verify(selector, methodName) {
    if (!selector) throw new Error("Unexpected value for ".concat(methodName, " in connect."));
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $c7b80bd183211e5d$var$warning("The selector for ".concat(methodName, " of connect did not specify a value for dependsOnOwnProps."));
    }
}
function $c7b80bd183211e5d$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $c7b80bd183211e5d$var$verify(mapStateToProps, "mapStateToProps");
    $c7b80bd183211e5d$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $c7b80bd183211e5d$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $c7b80bd183211e5d$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $c7b80bd183211e5d$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, initMapStateToProps = _b.initMapStateToProps, initMapDispatchToProps = _b.initMapDispatchToProps, initMergeProps = _b.initMergeProps, options = $c7b80bd183211e5d$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    return $c7b80bd183211e5d$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $c7b80bd183211e5d$var$bindActionCreators(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, $2Xzd1._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $c7b80bd183211e5d$var$isPlainObject(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $YtE9h._)(obj)) !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $c7b80bd183211e5d$var$verifyPlainObject(value, displayName, methodName) {
    if (!$c7b80bd183211e5d$var$isPlainObject(value)) $c7b80bd183211e5d$var$warning("".concat(methodName, "() in ").concat(displayName, " must return a plain object. Instead received ").concat(value, "."));
}
// src/connect/wrapMapToProps.ts
function $c7b80bd183211e5d$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        var constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $c7b80bd183211e5d$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $c7b80bd183211e5d$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $c7b80bd183211e5d$var$getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $c7b80bd183211e5d$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $c7b80bd183211e5d$var$createInvalidArgFactory(arg, name) {
    return function(dispatch, options) {
        throw new Error("Invalid value of type ".concat(typeof arg === "undefined" ? "undefined" : (0, $YtE9h._)(arg), " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
    };
}
// src/connect/mapDispatchToProps.ts
function $c7b80bd183211e5d$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && (typeof mapDispatchToProps === "undefined" ? "undefined" : (0, $YtE9h._)(mapDispatchToProps)) === "object" ? $c7b80bd183211e5d$var$wrapMapToPropsConstant(function(dispatch) {
        return(// @ts-ignore
        $c7b80bd183211e5d$var$bindActionCreators(mapDispatchToProps, dispatch));
    }) : !mapDispatchToProps ? $c7b80bd183211e5d$var$wrapMapToPropsConstant(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $c7b80bd183211e5d$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $c7b80bd183211e5d$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $c7b80bd183211e5d$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $c7b80bd183211e5d$var$wrapMapToPropsConstant(function() {
        return {};
    }) : typeof mapStateToProps === "function" ? // @ts-ignore
    $c7b80bd183211e5d$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $c7b80bd183211e5d$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $c7b80bd183211e5d$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $c7b80bd183211e5d$var$__spreadValues($c7b80bd183211e5d$var$__spreadValues($c7b80bd183211e5d$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $c7b80bd183211e5d$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $c7b80bd183211e5d$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? function() {
        return $c7b80bd183211e5d$var$defaultMergeProps;
    } : typeof mergeProps === "function" ? $c7b80bd183211e5d$var$wrapMergePropsFunc(mergeProps) : $c7b80bd183211e5d$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $c7b80bd183211e5d$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $c7b80bd183211e5d$var$createListenerCollection() {
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            $c7b80bd183211e5d$var$defaultNoopBatch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $c7b80bd183211e5d$var$nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function $c7b80bd183211e5d$var$createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = $c7b80bd183211e5d$var$nullListeners;
    var subscriptionsAmount = 0;
    var selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        var cleanupListener = listeners.subscribe(listener);
        var removed = false;
        return function() {
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $c7b80bd183211e5d$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $c7b80bd183211e5d$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $c7b80bd183211e5d$var$canUseDOM = function() {
    return !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
};
var $c7b80bd183211e5d$var$isDOM = /* @__PURE__ */ $c7b80bd183211e5d$var$canUseDOM();
var $c7b80bd183211e5d$var$isRunningInReactNative = function() {
    return typeof navigator !== "undefined" && navigator.product === "ReactNative";
};
var $c7b80bd183211e5d$var$isReactNative = /* @__PURE__ */ $c7b80bd183211e5d$var$isRunningInReactNative();
var $c7b80bd183211e5d$var$getUseIsomorphicLayoutEffect = function() {
    return $c7b80bd183211e5d$var$isDOM || $c7b80bd183211e5d$var$isReactNative ? $fIwXP.useLayoutEffect : $fIwXP.useEffect;
};
var $c7b80bd183211e5d$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $c7b80bd183211e5d$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $c7b80bd183211e5d$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $c7b80bd183211e5d$export$d36bdfa510afb180(objA, objB) {
    if ($c7b80bd183211e5d$var$is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, $YtE9h._)(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : (0, $YtE9h._)(objB)) !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$c7b80bd183211e5d$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $c7b80bd183211e5d$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $c7b80bd183211e5d$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $c7b80bd183211e5d$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $c7b80bd183211e5d$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $c7b80bd183211e5d$var$_obj;
var $c7b80bd183211e5d$var$TYPE_STATICS = ($c7b80bd183211e5d$var$_obj = {}, (0, $hD5pT._)($c7b80bd183211e5d$var$_obj, $c7b80bd183211e5d$var$ForwardRef, $c7b80bd183211e5d$var$FORWARD_REF_STATICS), (0, $hD5pT._)($c7b80bd183211e5d$var$_obj, $c7b80bd183211e5d$var$Memo, $c7b80bd183211e5d$var$MEMO_STATICS), $c7b80bd183211e5d$var$_obj);
function $c7b80bd183211e5d$var$getStatics(component) {
    if ($c7b80bd183211e5d$var$isMemo(component)) return $c7b80bd183211e5d$var$MEMO_STATICS;
    return $c7b80bd183211e5d$var$TYPE_STATICS[component["$$typeof"]] || $c7b80bd183211e5d$var$REACT_STATICS;
}
var $c7b80bd183211e5d$var$defineProperty = Object.defineProperty;
var $c7b80bd183211e5d$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $c7b80bd183211e5d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $c7b80bd183211e5d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $c7b80bd183211e5d$var$getPrototypeOf = Object.getPrototypeOf;
var $c7b80bd183211e5d$var$objectPrototype = Object.prototype;
function $c7b80bd183211e5d$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($c7b80bd183211e5d$var$objectPrototype) {
            var inheritedComponent = $c7b80bd183211e5d$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $c7b80bd183211e5d$var$objectPrototype) $c7b80bd183211e5d$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        var keys = $c7b80bd183211e5d$var$getOwnPropertyNames(sourceComponent);
        if ($c7b80bd183211e5d$var$getOwnPropertySymbols) keys = keys.concat($c7b80bd183211e5d$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $c7b80bd183211e5d$var$getStatics(targetComponent);
        var sourceStatics = $c7b80bd183211e5d$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$c7b80bd183211e5d$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $c7b80bd183211e5d$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $c7b80bd183211e5d$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $c7b80bd183211e5d$var$ContextKey = /* @__PURE__ */ Symbol.for("react-redux-context");
var $c7b80bd183211e5d$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $c7b80bd183211e5d$var$getContext() {
    var _a;
    if (!$fIwXP.createContext) return {};
    var contextMap = (_a = $c7b80bd183211e5d$var$gT[$c7b80bd183211e5d$var$ContextKey]) != null ? _a : $c7b80bd183211e5d$var$gT[$c7b80bd183211e5d$var$ContextKey] = /* @__PURE__ */ new Map();
    var realContext = contextMap.get($fIwXP.createContext);
    if (!realContext) {
        realContext = $fIwXP.createContext(null);
        contextMap.set($fIwXP.createContext, realContext);
    }
    return realContext;
}
var $c7b80bd183211e5d$export$cc80c08dc91f1c00 = /* @__PURE__ */ $c7b80bd183211e5d$var$getContext();
// src/components/connect.tsx
var $c7b80bd183211e5d$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $c7b80bd183211e5d$var$stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $c7b80bd183211e5d$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
        return effectFunc.apply(void 0, (0, $2Xzd1._)(effectArgs));
    }, dependencies);
}
function $c7b80bd183211e5d$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $c7b80bd183211e5d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return function() {};
    var didUnsubscribe = false;
    var lastThrownError = null;
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $c7b80bd183211e5d$var$strictEqual(a, b) {
    return a === b;
}
var $c7b80bd183211e5d$var$hasWarnedAboutDeprecatedPureOption = false;
function $c7b80bd183211e5d$var$connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? $c7b80bd183211e5d$var$strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? $c7b80bd183211e5d$export$d36bdfa510afb180 : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? $c7b80bd183211e5d$export$d36bdfa510afb180 : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? $c7b80bd183211e5d$export$d36bdfa510afb180 : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? $c7b80bd183211e5d$export$cc80c08dc91f1c00 : _ref_context;
    var Context = context;
    var initMapStateToProps = $c7b80bd183211e5d$var$mapStateToPropsFactory(mapStateToProps);
    var initMapDispatchToProps = $c7b80bd183211e5d$var$mapDispatchToPropsFactory(mapDispatchToProps);
    var initMergeProps = $c7b80bd183211e5d$var$mergePropsFactory(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        var ConnectFunction = function ConnectFunction(props) {
            var _React_useMemo = (0, $kB67t._)($fIwXP.useMemo(function() {
                var _a = props, reactReduxForwardedRef2 = _a.reactReduxForwardedRef, wrapperProps2 = $c7b80bd183211e5d$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = $fIwXP.useMemo(function() {
                var ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            var contextValue = $fIwXP.useContext(ContextToUse);
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = $fIwXP.useMemo(function() {
                return $c7b80bd183211e5d$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, $kB67t._)($fIwXP.useMemo(function() {
                if (!shouldHandleStateChanges) return $c7b80bd183211e5d$var$NO_SUBSCRIPTION_ARRAY;
                var subscription2 = $c7b80bd183211e5d$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                var notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1];
            var overriddenContextValue = $fIwXP.useMemo(function() {
                if (didStoreComeFromProps) return contextValue;
                return $c7b80bd183211e5d$var$__spreadProps($c7b80bd183211e5d$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            var lastChildProps = $fIwXP.useRef(void 0);
            var lastWrapperProps = $fIwXP.useRef(wrapperProps);
            var childPropsFromStoreUpdate = $fIwXP.useRef(void 0);
            var renderIsScheduled = $fIwXP.useRef(false);
            var isMounted = $fIwXP.useRef(false);
            var latestSubscriptionCallbackError = $fIwXP.useRef(void 0);
            $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = $fIwXP.useMemo(function() {
                var selector = function() {
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            var subscribeForReact = $fIwXP.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return $c7b80bd183211e5d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $c7b80bd183211e5d$var$useIsomorphicLayoutEffectWithArgs($c7b80bd183211e5d$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = $fIwXP.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
                throw err;
            }
            $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            var renderedWrappedComponent = $fIwXP.useMemo(function() {
                return(// @ts-ignore
                /* @__PURE__ */ $fIwXP.createElement(WrappedComponent, $c7b80bd183211e5d$var$__spreadProps($c7b80bd183211e5d$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            var renderedChild = $fIwXP.useMemo(function() {
                if (shouldHandleStateChanges) return /* @__PURE__ */ $fIwXP.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        };
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = "Connect(".concat(wrappedComponentName, ")");
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        var _Connect = $fIwXP.memo(ConnectFunction);
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = $fIwXP.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $fIwXP.createElement(Connect, $c7b80bd183211e5d$var$__spreadProps($c7b80bd183211e5d$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $c7b80bd183211e5d$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $c7b80bd183211e5d$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $c7b80bd183211e5d$export$64605811ab45167f = $c7b80bd183211e5d$var$connect;
// src/components/Provider.tsx
function $c7b80bd183211e5d$var$Provider(providerProps) {
    var children = providerProps.children, context = providerProps.context, serverState = providerProps.serverState, store = providerProps.store;
    var contextValue = $fIwXP.useMemo(function() {
        var subscription = $c7b80bd183211e5d$var$createSubscription(store);
        var baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    var previousState = $fIwXP.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $fIwXP.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $c7b80bd183211e5d$export$2881499e37b75b9a = $c7b80bd183211e5d$var$Provider;
// src/hooks/useReduxContext.ts
function $c7b80bd183211e5d$var$createReduxContextHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    return function useReduxContext2() {
        var contextValue = $fIwXP.useContext(context);
        return contextValue;
    };
}
var $c7b80bd183211e5d$var$useReduxContext = /* @__PURE__ */ $c7b80bd183211e5d$var$createReduxContextHook();
// src/hooks/useStore.ts
function $c7b80bd183211e5d$export$671dba69185d0304() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $c7b80bd183211e5d$export$cc80c08dc91f1c00 ? $c7b80bd183211e5d$var$useReduxContext : // @ts-ignore
    $c7b80bd183211e5d$var$createReduxContextHook(context);
    var useStore2 = function() {
        var store = useReduxContext2().store;
        return store;
    };
    Object.assign(useStore2, {
        withTypes: function() {
            return useStore2;
        }
    });
    return useStore2;
}
var $c7b80bd183211e5d$export$6ccbb43953eebf8 = /* @__PURE__ */ $c7b80bd183211e5d$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $c7b80bd183211e5d$export$bc9b55530897c558() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    var useStore2 = context === $c7b80bd183211e5d$export$cc80c08dc91f1c00 ? $c7b80bd183211e5d$export$6ccbb43953eebf8 : $c7b80bd183211e5d$export$671dba69185d0304(context);
    var useDispatch2 = function() {
        var store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: function() {
            return useDispatch2;
        }
    });
    return useDispatch2;
}
var $c7b80bd183211e5d$export$8ad76b76a4c905f8 = /* @__PURE__ */ $c7b80bd183211e5d$export$bc9b55530897c558();
var $c7b80bd183211e5d$var$refEquality = function(a, b) {
    return a === b;
};
function $c7b80bd183211e5d$export$2b53f90d2bd1cbfb() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $c7b80bd183211e5d$export$cc80c08dc91f1c00 ? $c7b80bd183211e5d$var$useReduxContext : $c7b80bd183211e5d$var$createReduxContextHook(context);
    var useSelector2 = function(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? $c7b80bd183211e5d$var$refEquality : _ref_equalityFn;
        var reduxContext = useReduxContext2();
        var store = reduxContext.store, subscription = reduxContext.subscription, getServerState = reduxContext.getServerState;
        var firstRun = $fIwXP.useRef(true);
        var wrappedSelector = $fIwXP.useCallback((0, $hD5pT._)({}, selector.name, function(state) {
            var selected = selector(state);
            var e, e1;
            return selected;
        })[selector.name], [
            selector
        ]);
        var selectedState = (0, $6dda7e3f4bfdb607$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $fIwXP.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: function() {
            return useSelector2;
        }
    });
    return useSelector2;
}
var $c7b80bd183211e5d$export$2105062e25df4afe = /* @__PURE__ */ $c7b80bd183211e5d$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $c7b80bd183211e5d$export$712ea50be43a7858 = $c7b80bd183211e5d$var$defaultNoopBatch;


var $f310bc4ea983f747$var$HeaderComponent = function HeaderComponent() {
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(true), 2), logedInUser = _useState[0], setLogedInUser = _useState[1];
    var _useState1 = (0, $kB67t._)((0, $fIwXP.useState)(false), 2), menuActive = _useState1[0], setMenuActive = _useState1[1];
    var user = (0, $fIwXP.useContext)((0, $0cf10ba694782b3e$export$2e2bcd8739ae039)).user;
    var _useContext = (0, $fIwXP.useContext)((0, $8a4be34b89c09502$export$5558332cef65f159)), state = _useContext.state, dispatch = _useContext.dispatch;
    var cartCount = (0, $c7b80bd183211e5d$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    console.log(cartCount);
    return /*#__PURE__*/ (0, $cc6u1.jsx)("header", {
        className: "header py-5 lg:py-8 fixed w-full top-0 left-0 shadow-lg bg-black z-10",
        id: "header",
        children: /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
            className: "flex justify-between items-center container",
            children: [
                /*#__PURE__*/ (0, $cc6u1.jsx)((0, $abvdI.Link), {
                    to: "/",
                    className: "brand",
                    children: "Food Villa"
                }),
                /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                    className: "text-2xl md:hidden",
                    onClick: function() {
                        return setMenuActive(!menuActive);
                    },
                    children: /*#__PURE__*/ (0, $cc6u1.jsx)("i", {
                        className: "fas fa-bars"
                    })
                }),
                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsx)("nav", {
                            className: "navbar ".concat(menuActive ? "block" : "hidden", " z-10 md:block absolute md:static top-full w-full left-0 px-5 md:p-0 bg-gray-600 md:bg-transparent"),
                            children: /*#__PURE__*/ (0, $cc6u1.jsxs)("ul", {
                                className: "menu-inner flex md:gap-5 lg:gap-10 flex-col md:flex-row",
                                onClick: function() {
                                    return setMenuActive(!menuActive);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "menu-item",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $abvdI.Link), {
                                            to: "/",
                                            className: "menu-link block py-3 md:p-0",
                                            children: "Home"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "menu-item",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $abvdI.Link), {
                                            to: "/about-us",
                                            className: "menu-link block py-3 md:p-0",
                                            children: "About Us"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "menu-item",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $abvdI.Link), {
                                            to: "/contact-us",
                                            className: "menu-link block py-3 md:p-0",
                                            children: "Contact"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "menu-item",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $abvdI.Link), {
                                            to: "/instantMart",
                                            className: "menu-link block py-3 md:p-0",
                                            children: "InstantMart"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("li", {
                                        className: "menu-item relative",
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $abvdI.Link), {
                                                to: "/cart",
                                                className: "menu-link block py-3 md:p-0",
                                                children: "Cart"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                                className: "absolute -top-3 -right-4 bg-green-500 text-white text-xs font-bold px-2 py-0.5 rounded-full",
                                                children: [
                                                    " ",
                                                    cartCount.length
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        logedInUser ? /*#__PURE__*/ (0, $cc6u1.jsxs)("button", {
                            className: "menu-block",
                            onClick: function() {
                                return setLogedInUser(false);
                            },
                            children: [
                                "Login ",
                                user.name
                            ]
                        }) : /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                            className: "menu-block",
                            onClick: function() {
                                return setLogedInUser(true);
                            },
                            children: "Logout"
                        })
                    ]
                })
            ]
        })
    });
};
var $f310bc4ea983f747$export$2e2bcd8739ae039 = $f310bc4ea983f747$var$HeaderComponent;



var $cc6u1 = parcelRequire("cc6u1");
var $6709bac9fe63cf1c$var$Footer = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsx)("footer", {
        className: "footer",
        children: /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "footer-col",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                                children: "company"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                            href: "#",
                                            children: "about us"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                            href: "#",
                                            children: "our services"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                            href: "#",
                                            children: "privacy policy"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                            href: "#",
                                            children: "affiliate program"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "footer-col",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                                children: "get help"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                            href: "#",
                                            children: "FAQ"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                            href: "#",
                                            children: "shipping"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                            href: "#",
                                            children: "returns"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                            href: "#",
                                            children: "order status"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                            href: "#",
                                            children: "payment options"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "footer-col",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                                children: "online shop"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                            href: "#",
                                            children: "watch"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                            href: "#",
                                            children: "bag"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                            href: "#",
                                            children: "shoes"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                            href: "#",
                                            children: "dress"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "footer-col",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                                children: "follow us"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "social-links",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                        href: "#",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("i", {
                                            className: "fab fa-facebook-f"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                        href: "#",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("i", {
                                            className: "fab fa-twitter"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                        href: "#",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("i", {
                                            className: "fab fa-instagram"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                        href: "#",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("i", {
                                            className: "fab fa-linkedin-in"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $6709bac9fe63cf1c$export$2e2bcd8739ae039 = $6709bac9fe63cf1c$var$Footer;



var $cc6u1 = parcelRequire("cc6u1");
var $717a2f0a6a708d12$var$Contact = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        className: "contact py-10 pt-[98px] md:pt-[128px]",
        children: /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                    className: "banner-img mb-5",
                    src: "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/seo/Food_collectionbanner.png",
                    alt: "banner"
                }),
                /*#__PURE__*/ (0, $cc6u1.jsx)("h2", {
                    className: "text-3xl font-bold whitespace-nowrap mb-4",
                    children: "Contact Us"
                }),
                /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                    className: "text-xl font-bold mb-4",
                    children: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem, mollitia!"
                }),
                /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                    className: "text-lg mb-4",
                    children: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Excepturi vel sequi, consequuntur quisquam officia, omnis architecto labore molestias unde quod ullam necessitatibus rem tenetur! Ad ex repellat vel magnam ullam."
                })
            ]
        })
    });
};
var $717a2f0a6a708d12$export$2e2bcd8739ae039 = $717a2f0a6a708d12$var$Contact;



var $cc6u1 = parcelRequire("cc6u1");

var $abvdI = parcelRequire("abvdI");
var $dAaLE = parcelRequire("dAaLE");
var $747845963c0a4b26$var$ErrorPage = function() {
    var err = (0, $dAaLE.useRouteError)();
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "h-screen flex justify-center items-center flex-col",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                className: "text-3xl font-bold text-center mb-4",
                children: "Oops!!"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                className: "text-lg text-center mb-4",
                children: "Something went Wrong!!"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                className: "mb-4",
                children: err.status + " : " + err.statusText
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $abvdI.Link), {
                to: "/",
                className: "text-center block text-blue-500",
                children: "Back to home \uD83D\uDE0A"
            })
        ]
    });
};
var $747845963c0a4b26$export$2e2bcd8739ae039 = $747845963c0a4b26$var$ErrorPage;



var $cc6u1 = parcelRequire("cc6u1");

var $dAaLE = parcelRequire("dAaLE");

var $fIwXP = parcelRequire("fIwXP");

var $iVsXN = parcelRequire("iVsXN");

var $cc6u1 = parcelRequire("cc6u1");
var $4fe64b519d56ac5f$var$ShimmerMenu = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "flex flex-col md:flex-row gap-10",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "animate-pulse rounded-[20px] !bg-gray-500 w-full lg:w-[300px] h-[420px]"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "animate-pulse rounded-[20px] !bg-gray-500 w-full lg:w-[940px] h-[420px]"
            })
        ]
    });
};
var $4fe64b519d56ac5f$export$2e2bcd8739ae039 = $4fe64b519d56ac5f$var$ShimmerMenu;



var $7k5I8 = parcelRequire("7k5I8");

var $kB67t = parcelRequire("kB67t");

var $lFlDF = parcelRequire("lFlDF");

var $fIwXP = parcelRequire("fIwXP");

var $iVsXN = parcelRequire("iVsXN");
var $37d33947ca492c36$var$useGetMenu = function(resId) {
    var getRestaurantMenuData = function getRestaurantMenuData() {
        return _getRestaurantMenuData.apply(this, arguments);
    };
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(""), 2), menuGet = _useState[0], setMenuGet = _useState[1];
    (0, $fIwXP.useEffect)(function() {
        getRestaurantMenuData();
    }, []);
    function _getRestaurantMenuData() {
        _getRestaurantMenuData = (0, $7k5I8._)(function() {
            var data, reponseData;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("".concat((0, $iVsXN.RESTAURANT_MENU)).concat(resId))
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        reponseData = _state.sent();
                        // console.log(reponseData);
                        setMenuGet(reponseData);
                        return [
                            2
                        ];
                }
            });
        });
        return _getRestaurantMenuData.apply(this, arguments);
    }
    return menuGet;
};
var $37d33947ca492c36$export$2e2bcd8739ae039 = $37d33947ca492c36$var$useGetMenu;



var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");

var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");

var $iVsXN = parcelRequire("iVsXN");


var $7k5I8 = parcelRequire("7k5I8");

var $3Gvhd = parcelRequire("3Gvhd");

var $bB0zn = parcelRequire("bB0zn");

var $f5KHm = parcelRequire("f5KHm");

var $6QEWP = parcelRequire("6QEWP");

var $hD5pT = parcelRequire("hD5pT");

var $ZhYhU = parcelRequire("ZhYhU");
function $5f0e95e6df7a47eb$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $ZhYhU._)(object);
        if (object === null) break;
    }
    return object;
}


function $04ca9dac0ceac2e2$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $04ca9dac0ceac2e2$export$71511d61b312f219 = Reflect.get;
    else $04ca9dac0ceac2e2$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $5f0e95e6df7a47eb$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $04ca9dac0ceac2e2$export$71511d61b312f219(target, property, receiver || target);
}



var $ZhYhU = parcelRequire("ZhYhU");

var $5dLwP = parcelRequire("5dLwP");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $fPaN7 = parcelRequire("fPaN7");

var $lFlDF = parcelRequire("lFlDF");
// src/utils/formatProdErrorMessage.ts

var $hD5pT = parcelRequire("hD5pT");

var $eRslx = parcelRequire("eRslx");


var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");
function $a039f9c7168ef4c9$var$formatProdErrorMessage(code) {
    return "Minified Redux error #".concat(code, "; visit https://redux.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}
// src/utils/symbol-observable.ts
var $a039f9c7168ef4c9$var$$$observable = /* @__PURE__ */ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
var $a039f9c7168ef4c9$var$symbol_observable_default = $a039f9c7168ef4c9$var$$$observable;
// src/utils/actionTypes.ts
var $a039f9c7168ef4c9$var$randomString = function() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $a039f9c7168ef4c9$var$ActionTypes = {
    INIT: "@@redux/INIT".concat($a039f9c7168ef4c9$var$randomString()),
    REPLACE: "@@redux/REPLACE".concat($a039f9c7168ef4c9$var$randomString()),
    PROBE_UNKNOWN_ACTION: function() {
        return "@@redux/PROBE_UNKNOWN_ACTION".concat($a039f9c7168ef4c9$var$randomString());
    }
};
var $a039f9c7168ef4c9$export$4219e499db7ca678 = $a039f9c7168ef4c9$var$ActionTypes;
// src/utils/isPlainObject.ts
function $a039f9c7168ef4c9$export$53b83ca8eaab0383(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $YtE9h._)(obj)) !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $a039f9c7168ef4c9$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $YtE9h._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($a039f9c7168ef4c9$var$isDate(val)) return "date";
    if ($a039f9c7168ef4c9$var$isError(val)) return "error";
    var constructorName = $a039f9c7168ef4c9$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $a039f9c7168ef4c9$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $a039f9c7168ef4c9$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $a039f9c7168ef4c9$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $a039f9c7168ef4c9$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $YtE9h._)(val);
    return typeOfVal;
}
// src/createStore.ts
function $a039f9c7168ef4c9$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(1));
        return enhancer($a039f9c7168ef4c9$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = /* @__PURE__ */ new Map();
    var nextListeners = currentListeners;
    var listenerIdCounter = 0;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach(function(listener, key) {
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        var listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$a039f9c7168ef4c9$export$53b83ca8eaab0383(action)) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        listeners.forEach(function(listener) {
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $a039f9c7168ef4c9$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        var outerSubscribe = subscribe;
        return (0, $hD5pT._)({
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function(observer) {
                if ((typeof observer === "undefined" ? "undefined" : (0, $YtE9h._)(observer)) !== "object" || observer === null) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(11));
                function observeState() {
                    var observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, $a039f9c7168ef4c9$var$symbol_observable_default, function() {
            return this;
        });
    }
    dispatch({
        type: $a039f9c7168ef4c9$export$4219e499db7ca678.INIT
    });
    var store = (0, $hD5pT._)({
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, $a039f9c7168ef4c9$var$symbol_observable_default, observable);
    return store;
}
function $a039f9c7168ef4c9$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $a039f9c7168ef4c9$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $a039f9c7168ef4c9$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $a039f9c7168ef4c9$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $a039f9c7168ef4c9$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$a039f9c7168ef4c9$export$53b83ca8eaab0383(inputState)) return "The ".concat(argumentName, ' has unexpected type of "').concat($a039f9c7168ef4c9$var$kindOf(inputState), '". Expected argument to be an object with the following keys: "').concat(reducerKeys.join('", "'), '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $a039f9c7168ef4c9$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected ".concat(unexpectedKeys.length > 1 ? "keys" : "key", ' "').concat(unexpectedKeys.join('", "'), '" found in ').concat(argumentName, '. Expected to find one of the known reducer keys instead: "').concat(reducerKeys.join('", "'), '". Unexpected keys will be ignored.');
}
function $a039f9c7168ef4c9$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(void 0, {
            type: $a039f9c7168ef4c9$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $a039f9c7168ef4c9$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(13));
    });
}
function $a039f9c7168ef4c9$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $a039f9c7168ef4c9$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
        if (shapeAssertionError) throw shapeAssertionError;
        var hasChanged = false;
        var nextState = {};
        for(var i = 0; i < finalReducerKeys.length; i++){
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $a039f9c7168ef4c9$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return dispatch(actionCreator.apply(this, args));
    };
}
function $a039f9c7168ef4c9$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $a039f9c7168ef4c9$var$bindActionCreator(actionCreators, dispatch);
    if ((typeof actionCreators === "undefined" ? "undefined" : (0, $YtE9h._)(actionCreators)) !== "object" || actionCreators === null) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $a039f9c7168ef4c9$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $a039f9c7168ef4c9$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return a(b.apply(void 0, (0, $2Xzd1._)(args)));
        };
    });
}
// src/applyMiddleware.ts
function $a039f9c7168ef4c9$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
        middlewares[_key] = arguments[_key];
    }
    return function(createStore2) {
        return function(reducer, preloadedState) {
            var store = createStore2(reducer, preloadedState);
            var dispatch = function() {
                throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function(action) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    return dispatch.apply(void 0, [
                        action
                    ].concat((0, $2Xzd1._)(args)));
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            dispatch = $a039f9c7168ef4c9$export$f672e0b6f7222cd7.apply(void 0, (0, $2Xzd1._)(chain))(store.dispatch);
            return (0, $f17388ede13a49cc$export$71511d61b312f219)((0, $eRslx._)({}, store), {
                dispatch: dispatch
            });
        };
    };
}
// src/utils/isAction.ts
function $a039f9c7168ef4c9$export$b956e38827fca970(action) {
    return $a039f9c7168ef4c9$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}



var $5icQr = parcelRequire("5icQr");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");
var $874a87fa87407f05$var$__defProp = Object.defineProperty;
var $874a87fa87407f05$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $874a87fa87407f05$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $874a87fa87407f05$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $874a87fa87407f05$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $874a87fa87407f05$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $874a87fa87407f05$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($874a87fa87407f05$var$__hasOwnProp.call(b, prop)) $874a87fa87407f05$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($874a87fa87407f05$var$__getOwnPropSymbols) try {
        for(var _iterator = $874a87fa87407f05$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($874a87fa87407f05$var$__propIsEnum.call(b, prop)) $874a87fa87407f05$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $874a87fa87407f05$var$__publicField = function(obj, key, value) {
    $874a87fa87407f05$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $YtE9h._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $874a87fa87407f05$var$runIdentityFunctionCheck = function(resultFunc, inputSelectorsResults, outputSelectorResult) {
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        var isInputSameAsOutput = false;
        try {
            var emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            var stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                stack = e.stack;
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $874a87fa87407f05$var$runInputStabilityCheck = function(inputSelectorResultsObject, options, inputSelectorArgs) {
    var memoize = options.memoize, memoizeOptions = options.memoizeOptions;
    var inputSelectorResults = inputSelectorResultsObject.inputSelectorResults, inputSelectorResultsCopy = inputSelectorResultsObject.inputSelectorResultsCopy;
    var createAnEmptyObject = memoize.apply(void 0, [
        function() {
            return {};
        }
    ].concat((0, $2Xzd1._)(memoizeOptions)));
    var areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        var stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            stack = e.stack;
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $874a87fa87407f05$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $874a87fa87407f05$export$1e290349de99e28c = function(devModeChecks) {
    Object.assign($874a87fa87407f05$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $874a87fa87407f05$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $874a87fa87407f05$var$assertIsFunction(func) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected a function, instead received ".concat(typeof func === "undefined" ? "undefined" : (0, $YtE9h._)(func));
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $874a87fa87407f05$var$assertIsObject(object) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected an object, instead received ".concat(typeof object === "undefined" ? "undefined" : (0, $YtE9h._)(object));
    if ((typeof object === "undefined" ? "undefined" : (0, $YtE9h._)(object)) !== "object") throw new TypeError(errorMessage);
}
function $874a87fa87407f05$var$assertIsArrayOfFunctions(array) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected all items to be functions, instead received the following types: ";
    if (!array.every(function(item) {
        return typeof item === "function";
    })) {
        var itemTypes = array.map(function(item) {
            return typeof item === "function" ? "function ".concat(item.name || "unnamed", "()") : typeof item === "undefined" ? "undefined" : (0, $YtE9h._)(item);
        }).join(", ");
        throw new TypeError("".concat(errorMessage, "[").concat(itemTypes, "]"));
    }
}
var $874a87fa87407f05$var$ensureIsArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
function $874a87fa87407f05$var$getDependencies(createSelectorArgs) {
    var dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $874a87fa87407f05$var$assertIsArrayOfFunctions(dependencies, "createSelector expects all input-selectors to be functions, but received the following types: ");
    return dependencies;
}
function $874a87fa87407f05$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    var inputSelectorResults = [];
    var length = dependencies.length;
    for(var i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $874a87fa87407f05$var$getDevModeChecksExecutionInfo = function(firstRun, devModeChecks) {
    var __spreadValues1 = $874a87fa87407f05$var$__spreadValues($874a87fa87407f05$var$__spreadValues({}, $874a87fa87407f05$var$globalDevModeChecks), devModeChecks), identityFunctionCheck = __spreadValues1.identityFunctionCheck, inputStabilityCheck = __spreadValues1.inputStabilityCheck;
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $874a87fa87407f05$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $874a87fa87407f05$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $874a87fa87407f05$var$$REVISION = 0;
var $874a87fa87407f05$var$CURRENT_TRACKER = null;
var $874a87fa87407f05$var$Cell = /*#__PURE__*/ function() {
    "use strict";
    function Cell(initialValue) {
        var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $874a87fa87407f05$var$tripleEq;
        (0, $bB0zn._)(this, Cell);
        $874a87fa87407f05$var$__publicField(this, "revision", $874a87fa87407f05$var$$REVISION);
        $874a87fa87407f05$var$__publicField(this, "_value");
        $874a87fa87407f05$var$__publicField(this, "_lastValue");
        $874a87fa87407f05$var$__publicField(this, "_isEqual", $874a87fa87407f05$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    (0, $6QEWP._)(Cell, [
        {
            key: "value",
            get: // Whenever a storage value is read, it'll add itself to the current tracker if
            // one exists, entangling its state with that cache.
            function get() {
                $874a87fa87407f05$var$CURRENT_TRACKER == null || $874a87fa87407f05$var$CURRENT_TRACKER.add(this);
                return this._value;
            },
            set: // Whenever a storage value is updated, we bump the global revision clock,
            // assign the revision for this storage to the new value, _and_ we schedule a
            // rerender. This is important, and it's what makes autotracking  _pull_
            // based. We don't actively tell the caches which depend on the storage that
            // anything has happened. Instead, we recompute the caches when needed.
            function set(newValue) {
                if (this.value === newValue) return;
                this._value = newValue;
                this.revision = ++$874a87fa87407f05$var$$REVISION;
            }
        }
    ]);
    return Cell;
}();
function $874a87fa87407f05$var$tripleEq(a, b) {
    return a === b;
}
var $874a87fa87407f05$var$TrackingCache = /*#__PURE__*/ function() {
    "use strict";
    function TrackingCache(fn) {
        (0, $bB0zn._)(this, TrackingCache);
        $874a87fa87407f05$var$__publicField(this, "_cachedValue");
        $874a87fa87407f05$var$__publicField(this, "_cachedRevision", -1);
        $874a87fa87407f05$var$__publicField(this, "_deps", []);
        $874a87fa87407f05$var$__publicField(this, "hits", 0);
        $874a87fa87407f05$var$__publicField(this, "fn");
        this.fn = fn;
    }
    (0, $6QEWP._)(TrackingCache, [
        {
            key: "clear",
            value: function clear() {
                this._cachedValue = void 0;
                this._cachedRevision = -1;
                this._deps = [];
                this.hits = 0;
            }
        },
        {
            key: "value",
            get: function get() {
                if (this.revision > this._cachedRevision) {
                    var fn = this.fn;
                    var currentTracker = /* @__PURE__ */ new Set();
                    var prevTracker = $874a87fa87407f05$var$CURRENT_TRACKER;
                    $874a87fa87407f05$var$CURRENT_TRACKER = currentTracker;
                    this._cachedValue = fn();
                    $874a87fa87407f05$var$CURRENT_TRACKER = prevTracker;
                    this.hits++;
                    this._deps = Array.from(currentTracker);
                    this._cachedRevision = this.revision;
                }
                $874a87fa87407f05$var$CURRENT_TRACKER == null || $874a87fa87407f05$var$CURRENT_TRACKER.add(this);
                return this._cachedValue;
            }
        },
        {
            key: "revision",
            get: function get() {
                var _Math;
                return (_Math = Math).max.apply(_Math, (0, $2Xzd1._)(this._deps.map(function(d) {
                    return d.revision;
                })).concat([
                    0
                ]));
            }
        }
    ]);
    return TrackingCache;
}();
function $874a87fa87407f05$var$getValue(cell) {
    if (!(cell instanceof $874a87fa87407f05$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $874a87fa87407f05$var$setValue(storage, value) {
    if (!(storage instanceof $874a87fa87407f05$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $874a87fa87407f05$var$createCell(initialValue) {
    var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $874a87fa87407f05$var$tripleEq;
    return new $874a87fa87407f05$var$Cell(initialValue, isEqual);
}
function $874a87fa87407f05$var$createCache(fn) {
    $874a87fa87407f05$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $874a87fa87407f05$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $874a87fa87407f05$var$neverEq = function(a, b) {
    return false;
};
function $874a87fa87407f05$var$createTag() {
    return $874a87fa87407f05$var$createCell(null, $874a87fa87407f05$var$neverEq);
}
function $874a87fa87407f05$var$dirtyTag(tag, value) {
    $874a87fa87407f05$var$setValue(tag, value);
}
var $874a87fa87407f05$var$consumeCollection = function(node) {
    var tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $874a87fa87407f05$var$createTag();
    $874a87fa87407f05$var$getValue(tag);
};
var $874a87fa87407f05$var$dirtyCollection = function(node) {
    var tag = node.collectionTag;
    if (tag !== null) $874a87fa87407f05$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $874a87fa87407f05$var$REDUX_PROXY_LABEL = Symbol();
var $874a87fa87407f05$var$nextId = 0;
var $874a87fa87407f05$var$proto = Object.getPrototypeOf({});
var $874a87fa87407f05$var$ObjectTreeNode = function ObjectTreeNode(value) {
    "use strict";
    (0, $bB0zn._)(this, ObjectTreeNode);
    this.value = value;
    $874a87fa87407f05$var$__publicField(this, "proxy", new Proxy(this, $874a87fa87407f05$var$objectProxyHandler));
    $874a87fa87407f05$var$__publicField(this, "tag", $874a87fa87407f05$var$createTag());
    $874a87fa87407f05$var$__publicField(this, "tags", {});
    $874a87fa87407f05$var$__publicField(this, "children", {});
    $874a87fa87407f05$var$__publicField(this, "collectionTag", null);
    $874a87fa87407f05$var$__publicField(this, "id", $874a87fa87407f05$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $874a87fa87407f05$var$objectProxyHandler = {
    get: function(node, key) {
        function calculateResult() {
            var value = node.value;
            var childValue = Reflect.get(value, key);
            if ((typeof key === "undefined" ? "undefined" : (0, $YtE9h._)(key)) === "symbol") return childValue;
            if (key in $874a87fa87407f05$var$proto) return childValue;
            if ((typeof childValue === "undefined" ? "undefined" : (0, $YtE9h._)(childValue)) === "object" && childValue !== null) {
                var childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $874a87fa87407f05$var$createNode(childValue);
                if (childNode.tag) $874a87fa87407f05$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                var tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $874a87fa87407f05$var$createTag();
                    tag.value = childValue;
                }
                $874a87fa87407f05$var$getValue(tag);
                return childValue;
            }
        }
        var res = calculateResult();
        return res;
    },
    ownKeys: function(node) {
        $874a87fa87407f05$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor: function(node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has: function(node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $874a87fa87407f05$var$ArrayTreeNode = function ArrayTreeNode(value) {
    "use strict";
    (0, $bB0zn._)(this, ArrayTreeNode);
    this.value = value;
    $874a87fa87407f05$var$__publicField(this, "proxy", new Proxy([
        this
    ], $874a87fa87407f05$var$arrayProxyHandler));
    $874a87fa87407f05$var$__publicField(this, "tag", $874a87fa87407f05$var$createTag());
    $874a87fa87407f05$var$__publicField(this, "tags", {});
    $874a87fa87407f05$var$__publicField(this, "children", {});
    $874a87fa87407f05$var$__publicField(this, "collectionTag", null);
    $874a87fa87407f05$var$__publicField(this, "id", $874a87fa87407f05$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $874a87fa87407f05$var$arrayProxyHandler = {
    get: function(param, key) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        if (key === "length") $874a87fa87407f05$var$consumeCollection(node);
        return $874a87fa87407f05$var$objectProxyHandler.get(node, key);
    },
    ownKeys: function(param) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        return $874a87fa87407f05$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor: function(param, prop) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        return $874a87fa87407f05$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has: function(param, prop) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        return $874a87fa87407f05$var$objectProxyHandler.has(node, prop);
    }
};
function $874a87fa87407f05$var$createNode(value) {
    if (Array.isArray(value)) return new $874a87fa87407f05$var$ArrayTreeNode(value);
    return new $874a87fa87407f05$var$ObjectTreeNode(value);
}
function $874a87fa87407f05$var$updateNode(node, newValue) {
    var value = node.value, tags = node.tags, children = node.children;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $874a87fa87407f05$var$dirtyCollection(node);
    else if (value !== newValue) {
        var oldKeysSize = 0;
        var newKeysSize = 0;
        var anyKeysAdded = false;
        for(var _key in value)oldKeysSize++;
        for(var key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        var isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $874a87fa87407f05$var$dirtyCollection(node);
    }
    for(var key1 in tags){
        var childValue = value[key1];
        var newChildValue = newValue[key1];
        if (childValue !== newChildValue) {
            $874a87fa87407f05$var$dirtyCollection(node);
            $874a87fa87407f05$var$dirtyTag(tags[key1], newChildValue);
        }
        if ((typeof newChildValue === "undefined" ? "undefined" : (0, $YtE9h._)(newChildValue)) === "object" && newChildValue !== null) delete tags[key1];
    }
    for(var key2 in children){
        var childNode = children[key2];
        var newChildValue1 = newValue[key2];
        var childValue1 = childNode.value;
        if (childValue1 === newChildValue1) continue;
        else if ((typeof newChildValue1 === "undefined" ? "undefined" : (0, $YtE9h._)(newChildValue1)) === "object" && newChildValue1 !== null) $874a87fa87407f05$var$updateNode(childNode, newChildValue1);
        else {
            $874a87fa87407f05$var$deleteNode(childNode);
            delete children[key2];
        }
    }
}
function $874a87fa87407f05$var$deleteNode(node) {
    if (node.tag) $874a87fa87407f05$var$dirtyTag(node.tag, null);
    $874a87fa87407f05$var$dirtyCollection(node);
    for(var key in node.tags)$874a87fa87407f05$var$dirtyTag(node.tags[key], null);
    for(var key1 in node.children)$874a87fa87407f05$var$deleteNode(node.children[key1]);
}
// src/lruMemoize.ts
function $874a87fa87407f05$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $874a87fa87407f05$var$NOT_FOUND;
        },
        put: function(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function() {
            entry = void 0;
        }
    };
}
function $874a87fa87407f05$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $874a87fa87407f05$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $874a87fa87407f05$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $874a87fa87407f05$export$3f025202a230c6dd = function(a, b) {
    return a === b;
};
function $874a87fa87407f05$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $874a87fa87407f05$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    var providedOptions = (typeof equalityCheckOrOptions === "undefined" ? "undefined" : (0, $YtE9h._)(equalityCheckOrOptions)) === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions_equalityCheck = providedOptions.equalityCheck, equalityCheck = _providedOptions_equalityCheck === void 0 ? $874a87fa87407f05$export$3f025202a230c6dd : _providedOptions_equalityCheck, _providedOptions_maxSize = providedOptions.maxSize, maxSize = _providedOptions_maxSize === void 0 ? 1 : _providedOptions_maxSize, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $874a87fa87407f05$var$createCacheKeyComparator(equalityCheck);
    var resultsCount = 0;
    var cache = maxSize <= 1 ? $874a87fa87407f05$var$createSingletonCache(comparator) : $874a87fa87407f05$var$createLruCache(maxSize, comparator);
    function memoized() {
        var value = cache.get(arguments);
        if (value === $874a87fa87407f05$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $874a87fa87407f05$export$c8f9cf88d9fdee55(func) {
    var node = $874a87fa87407f05$var$createNode([]);
    var lastArgs = null;
    var shallowEqual = $874a87fa87407f05$var$createCacheKeyComparator($874a87fa87407f05$export$3f025202a230c6dd);
    var cache = $874a87fa87407f05$var$createCache(function() {
        var res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $874a87fa87407f05$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $874a87fa87407f05$var$StrongRef = /*#__PURE__*/ function() {
    "use strict";
    function StrongRef(value) {
        (0, $bB0zn._)(this, StrongRef);
        this.value = value;
    }
    (0, $6QEWP._)(StrongRef, [
        {
            key: "deref",
            value: function deref() {
                return this.value;
            }
        }
    ]);
    return StrongRef;
}();
var $874a87fa87407f05$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $874a87fa87407f05$var$StrongRef;
var $874a87fa87407f05$var$UNTERMINATED = 0;
var $874a87fa87407f05$var$TERMINATED = 1;
function $874a87fa87407f05$var$createCacheNode() {
    return {
        s: $874a87fa87407f05$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $874a87fa87407f05$export$8402dc26d96f6902(func) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fnNode = $874a87fa87407f05$var$createCacheNode();
    var resultEqualityCheck = options.resultEqualityCheck;
    var lastResult;
    var resultsCount = 0;
    function memoized() {
        var _a, _b;
        var cacheNode = fnNode;
        var length = arguments.length;
        for(var i = 0, l = length; i < l; i++){
            var arg = arguments[i];
            if (typeof arg === "function" || (typeof arg === "undefined" ? "undefined" : (0, $YtE9h._)(arg)) === "object" && arg !== null) {
                var objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                var objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $874a87fa87407f05$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                var primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                var primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $874a87fa87407f05$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        var terminatedNode = cacheNode;
        var result;
        if (cacheNode.s === $874a87fa87407f05$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                var needsWeakRef = (typeof result === "undefined" ? "undefined" : (0, $YtE9h._)(result)) === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $874a87fa87407f05$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $874a87fa87407f05$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = function() {
        fnNode = $874a87fa87407f05$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $874a87fa87407f05$export$5943f4447f6ef248(memoizeOrOptions) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    }
    var createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    var createSelector2 = function() {
        for(var _len = arguments.length, createSelectorArgs = new Array(_len), _key = 0; _key < _len; _key++){
            createSelectorArgs[_key] = arguments[_key];
        }
        var recomputations = 0;
        var dependencyRecomputations = 0;
        var lastResult;
        var directlyPassedOptions = {};
        var resultFunc = createSelectorArgs.pop();
        if ((typeof resultFunc === "undefined" ? "undefined" : (0, $YtE9h._)(resultFunc)) === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $874a87fa87407f05$var$assertIsFunction(resultFunc, "createSelector expects an output function after the inputs, but received: [".concat(typeof resultFunc === "undefined" ? "undefined" : (0, $YtE9h._)(resultFunc), "]"));
        var combinedOptions = $874a87fa87407f05$var$__spreadValues($874a87fa87407f05$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        var memoize = combinedOptions.memoize, _combinedOptions_memoizeOptions = combinedOptions.memoizeOptions, memoizeOptions = _combinedOptions_memoizeOptions === void 0 ? [] : _combinedOptions_memoizeOptions, _combinedOptions_argsMemoize = combinedOptions.argsMemoize, argsMemoize = _combinedOptions_argsMemoize === void 0 ? $874a87fa87407f05$export$8402dc26d96f6902 : _combinedOptions_argsMemoize, _combinedOptions_argsMemoizeOptions = combinedOptions.argsMemoizeOptions, argsMemoizeOptions = _combinedOptions_argsMemoizeOptions === void 0 ? [] : _combinedOptions_argsMemoizeOptions, _combinedOptions_devModeChecks = combinedOptions.devModeChecks, devModeChecks = _combinedOptions_devModeChecks === void 0 ? {} : _combinedOptions_devModeChecks;
        var finalMemoizeOptions = $874a87fa87407f05$var$ensureIsArray(memoizeOptions);
        var finalArgsMemoizeOptions = $874a87fa87407f05$var$ensureIsArray(argsMemoizeOptions);
        var dependencies = $874a87fa87407f05$var$getDependencies(createSelectorArgs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat((0, $2Xzd1._)(finalMemoizeOptions)));
        var firstRun = true;
        var selector = argsMemoize.apply(void 0, [
            function dependenciesChecker() {
                dependencyRecomputations++;
                var inputSelectorResults = $874a87fa87407f05$var$collectInputSelectorResults(dependencies, arguments);
                lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
                return lastResult;
            }
        ].concat((0, $2Xzd1._)(finalArgsMemoizeOptions)));
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: function() {
                return dependencyRecomputations;
            },
            resetDependencyRecomputations: function() {
                dependencyRecomputations = 0;
            },
            lastResult: function() {
                return lastResult;
            },
            recomputations: function() {
                return recomputations;
            },
            resetRecomputations: function() {
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: function() {
            return createSelector2;
        }
    });
    return createSelector2;
}
var $874a87fa87407f05$export$595d22ed68ca2841 = /* @__PURE__ */ $874a87fa87407f05$export$5943f4447f6ef248($874a87fa87407f05$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $874a87fa87407f05$export$75979cfcd91bf38f = Object.assign(function(inputSelectorsObject) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $874a87fa87407f05$export$595d22ed68ca2841;
    $874a87fa87407f05$var$assertIsObject(inputSelectorsObject, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ".concat(typeof inputSelectorsObject === "undefined" ? "undefined" : (0, $YtE9h._)(inputSelectorsObject)));
    var inputSelectorKeys = Object.keys(inputSelectorsObject);
    var dependencies = inputSelectorKeys.map(function(key) {
        return inputSelectorsObject[key];
    });
    var structuredSelector = selectorCreator(dependencies, function() {
        for(var _len = arguments.length, inputSelectorResults = new Array(_len), _key = 0; _key < _len; _key++){
            inputSelectorResults[_key] = arguments[_key];
        }
        return inputSelectorResults.reduce(function(composition, value, index) {
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: function() {
        return $874a87fa87407f05$export$75979cfcd91bf38f;
    }
});


// src/index.ts
function $2193944b4716daad$var$createThunkMiddleware(extraArgument) {
    var middleware = function(param) {
        var dispatch = param.dispatch, getState = param.getState;
        return function(next) {
            return function(action) {
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
    return middleware;
}
var $2193944b4716daad$export$dd164f5517779f15 = $2193944b4716daad$var$createThunkMiddleware();
var $2193944b4716daad$export$16d06542a1949d9e = $2193944b4716daad$var$createThunkMiddleware;



var $ibRPI = parcelRequire("ibRPI");
var $44e97ff44f917989$var$__defProp = Object.defineProperty;
var $44e97ff44f917989$var$__defProps = Object.defineProperties;
var $44e97ff44f917989$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $44e97ff44f917989$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $44e97ff44f917989$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $44e97ff44f917989$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $44e97ff44f917989$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $44e97ff44f917989$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $44e97ff44f917989$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($44e97ff44f917989$var$__hasOwnProp.call(b, prop)) $44e97ff44f917989$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($44e97ff44f917989$var$__getOwnPropSymbols) try {
        for(var _iterator = $44e97ff44f917989$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($44e97ff44f917989$var$__propIsEnum.call(b, prop)) $44e97ff44f917989$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $44e97ff44f917989$var$__spreadProps = function(a, b) {
    return $44e97ff44f917989$var$__defProps(a, $44e97ff44f917989$var$__getOwnPropDescs(b));
};
var $44e97ff44f917989$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($44e97ff44f917989$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $44e97ff44f917989$var$__getOwnPropSymbols) try {
        for(var _iterator = $44e97ff44f917989$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $44e97ff44f917989$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $44e97ff44f917989$var$__publicField = function(obj, key, value) {
    return $44e97ff44f917989$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $YtE9h._)(key)) !== "symbol" ? key + "" : key, value);
};
var $44e97ff44f917989$export$aab6de9e3dbb1473 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var createSelector2 = (0, $874a87fa87407f05$export$5943f4447f6ef248).apply(void 0, (0, $2Xzd1._)(args));
    var createDraftSafeSelector2 = Object.assign(function() {
        for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
            args2[_key] = arguments[_key];
        }
        var selector = createSelector2.apply(void 0, (0, $2Xzd1._)(args2));
        var wrappedSelector = function(value) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            return selector.apply(void 0, [
                (0, $5icQr.isDraft)(value) ? (0, $5icQr.current)(value) : value
            ].concat((0, $2Xzd1._)(rest)));
        };
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: function() {
            return createDraftSafeSelector2;
        }
    });
    return createDraftSafeSelector2;
};
var $44e97ff44f917989$export$a5d3c27355e35910 = /* @__PURE__ */ $44e97ff44f917989$export$aab6de9e3dbb1473((0, $874a87fa87407f05$export$8402dc26d96f6902));
var $44e97ff44f917989$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function composeWithDevTools() {
    if (arguments.length === 0) return void 0;
    if ((0, $YtE9h._)(arguments[0]) === "object") return 0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7;
    return (0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $44e97ff44f917989$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function devToolsEnhancer() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $44e97ff44f917989$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $44e97ff44f917989$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, (0, $2Xzd1._)(args));
            if (!prepared) throw new Error($44e97ff44f917989$export$378fa86b259c0280(0));
            return $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "".concat(type);
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return (0, $a039f9c7168ef4c9$export$b956e38827fca970)(action) && action.type === type;
    };
    return actionCreator;
}
function $44e97ff44f917989$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $44e97ff44f917989$var$hasMatchFunction(action);
}
function $44e97ff44f917989$export$ebd532f9034651f3(action) {
    return (0, $a039f9c7168ef4c9$export$b956e38827fca970)(action) && Object.keys(action).every($44e97ff44f917989$var$isValidKey);
}
function $44e97ff44f917989$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $44e97ff44f917989$var$getMessage(type) {
    var splitType = type ? "".concat(type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "'.concat(type || "unknown", "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(").concat(actionName, "())` instead of `dispatch(").concat(actionName, ")`. This is necessary even if the action has no payload.");
}
function $44e97ff44f917989$export$6a1fcb4ceef578f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $44e97ff44f917989$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn("".concat(fnName, " took ").concat(elapsed, "ms, which is more than the warning threshold of ").concat(maxDelay, "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that."));
        }
    };
}
var $44e97ff44f917989$export$1908877435b1d5e9 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $5dLwP._)(_Tuple, Array1);
    function _Tuple() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        (0, $bB0zn._)(this, _Tuple);
        var _this;
        _this = (0, $3Gvhd._)(this, _Tuple, (0, $2Xzd1._)(items));
        Object.setPrototypeOf(_this, _Tuple.prototype);
        return _this;
    }
    (0, $6QEWP._)(_Tuple, [
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                return (0, $04ca9dac0ceac2e2$export$71511d61b312f219)((0, $ZhYhU._)(_Tuple.prototype), "concat", this).apply(this, arr);
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                if (arr.length === 1 && Array.isArray(arr[0])) return (0, $f5KHm._)(_Tuple, (0, $2Xzd1._)(arr[0].concat(this)));
                return (0, $f5KHm._)(_Tuple, (0, $2Xzd1._)(arr.concat(this)));
            }
        }
    ], [
        {
            key: Symbol.species,
            get: function get() {
                return _Tuple;
            }
        }
    ]);
    return _Tuple;
}((0, $fPaN7._)(Array));
function $44e97ff44f917989$var$freezeDraftable(val) {
    return (0, $5icQr.isDraftable)(val) ? (0, $5icQr.produce)(val, function() {}) : val;
}
function $44e97ff44f917989$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $44e97ff44f917989$export$9021b2733a0028a3(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) !== "object" || value == null || Object.isFrozen(value);
}
function $44e97ff44f917989$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $44e97ff44f917989$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $44e97ff44f917989$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $44e97ff44f917989$var$trackProperties(isImmutable) {
    var ignorePaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], obj = arguments.length > 2 ? arguments[2] : void 0, path = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", checkedObjects = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : /* @__PURE__ */ new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $44e97ff44f917989$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $44e97ff44f917989$var$detectMutations(isImmutable) {
    var _loop = function(key2) {
        var nestedPath = path ? path + "." + key2 : key2;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $44e97ff44f917989$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key2], obj[key2], sameRef, nestedPath);
        if (result.wasMutated) return {
            v: result
        };
    };
    var ignoredPaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], trackedProperty = arguments.length > 2 ? arguments[2] : void 0, obj = arguments.length > 3 ? arguments[3] : void 0, sameParentRef = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, path = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key1 in obj)keysToDetect[key1] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for(var key2 in keysToDetect){
        var _ret = _loop(key2);
        if ((0, $YtE9h._)(_ret) === "object") return _ret.v;
    }
    return {
        wasMutated: false
    };
}
function $44e97ff44f917989$export$9181bb1a5474289() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var stringify, getSerialize, getState, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $44e97ff44f917989$export$77670485918dab4e(val) {
    var type = typeof val === "undefined" ? "undefined" : (0, $YtE9h._)(val);
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $a039f9c7168ef4c9$export$53b83ca8eaab0383)(val);
}
function $44e97ff44f917989$export$ada5dca0b571bc7(value) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isSerializable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $44e97ff44f917989$export$77670485918dab4e, getEntries = arguments.length > 3 ? arguments[3] : void 0, ignoredPaths = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], cache = arguments.length > 5 ? arguments[5] : void 0;
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if ((typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], nestedValue = _step_value[1];
            var nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                var hasMatches = ignoredPaths.some(function(ignored) {
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) return "continue";
            }
            if (!isSerializable(nestedValue)) return {
                v: {
                    keyPath: nestedPath,
                    value: nestedValue
                }
            };
            if ((typeof nestedValue === "undefined" ? "undefined" : (0, $YtE9h._)(nestedValue)) === "object") {
                foundNestedSerializable = $44e97ff44f917989$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
                if (foundNestedSerializable) return {
                    v: foundNestedSerializable
                };
            }
        };
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $YtE9h._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (cache && $44e97ff44f917989$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $44e97ff44f917989$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nestedValue = _step.value;
            if ((typeof nestedValue === "undefined" ? "undefined" : (0, $YtE9h._)(nestedValue)) !== "object" || nestedValue === null) continue;
            if (!$44e97ff44f917989$var$isNestedFrozen(nestedValue)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $44e97ff44f917989$export$6dea1aad6dac5ac2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var storeAPI, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $44e97ff44f917989$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $44e97ff44f917989$var$buildGetDefaultMiddleware = function() {
    return function getDefaultMiddleware(options) {
        var _ref = options != null ? options : {}, _ref_thunk = _ref.thunk, thunk = _ref_thunk === void 0 ? true : _ref_thunk, _ref_immutableCheck = _ref.immutableCheck, immutableCheck = _ref_immutableCheck === void 0 ? true : _ref_immutableCheck, _ref_serializableCheck = _ref.serializableCheck, serializableCheck = _ref_serializableCheck === void 0 ? true : _ref_serializableCheck, _ref_actionCreatorCheck = _ref.actionCreatorCheck, actionCreatorCheck = _ref_actionCreatorCheck === void 0 ? true : _ref_actionCreatorCheck;
        var middlewareArray = new $44e97ff44f917989$export$1908877435b1d5e9();
        if (thunk) {
            if ($44e97ff44f917989$var$isBoolean(thunk)) middlewareArray.push((0, $2193944b4716daad$export$dd164f5517779f15));
            else middlewareArray.push((0, $2193944b4716daad$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
};
// src/autoBatchEnhancer.ts
var $44e97ff44f917989$export$8fb31c0f05df007b = "RTK_autoBatch";
var $44e97ff44f917989$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        return {
            payload: payload,
            meta: (0, $hD5pT._)({}, $44e97ff44f917989$export$8fb31c0f05df007b, true)
        };
    };
};
var $44e97ff44f917989$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $44e97ff44f917989$export$676277d7dca0f396 = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        type: "raf"
    };
    return function(next) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var store = next.apply(void 0, (0, $2Xzd1._)(args));
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = /* @__PURE__ */ new Set();
            var queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $44e97ff44f917989$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $44e97ff44f917989$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$44e97ff44f917989$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/getDefaultEnhancers.ts
var $44e97ff44f917989$var$buildGetDefaultEnhancers = function(middlewareEnhancer) {
    return function getDefaultEnhancers(options) {
        var _ref = options != null ? options : {}, _ref_autoBatch = _ref.autoBatch, autoBatch = _ref_autoBatch === void 0 ? true : _ref_autoBatch;
        var enhancerArray = new $44e97ff44f917989$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($44e97ff44f917989$export$676277d7dca0f396((typeof autoBatch === "undefined" ? "undefined" : (0, $YtE9h._)(autoBatch)) === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
};
// src/configureStore.ts
function $44e97ff44f917989$export$7d8a5b498da695ac(options) {
    var getDefaultMiddleware = $44e97ff44f917989$var$buildGetDefaultMiddleware();
    var _ref = options || {}, reducer = _ref.reducer, middleware = _ref.middleware, _ref_devTools = _ref.devTools, devTools = _ref_devTools === void 0 ? true : _ref_devTools, preloadedState = _ref.preloadedState, enhancers = _ref.enhancers;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $a039f9c7168ef4c9$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $a039f9c7168ef4c9$export$66e4520cdb265d18)(reducer);
    else throw new Error($44e97ff44f917989$export$378fa86b259c0280(1));
    var finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var finalCompose = (0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $44e97ff44f917989$var$composeWithDevTools($44e97ff44f917989$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, (typeof devTools === "undefined" ? "undefined" : (0, $YtE9h._)(devTools)) === "object" && devTools));
    var middlewareEnhancer = (0, $a039f9c7168ef4c9$export$9ff26e0402cc7b7).apply(void 0, (0, $2Xzd1._)(finalMiddleware));
    var getDefaultEnhancers = $44e97ff44f917989$var$buildGetDefaultEnhancers(middlewareEnhancer);
    var storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    var composedEnhancer = finalCompose.apply(void 0, (0, $2Xzd1._)(storeEnhancers));
    return (0, $a039f9c7168ef4c9$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $44e97ff44f917989$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($44e97ff44f917989$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($44e97ff44f917989$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $44e97ff44f917989$var$isStateFunction(x) {
    return typeof x === "function";
}
function $44e97ff44f917989$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    var _executeReducerBuilderCallback = (0, $kB67t._)($44e97ff44f917989$var$executeReducerBuilderCallback(mapOrBuilderCallback), 3), actionsMap = _executeReducerBuilderCallback[0], finalActionMatchers = _executeReducerBuilderCallback[1], finalDefaultCaseReducer = _executeReducerBuilderCallback[2];
    var getInitialState;
    if ($44e97ff44f917989$var$isStateFunction(initialState)) getInitialState = function() {
        return $44e97ff44f917989$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState = $44e97ff44f917989$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState;
        };
    }
    function reducer() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getInitialState(), action = arguments.length > 1 ? arguments[1] : void 0;
        var caseReducers = [
            actionsMap[action.type]
        ].concat((0, $2Xzd1._)(finalActionMatchers.filter(function(param) {
            var matcher = param.matcher;
            return matcher(action);
        }).map(function(param) {
            var reducer2 = param.reducer;
            return reducer2;
        })));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $5icQr.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $5icQr.isDraftable)(previousState)) {
                    var result1 = caseReducer(previousState, action);
                    if (result1 === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result1;
                } else return (0, $5icQr.produce)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $44e97ff44f917989$var$matches = function(matcher, action) {
    if ($44e97ff44f917989$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $44e97ff44f917989$export$2c3435c7647f7b0d() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.some(function(matcher) {
            return $44e97ff44f917989$var$matches(matcher, action);
        });
    };
}
function $44e97ff44f917989$export$9dd1fb32974da385() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.every(function(matcher) {
            return $44e97ff44f917989$var$matches(matcher, action);
        });
    };
}
function $44e97ff44f917989$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $44e97ff44f917989$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $44e97ff44f917989$export$872dec21e9a69476() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$872dec21e9a69476()(asyncThunks[0]);
    return $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.pending;
    })));
}
function $44e97ff44f917989$export$a5c5d27e3994c5be() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.rejected;
    })));
}
function $44e97ff44f917989$export$fcc3388fb56de601() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $44e97ff44f917989$export$9dd1fb32974da385($44e97ff44f917989$export$a5c5d27e3994c5be.apply(void 0, (0, $2Xzd1._)(asyncThunks)), hasFlag);
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$fcc3388fb56de601()(asyncThunks[0]);
    return $44e97ff44f917989$export$9dd1fb32974da385($44e97ff44f917989$export$a5c5d27e3994c5be.apply(void 0, (0, $2Xzd1._)(asyncThunks)), hasFlag);
}
function $44e97ff44f917989$export$1da80a6ef1307441() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$1da80a6ef1307441()(asyncThunks[0]);
    return $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.fulfilled;
    })));
}
function $44e97ff44f917989$export$6aa4142d99c1abce() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(asyncThunks.flatMap(function(asyncThunk) {
        return [
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ];
    })));
}
// src/nanoid.ts
var $44e97ff44f917989$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $44e97ff44f917989$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $44e97ff44f917989$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $44e97ff44f917989$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $44e97ff44f917989$var$RejectWithValue = function RejectWithValue(payload, meta) {
    "use strict";
    (0, $bB0zn._)(this, RejectWithValue);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $44e97ff44f917989$var$__publicField(this, "_type");
};
var $44e97ff44f917989$var$FulfillWithMeta = function FulfillWithMeta(payload, meta) {
    "use strict";
    (0, $bB0zn._)(this, FulfillWithMeta);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $44e97ff44f917989$var$__publicField(this, "_type");
};
var $44e97ff44f917989$export$c97c53d0b2d5d81e = function(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) === "object" && value !== null) {
        var simpleError = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $44e97ff44f917989$var$commonProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                if (typeof value[property] === "string") simpleError[property] = value[property];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $44e97ff44f917989$export$6abd22dc03e5063f = /* @__PURE__ */ function() {
    var createAsyncThunk2 = function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $44e97ff44f917989$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $44e97ff44f917989$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $44e97ff44f917989$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $44e97ff44f917989$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var abort = function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                };
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $44e97ff44f917989$export$ac4959f4f1338dfc();
                var abortController = new AbortController();
                var abortHandler;
                var abortReason;
                var promise = (0, $7k5I8._)(function() {
                    var _a, _b, finalAction, conditionResult, abortedPromise, err, skipDispatch;
                    return (0, $lFlDF.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    5,
                                    6
                                ]);
                                conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                    getState: getState,
                                    extra: extra
                                });
                                if (!$44e97ff44f917989$var$isThenable(conditionResult)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    conditionResult
                                ];
                            case 1:
                                conditionResult = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (conditionResult === false || abortController.signal.aborted) throw {
                                    name: "ConditionError",
                                    message: "Aborted due to condition callback returning false."
                                };
                                abortedPromise = new Promise(function(_, reject) {
                                    abortHandler = function() {
                                        reject({
                                            name: "AbortError",
                                            message: abortReason || "Aborted"
                                        });
                                    };
                                    abortController.signal.addEventListener("abort", abortHandler);
                                });
                                dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                    requestId: requestId,
                                    arg: arg
                                }, {
                                    getState: getState,
                                    extra: extra
                                })));
                                return [
                                    4,
                                    Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            abort: abort,
                                            rejectWithValue: function(value, meta) {
                                                return new $44e97ff44f917989$var$RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function(value, meta) {
                                                return new $44e97ff44f917989$var$FulfillWithMeta(value, meta);
                                            }
                                        })).then(function(result) {
                                            if (result instanceof $44e97ff44f917989$var$RejectWithValue) throw result;
                                            if (result instanceof $44e97ff44f917989$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])
                                ];
                            case 3:
                                finalAction = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                err = _state.sent();
                                finalAction = err instanceof $44e97ff44f917989$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                                return [
                                    7
                                ];
                            case 6:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) dispatch(finalAction);
                                return [
                                    2,
                                    finalAction
                                ];
                        }
                    });
                })();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise.then($44e97ff44f917989$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $44e97ff44f917989$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    };
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $44e97ff44f917989$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $44e97ff44f917989$var$isThenable(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $44e97ff44f917989$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $44e97ff44f917989$export$343355ed40c51c46 = (0, $hD5pT._)({}, $44e97ff44f917989$var$asyncThunkSymbol, $44e97ff44f917989$export$6abd22dc03e5063f);
var $44e97ff44f917989$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType2) {
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
}($44e97ff44f917989$export$23a094319a4b586 || {});
function $44e97ff44f917989$var$getType(slice, actionKey) {
    return "".concat(slice, "/").concat(actionKey);
}
function $44e97ff44f917989$export$affdea4146de9cf5() {
    var creators = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).creators;
    var _a;
    var cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$44e97ff44f917989$var$asyncThunkSymbol];
    return function createSlice2(options) {
        var name = options.name, _options_reducerPath = options.reducerPath, reducerPath = _options_reducerPath === void 0 ? name : _options_reducerPath;
        if (!name) throw new Error($44e97ff44f917989$export$378fa86b259c0280(11));
        typeof $ibRPI === "undefined" ? "undefined" : (0, $YtE9h._)($ibRPI);
        var reducers = (typeof options.reducers === "function" ? options.reducers($44e97ff44f917989$var$buildReducerCreators()) : options.reducers) || {};
        var reducerNames = Object.keys(reducers);
        var context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        var contextMethods = {
            addCase: function(typeOrActionCreator, reducer2) {
                var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($44e97ff44f917989$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($44e97ff44f917989$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher: function(matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction: function(name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer: function(name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach(function(reducerName) {
            var reducerDefinition = reducers[reducerName];
            var reducerDetails = {
                reducerName: reducerName,
                type: $44e97ff44f917989$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($44e97ff44f917989$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $44e97ff44f917989$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $44e97ff44f917989$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            var _ref = (0, $kB67t._)(typeof options.extraReducers === "function" ? $44e97ff44f917989$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ], 3), tmp = _ref[0], extraReducers = tmp === void 0 ? {} : tmp, tmp1 = _ref[1], actionMatchers = tmp1 === void 0 ? [] : tmp1, defaultCaseReducer = _ref[2];
            var finalCaseReducers = $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $44e97ff44f917989$export$473eb76d322d0290(options.initialState, function(builder) {
                for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = context.sliceMatchers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sM = _step.value;
                        builder.addMatcher(sM.matcher, sM.reducer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = actionMatchers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var m = _step1.value;
                        builder.addMatcher(m.matcher, m.reducer);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        var selectSelf = function(state) {
            return state;
        };
        var injectedSelectorCache = /* @__PURE__ */ new Map();
        var _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2) {
            var injected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            function selectSlice(state) {
                var sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors() {
                var selectState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : selectSelf;
                var selectorCache = $44e97ff44f917989$var$getOrInsertComputed(injectedSelectorCache, injected, function() {
                    return /* @__PURE__ */ new WeakMap();
                });
                return $44e97ff44f917989$var$getOrInsertComputed(selectorCache, selectState, function() {
                    var _a2;
                    var map = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries((_a2 = options.selectors) != null ? _a2 : {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $kB67t._)(_step.value, 2), name2 = _step_value[0], selector = _step_value[1];
                            map[name2] = $44e97ff44f917989$var$wrapSelector(selector, selectState, getInitialState, injected);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        var slice = $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto: function(injectable) {
                var _a2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _b = _a2, pathOpt = _b.reducerPath, config = $44e97ff44f917989$var$__objRest(_b, [
                    "reducerPath"
                ]);
                var newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $44e97ff44f917989$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector.apply(void 0, [
            sliceState
        ].concat((0, $2Xzd1._)(args)));
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $44e97ff44f917989$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $44e97ff44f917989$export$affdea4146de9cf5();
function $44e97ff44f917989$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $44e97ff44f917989$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = function() {
        return asyncThunk;
    };
    return {
        reducer: function(caseReducer) {
            return Object.assign(// hack so the wrapping function has the same name as the original
            // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
            (0, $hD5pT._)({}, caseReducer.name, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return caseReducer.apply(void 0, (0, $2Xzd1._)(args));
            })[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer: function(prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $44e97ff44f917989$var$handleNormalReducerDefinition(param, maybeReducerWithPrepare, context) {
    var type = param.type, reducerName = param.reducerName, createNotation = param.createNotation;
    var caseReducer;
    var prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$44e97ff44f917989$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($44e97ff44f917989$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $44e97ff44f917989$export$309c7a02b0b0bc62(type, prepareCallback) : $44e97ff44f917989$export$309c7a02b0b0bc62(type));
}
function $44e97ff44f917989$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $44e97ff44f917989$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $44e97ff44f917989$var$handleThunkCaseReducerDefinition(param, reducerDefinition, context, cAT) {
    var type = param.type, reducerName = param.reducerName;
    if (!cAT) throw new Error($44e97ff44f917989$export$378fa86b259c0280(18));
    var payloadCreator = reducerDefinition.payloadCreator, fulfilled = reducerDefinition.fulfilled, pending = reducerDefinition.pending, rejected = reducerDefinition.rejected, settled = reducerDefinition.settled, options = reducerDefinition.options;
    var thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $44e97ff44f917989$var$noop,
        pending: pending || $44e97ff44f917989$var$noop,
        rejected: rejected || $44e97ff44f917989$var$noop,
        settled: settled || $44e97ff44f917989$var$noop
    });
}
function $44e97ff44f917989$var$noop() {}
// src/entities/entity_state.ts
function $44e97ff44f917989$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $44e97ff44f917989$var$createInitialStateFactory(stateAdapter) {
    function getInitialState() {
        var additionalState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, entities = arguments.length > 1 ? arguments[1] : void 0;
        var state = Object.assign($44e97ff44f917989$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $44e97ff44f917989$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var tmp = options.createSelector, createSelector2 = tmp === void 0 ? $44e97ff44f917989$export$a5d3c27355e35910 : tmp;
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createSelector2(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createSelector2(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $44e97ff44f917989$var$isDraftTyped = (0, $5icQr.isDraft);
function $44e97ff44f917989$var$createSingleArgumentStateOperator(mutator) {
    var operator = $44e97ff44f917989$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $44e97ff44f917989$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $44e97ff44f917989$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($44e97ff44f917989$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $5icQr.produce)(state, runMutator);
    };
}
function $44e97ff44f917989$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $44e97ff44f917989$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $44e97ff44f917989$var$getCurrent(value) {
    return (0, $5icQr.isDraft)(value) ? (0, $5icQr.current)(value) : value;
}
function $44e97ff44f917989$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
    var existingIdsArray = $44e97ff44f917989$var$getCurrent(state.ids);
    var existingIds = new Set(existingIdsArray);
    var added = [];
    var updated = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entity = _step.value;
            var id = $44e97ff44f917989$var$selectIdValue(entity, selectId);
            if (existingIds.has(id)) updated.push({
                id: id,
                changes: entity
            });
            else added.push(entity);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $44e97ff44f917989$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $44e97ff44f917989$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                addOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setOneMutably(entity, state) {
        var key = $44e97ff44f917989$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                setOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        var updated = Object.assign({}, original3, update.changes);
        var newKey = $44e97ff44f917989$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map(function(e) {
                return $44e97ff44f917989$var$selectIdValue(e, selectId);
            });
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $kB67t._)($44e97ff44f917989$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $44e97ff44f917989$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $44e97ff44f917989$var$createStateOperator(addOneMutably),
        addMany: $44e97ff44f917989$var$createStateOperator(addManyMutably),
        setOne: $44e97ff44f917989$var$createStateOperator(setOneMutably),
        setMany: $44e97ff44f917989$var$createStateOperator(setManyMutably),
        setAll: $44e97ff44f917989$var$createStateOperator(setAllMutably),
        updateOne: $44e97ff44f917989$var$createStateOperator(updateOneMutably),
        updateMany: $44e97ff44f917989$var$createStateOperator(updateManyMutably),
        upsertOne: $44e97ff44f917989$var$createStateOperator(upsertOneMutably),
        upsertMany: $44e97ff44f917989$var$createStateOperator(upsertManyMutably),
        removeOne: $44e97ff44f917989$var$createStateOperator(removeOneMutably),
        removeMany: $44e97ff44f917989$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $44e97ff44f917989$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    var lowIndex = 0;
    var highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        var middleIndex = lowIndex + highIndex >>> 1;
        var currentItem = sortedItems[middleIndex];
        var res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $44e97ff44f917989$var$insert(sortedItems, item, comparisonFunction) {
    var insertAtIndex = $44e97ff44f917989$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $44e97ff44f917989$var$createSortedStateAdapter(selectId, comparer) {
    var _createUnsortedStateAdapter = $44e97ff44f917989$var$createUnsortedStateAdapter(selectId), removeOne = _createUnsortedStateAdapter.removeOne, removeMany = _createUnsortedStateAdapter.removeMany, removeAll = _createUnsortedStateAdapter.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        var existingKeys = new Set(existingIds != null ? existingIds : $44e97ff44f917989$var$getCurrent(state.ids));
        var models = newEntities.filter(function(model) {
            return !existingKeys.has($44e97ff44f917989$var$selectIdValue(model, selectId));
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    delete state.entities[selectId(item)];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        var replacedIds = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var update = _step.value;
                var entity = state.entities[update.id];
                if (!entity) continue;
                appliedUpdates = true;
                Object.assign(entity, update.changes);
                var newId = selectId(entity);
                if (update.id !== newId) {
                    replacedIds = true;
                    delete state.entities[update.id];
                    var oldIndex = state.ids.indexOf(update.id);
                    state.ids[oldIndex] = newId;
                    state.entities[newId] = entity;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $kB67t._)($44e97ff44f917989$var$splitAddedUpdatedEntities(newEntities, selectId, state), 3), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1], existingIdsArray = _splitAddedUpdatedEntities[2];
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    var mergeFunction = function(state, addedItems, appliedUpdates, replacedIds) {
        var currentEntities = $44e97ff44f917989$var$getCurrent(state.entities);
        var currentIds = $44e97ff44f917989$var$getCurrent(state.ids);
        var stateEntities = state.entities;
        var ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        var sortedEntities = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var id = _step.value;
                var entity = currentEntities[id];
                if (entity) sortedEntities.push(entity);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var wasPreviouslyEmpty = sortedEntities.length === 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = addedItems[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var item = _step1.value;
                stateEntities[selectId(item)] = item;
                if (!wasPreviouslyEmpty) $44e97ff44f917989$var$insert(sortedEntities, item, comparer);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        var newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $44e97ff44f917989$var$createStateOperator(addOneMutably),
        updateOne: $44e97ff44f917989$var$createStateOperator(updateOneMutably),
        upsertOne: $44e97ff44f917989$var$createStateOperator(upsertOneMutably),
        setOne: $44e97ff44f917989$var$createStateOperator(setOneMutably),
        setMany: $44e97ff44f917989$var$createStateOperator(setManyMutably),
        setAll: $44e97ff44f917989$var$createStateOperator(setAllMutably),
        addMany: $44e97ff44f917989$var$createStateOperator(addManyMutably),
        updateMany: $44e97ff44f917989$var$createStateOperator(updateManyMutably),
        upsertMany: $44e97ff44f917989$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $44e97ff44f917989$export$abcf4037b41e0df() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var __spreadValues1 = $44e97ff44f917989$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = __spreadValues1.selectId, sortComparer = __spreadValues1.sortComparer;
    var stateAdapter = sortComparer ? $44e97ff44f917989$var$createSortedStateAdapter(selectId, sortComparer) : $44e97ff44f917989$var$createUnsortedStateAdapter(selectId);
    var stateFactory = $44e97ff44f917989$var$createInitialStateFactory(stateAdapter);
    var selectorsFactory = $44e97ff44f917989$var$createSelectorsFactory();
    return $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $44e97ff44f917989$var$task = "task";
var $44e97ff44f917989$var$listener = "listener";
var $44e97ff44f917989$var$completed = "completed";
var $44e97ff44f917989$var$cancelled = "cancelled";
var $44e97ff44f917989$var$taskCancelled = "task-".concat($44e97ff44f917989$var$cancelled);
var $44e97ff44f917989$var$taskCompleted = "task-".concat($44e97ff44f917989$var$completed);
var $44e97ff44f917989$var$listenerCancelled = "".concat($44e97ff44f917989$var$listener, "-").concat($44e97ff44f917989$var$cancelled);
var $44e97ff44f917989$var$listenerCompleted = "".concat($44e97ff44f917989$var$listener, "-").concat($44e97ff44f917989$var$completed);
var $44e97ff44f917989$export$cb1bdac908fed7f = function TaskAbortError(code) {
    "use strict";
    (0, $bB0zn._)(this, TaskAbortError);
    this.code = code;
    $44e97ff44f917989$var$__publicField(this, "name", "TaskAbortError");
    $44e97ff44f917989$var$__publicField(this, "message");
    this.message = "".concat($44e97ff44f917989$var$task, " ").concat($44e97ff44f917989$var$cancelled, " (reason: ").concat(code, ")");
};
// src/listenerMiddleware/utils.ts
var $44e97ff44f917989$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError($44e97ff44f917989$export$378fa86b259c0280(32));
};
var $44e97ff44f917989$var$noop2 = function() {};
var $44e97ff44f917989$var$catchRejection = function(promise) {
    var onError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $44e97ff44f917989$var$noop2;
    promise.catch(onError);
    return promise;
};
var $44e97ff44f917989$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $44e97ff44f917989$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $44e97ff44f917989$var$validateActive = function(signal) {
    if (signal.aborted) {
        var reason = signal.reason;
        throw new $44e97ff44f917989$export$cb1bdac908fed7f(reason);
    }
};
function $44e97ff44f917989$var$raceWithSignal(signal, promise) {
    var cleanup = $44e97ff44f917989$var$noop2;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $44e97ff44f917989$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $44e97ff44f917989$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $44e97ff44f917989$var$noop2;
    });
}
var $44e97ff44f917989$var$runTask = /*#__PURE__*/ function() {
    var _ref = (0, $7k5I8._)(function(task2, cleanUp) {
        var value, error;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        Promise.resolve()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        task2()
                    ];
                case 2:
                    value = _state.sent();
                    return [
                        2,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            status: error instanceof $44e97ff44f917989$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function runTask(task2, cleanUp) {
        return _ref.apply(this, arguments);
    };
}();
var $44e97ff44f917989$var$createPause = function(signal) {
    return function(promise) {
        return $44e97ff44f917989$var$catchRejection($44e97ff44f917989$var$raceWithSignal(signal, promise).then(function(output) {
            $44e97ff44f917989$var$validateActive(signal);
            return output;
        }));
    };
};
var $44e97ff44f917989$var$createDelay = function(signal) {
    var pause = $44e97ff44f917989$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $44e97ff44f917989$var$assign = Object.assign;
var $44e97ff44f917989$var$INTERNAL_NIL_TOKEN = {};
var $44e97ff44f917989$var$alm = "listenerMiddleware";
var $44e97ff44f917989$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $44e97ff44f917989$var$addAbortSignalListener(parentAbortSignal, function() {
            return $44e97ff44f917989$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $44e97ff44f917989$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $44e97ff44f917989$var$runTask(/*#__PURE__*/ (0, $7k5I8._)(function() {
            var result2;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $44e97ff44f917989$var$validateActive(parentAbortSignal);
                        $44e97ff44f917989$var$validateActive(childAbortController.signal);
                        return [
                            4,
                            taskExecutor({
                                pause: $44e97ff44f917989$var$createPause(childAbortController.signal),
                                delay: $44e97ff44f917989$var$createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })
                        ];
                    case 1:
                        result2 = _state.sent();
                        $44e97ff44f917989$var$validateActive(childAbortController.signal);
                        return [
                            2,
                            result2
                        ];
                }
            });
        }), function() {
            return $44e97ff44f917989$var$abortControllerWithReason(childAbortController, $44e97ff44f917989$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($44e97ff44f917989$var$noop2));
        return {
            result: $44e97ff44f917989$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $44e97ff44f917989$var$abortControllerWithReason(childAbortController, $44e97ff44f917989$var$taskCancelled);
            }
        };
    };
};
var $44e97ff44f917989$var$createTakePattern = function(startListening, signal) {
    var take = /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(predicate, timeout) {
            var unsubscribe, tuplePromise, promises, output;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $44e97ff44f917989$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            $44e97ff44f917989$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _state.sent();
                        $44e97ff44f917989$var$validateActive(signal);
                        return [
                            2,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function take(predicate, timeout) {
            return _ref.apply(this, arguments);
        };
    }();
    return function(predicate, timeout) {
        return $44e97ff44f917989$var$catchRejection(take(predicate, timeout));
    };
};
var $44e97ff44f917989$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $44e97ff44f917989$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($44e97ff44f917989$export$378fa86b259c0280(21));
    $44e97ff44f917989$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $44e97ff44f917989$var$createListenerEntry = /* @__PURE__ */ $44e97ff44f917989$var$assign(function(options) {
    var _getListenerEntryPropsFrom = $44e97ff44f917989$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, predicate = _getListenerEntryPropsFrom.predicate, effect = _getListenerEntryPropsFrom.effect;
    var entry = {
        id: $44e97ff44f917989$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: function() {
            throw new Error($44e97ff44f917989$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: function() {
        return $44e97ff44f917989$var$createListenerEntry;
    }
});
var $44e97ff44f917989$var$findListenerEntry = function(listenerMap, options) {
    var _getListenerEntryPropsFrom = $44e97ff44f917989$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, effect = _getListenerEntryPropsFrom.effect, predicate = _getListenerEntryPropsFrom.predicate;
    return Array.from(listenerMap.values()).find(function(entry) {
        var matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $44e97ff44f917989$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $44e97ff44f917989$var$abortControllerWithReason(controller, $44e97ff44f917989$var$listenerCancelled);
    });
};
var $44e97ff44f917989$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($44e97ff44f917989$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $44e97ff44f917989$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $44e97ff44f917989$export$f03a6b845d3fb58b = /* @__PURE__ */ $44e97ff44f917989$var$assign(/* @__PURE__ */ $44e97ff44f917989$export$309c7a02b0b0bc62("".concat($44e97ff44f917989$var$alm, "/add")), {
    withTypes: function() {
        return $44e97ff44f917989$export$f03a6b845d3fb58b;
    }
});
var $44e97ff44f917989$export$b1b8022855fb2b71 = /* @__PURE__ */ $44e97ff44f917989$export$309c7a02b0b0bc62("".concat($44e97ff44f917989$var$alm, "/removeAll"));
var $44e97ff44f917989$export$b03e9483f936dccb = /* @__PURE__ */ $44e97ff44f917989$var$assign(/* @__PURE__ */ $44e97ff44f917989$export$309c7a02b0b0bc62("".concat($44e97ff44f917989$var$alm, "/remove")), {
    withTypes: function() {
        return $44e97ff44f917989$export$b03e9483f936dccb;
    }
});
var $44e97ff44f917989$var$defaultErrorHandler = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).error.apply(_console, [
        "".concat($44e97ff44f917989$var$alm, "/error")
    ].concat((0, $2Xzd1._)(args)));
};
var $44e97ff44f917989$export$1228acebbbcb485b = function() {
    var middlewareOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var listenerMap = /* @__PURE__ */ new Map();
    var extra = middlewareOptions.extra, _middlewareOptions_onError = middlewareOptions.onError, onError = _middlewareOptions_onError === void 0 ? $44e97ff44f917989$var$defaultErrorHandler : _middlewareOptions_onError;
    $44e97ff44f917989$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $44e97ff44f917989$var$cancelActiveListeners(entry);
        };
    };
    var startListening = function(options) {
        var _a;
        var entry = (_a = $44e97ff44f917989$var$findListenerEntry(listenerMap, options)) != null ? _a : $44e97ff44f917989$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $44e97ff44f917989$var$assign(startListening, {
        withTypes: function() {
            return startListening;
        }
    });
    var stopListening = function(options) {
        var entry = $44e97ff44f917989$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $44e97ff44f917989$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $44e97ff44f917989$var$assign(stopListening, {
        withTypes: function() {
            return stopListening;
        }
    });
    var notifyListener = /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(entry, action, api, getOriginalState) {
            var internalTaskController, take, autoJoinPromises, listenerError;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $44e97ff44f917989$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4,
                            Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
                            $44e97ff44f917989$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $44e97ff44f917989$var$createDelay(internalTaskController.signal),
                                pause: $44e97ff44f917989$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $44e97ff44f917989$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $44e97ff44f917989$var$abortControllerWithReason(controller, $44e97ff44f917989$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                },
                                cancel: function() {
                                    $44e97ff44f917989$var$abortControllerWithReason(internalTaskController, $44e97ff44f917989$var$listenerCancelled);
                                    entry.pending.delete(internalTaskController);
                                },
                                throwIfCancelled: function() {
                                    $44e97ff44f917989$var$validateActive(internalTaskController.signal);
                                }
                            })))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        listenerError = _state.sent();
                        if (!(listenerError instanceof $44e97ff44f917989$export$cb1bdac908fed7f)) $44e97ff44f917989$var$safelyNotifyError(onError, listenerError, {
                            raisedBy: "effect"
                        });
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            Promise.all(autoJoinPromises)
                        ];
                    case 5:
                        _state.sent();
                        $44e97ff44f917989$var$abortControllerWithReason(internalTaskController, $44e97ff44f917989$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function notifyListener(entry, action, api, getOriginalState) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearListenerMiddleware = $44e97ff44f917989$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!(0, $a039f9c7168ef4c9$export$b956e38827fca970)(action)) return next(action);
                if ($44e97ff44f917989$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($44e97ff44f917989$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($44e97ff44f917989$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $44e97ff44f917989$var$INTERNAL_NIL_TOKEN) throw new Error($44e97ff44f917989$export$378fa86b259c0280(23));
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = listenerEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var entry = _step.value;
                                var runListener = false;
                                try {
                                    runListener = entry.predicate(action, currentState, originalState);
                                } catch (predicateError) {
                                    runListener = false;
                                    $44e97ff44f917989$var$safelyNotifyError(onError, predicateError, {
                                        raisedBy: "predicate"
                                    });
                                }
                                if (!runListener) continue;
                                notifyListener(entry, action, api, getOriginalState);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } finally{
                    originalState = $44e97ff44f917989$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $44e97ff44f917989$var$createMiddlewareEntry = function(middleware) {
    return {
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    };
};
var $44e97ff44f917989$var$matchInstance = function(instanceId) {
    return function(action) {
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
};
var $44e97ff44f917989$export$4bb1606a79445586 = function() {
    var instanceId = $44e97ff44f917989$export$ac4959f4f1338dfc();
    var middlewareMap = /* @__PURE__ */ new Map();
    var withMiddleware = Object.assign($44e97ff44f917989$export$309c7a02b0b0bc62("dynamicMiddleware/add", function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        return {
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        };
    }), {
        withTypes: function() {
            return withMiddleware;
        }
    });
    var addMiddleware = Object.assign(function addMiddleware2() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        middlewares.forEach(function(middleware2) {
            $44e97ff44f917989$var$getOrInsertComputed(middlewareMap, middleware2, $44e97ff44f917989$var$createMiddlewareEntry);
        });
    }, {
        withTypes: function() {
            return addMiddleware;
        }
    });
    var getFinalMiddleware = function(api) {
        var appliedMiddleware = Array.from(middlewareMap.values()).map(function(entry) {
            return $44e97ff44f917989$var$getOrInsertComputed(entry.applied, api, entry.middleware);
        });
        return (0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7).apply(void 0, (0, $2Xzd1._)(appliedMiddleware));
    };
    var isWithMiddleware = $44e97ff44f917989$export$9dd1fb32974da385(withMiddleware, $44e97ff44f917989$var$matchInstance(instanceId));
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (isWithMiddleware(action)) {
                    addMiddleware.apply(void 0, (0, $2Xzd1._)(action.payload));
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
        };
    };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $44e97ff44f917989$var$isSliceLike = function(maybeSliceLike) {
    return "reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
};
var $44e97ff44f917989$var$getReducers = function(slices) {
    return slices.flatMap(function(sliceOrMap) {
        return $44e97ff44f917989$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap);
    });
};
var $44e97ff44f917989$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $44e97ff44f917989$var$isStateProxy = function(value) {
    return !!value && !!value[$44e97ff44f917989$var$ORIGINAL_STATE];
};
var $44e97ff44f917989$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $44e97ff44f917989$var$createStateProxy = function(state, reducerMap) {
    return $44e97ff44f917989$var$getOrInsertComputed($44e97ff44f917989$var$stateProxyMap, state, function() {
        return new Proxy(state, {
            get: function(target, prop, receiver) {
                if (prop === $44e97ff44f917989$var$ORIGINAL_STATE) return target;
                var result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    var reducer = reducerMap[prop.toString()];
                    if (reducer) {
                        var reducerResult = reducer(void 0, {
                            type: $44e97ff44f917989$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($44e97ff44f917989$export$378fa86b259c0280(24));
                        return reducerResult;
                    }
                }
                return result;
            }
        });
    });
};
var $44e97ff44f917989$var$original = function(state) {
    if (!$44e97ff44f917989$var$isStateProxy(state)) throw new Error($44e97ff44f917989$export$378fa86b259c0280(25));
    return state[$44e97ff44f917989$var$ORIGINAL_STATE];
};
var $44e97ff44f917989$var$noopReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return state;
};
function $44e97ff44f917989$export$a3734c7614660b9() {
    for(var _len = arguments.length, slices = new Array(_len), _key = 0; _key < _len; _key++){
        slices[_key] = arguments[_key];
    }
    var reducerMap = Object.fromEntries($44e97ff44f917989$var$getReducers(slices));
    var getReducer = function() {
        return Object.keys(reducerMap).length ? (0, $a039f9c7168ef4c9$export$66e4520cdb265d18)(reducerMap) : $44e97ff44f917989$var$noopReducer;
    };
    var reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = function() {
        return combinedReducer;
    };
    var inject = function(slice) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var reducerPath = slice.reducerPath, reducerToInject = slice.reducer;
        var currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $ibRPI === "undefined" ? "undefined" : (0, $YtE9h._)($ibRPI);
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    var selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return selectorFn.apply(void 0, [
                $44e97ff44f917989$var$createStateProxy(selectState ? selectState.apply(void 0, [
                    state
                ].concat((0, $2Xzd1._)(args))) : state, reducerMap)
            ].concat((0, $2Xzd1._)(args)));
        };
    }, {
        original: $44e97ff44f917989$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $44e97ff44f917989$export$378fa86b259c0280(code) {
    return "Minified Redux Toolkit error #".concat(code, "; visit https://redux-toolkit.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}


var $2767c9397776ff73$var$cartSlice = (0, $44e97ff44f917989$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: JSON.parse(localStorage.getItem("cartNew")) || []
    },
    reducers: {
        addItem: function(state, action) {
            state.items.push(action.payload);
            localStorage.setItem("cartNew", JSON.stringify(state.items));
        },
        removeItem: function(state, action) {
            state.items = state.items.filter(function(item) {
                var _item_info;
                return (item === null || item === void 0 ? void 0 : (_item_info = item.info) === null || _item_info === void 0 ? void 0 : _item_info.id) !== action.payload;
            });
            localStorage.setItem("cartNew", JSON.stringify(state.items));
        },
        cartClear: function(state) {
            state.items = [];
            localStorage.setItem("cartNew", JSON.stringify(state.items));
        }
    }
});
var $2767c9397776ff73$var$_cartSlice_actions = $2767c9397776ff73$var$cartSlice.actions;
var $2767c9397776ff73$export$fb9705de59d96855 = $2767c9397776ff73$var$_cartSlice_actions.addItem, $2767c9397776ff73$export$fe2d9b4e03920b4c = $2767c9397776ff73$var$_cartSlice_actions.removeItem, $2767c9397776ff73$export$10e1a9010e4bc561 = $2767c9397776ff73$var$_cartSlice_actions.cartClear;
var $2767c9397776ff73$export$2e2bcd8739ae039 = $2767c9397776ff73$var$cartSlice.reducer;


var $eddd11fdfb9a41ec$var$MenuItemList = function(param) {
    var menuItemList = param.menuItemList;
    var _menuItemList_card_info, _menuItemList_card, _menuItemList_card_info1, _menuItemList_card1, _menuItemList_card_info2, _menuItemList_card2, _menuItemList_card_info_offerTags_, _menuItemList_card_info_offerTags, _menuItemList_card_info3, _menuItemList_card3, _menuItemList_card_info_offerTags_1, _menuItemList_card_info_offerTags1, _menuItemList_card_info4, _menuItemList_card4, _menuItemList_card_info_ratings_aggregatedRating, _menuItemList_card_info_ratings, _menuItemList_card_info5, _menuItemList_card5, _menuItemList_card_info_ratings_aggregatedRating1, _menuItemList_card_info_ratings1, _menuItemList_card_info6, _menuItemList_card6, _menuItemList_card_info7, _menuItemList_card7, _menuItemList_card_info8, _menuItemList_card8, _menuItemList_card_info9, _menuItemList_card9, _menuItemList_card_info10, _menuItemList_card10;
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(false), 2), added = _useState[0], setAdded = _useState[1];
    //   const { state, dispatch } = useContext(CartContext);
    // const localStorageMenulist = useSelector((store) => (store.cart.items))
    // localStorageMenulist.map((item)=>{
    //     if((item?.info?.id==menuItemList?.card?.info?.id)){
    //         setAdded(true)
    //     }
    // })
    var dispatchRedux = (0, $c7b80bd183211e5d$export$8ad76b76a4c905f8)();
    var handlerAddItem = function(item) {
        dispatchRedux((0, $2767c9397776ff73$export$fb9705de59d96855)(item));
        setAdded(true);
    };
    var handlerRemoveItem = function(item) {
        console.log(item);
        dispatchRedux((0, $2767c9397776ff73$export$fe2d9b4e03920b4c)(item));
        setAdded(false);
    };
    return /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
        className: "mb-2",
        children: /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
            className: "bg-black text-white p-4 rounded-lg flex gap-4",
            children: [
                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                    className: "flex-grow",
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsx)("h2", {
                            className: "text-lg font-bold",
                            children: (menuItemList === null || menuItemList === void 0 ? void 0 : (_menuItemList_card = menuItemList.card) === null || _menuItemList_card === void 0 ? void 0 : (_menuItemList_card_info = _menuItemList_card.info) === null || _menuItemList_card_info === void 0 ? void 0 : _menuItemList_card_info.name) || "Unnamed Item"
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("p", {
                            className: "text-green-400 font-semibold",
                            children: [
                                "\u20B9",
                                " ",
                                (menuItemList === null || menuItemList === void 0 ? void 0 : (_menuItemList_card1 = menuItemList.card) === null || _menuItemList_card1 === void 0 ? void 0 : (_menuItemList_card_info1 = _menuItemList_card1.info) === null || _menuItemList_card_info1 === void 0 ? void 0 : _menuItemList_card_info1.price) ? ((menuItemList === null || menuItemList === void 0 ? void 0 : (_menuItemList_card2 = menuItemList.card) === null || _menuItemList_card2 === void 0 ? void 0 : (_menuItemList_card_info2 = _menuItemList_card2.info) === null || _menuItemList_card_info2 === void 0 ? void 0 : _menuItemList_card_info2.price) / 100).toFixed(2) : "N/A",
                                /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                    className: "text-sm",
                                    children: [
                                        "\u26A1",
                                        " ",
                                        (menuItemList === null || menuItemList === void 0 ? void 0 : (_menuItemList_card3 = menuItemList.card) === null || _menuItemList_card3 === void 0 ? void 0 : (_menuItemList_card_info3 = _menuItemList_card3.info) === null || _menuItemList_card_info3 === void 0 ? void 0 : (_menuItemList_card_info_offerTags = _menuItemList_card_info3.offerTags) === null || _menuItemList_card_info_offerTags === void 0 ? void 0 : (_menuItemList_card_info_offerTags_ = _menuItemList_card_info_offerTags[0]) === null || _menuItemList_card_info_offerTags_ === void 0 ? void 0 : _menuItemList_card_info_offerTags_.title) || "",
                                        " ",
                                        (menuItemList === null || menuItemList === void 0 ? void 0 : (_menuItemList_card4 = menuItemList.card) === null || _menuItemList_card4 === void 0 ? void 0 : (_menuItemList_card_info4 = _menuItemList_card4.info) === null || _menuItemList_card_info4 === void 0 ? void 0 : (_menuItemList_card_info_offerTags1 = _menuItemList_card_info4.offerTags) === null || _menuItemList_card_info_offerTags1 === void 0 ? void 0 : (_menuItemList_card_info_offerTags_1 = _menuItemList_card_info_offerTags1[0]) === null || _menuItemList_card_info_offerTags_1 === void 0 ? void 0 : _menuItemList_card_info_offerTags_1.subTitle) || ""
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("p", {
                            className: "text-green-400 font-bold text-sm",
                            children: [
                                "\u2605",
                                " ",
                                (menuItemList === null || menuItemList === void 0 ? void 0 : (_menuItemList_card5 = menuItemList.card) === null || _menuItemList_card5 === void 0 ? void 0 : (_menuItemList_card_info5 = _menuItemList_card5.info) === null || _menuItemList_card_info5 === void 0 ? void 0 : (_menuItemList_card_info_ratings = _menuItemList_card_info5.ratings) === null || _menuItemList_card_info_ratings === void 0 ? void 0 : (_menuItemList_card_info_ratings_aggregatedRating = _menuItemList_card_info_ratings.aggregatedRating) === null || _menuItemList_card_info_ratings_aggregatedRating === void 0 ? void 0 : _menuItemList_card_info_ratings_aggregatedRating.rating) || "No Rating",
                                "(",
                                (menuItemList === null || menuItemList === void 0 ? void 0 : (_menuItemList_card6 = menuItemList.card) === null || _menuItemList_card6 === void 0 ? void 0 : (_menuItemList_card_info6 = _menuItemList_card6.info) === null || _menuItemList_card_info6 === void 0 ? void 0 : (_menuItemList_card_info_ratings1 = _menuItemList_card_info6.ratings) === null || _menuItemList_card_info_ratings1 === void 0 ? void 0 : (_menuItemList_card_info_ratings_aggregatedRating1 = _menuItemList_card_info_ratings1.aggregatedRating) === null || _menuItemList_card_info_ratings_aggregatedRating1 === void 0 ? void 0 : _menuItemList_card_info_ratings_aggregatedRating1.ratingCountV2) || "0",
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                            className: "text-gray-300 text-sm mt-1 line-clamp-2",
                            children: (menuItemList === null || menuItemList === void 0 ? void 0 : (_menuItemList_card7 = menuItemList.card) === null || _menuItemList_card7 === void 0 ? void 0 : (_menuItemList_card_info7 = _menuItemList_card7.info) === null || _menuItemList_card_info7 === void 0 ? void 0 : _menuItemList_card_info7.description) || "No description available"
                        })
                    ]
                }),
                (menuItemList === null || menuItemList === void 0 ? void 0 : (_menuItemList_card8 = menuItemList.card) === null || _menuItemList_card8 === void 0 ? void 0 : (_menuItemList_card_info8 = _menuItemList_card8.info) === null || _menuItemList_card_info8 === void 0 ? void 0 : _menuItemList_card_info8.imageId) && /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                    className: "flex-shrink-0 text-center",
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                            src: "".concat((0, $iVsXN.MENUS_IMG_URL)).concat(menuItemList === null || menuItemList === void 0 ? void 0 : (_menuItemList_card9 = menuItemList.card) === null || _menuItemList_card9 === void 0 ? void 0 : (_menuItemList_card_info9 = _menuItemList_card9.info) === null || _menuItemList_card_info9 === void 0 ? void 0 : _menuItemList_card_info9.imageId),
                            alt: menuItemList === null || menuItemList === void 0 ? void 0 : (_menuItemList_card10 = menuItemList.card) === null || _menuItemList_card10 === void 0 ? void 0 : (_menuItemList_card_info10 = _menuItemList_card10.info) === null || _menuItemList_card_info10 === void 0 ? void 0 : _menuItemList_card_info10.name,
                            className: "w-24 h-24 rounded-lg"
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                            className: "flex justify-center items-center mt-2 gap-3",
                            children: added ? /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "bg-red-500 text-white px-4 py-1 rounded-lg",
                                onClick: function() {
                                    var _menuItemList_card_info, _menuItemList_card;
                                    return handlerRemoveItem(menuItemList === null || menuItemList === void 0 ? void 0 : (_menuItemList_card = menuItemList.card) === null || _menuItemList_card === void 0 ? void 0 : (_menuItemList_card_info = _menuItemList_card.info) === null || _menuItemList_card_info === void 0 ? void 0 : _menuItemList_card_info.id);
                                },
                                children: "Remove"
                            }) : /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "bg-green-500 text-white px-4 py-1 rounded-lg",
                                onClick: function() {
                                    return handlerAddItem(menuItemList === null || menuItemList === void 0 ? void 0 : menuItemList.card);
                                },
                                children: "Add"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $eddd11fdfb9a41ec$export$2e2bcd8739ae039 = $eddd11fdfb9a41ec$var$MenuItemList;


var $275fd59e69c4dc3a$var$MenuList = function(param) {
    var menu = param.menu;
    var _menu_data_cards__groupedCard_cardGroupMap_REGULAR, _menu_data_cards__groupedCard_cardGroupMap, _menu_data_cards__groupedCard, _menu_data_cards_, _menu_data, _menuList_slice_filter // Safely filter empty cards
    , _menuList_slice;
    var menuList = menu === null || menu === void 0 ? void 0 : (_menu_data = menu.data) === null || _menu_data === void 0 ? void 0 : (_menu_data_cards_ = _menu_data.cards[4]) === null || _menu_data_cards_ === void 0 ? void 0 : (_menu_data_cards__groupedCard = _menu_data_cards_.groupedCard) === null || _menu_data_cards__groupedCard === void 0 ? void 0 : (_menu_data_cards__groupedCard_cardGroupMap = _menu_data_cards__groupedCard.cardGroupMap) === null || _menu_data_cards__groupedCard_cardGroupMap === void 0 ? void 0 : (_menu_data_cards__groupedCard_cardGroupMap_REGULAR = _menu_data_cards__groupedCard_cardGroupMap.REGULAR) === null || _menu_data_cards__groupedCard_cardGroupMap_REGULAR === void 0 ? void 0 : _menu_data_cards__groupedCard_cardGroupMap_REGULAR.cards;
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(), 2), openId = _useState[0], setOpenId = _useState[1];
    var toggleAccordion = function(id) {
        setOpenId(openId === id ? null : id);
    };
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        className: "flex gap-10 flex-wrap",
        children: menuList === null || menuList === void 0 ? void 0 : (_menuList_slice = menuList.slice(1)) === null || _menuList_slice === void 0 ? void 0 : (_menuList_slice_filter = _menuList_slice.filter(function(card) {
            var _card_card_card_itemCards, _card_card_card, _card_card;
            return (card === null || card === void 0 ? void 0 : (_card_card = card.card) === null || _card_card === void 0 ? void 0 : (_card_card_card = _card_card.card) === null || _card_card_card === void 0 ? void 0 : (_card_card_card_itemCards = _card_card_card.itemCards) === null || _card_card_card_itemCards === void 0 ? void 0 : _card_card_card_itemCards.length) > 0;
        })) === null || _menuList_slice_filter === void 0 ? void 0 : _menuList_slice_filter.map(function(card, index) {
            var _card_card_card, _card_card, _card_card_card1, _card_card1, _card_card_card2, _card_card2, _card_card_card_itemCards, _card_card_card3, _card_card3, _card_card_card4, _card_card4;
            return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "w-full border-collapse border rounded-lg p-5",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("h1", {
                        className: "text-xl font-bold flex items-center justify-between cursor-pointer",
                        onClick: function() {
                            var _card_card_card, _card_card;
                            return toggleAccordion(card === null || card === void 0 ? void 0 : (_card_card = card.card) === null || _card_card === void 0 ? void 0 : (_card_card_card = _card_card.card) === null || _card_card_card === void 0 ? void 0 : _card_card_card.categoryId);
                        },
                        children: [
                            (card === null || card === void 0 ? void 0 : (_card_card = card.card) === null || _card_card === void 0 ? void 0 : (_card_card_card = _card_card.card) === null || _card_card_card === void 0 ? void 0 : _card_card_card.title) || "No Title",
                            " ",
                            /*#__PURE__*/ (0, $cc6u1.jsx)("i", {
                                className: "fas fa-caret-down".concat(openId === (card === null || card === void 0 ? void 0 : (_card_card1 = card.card) === null || _card_card1 === void 0 ? void 0 : (_card_card_card1 = _card_card1.card) === null || _card_card_card1 === void 0 ? void 0 : _card_card_card1.categoryId) ? " rotate-180" : "")
                            })
                        ]
                    }),
                    openId === (card === null || card === void 0 ? void 0 : (_card_card2 = card.card) === null || _card_card2 === void 0 ? void 0 : (_card_card_card2 = _card_card2.card) === null || _card_card_card2 === void 0 ? void 0 : _card_card_card2.categoryId) && /*#__PURE__*/ (0, $cc6u1.jsx)("ul", {
                        className: "mt-4",
                        children: card === null || card === void 0 ? void 0 : (_card_card3 = card.card) === null || _card_card3 === void 0 ? void 0 : (_card_card_card3 = _card_card3.card) === null || _card_card_card3 === void 0 ? void 0 : (_card_card_card_itemCards = _card_card_card3.itemCards) === null || _card_card_card_itemCards === void 0 ? void 0 : _card_card_card_itemCards.map(function(element) {
                            var _card_card_card_itemCards_card_info, _card_card_card_itemCards_card, _card_card_card_itemCards, _card_card_card, _card_card;
                            return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $eddd11fdfb9a41ec$export$2e2bcd8739ae039), {
                                menuItemList: element
                            }, (card === null || card === void 0 ? void 0 : (_card_card = card.card) === null || _card_card === void 0 ? void 0 : (_card_card_card = _card_card.card) === null || _card_card_card === void 0 ? void 0 : (_card_card_card_itemCards = _card_card_card.itemCards) === null || _card_card_card_itemCards === void 0 ? void 0 : (_card_card_card_itemCards_card = _card_card_card_itemCards.card) === null || _card_card_card_itemCards_card === void 0 ? void 0 : (_card_card_card_itemCards_card_info = _card_card_card_itemCards_card.info) === null || _card_card_card_itemCards_card_info === void 0 ? void 0 : _card_card_card_itemCards_card_info.id) || Math.random());
                        })
                    })
                ]
            }, (card === null || card === void 0 ? void 0 : (_card_card4 = card.card) === null || _card_card4 === void 0 ? void 0 : (_card_card_card4 = _card_card4.card) === null || _card_card_card4 === void 0 ? void 0 : _card_card_card4.categoryId) || index);
        })
    });
};
var $275fd59e69c4dc3a$export$2e2bcd8739ae039 = $275fd59e69c4dc3a$var$MenuList;


var $d1dc02be9882a390$var$RestaurantMenu = function() {
    var _menu_data_cards__card_card_info, _menu_data_cards__card_card, _menu_data_cards__card, _menu_data_cards_, _menu_data, _menu_data_cards__card_card_info1, _menu_data_cards__card_card1, _menu_data_cards__card1, _menu_data_cards_1, _menu_data1, _menu_data_cards__card_card_info2, _menu_data_cards__card_card2, _menu_data_cards__card2, _menu_data_cards_2, _menu_data2, _menu_data_cards__card_card_info3, _menu_data_cards__card_card3, _menu_data_cards__card3, _menu_data_cards_3, _menu_data3, _menu_data_cards__card_card_info4, _menu_data_cards__card_card4, _menu_data_cards__card4, _menu_data_cards_4, _menu_data4, _menu_data_cards__card_card_info5, _menu_data_cards__card_card5, _menu_data_cards__card5, _menu_data_cards_5, _menu_data5;
    var resId = (0, $dAaLE.useParams)("").resId;
    var menu = (0, $37d33947ca492c36$export$2e2bcd8739ae039)(resId);
    console.log(menu);
    var product = menu;
    (0, $fIwXP.useEffect)(function() {
        window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        className: "py-14 pt-[98px] md:pt-[128px]",
        children: /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
            className: "container",
            children: menu.length === 0 ? /*#__PURE__*/ (0, $cc6u1.jsx)((0, $4fe64b519d56ac5f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "menu-wrap flex flex-col md:flex-row gap-10",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "restaurent-details md:w-[300px] flex-none md:sticky top-[128px] h-[calc(100vh-128px)] overflow-y-auto",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                                className: "text-3xl font-bold mb-4",
                                children: menu === null || menu === void 0 ? void 0 : (_menu_data = menu.data) === null || _menu_data === void 0 ? void 0 : (_menu_data_cards_ = _menu_data.cards[2]) === null || _menu_data_cards_ === void 0 ? void 0 : (_menu_data_cards__card = _menu_data_cards_.card) === null || _menu_data_cards__card === void 0 ? void 0 : (_menu_data_cards__card_card = _menu_data_cards__card.card) === null || _menu_data_cards__card_card === void 0 ? void 0 : (_menu_data_cards__card_card_info = _menu_data_cards__card_card.info) === null || _menu_data_cards__card_card_info === void 0 ? void 0 : _menu_data_cards__card_card_info.name
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                className: "h-[300px]",
                                src: (0, $iVsXN.IMG_URL) + (menu === null || menu === void 0 ? void 0 : (_menu_data1 = menu.data) === null || _menu_data1 === void 0 ? void 0 : (_menu_data_cards_1 = _menu_data1.cards[2]) === null || _menu_data_cards_1 === void 0 ? void 0 : (_menu_data_cards__card1 = _menu_data_cards_1.card) === null || _menu_data_cards__card1 === void 0 ? void 0 : (_menu_data_cards__card_card1 = _menu_data_cards__card1.card) === null || _menu_data_cards__card_card1 === void 0 ? void 0 : (_menu_data_cards__card_card_info1 = _menu_data_cards__card_card1.info) === null || _menu_data_cards__card_card_info1 === void 0 ? void 0 : _menu_data_cards__card_card_info1.cloudinaryImageId),
                                alt: "reataurantImg"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                                className: "text-lg mt-4",
                                children: menu === null || menu === void 0 ? void 0 : (_menu_data2 = menu.data) === null || _menu_data2 === void 0 ? void 0 : (_menu_data_cards_2 = _menu_data2.cards[2]) === null || _menu_data_cards_2 === void 0 ? void 0 : (_menu_data_cards__card2 = _menu_data_cards_2.card) === null || _menu_data_cards__card2 === void 0 ? void 0 : (_menu_data_cards__card_card2 = _menu_data_cards__card2.card) === null || _menu_data_cards__card_card2 === void 0 ? void 0 : (_menu_data_cards__card_card_info2 = _menu_data_cards__card_card2.info) === null || _menu_data_cards__card_card_info2 === void 0 ? void 0 : _menu_data_cards__card_card_info2.costForTwoMessage
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                                className: "text-lg",
                                children: menu === null || menu === void 0 ? void 0 : (_menu_data3 = menu.data) === null || _menu_data3 === void 0 ? void 0 : (_menu_data_cards_3 = _menu_data3.cards[2]) === null || _menu_data_cards_3 === void 0 ? void 0 : (_menu_data_cards__card3 = _menu_data_cards_3.card) === null || _menu_data_cards__card3 === void 0 ? void 0 : (_menu_data_cards__card_card3 = _menu_data_cards__card3.card) === null || _menu_data_cards__card_card3 === void 0 ? void 0 : (_menu_data_cards__card_card_info3 = _menu_data_cards__card_card3.info) === null || _menu_data_cards__card_card_info3 === void 0 ? void 0 : _menu_data_cards__card_card_info3.cuisines.join(", ")
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("i", {
                                        className: "fas fa-map-marker-alt"
                                    }),
                                    " ",
                                    (menu === null || menu === void 0 ? void 0 : (_menu_data4 = menu.data) === null || _menu_data4 === void 0 ? void 0 : (_menu_data_cards_4 = _menu_data4.cards[2]) === null || _menu_data_cards_4 === void 0 ? void 0 : (_menu_data_cards__card4 = _menu_data_cards_4.card) === null || _menu_data_cards__card4 === void 0 ? void 0 : (_menu_data_cards__card_card4 = _menu_data_cards__card4.card) === null || _menu_data_cards__card_card4 === void 0 ? void 0 : (_menu_data_cards__card_card_info4 = _menu_data_cards__card_card4.info) === null || _menu_data_cards__card_card_info4 === void 0 ? void 0 : _menu_data_cards__card_card_info4.areaName) + ", " + (menu === null || menu === void 0 ? void 0 : (_menu_data5 = menu.data) === null || _menu_data5 === void 0 ? void 0 : (_menu_data_cards_5 = _menu_data5.cards[2]) === null || _menu_data_cards_5 === void 0 ? void 0 : (_menu_data_cards__card5 = _menu_data_cards_5.card) === null || _menu_data_cards__card5 === void 0 ? void 0 : (_menu_data_cards__card_card5 = _menu_data_cards__card5.card) === null || _menu_data_cards__card_card5 === void 0 ? void 0 : (_menu_data_cards__card_card_info5 = _menu_data_cards__card_card5.info) === null || _menu_data_cards__card_card_info5 === void 0 ? void 0 : _menu_data_cards__card_card_info5.locality)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "restaurent-menu w-full md:overflow-y-auto",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("p", {
                                className: "text-2xl font-bold mb-4",
                                children: [
                                    "Menu List ",
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("i", {
                                        className: "fas fa-utensils"
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $275fd59e69c4dc3a$export$2e2bcd8739ae039), {
                                menu: menu
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $d1dc02be9882a390$export$2e2bcd8739ae039 = $d1dc02be9882a390$var$RestaurantMenu;



var $cc6u1 = parcelRequire("cc6u1");
var $adcab6f3937e2a12$exports = {};

$adcab6f3937e2a12$exports = (parcelRequire("i1aqH")).getBundleURL('6MXXU') + "logo.ac088745.png";


var $67815f64c800f425$var$LoginPage = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        className: "py-10",
        children: /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "sm:mx-auto sm:w-full sm:max-w-sm",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($adcab6f3937e2a12$exports))),
                                className: "mx-auto h-auto w-[226px]",
                                alt: "Food Villa"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h2", {
                                className: "mt-10 text-2xl/9 font-bold tracking-tight text-white",
                                children: "Sign in to your account"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("form", {
                                action: "#",
                                method: "POST",
                                className: "space-y-6",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("label", {
                                                htmlFor: "email",
                                                className: "block text-sm/6 font-medium text-white",
                                                children: "Email address"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "mt-2",
                                                children: /*#__PURE__*/ (0, $cc6u1.jsx)("input", {
                                                    id: "email",
                                                    name: "email",
                                                    type: "email",
                                                    required: true,
                                                    autoComplete: "email",
                                                    className: "block w-full rounded-md bg-gray-300 px-3 py-1.5 text-base text-black outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("label", {
                                                        htmlFor: "password",
                                                        className: "block text-sm/6 font-medium text-white",
                                                        children: "Password"
                                                    }),
                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                        className: "text-sm",
                                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                                            href: "#",
                                                            className: "font-semibold text-indigo-600 hover:text-indigo-500",
                                                            children: "Forgot password?"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "mt-2",
                                                children: /*#__PURE__*/ (0, $cc6u1.jsx)("input", {
                                                    id: "password",
                                                    name: "password",
                                                    type: "password",
                                                    required: true,
                                                    autoComplete: "current-password",
                                                    className: "block w-full rounded-md bg-gray-300 px-3 py-1.5 text-base text-black outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                            type: "submit",
                                            className: "flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
                                            children: "Sign in"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("p", {
                                className: "mt-10 text-center text-sm/6 text-white",
                                children: [
                                    "Don't have an account ?",
                                    " ",
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("a", {
                                        href: "#",
                                        className: "font-semibold text-indigo-600 hover:text-indigo-500",
                                        children: "Sign Up"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $67815f64c800f425$export$2e2bcd8739ae039 = $67815f64c800f425$var$LoginPage;



var $cc6u1 = parcelRequire("cc6u1");
var $3cd62588abfd99dd$var$InnerAbout = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        className: "text-2xl",
        children: "Inner About"
    });
};
var $3cd62588abfd99dd$export$2e2bcd8739ae039 = $3cd62588abfd99dd$var$InnerAbout;



var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");

var $dAaLE = parcelRequire("dAaLE");

var $gcxSh = parcelRequire("gcxSh");

var $iVsXN = parcelRequire("iVsXN");

var $fIwXP = parcelRequire("fIwXP");

var $a32c31915d5d79c4$var$MartProduct = function() {
    var _filterProduct__variations__price_offer_applied, _filterProduct__variations__price, _filterProduct__variations_, _filterProduct_, _filterProduct__variations_1, _filterProduct_1, _filterProduct__variations_2, _filterProduct_2, _filterProduct__variations__cart_allowed_quantity, _filterProduct__variations_3, _filterProduct_3, _filterProduct__variations__price1, _filterProduct__variations_4, _filterProduct_4, _filterProduct__variations__price2, _filterProduct__variations_5, _filterProduct_5, _filterProduct__variations_6, _filterProduct_6, _filterProduct_7, _filterProduct__variations__price_offer_applied1, _filterProduct__variations__price3, _filterProduct__variations_7, _filterProduct_8, _filterProduct__variations__cart_allowed_quantity1, _filterProduct__variations_8, _filterProduct_9, _filterProduct__variations_9, _filterProduct_10;
    var product = (0, $gcxSh.default)();
    console.log(product);
    var productId = (0, $dAaLE.useParams)().productId;
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(""), 2), filterProduct = _useState[0], setFilterProduct = _useState[1];
    (0, $fIwXP.useEffect)(function() {
        setFilterProduct(function() {
            return product.filter(function(element) {
                return element.product_id == productId;
            });
        });
    }, [
        filterProduct
    ]);
    (0, $fIwXP.useEffect)(function() {
        window.scrollTo(0, 0);
    }, []);
    console.log(filterProduct);
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        className: "py-10 pt-[98px] md:pt-[128px]",
        children: /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
            className: "container",
            children: filterProduct.length === 0 ? /*#__PURE__*/ (0, $cc6u1.jsx)((0, $4fe64b519d56ac5f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "flex flex-col md:flex-row",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "lg:w-[500px] bg-black rounded-xl shadow-md p-4 relative",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                className: "absolute top-2 left-2 bg-orange-500 text-white text-xs font-bold px-2 py-1 rounded",
                                children: (_filterProduct_ = filterProduct[0]) === null || _filterProduct_ === void 0 ? void 0 : (_filterProduct__variations_ = _filterProduct_.variations[0]) === null || _filterProduct__variations_ === void 0 ? void 0 : (_filterProduct__variations__price = _filterProduct__variations_.price) === null || _filterProduct__variations__price === void 0 ? void 0 : (_filterProduct__variations__price_offer_applied = _filterProduct__variations__price.offer_applied) === null || _filterProduct__variations__price_offer_applied === void 0 ? void 0 : _filterProduct__variations__price_offer_applied.product_description
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                src: (0, $iVsXN.MART_PRODUCT_IMG) + ((_filterProduct_1 = filterProduct[0]) === null || _filterProduct_1 === void 0 ? void 0 : (_filterProduct__variations_1 = _filterProduct_1.variations[0]) === null || _filterProduct__variations_1 === void 0 ? void 0 : _filterProduct__variations_1.images[0]),
                                alt: "Product",
                                className: "w-full max-h-72 object-cover rounded"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                className: "mt-2 text-white text-xs flex items-center",
                                children: /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                    children: "\u23F3 12 mins"
                                })
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h2", {
                                className: "text-white font-semibold text-xl  mt-1",
                                children: (_filterProduct_2 = filterProduct[0]) === null || _filterProduct_2 === void 0 ? void 0 : (_filterProduct__variations_2 = _filterProduct_2.variations[0]) === null || _filterProduct__variations_2 === void 0 ? void 0 : _filterProduct__variations_2.display_name
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("p", {
                                className: "text-white text-md",
                                children: [
                                    (_filterProduct_3 = filterProduct[0]) === null || _filterProduct_3 === void 0 ? void 0 : (_filterProduct__variations_3 = _filterProduct_3.variations[0]) === null || _filterProduct__variations_3 === void 0 ? void 0 : (_filterProduct__variations__cart_allowed_quantity = _filterProduct__variations_3.cart_allowed_quantity) === null || _filterProduct__variations__cart_allowed_quantity === void 0 ? void 0 : _filterProduct__variations__cart_allowed_quantity.total,
                                    " ",
                                    "Piece"
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "flex items-center mt-1",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                        className: "text-white font-bold text-lg",
                                        children: [
                                            "\u20B9",
                                            (_filterProduct_4 = filterProduct[0]) === null || _filterProduct_4 === void 0 ? void 0 : (_filterProduct__variations_4 = _filterProduct_4.variations[0]) === null || _filterProduct__variations_4 === void 0 ? void 0 : (_filterProduct__variations__price1 = _filterProduct__variations_4.price) === null || _filterProduct__variations__price1 === void 0 ? void 0 : _filterProduct__variations__price1.offer_price
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                        className: "text-gray-300 text-sm line-through ml-2",
                                        children: [
                                            "\u20B9",
                                            (_filterProduct_5 = filterProduct[0]) === null || _filterProduct_5 === void 0 ? void 0 : (_filterProduct__variations_5 = _filterProduct_5.variations[0]) === null || _filterProduct__variations_5 === void 0 ? void 0 : (_filterProduct__variations__price2 = _filterProduct__variations_5.price) === null || _filterProduct__variations__price2 === void 0 ? void 0 : _filterProduct__variations__price2.store_price
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "w-full bg-green-500 text-white font-bold py-2 mt-2 rounded",
                                children: "ADD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "w-full bg-black text-white rounded-lg shadow-md p-4",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h2", {
                                className: "text-xl font-semibold mb-3",
                                children: "Highlights"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("table", {
                                className: "w-full border border-gray-700 rounded-md",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsxs)("tr", {
                                            className: "border-b  border-gray-700",
                                            children: [
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("th", {
                                                    className: "p-3 text-start font-medium w-1/3",
                                                    children: "Attribute"
                                                }),
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("th", {
                                                    className: "p-3 text-start font-medium",
                                                    children: "Details"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("tr", {
                                                className: "border-b border-gray-700",
                                                children: [
                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("td", {
                                                        className: "p-3 font-medium w-1/3",
                                                        children: "Included In the Box"
                                                    }),
                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("td", {
                                                        className: "p-3",
                                                        children: (_filterProduct_6 = filterProduct[0]) === null || _filterProduct_6 === void 0 ? void 0 : (_filterProduct__variations_6 = _filterProduct_6.variations[0]) === null || _filterProduct__variations_6 === void 0 ? void 0 : _filterProduct__variations_6.display_name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("tr", {
                                                className: "border-b border-gray-700",
                                                children: [
                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("td", {
                                                        className: "p-3 font-medium",
                                                        children: "Brand"
                                                    }),
                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("td", {
                                                        className: "p-3",
                                                        children: (_filterProduct_7 = filterProduct[0]) === null || _filterProduct_7 === void 0 ? void 0 : _filterProduct_7.brand
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("tr", {
                                                className: "border-b border-gray-700",
                                                children: [
                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("td", {
                                                        className: "p-3 font-medium",
                                                        children: "Discount"
                                                    }),
                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("td", {
                                                        className: "p-3",
                                                        children: (_filterProduct_8 = filterProduct[0]) === null || _filterProduct_8 === void 0 ? void 0 : (_filterProduct__variations_7 = _filterProduct_8.variations[0]) === null || _filterProduct__variations_7 === void 0 ? void 0 : (_filterProduct__variations__price3 = _filterProduct__variations_7.price) === null || _filterProduct__variations__price3 === void 0 ? void 0 : (_filterProduct__variations__price_offer_applied1 = _filterProduct__variations__price3.offer_applied) === null || _filterProduct__variations__price_offer_applied1 === void 0 ? void 0 : _filterProduct__variations__price_offer_applied1.product_description
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("tr", {
                                                className: "border-b border-gray-700",
                                                children: [
                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("td", {
                                                        className: "p-3 font-medium",
                                                        children: "Pack Size"
                                                    }),
                                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("td", {
                                                        className: "p-3",
                                                        children: [
                                                            "Pack of",
                                                            " ",
                                                            (_filterProduct_9 = filterProduct[0]) === null || _filterProduct_9 === void 0 ? void 0 : (_filterProduct__variations_8 = _filterProduct_9.variations[0]) === null || _filterProduct__variations_8 === void 0 ? void 0 : (_filterProduct__variations__cart_allowed_quantity1 = _filterProduct__variations_8.cart_allowed_quantity) === null || _filterProduct__variations__cart_allowed_quantity1 === void 0 ? void 0 : _filterProduct__variations__cart_allowed_quantity1.total
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("td", {
                                                        className: "p-3 font-medium",
                                                        children: "Category"
                                                    }),
                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("td", {
                                                        className: "p-3",
                                                        children: (_filterProduct_10 = filterProduct[0]) === null || _filterProduct_10 === void 0 ? void 0 : (_filterProduct__variations_9 = _filterProduct_10.variations[0]) === null || _filterProduct__variations_9 === void 0 ? void 0 : _filterProduct__variations_9.category
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $a32c31915d5d79c4$export$2e2bcd8739ae039 = $a32c31915d5d79c4$var$MartProduct;


// import { useContext } from "react";
// import { CartContext } from "../utils/UpdateCartContext";

var $cc6u1 = parcelRequire("cc6u1");

var $abvdI = parcelRequire("abvdI");

var $iVsXN = parcelRequire("iVsXN");


var $b47241cf3d81c34b$var$Cart = function() {
    // const { state, dispatch } = useContext(CartContext);
    // console.log("Cart State:", state);
    // console.log("Cart Items:", state?.cart.length);
    // let updatedPrice = 0;
    // console.log(state?.cart?.info?.id);
    // state?.cart.map(
    //   (element) => (updatedPrice = element?.info?.price + updatedPrice)
    // );
    // updatedPrice = (updatedPrice / 100).toFixed(2);
    var foodItem = (0, $c7b80bd183211e5d$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    console.log(foodItem);
    var updatedPrice = 0;
    foodItem.map(function(element) {
        var _element_info;
        return updatedPrice = (element === null || element === void 0 ? void 0 : (_element_info = element.info) === null || _element_info === void 0 ? void 0 : _element_info.price) + updatedPrice;
    });
    updatedPrice = (updatedPrice / 100).toFixed(2);
    var dispatch = (0, $c7b80bd183211e5d$export$8ad76b76a4c905f8)();
    var handlerclear = function() {
        dispatch((0, $2767c9397776ff73$export$10e1a9010e4bc561)());
    };
    var handlerRemoveItem = function(item) {
        console.log(item);
        dispatch((0, $2767c9397776ff73$export$fe2d9b4e03920b4c)(item));
    };
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        className: "pb-[40px] pt-[98px] md:pt-[128px]",
        children: /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
            className: "container",
            children: foodItem.length == 0 ? /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "flex flex-col h-[50vh] justify-center items-center",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("strong", {
                        className: "font-bold text-3xl mb-4",
                        children: "Your cart is empty"
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("p", {
                        children: [
                            "You can go to",
                            " ",
                            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $abvdI.Link), {
                                className: "underline text-blue-600",
                                to: "/",
                                children: "home page"
                            }),
                            " ",
                            "to view more restaurants"
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "bg-black text-white p-4",
                children: /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                    className: "",
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("h3", {
                            className: "font-bold text-3xl mb-5 flex justify-between",
                            children: [
                                "Cart",
                                " ",
                                /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                    className: "bg-red-500 p-3 py-1 text-lg rounded-md",
                                    onClick: handlerclear,
                                    children: "All Clear Cart"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                            className: "mt-4 space-y-4",
                            children: foodItem.map(function(element, index) {
                                var _element_info, _element_info1, _element_info2, _element_info3, _element_info4, _element_info5;
                                return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                    className: "flex justify-between items-center border-b pb-4 px-2",
                                    children: [
                                        /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                                    src: "".concat((0, $iVsXN.MENUS_IMG_URL)).concat(element === null || element === void 0 ? void 0 : (_element_info = element.info) === null || _element_info === void 0 ? void 0 : _element_info.imageId),
                                                    alt: element === null || element === void 0 ? void 0 : (_element_info1 = element.info) === null || _element_info1 === void 0 ? void 0 : _element_info1.name,
                                                    className: " rounded-lg h-[60px] w-[60px]"
                                                }),
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                                                    children: element === null || element === void 0 ? void 0 : (_element_info2 = element.info) === null || _element_info2 === void 0 ? void 0 : _element_info2.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                            className: "flex items-center gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                                    className: "bg-gray-700 px-2 rounded",
                                                    children: "-"
                                                }),
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                                    className: "bg-gray-700 px-2 rounded",
                                                    children: "+"
                                                }),
                                                /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                                    className: "text-green-400 min-w-20 text-end",
                                                    children: [
                                                        "\u20B9",
                                                        " ",
                                                        (element === null || element === void 0 ? void 0 : (_element_info3 = element.info) === null || _element_info3 === void 0 ? void 0 : _element_info3.price) ? ((element === null || element === void 0 ? void 0 : (_element_info4 = element.info) === null || _element_info4 === void 0 ? void 0 : _element_info4.price) / 100).toFixed(2) : "N/A"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                                    className: "ml-2",
                                                    onClick: function() {
                                                        var _element_info;
                                                        return handlerRemoveItem(element === null || element === void 0 ? void 0 : (_element_info = element.info) === null || _element_info === void 0 ? void 0 : _element_info.id);
                                                    },
                                                    children: /*#__PURE__*/ (0, $cc6u1.jsx)("i", {
                                                        className: "fas fa-trash text-red-500"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, element === null || element === void 0 ? void 0 : (_element_info5 = element.info) === null || _element_info5 === void 0 ? void 0 : _element_info5.id);
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                            className: " pt-4 space-y-2",
                            children: [
                                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                            children: "Item Total"
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                            children: [
                                                "\u20B9 ",
                                                updatedPrice
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                            children: "Delivery Fee | 4.5 kms"
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                            children: "\u20B9 22"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                            children: "Platform Fee"
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                            className: "text-blue-400",
                                            children: "\u20B9 6"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                    className: "flex justify-between border-b pb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                            children: "GST and Restaurant Charges"
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                            children: "\u20B9 67.01"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                    className: "flex justify-between font-bold text-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                            children: "TO PAY"
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                            children: [
                                                "\u20B9 ",
                                                +updatedPrice + 22 + 6 + 67.01
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $b47241cf3d81c34b$export$2e2bcd8739ae039 = $b47241cf3d81c34b$var$Cart;






var $d87ff5e5cbd2b751$var$foodStore = (0, $44e97ff44f917989$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $2767c9397776ff73$export$2e2bcd8739ae039)
    }
});
var $d87ff5e5cbd2b751$export$2e2bcd8739ae039 = $d87ff5e5cbd2b751$var$foodStore;



var $09895653c26cf4ac$var$MainSection = /*#__PURE__*/ (0, $fIwXP.lazy)(function() {
    return (parcelRequire("dg0St"));
});

var $09895653c26cf4ac$var$InstantMart = /*#__PURE__*/ (0, $fIwXP.lazy)(function() {
    return (parcelRequire("gyRE9"));
});

var $09895653c26cf4ac$var$About = /*#__PURE__*/ (0, $fIwXP.lazy)(function() {
    return (parcelRequire("djdP9"));
});
// const para2 = <p id="pra1" className="text-xl font-bold">paragraph 2</p>
// const pra = React.createElement(
//     "p",
//     {
//       id: "pra1", className:"text-xl font-bold"
//     },
//     "Pragraph "
//   );
// const heading = React.createElement(
//     "h1",
//     {
//       id: "title1", key:"h1", className:"text-3xl font-bold"
//     },
//     ["Heading 1",pra,para2]
//   );
//   const heading2 = React.createElement(
//     "h2",
//     {
//       id: "title2", key:"h2", className:"text-3xl font-bold"
//     },
//     ["Heading 2",pra,para2]
//   );
// const container = React.createElement(
//   "div",
//   {
//     id: "container", className:"p-4"
//   },
//   [heading, heading2]
// );
// console.log(heading);
//   const title = (
//     "manish"
// )
// function Surname() {
//   return("kumar")
// }
//   const HeaderComponent = function(){
//     return(
//       <div className="text-xl font-bold">Hi {title} {Surname()} {<Surname />}</div>
//   )
//   }
var $09895653c26cf4ac$var$AppLayout = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsxs)((0, $c7b80bd183211e5d$export$2881499e37b75b9a), {
        store: (0, $d87ff5e5cbd2b751$export$2e2bcd8739ae039),
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $f310bc4ea983f747$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $dAaLE.Outlet), {}),
            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $6709bac9fe63cf1c$export$2e2bcd8739ae039), {})
        ]
    });
};
var $09895653c26cf4ac$var$appRouter = (0, $abvdI.createBrowserRouter)([
    {
        path: "/login-page",
        element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $67815f64c800f425$export$2e2bcd8739ae039), {})
    },
    {
        path: "/",
        element: /*#__PURE__*/ (0, $cc6u1.jsx)($09895653c26cf4ac$var$AppLayout, {}),
        errorElement: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $747845963c0a4b26$export$2e2bcd8739ae039), {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)($09895653c26cf4ac$var$MainSection, {})
            },
            {
                path: "/about-us",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $fIwXP.Suspense), {
                    fallback: /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                        className: "text-3xl h-[60vh] flex items-center justify-center text-center flex-col",
                        children: "Loading...."
                    }),
                    children: /*#__PURE__*/ (0, $cc6u1.jsx)($09895653c26cf4ac$var$About, {})
                }),
                children: [
                    {
                        path: "inner-about",
                        element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $3cd62588abfd99dd$export$2e2bcd8739ae039), {})
                    }
                ]
            },
            {
                path: "/contact-us",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $717a2f0a6a708d12$export$2e2bcd8739ae039), {})
            },
            {
                path: "/restaurant/:resId",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $d1dc02be9882a390$export$2e2bcd8739ae039), {})
            },
            {
                path: "/product/:productId",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $a32c31915d5d79c4$export$2e2bcd8739ae039), {})
            },
            {
                path: "/instantMart",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $fIwXP.Suspense), {
                    fallback: /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                        className: "text-3xl h-[60vh] flex items-center justify-center text-center flex-col",
                        children: "Loading...."
                    }),
                    children: /*#__PURE__*/ (0, $cc6u1.jsx)($09895653c26cf4ac$var$InstantMart, {})
                })
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $b47241cf3d81c34b$export$2e2bcd8739ae039), {})
            }
        ]
    }
], {
    future: {
        v7_skipActionErrorRevalidation: true
    }
});
var $09895653c26cf4ac$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($fb34d4b6d3b01836$exports))).createRoot(document.getElementById("root"));
//passing a react element inside the root
//async defer
$09895653c26cf4ac$var$root.render(/*#__PURE__*/ (0, $cc6u1.jsx)((0, $8a4be34b89c09502$export$9081b9c87ee4e12e), {
    children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $abvdI.RouterProvider), {
        router: $09895653c26cf4ac$var$appRouter
    })
})); // root.render(<CartProvider><RouterProvider router={appRouter} /></CartProvider>);

})();
//# sourceMappingURL=index.764cd458.js.map
